webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.App = undefined;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _routes = __webpack_require__(161);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vueRouter = __webpack_require__(466);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueSweetalert = __webpack_require__(467);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	__webpack_require__(297);
	
	var _elementUi = __webpack_require__(281);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(284);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _store = __webpack_require__(93);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueResize = __webpack_require__(465);
	
	var _vueResize2 = _interopRequireDefault(_vueResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResize2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueSweetalert2.default);
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	var router = new _vueRouter2.default({
		routes: _routes2.default
	});
	
	__webpack_require__(339);
	__webpack_require__(346);
	__webpack_require__(336);
	__webpack_require__(338);
	__webpack_require__(337);
	__webpack_require__(344);
	__webpack_require__(345);
	__webpack_require__(335);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(340);
	
	var App = new _vue2.default({
		router: router,
		store: _store2.default,
		methods: {
			errorWrapper: function errorWrapper(errorCallback) {
				var _this = this;
	
				return function (e) {
					if (e.responseJSON && e.responseJSON.declaration) {
						switch (e.responseJSON.declaration) {
							case 'auth_token_needs_refresh':
								return;
	
							case 'no_account_selected':
								if (_this.$store.getters.userAccountsLength) {
									_this.$router.replace('/app/select_account');
									return;
								}
								break;
	
							case 'csrf_token_mismatch':
							case 'auth_token_missing':
							case 'auth_token_expired':
							case 'auth_token_invalid':
								localStorage.removeItem('sessionStart');
								_this.$router.push('/login');
								return;
	
							default:
						}
					}
	
					errorCallback(e);
				};
			}
		}
	});
	
	App.$mount('#app');
	
	exports.App = App;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _environment = __webpack_require__(160);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _zxcvbn = __webpack_require__(473);
	
	var _zxcvbn2 = _interopRequireDefault(_zxcvbn);
	
	var _store = __webpack_require__(93);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var csrfToken = void 0;
	
	var isIE10 = false;
	
	var resizeHandlers = [];
	
	var getResponsiveBreakpoint = function getResponsiveBreakpoint(size) {
		var sizes = {
			'xs': 480,
			'sm': 768,
			'md': 992,
			'lg': 1200
		};
	
		return sizes[size] ? sizes[size] : 0;
	};
	
	var resBreakpointMd = getResponsiveBreakpoint('md');
	
	var handleInit = function handleInit() {
		isIE10 = !!navigator.userAgent.match(/MSIE 10.0/);
	
		if (isIE10) {
			(0, _jquery2.default)('html').addClass('ie10').addClass('ie');
		}
	};
	
	var runResizeHandlers = function runResizeHandlers() {
		for (var i = 0; i < resizeHandlers.length; i++) {
			var each = resizeHandlers[i];
			each.call();
		}
	};
	
	var handleOnResize = function handleOnResize() {
		var windowWidth = (0, _jquery2.default)(window).width();
		var windowHeight = (0, _jquery2.default)(window).height();
		var resize = void 0;
	
		(0, _jquery2.default)(window).resize(function () {
			if ((0, _jquery2.default)(window).width() !== windowWidth || (0, _jquery2.default)(window).height() !== windowHeight) {
				windowWidth = (0, _jquery2.default)(window).width();
				windowHeight = (0, _jquery2.default)(window).height();
				if (resize) {
					clearTimeout(resize);
				}
				resize = setTimeout(function () {
					runResizeHandlers();
				}, 50);
			}
		});
	};
	
	var addResizeHandler = function addResizeHandler(func) {
		resizeHandlers.push(func);
	};
	
	var handleMaterialDesign = function handleMaterialDesign() {
		(0, _jquery2.default)('body').on('click', '.md-checkbox > label, .md-radio > label', function () {
			var the = (0, _jquery2.default)(undefined);
	
			var el = (0, _jquery2.default)(undefined).children('span:first-child');
	
			el.addClass('inc');
	
			var newone = el.clone(true);
	
			el.before(newone);
	
			(0, _jquery2.default)('.' + el.attr('class') + ':last', the).remove();
		});
	
		if ((0, _jquery2.default)('body').hasClass('page-md')) {
			var element = void 0;
			var circle = void 0;
			var d = void 0;
			var x = void 0;
			var y = void 0;
	
			(0, _jquery2.default)('body').on('click', 'a.btn, button.btn, input.btn, label.btn', function (e) {
				element = (0, _jquery2.default)(e.target);
	
				if (element.find('.md-click-circle').length === 0) {
					element.prepend('<span class="md-click-circle"></span>');
				}
	
				circle = element.find('.md-click-circle');
				circle.removeClass('md-click-animate');
	
				if (!circle.height() && !circle.width()) {
					d = Math.max(element.outerWidth(), element.outerHeight());
					circle.css({ height: d, width: d });
				}
	
				x = e.pageX - element.offset().left - circle.width() / 2;
				y = e.pageY - element.offset().top - circle.height() / 2;
	
				circle.css({ top: y + 'px', left: x + 'px' }).addClass('md-click-animate');
	
				setTimeout(function () {
					circle.remove();
				}, 1000);
			});
		}
	
		var handleInput = function handleInput(el) {
			if (el.val() !== '') {
				el.addClass('edited');
			} else {
				el.removeClass('edited');
			}
		};
	
		(0, _jquery2.default)('body').on('keydown', '.form-md-floating-label .form-control', function (e) {
			handleInput((0, _jquery2.default)(undefined));
		});
		(0, _jquery2.default)('body').on('blur', '.form-md-floating-label .form-control', function (e) {
			handleInput((0, _jquery2.default)(undefined));
		});
	
		(0, _jquery2.default)('.form-md-floating-label .form-control').each(function () {
			if ((0, _jquery2.default)(undefined).val().length > 0) {
				(0, _jquery2.default)(undefined).addClass('edited');
			}
		});
	};
	
	var getViewPort = function getViewPort() {
		var e = window;
		var a = 'inner';
		if (!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
	
		return {
			width: e[a + 'Width'],
			height: e[a + 'Height']
		};
	};
	
	var handleHeight = function handleHeight() {};
	
	var handle100HeightContent = function handle100HeightContent() {
		(0, _jquery2.default)('.full-height-content').each(function () {
			var target = (0, _jquery2.default)(undefined);
			var height = void 0;
	
			height = getViewPort().height - (0, _jquery2.default)('.page-header').outerHeight(true) - (0, _jquery2.default)('.page-footer').outerHeight(true) - (0, _jquery2.default)('.page-title').outerHeight(true) - (0, _jquery2.default)('.page-bar').outerHeight(true);
	
			target.css('min-height', height);
		});
	};
	
	var handleSidebarAndContentHeight = function handleSidebarAndContentHeight() {
		var content = (0, _jquery2.default)('.page-content');
		var sidebar = (0, _jquery2.default)('.page-sidebar');
		var height = void 0;
	
		var headerHeight = (0, _jquery2.default)('.page-header').outerHeight();
		var footerHeight = (0, _jquery2.default)('.page-footer').outerHeight();
	
		if (!headerHeight) {
			headerHeight = 0;
		}
		if (!footerHeight) {
			footerHeight = 0;
		}
	
		if (getViewPort().width < resBreakpointMd) {
			height = getViewPort().height - headerHeight - footerHeight;
		} else {
			height = sidebar.height() + 20;
		}
	
		if (height + headerHeight + footerHeight <= getViewPort().height) {
			height = getViewPort().height - headerHeight - footerHeight;
		}
	
		content.css('min-height', height);
	};
	
	var calculateFixedSidebarViewportHeight = function calculateFixedSidebarViewportHeight() {
		var sidebarHeight = getViewPort().height - (0, _jquery2.default)('.page-header').outerHeight(true);
	
		return sidebarHeight;
	};
	
	var handleFixedSidebar = function handleFixedSidebar() {
		var menu = (0, _jquery2.default)('.page-sidebar-menu');
		handleSidebarAndContentHeight();
	
		if (getViewPort().width >= resBreakpointMd && !(0, _jquery2.default)('body').hasClass('page-sidebar-menu-not-fixed')) {
			menu.attr('data-height', calculateFixedSidebarViewportHeight());
	
			handleSidebarAndContentHeight();
		}
	};
	
	var handleResponsiveSidebarToggler = function handleResponsiveSidebarToggler() {
		(0, _jquery2.default)('a.responsive-toggler').on('click', function (e) {
			var sidebar = (0, _jquery2.default)('.page-sidebar');
	
			if (sidebar.hasClass('in')) {
				sidebar.removeClass('in');
			} else {
				sidebar.addClass('in');
			}
	
			(0, _jquery2.default)(window).trigger('resize');
		});
	};
	
	var handleSidebarToggler = function handleSidebarToggler() {
		(0, _jquery2.default)('body').on('click', '.sidebar-toggler', function (e) {
			var body = (0, _jquery2.default)('body');
			var sidebar = (0, _jquery2.default)('.page-sidebar');
			var sidebarMenu = (0, _jquery2.default)('.page-sidebar-menu');
			(0, _jquery2.default)('.sidebar-search', sidebar).removeClass('open');
	
			if (body.hasClass('page-sidebar-closed')) {
				body.removeClass('page-sidebar-closed');
				sidebarMenu.removeClass('page-sidebar-menu-closed');
			} else {
				body.addClass('page-sidebar-closed');
				sidebarMenu.addClass('page-sidebar-menu-closed');
				if (body.hasClass('page-sidebar-fixed')) {
					sidebarMenu.trigger('mouseleave');
				}
			}
	
			(0, _jquery2.default)(window).trigger('resize');
		});
	};
	
	var handleTabs = function handleTabs() {
		(0, _jquery2.default)('body').on('shown.bs.tab', 'a[data-toggle="tab"]', function () {
			handleSidebarAndContentHeight();
		});
	};
	
	var handleSidebarMenu = function handleSidebarMenu() {
		setTimeout(function () {
			(0, _jquery2.default)('.page-sidebar-menu').on('click', 'li > a.nav-link', function (e) {
				if ((0, _jquery2.default)(this).hasClass('nav-toggle')) {
					return;
				}
				if (getViewPort().width < resBreakpointMd && (0, _jquery2.default)('.page-sidebar').hasClass('in')) {
					(0, _jquery2.default)('.page-header .responsive-toggler').click();
				}
			});
		}, 1000);
	};
	
	exports.default = {
		convertBooleanToInt: function convertBooleanToInt(value) {
			return value ? 1 : 0;
		},
		$ajax: function $ajax(options, noRetry) {
			options.beforeSend = function (xhr) {
				csrfToken = ('' + Math.random()).replace('0.', '');
				if (document.cookie !== '' && document.cookie.indexOf('csrf_token=') !== -1) {
					csrfToken = document.cookie.split('csrf_token=')[1];
				} else {
					if (false) {
						document.cookie = 'csrf_token=' + csrfToken;
					} else {
						document.cookie = 'csrf_token=' + csrfToken + ';domain=.unoapp.io';
					}
				}
				xhr.setRequestHeader('X-CSRF-Token', csrfToken);
			};
	
			options.xhrFields = {
				withCredentials: true
			};
	
			var localhost = 'https://api.staging.unoapp.io';
			if (false) {
				if (_environment2.default.fake_backend) {} else {}
			}
	
			if (options.url.indexOf(localhost) === -1) {
				options.url = localhost + options.url;
			}
	
			_jquery2.default.ajax(options);
		},
		refreshWrapper: function refreshWrapper(callback) {
			return function (e) {
				if (e.status === 401 && e.responseJSON && e.responseJSON.declaration === 'auth_token_needs_refresh') {
					_jquery2.default.ajax({
						url: 'https://api.staging.unoapp.io/auth/refresh',
						method: 'POST',
						dataType: 'json',
						xhrFields: {
							withCredentials: true
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('X-CSRF-Token', csrfToken);
						},
						success: function success(response) {
							_store2.default.dispatch('setV3Token', response.payload.token);
	
							callback(response, 'success');
						},
						error: function error(refreshError) {
							callback(refreshError, 'error');
						}
					});
				} else {
					var status = e.status === 0 || e.status === 401 || e.status === 403 || e.status === 404 || e.status === 500 || e.responseJSON && e.responseJSON.status === 'error' ? 'error' : 'success';
					callback(e, status);
				}
			};
		},
		getGoogleFonts: function getGoogleFonts() {
			return new _promise2.default(function (resolve, reject) {
				_jquery2.default.ajax({
					method: 'GET',
					dataType: 'json',
					url: 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAGnCiR_SmDQ7ZQW5qhWx7Rdgntn91xkoE',
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		disableButton: function disableButton(event) {
			var button = void 0;
			if (event.type === 'submit') {
				button = (0, _jquery2.default)(event.target).find('button[type=submit]');
			} else {
				button = (0, _jquery2.default)(event.target);
			}
	
			var originalText = void 0;
			var originalHtml = void 0;
	
			if (!button[0]) {
				originalText = 'This is for save testing.';
			} else {
				originalHtml = button.html();
				originalText = button.text();
			}
			var originalColor = button.css('background-color');
			var whileDisabled = void 0,
			    _complete = void 0;
	
			button.addClass('background-animate');
	
			if (originalText.toLowerCase().indexOf('save') !== -1) {
				whileDisabled = 'saving';
				_complete = 'complete';
			}
	
			if (originalText.toLowerCase().indexOf('submit') !== -1) {
				whileDisabled = 'sending';
				_complete = 'complete';
			}
	
			if (whileDisabled) {
				button.html(whileDisabled);
			}
	
			button.prop('disabled', true);
			return {
				complete: function complete() {
					return new _promise2.default(function (resolve, reject) {
						setTimeout(function () {
							if (_complete) {
								button.html(_complete);
								button.css({ 'background-color': '#5cb85c' });
	
								setTimeout(function () {
									button.css({ 'background-color': originalColor });
									button.html(originalHtml);
									resolve();
								}, 1000);
							} else {
								button.prop('disabled', false);
								resolve();
							}
						}, 100);
					});
				},
				cancel: function cancel() {
					setTimeout(function () {
						if (whileDisabled || _complete) {
							button.html(originalHtml);
						}
						button.prop('disabled', false);
					}, 100);
				}
			};
		},
		passwordStrengthCheck: function passwordStrengthCheck(password) {
			var result = (0, _zxcvbn2.default)(password.substring(0, 50), ['unoapp', 'street']);
	
			var crackTime = result.crack_times_seconds.offline_slow_hashing_1e4_per_second;
	
			if (password.length < 8) {
				return 'Password must be 8 characters minimum';
			}
	
			if (crackTime < 60 * 60 * 24) {
				return 'Very Weak';
			} else if (crackTime < 60 * 60 * 24 * 365) {
				return 'Weak';
			} else if (crackTime < 60 * 60 * 24 * 365 * 100) {
				return 'OK';
			} else {
				return 'Strong';
			}
		},
		init: function init() {
			handleInit();
			handleOnResize();
			handleMaterialDesign();
			addResizeHandler(handleHeight);
		},
		initApp: function initApp() {
			this.initHeader();
			this.initSidebar(null);
			this.initContent();
		},
		initHeader: function initHeader() {},
		initSidebar: function initSidebar() {
			handleFixedSidebar();
			handleSidebarMenu();
			handleSidebarToggler();
			handleResponsiveSidebarToggler();
		},
		initContent: function initContent() {
			handle100HeightContent();
			handleTabs();
			handleSidebarAndContentHeight();
	
			addResizeHandler(handleSidebarAndContentHeight);
			addResizeHandler(handle100HeightContent);
		}
	};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(331)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(214),
	  /* template */
	  __webpack_require__(456),
	  /* scopeId */
	  "data-v-c6c474a8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(324)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(219),
	  /* template */
	  __webpack_require__(442),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(213),
	  /* template */
	  __webpack_require__(401),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getBusinessDetails: function getBusinessDetails(businessId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/business/' + businessId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getBusinesses: function getBusinesses(pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { page_number: pageNumber, records_per_page: recordsPerPage };
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/business/search',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createBusiness: function createBusiness(business) {
			var httpParams = {
				business_name: business.business_name,
				apps: business.apps
			};
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/business',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateBusiness: function updateBusiness(businessId, business) {
			var httpParams = {};
	
			for (var key in business) {
				httpParams[key] = business[key];
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/business/' + businessId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		addToBlacklist: function addToBlacklist(businessId) {
			var httpParams = {
				business_id: businessId
			};
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/blacklist',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		removeFromBlacklist: function removeFromBlacklist(businessId) {
			var httpParams = {
				business_id: businessId
			};
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/blacklist',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		forgotPassword: function forgotPassword(email) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/reset_password',
					data: { email: email },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		checkInvitationTokenExpiry: function checkInvitationTokenExpiry(invitationToken) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/validate_request',
					data: { token: invitationToken },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		setPassword: function setPassword(invitationToken, password) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/set_password',
					data: { token: invitationToken, password: password },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		inviteUser: function inviteUser(user, businessId, locationId) {
			var httpParam = {
				email: user.email,
				business_id: businessId
			};
			if (locationId) {
				httpParam.location_id = locationId;
				httpParam.account_type = 'location';
			} else {
				httpParam.account_type = 'business';
			}
			if (!user.name.first_name || !user.name.first_name.length) {
				delete user.name.first_name;
			}
			if (!user.name.last_name || !user.name.last_name.length) {
				delete user.name.last_name;
			}
			if (locationId) {
				httpParam.location_role_id = user.location_role.role_id;
			} else {
				if (user.role) {
					httpParam.role_id = user.role.role_id;
				} else {
					httpParam.role_id = user.role_id;
				}
			}
	
			httpParam.name = user.name;
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/send_invitation',
					data: httpParam,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		resendInvite: function resendInvite(accountId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/resend_invitation',
					data: { account_id: accountId },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		login: function login(email, password) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/login',
					data: { email: email, password: password },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		logOut: function logOut(userIdle) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/logout',
					data: { user_idle: userIdle },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		refresh: function refresh() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/refresh',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		loginToAccount: function loginToAccount(accountId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/auth/account/' + accountId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getLocations: function getLocations(businessId, pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { business_id: businessId, page_number: pageNumber, records_per_page: recordsPerPage };
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location/search',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createLocation: function createLocation(businessId, location) {
			var httpParams = {
				business_id: businessId,
				region_id: location.region.id,
				name: location.location_name,
				unoapp_defined_name: location.unoapp_defined_name
			};
	
			if (location.selected_location) {
				httpParams.latitude = location.selected_location.coordinates.lat;
				httpParams.longitude = location.selected_location.coordinates.lng;
	
				var streetAddress = {};
				location.selected_location.address_components.forEach(function (component) {
					component.types.forEach(function (type) {
						switch (type) {
							case 'street_address':
								httpParams.address_line_1 = component.long_name;
								break;
	
							case 'route':
							case 'premise':
								streetAddress.route = component.long_name;
								break;
	
							case 'street_number':
							case 'subpremise':
								streetAddress.street_number = component.long_name;
								break;
	
							case 'locality':
								httpParams.city = component.long_name;
								break;
	
							case 'country':
								httpParams.country = component.long_name;
								break;
	
							case 'postal_code':
								httpParams.postal_code = component.long_name;
								break;
	
							case 'administrative_area_level_1':
								httpParams.province = component.long_name;
								break;
	
							default:
						}
					});
				});
	
				if (!httpParams.street_address) {
					httpParams.street_address = streetAddress.street_number + ' ' + streetAddress.route;
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/location',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocation: function getLocation(locationId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location/' + locationId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		modifyLocation: function modifyLocation(location, bypassConflict) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/location/' + location.location_id,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocationDetails: function getLocationDetails(locationId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location/' + locationId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getFolders: function getFolders(businessId, locationId, parentId, pageNumber, recordsPerPage) {
			var httpParams = { parent_folder_id: parentId, sort_by: 'name', sort_order: 'asc', page_number: pageNumber, records_per_page: recordsPerPage };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/search/location_folders';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/search/business_folders';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getFolder: function getFolder(businessId, locationId, folderId) {
			var httpParams = { folder_id: folderId };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_folders';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/business_folders';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createFolder: function createFolder(businessId, locationId, folder, parentFolderId) {
			var httpParams = { name: folder.name, parent_id: parentFolderId };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_folders';
			} else {
				httpParams.business_id = businessId;
				httpParams.is_shared = _global2.default.convertBooleanToInt(folder.is_shared);
				url = '/resources/business_folders';
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateFolder: function updateFolder(businessId, locationId, folderId, folderName, folderPrivacy) {
			var httpParams = { folder_id: folderId, name: folderName };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_folders';
			} else {
				httpParams.business_id = businessId;
				httpParams.is_shared = _global2.default.convertBooleanToInt(folderPrivacy);
				url = '/resources/business_folders';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getResources: function getResources(businessId, locationId, folderId, pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { page_number: pageNumber, records_per_page: recordsPerPage };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/search/location_files';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/search/business_files';
			}
	
			if (folderId) {
				httpParams.folder_id = folderId;
			}
	
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getResource: function getResource(businessId, locationId, resourceId) {
			var httpParams = { file_id: resourceId };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_file';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/business_file';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateResource: function updateResource(businessId, locationId, resourceId, resourceName) {
			var httpParams = { file_id: resourceId, name: resourceName };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_file';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/business_file';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateResourceTags: function updateResourceTags(businessId, locationId, resourceId, tags) {
			var httpParams = { file_id: resourceId, tags: tags };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_files/update_tags';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/business_files/update_tags';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		upload: function upload(businessId, locationId, folderId, file) {
			var url = void 0;
			if (locationId) {
				url = '/resources/location_file/' + locationId + '/' + folderId;
			} else {
				url = '/resources/business_file/' + businessId + '/' + folderId;
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: file,
					contentType: false,
					processData: false,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getTags: function getTags(businessId, locationId, pageNumber, recordsPerPage) {
			var httpParams = { sort_by: 'name', sort_order: 'asc', page_number: pageNumber, records_per_page: recordsPerPage };
			var url = void 0;
	
			if (locationId) {
				httpParams.location_id = locationId;
				url = '/resources/location_tags';
			} else {
				httpParams.business_id = businessId;
				url = '/resources/business_tags';
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: url,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getRoles: function getRoles(businessId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/role/list',
					data: { business_id: businessId },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocationRoles: function getLocationRoles(locationId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location_role/list',
					data: { location_id: locationId },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getRolePages: function getRolePages(businessId, pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { business_id: businessId, page_number: pageNumber, records_per_page: recordsPerPage };
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/role/search',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocationRolePages: function getLocationRolePages(businessId, locationId, pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { business_id: businessId, location_id: locationId, page_number: pageNumber, records_per_page: recordsPerPage };
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location_role/search',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createRole: function createRole(businessId, role, bypassConflict) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/role',
					data: { business_id: businessId, role_name: role.name, approval_permission: _global2.default.convertBooleanToInt(role.approval_permission), app_permissions: role.app_permissions, bypass_conflict: _global2.default.convertBooleanToInt(bypassConflict) },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getRole: function getRole(roleId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/role/' + roleId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocationRole: function getLocationRole(roleId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/location_role/' + roleId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		modifyRole: function modifyRole(role, bypassConflict) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/role/' + role.role_id,
					data: { role_name: role.role_name, approval_permission: _global2.default.convertBooleanToInt(role.approval_permission), app_permissions: role.app_permissions, bypass_conflict: _global2.default.convertBooleanToInt(bypassConflict) },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		deleteRole: function deleteRole(roleId, bypassConflict) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/role/' + roleId,
					data: { bypass_conflict: _global2.default.convertBooleanToInt(bypassConflict) },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(221),
	  /* template */
	  __webpack_require__(406),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(318)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(223),
	  /* template */
	  __webpack_require__(433),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(300)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(224),
	  /* template */
	  __webpack_require__(404),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getCampaigns: function getCampaigns(businessId, locationId, pageNumber, recordsPerPage, searchCriteria) {
			var httpParams = { business_id: businessId, location_id: locationId, page_number: pageNumber, records_per_page: recordsPerPage };
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/gamification/campaign/list',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getTwilioAccounts: function getTwilioAccounts(locationId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/gamification/twilio/list',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createCampaign: function createCampaign(locationId, campaign) {
			var httpParams = { location_id: locationId };
	
			if (campaign) {
				for (var key in campaign) {
					if (key !== 'details') {
						if (campaign[key] === false || campaign[key] === true) {
							httpParams[key] = _global2.default.convertBooleanToInt(campaign[key]);
						} else {
							httpParams[key] = campaign[key];
						}
					}
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/campaign/create',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateCampaign: function updateCampaign(locationId, campaignId, campaign) {
			var httpParams = { location_id: locationId };
	
			if (campaign) {
				for (var key in campaign) {
					if (key !== 'details') {
						if (campaign[key] === false || campaign[key] === true) {
							httpParams[key] = _global2.default.convertBooleanToInt(campaign[key]);
						} else {
							httpParams[key] = campaign[key];
						}
					}
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createCampaignDetails: function createCampaignDetails(locationId, campaignId, campaignDetails) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			if (campaignDetails) {
				for (var key in campaignDetails) {
					if (key === 'twilio_account') {
						httpParams[key] = campaignDetails[key].id;
					} else if (key === 'keywords') {
						httpParams.keyphrase = campaignDetails[key];
					} else {
						httpParams[key] = campaignDetails[key];
					}
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/text2win/create',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateContestLayout: function updateContestLayout(locationId, campaignId, form, design, agreement, contestId) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			for (var key in form) {
				if (key !== 'email_fields') {
					if (form[key] === false || form[key] === true) {
						httpParams[key] = _global2.default.convertBooleanToInt(form[key]);
					} else {
						httpParams[key] = form[key];
					}
				} else {
					for (var emailKey in form.email_fields) {
						httpParams['email_' + emailKey] = form.email_fields[emailKey];
					}
				}
			}
	
			for (var _key in design) {
				if (design[_key] === false || design[_key] === true) {
					httpParams[_key] = _global2.default.convertBooleanToInt(design[_key]);
				} else {
					httpParams[_key] = design[_key];
				}
	
				if (_key === 'font_family') {
					httpParams.font_family = design.font_family.family;
				}
			}
	
			for (var _key2 in agreement) {
				if (_key2 !== 'urls') {
					if (agreement[_key2] === false || agreement[_key2] === true) {
						httpParams[_key2] = _global2.default.convertBooleanToInt(agreement[_key2]);
					} else {
						httpParams[_key2] = agreement[_key2];
					}
				} else {
					agreement.urls.forEach(function (url, i) {
						httpParams['agreement_url_' + (i + 1)] = url.url;
						httpParams['agreement_name_' + (i + 1)] = url.name;
					});
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/gamification/contest/' + contestId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createContestLayout: function createContestLayout(locationId, campaignId, form, design, agreement) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			for (var key in form) {
				if (key !== 'email_fields') {
					if (form[key] === false || form[key] === true) {
						httpParams[key] = _global2.default.convertBooleanToInt(form[key]);
					} else {
						httpParams[key] = form[key];
					}
				} else {
					for (var emailKey in form.email_fields) {
						httpParams['email_' + emailKey] = form.email_fields[emailKey];
					}
				}
			}
	
			for (var _key3 in design) {
				if (design[_key3] === false || design[_key3] === true) {
					httpParams[_key3] = _global2.default.convertBooleanToInt(design[_key3]);
				} else {
					httpParams[_key3] = design[_key3];
				}
	
				if (_key3 === 'font_family') {
					httpParams.font_family = design.font_family.family;
				}
			}
	
			for (var _key4 in agreement) {
				if (_key4 !== 'urls') {
					if (agreement[_key4] === false || agreement[_key4] === true) {
						httpParams[_key4] = _global2.default.convertBooleanToInt(agreement[_key4]);
					} else {
						httpParams[_key4] = agreement[_key4];
					}
				} else {
					agreement.urls.forEach(function (url, i) {
						httpParams['agreement_url_' + (i + 1)] = url.url;
						httpParams['agreement_name_' + (i + 1)] = url.name;
					});
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/contest/create',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getCampaign: function getCampaign(locationId, campaignId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		deleteCampaign: function deleteCampaign(locationId, campaignId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getContestDetails: function getContestDetails(locationId, campaignId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId + '/get_contest',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getPrizes: function getPrizes(locationId, campaignId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId + '/get_prize',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createContestPrize: function createContestPrize(locationId, campaignId, prize) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			for (var key in prize) {
				if (prize[key] === false || prize[key] === true) {
					httpParams[key] = _global2.default.convertBooleanToInt(prize[key]);
				} else {
					httpParams[key] = prize[key];
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/prize',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateContestPrize: function updateContestPrize(locationId, campaignId, prizeId, prize) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			for (var key in prize) {
				if (prize[key] === false || prize[key] === true) {
					httpParams[key] = _global2.default.convertBooleanToInt(prize[key]);
				} else {
					httpParams[key] = prize[key];
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/gamification/prize/' + prizeId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getSkillTestingQuestions: function getSkillTestingQuestions(locationId, campaignId) {
			var httpParams = { location_id: locationId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'GET',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId + '/skill_testing_question',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createSkillTestingQuestion: function createSkillTestingQuestion(locationId, campaignId, question) {
			var httpParams = { location_id: locationId };
	
			for (var key in question) {
				if (question[key] === false || question[key] === true) {
					httpParams[key] = _global2.default.convertBooleanToInt(question[key]);
				} else {
					httpParams[key] = question[key];
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/campaign/' + campaignId + '/skill_testing_question',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		deleteSkillTestingQuestion: function deleteSkillTestingQuestion(locationId, campaignId, questionId) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/gamification/skill_testing_question/' + questionId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createContestPrizeRule: function createContestPrizeRule(locationId, campaignId, prizeId, rule) {
			var httpParams = { location_id: locationId, campaign_id: campaignId };
	
			for (var key in rule) {
				if (key === 'date') {
					if (!rule.specific_day) {
						httpParams.date = 'null';
					} else {
						httpParams.date = rule.date;
					}
				} else {
					if (rule[key] === false || rule[key] === true) {
						httpParams[key] = _global2.default.convertBooleanToInt(rule[key]);
					} else {
						httpParams[key] = rule[key];
					}
				}
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/gamification/prize/' + prizeId + '/add_rule',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		updateCampaignStatus: function updateCampaignStatus(locationId, campaignId, status) {
			var httpParams = { location_id: locationId, status: status };
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/gamification/campaign_status/' + campaignId,
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(303)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(220),
	  /* template */
	  __webpack_require__(412),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(315)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(226),
	  /* template */
	  __webpack_require__(429),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getUserAccounts: function getUserAccounts() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/list',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getUsers: function getUsers(businessId, locationId, accountType, pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
			var httpParams = { business_id: businessId, location_id: locationId, account_type: accountType, page_number: pageNumber, records_per_page: recordsPerPage };
			if (sortCriteria) {
				for (var sortKey in sortCriteria) {
					httpParams[sortKey] = sortCriteria[sortKey];
				}
			}
	
			if (searchCriteria) {
				for (var searchKey in searchCriteria) {
					httpParams[searchKey] = searchCriteria[searchKey];
				}
			}
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/search',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getCurrentAccountDetails: function getCurrentAccountDetails() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/self',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getAccountDetails: function getAccountDetails(accountId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/' + accountId,
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		deleteUser: function deleteUser(accountId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/account/' + accountId,
					data: {},
					success: function success(response) {
						setTimeout(function () {
							resolve(response);
						}, 1000);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getBusinessLocations: function getBusinessLocations(businessId) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/locations_list',
					data: { business_id: businessId },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getLocationSearchResults: function getLocationSearchResults() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/locations_search',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getBusinessSearchResults: function getBusinessSearchResults() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/account/business_search',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(222),
	  /* template */
	  __webpack_require__(450),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getRegions: function getRegions(businessId, parentId) {
			var httpParams = {
				business_id: businessId
			};
	
			if (parentId) {
				httpParams.parent_id = parentId;
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/region/list',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		createRegion: function createRegion(businessId, regionName, parentId) {
			var httpParams = {
				business_id: businessId,
				name: regionName
			};
	
			if (parentId) {
				httpParams.parent_id = parentId;
			}
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/region',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		getRegionLocations: function getRegionLocations(businessId, regionId) {
			var httpParams = {
				business_id: businessId
			};
	
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/region/' + regionId + '/locations',
					data: httpParams,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ACTIVE_USER = exports.SET_ACTIVE_USER = 'SET_ACTIVE_USER';
	var UPDATE_ACTIVE_USER_NAME = exports.UPDATE_ACTIVE_USER_NAME = 'UPDATE_ACTIVE_USER_NAME';
	var CLEAR_USER_VARIABLES = exports.CLEAR_USER_VARIABLES = 'CLEAR_USER_VARIABLES';
	
	var SET_ACTIVE_USER_ACCOUNTS = exports.SET_ACTIVE_USER_ACCOUNTS = 'SET_ACTIVE_USER_ACCOUNTS';
	var SET_ACTIVE_ACCOUNT = exports.SET_ACTIVE_ACCOUNT = 'SET_ACTIVE_ACCOUNT';
	var SET_ACTIVE_BUSINESS_ID = exports.SET_ACTIVE_BUSINESS_ID = 'SET_ACTIVE_BUSINESS_ID';
	var SET_ACTIVE_BUSINESS_NAME = exports.SET_ACTIVE_BUSINESS_NAME = 'SET_ACTIVE_BUSINESS_NAME';
	var CLEAR_ACTIVE_BUSINESS = exports.CLEAR_ACTIVE_BUSINESS = 'CLEAR_ACTIVE_BUSINESS';
	var SET_ACTIVE_LOCATION_ID = exports.SET_ACTIVE_LOCATION_ID = 'SET_ACTIVE_LOCATION_ID';
	var SET_ACTIVE_LOCATION_NAME = exports.SET_ACTIVE_LOCATION_NAME = 'SET_ACTIVE_LOCATION_NAME';
	var CLEAR_ACTIVE_LOCATION = exports.CLEAR_ACTIVE_LOCATION = 'CLEAR_ACTIVE_LOCATION';
	var CLEAR_ACCOUNT_VARIABLES = exports.CLEAR_ACCOUNT_VARIABLES = 'CLEAR_ACCOUNT_VARIABLES';
	var SET_APP_LIST = exports.SET_APP_LIST = 'SET_APP_LIST';
	var SET_ROLE_APP_LIST = exports.SET_ROLE_APP_LIST = 'SET_ROLE_APP_LIST';
	var SET_V3_TOKEN = exports.SET_V3_TOKEN = 'SET_V3_TOKEN';
	
	var SET_GOOGLE_FONTS = exports.SET_GOOGLE_FONTS = 'SET_GOOGLE_FONTS';

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/01.325c58e.jpg";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(310)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(218),
	  /* template */
	  __webpack_require__(419),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(321)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(227),
	  /* template */
	  __webpack_require__(437),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _signageEndpoint = __webpack_require__(162);
	
	var _signageEndpoint2 = _interopRequireDefault(_signageEndpoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getLayouts: function getLayouts(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/layout',
					data: {
						location_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createLayout: function createLayout(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/layout',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteLayout: function deleteLayout(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/layout/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getZones: function getZones(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/zone',
					data: {
						layout_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createZone: function createZone(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/zone',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		updateZones: function updateZones(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PATCH',
					dataType: 'json',
					url: '/zone/' + obj.zone_id,
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteZone: function deleteZone(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/zone/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getPresentations: function getPresentations(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/presentation',
					data: {
						location_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createPresentation: function createPresentation(str, id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/presentation',
					data: {
						name: str,
						location_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deletePresentation: function deletePresentation(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/presentation/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getLayoutPlaylists: function getLayoutPlaylists(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/layout_playlist',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createLayoutPlaylist: function createLayoutPlaylist(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/layout_playlist',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteLayoutPlaylist: function deleteLayoutPlaylist(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/layout_playlist/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getLayoutPlaylistEntries: function getLayoutPlaylistEntries(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/layout_playlist_entry',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createLayoutPlaylistEntry: function createLayoutPlaylistEntry(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/layout_playlist_entry',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteLayoutPlaylistEntry: function deleteLayoutPlaylistEntry(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/layout_playlist_entry/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getSchedules: function getSchedules(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/schedule',
					data: {
						location_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createSchedule: function createSchedule(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/schedule',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteSchedule: function deleteSchedule(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/schedule/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getScheduleEntries: function getScheduleEntries(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/schedule_entry',
					data: {
						schedule_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createScheduleEntry: function createScheduleEntry(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/schedule_entry',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deleteScheduleEntry: function deleteScheduleEntry(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/schedule_entry/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getPlaylists: function getPlaylists(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/playlist',
					data: {
						presentation_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createPlaylist: function createPlaylist(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/playlist',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deletePlaylist: function deletePlaylist(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/playlist/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		getPlaylistEntries: function getPlaylistEntries(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/playlist_entry',
					data: {
						playlist_id: id
					},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		createPlaylistEntry: function createPlaylistEntry(obj) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'PUT',
					dataType: 'json',
					url: '/playlist_entry',
					data: obj,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		},
		deletePlaylistEntry: function deletePlaylistEntry(id) {
			return new _promise2.default(function (resolve, reject) {
				_signageEndpoint2.default.$ajax({
					method: 'DELETE',
					dataType: 'json',
					url: '/playlist_entry/' + id,
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						reject(e);
					}
				});
			});
		}
	};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(322)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(166),
	  /* template */
	  __webpack_require__(438),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(330)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(195),
	  /* template */
	  __webpack_require__(455),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(301)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(211),
	  /* template */
	  __webpack_require__(409),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.BackgroundRotator = undefined;
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundRotator = function BackgroundRotator(elm, images, options) {
		var wrapper, index, currentRatio;
		var defaults = {
			centeredX: true,
			centeredY: true,
			duration: 5000,
			fade: 0
		};
	
		var styles = {
			wrapper: {
				left: 0, top: 0, overflow: 'hidden', margin: 0, padding: 0, height: '100%', width: '100%', zIndex: -999999, position: 'absolute'
			},
			image: {
				position: 'absolute', display: 'none', margin: 0, padding: 0, border: 'none', width: 'auto', height: 'auto', maxHeight: 'none', maxWidth: 'none', zIndex: -999999
			}
		};
	
		return {
			init: function init() {
				if (images === undefined || images.length === 0) {
					return 'No images were passed.';
				}
	
				if (!elm) {
					elm = (0, _jquery2.default)('body');
				}
	
				elm.css('background-image', 'none');
	
				options = _jquery2.default.extend({}, defaults, options || {});
	
				wrapper = (0, _jquery2.default)('<div class="background-rotator"></div>').css(styles.wrapper).appendTo(elm);
	
				index = 0;
				this.show(index);
	
				var localBackgroundRotator = this;
	
				(0, _jquery2.default)(window).on('resize', function () {
					localBackgroundRotator.resize();
				});
			},
			show: function show(newIndex) {
				var _this = this;
	
				if (newIndex > images.length - 1) {
					return;
				}
				index = newIndex;
				var localBackgroundRotator = this;
	
				var oldImage = wrapper.find('img').addClass('delete_image');
	
				var img = (0, _jquery2.default)('<img/>').css(styles.image).bind('load', function (e) {
					var thisImg = (0, _jquery2.default)(e.target);
					var imgWidth = _this.width || (0, _jquery2.default)(e.target).width();
					var imgHeight = _this.height || (0, _jquery2.default)(e.target).height();
	
					currentRatio = imgWidth / imgHeight;
	
					thisImg.fadeIn(options.fade, function () {
						oldImage.remove();
	
						localBackgroundRotator.cycle();
					});
	
					localBackgroundRotator.resize();
				}).appendTo(wrapper);
	
				img.attr('src', images[newIndex]);
	
				return;
			},
			cycle: function cycle() {
				if (images.length > 1) {
					clearInterval(this.interval);
	
					var localBackgroundRotator = this;
	
					this.interval = setInterval(function () {
						localBackgroundRotator.next();
					}, options.duration);
				}
				return;
			},
			next: function next() {
				this.show(index < images.length - 1 ? index + 1 : 0);
			},
			resize: function resize() {
				var bgCss = { left: 0, top: 0 };
				var rootWidth = elm.innerWidth();
				var bgWidth = rootWidth;
				var rootHeight = elm.innerHeight();
				var bgHeight = bgWidth / currentRatio;
				var bgOffset;
	
				if (bgHeight >= rootHeight) {
					bgOffset = (bgHeight - rootHeight) / 2;
					if (options.centeredY) {
						bgCss.top = '-' + bgOffset + 'px';
					}
				} else {
					bgHeight = rootHeight;
					bgWidth = bgHeight * currentRatio;
					bgOffset = (bgWidth - rootWidth) / 2;
					if (options.centeredX) {
						bgCss.left = '-' + bgOffset + 'px';
					}
				}
	
				wrapper.css({ width: rootWidth, height: rootHeight }).find('img:not(.delete_image)').css({ width: bgWidth, height: bgHeight }).css(bgCss);
			}
		};
	};
	
	exports.BackgroundRotator = BackgroundRotator;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getApps: function getApps() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/app/list',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		getCurrentUserDetails: function getCurrentUserDetails() {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/user/self',
					data: {},
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		},
		confirmUserName: function confirmUserName(name) {
			return new _promise2.default(function (resolve, reject) {
				_global2.default.$ajax({
					method: 'POST',
					dataType: 'json',
					url: '/user/confirm_name',
					data: { name: name },
					success: function success(response) {
						resolve(response);
					},
					error: function error(e) {
						var _this = this;
						var _wrapper = _global2.default.refreshWrapper(function (e, status) {
							if (status === 'error') {
								reject(e);
							} else {
								_global2.default.$ajax(_this);
							}
						});
						_wrapper(e);
					}
				});
			});
		}
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _logger = __webpack_require__(468);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _account = __webpack_require__(163);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _user = __webpack_require__(165);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _google = __webpack_require__(164);
	
	var _google2 = _interopRequireDefault(_google);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	var store = new _vuex2.default.Store({
		modules: {
			account: _account2.default,
			user: _user2.default,
			google: _google2.default
		},
		actions: {
			clearVuexStore: function clearVuexStore(_ref) {
				var commit = _ref.commit;
	
				commit(types.CLEAR_ACCOUNT_VARIABLES);
				commit(types.CLEAR_USER_VARIABLES);
			}
		},
		strict: debug,
		plugins: debug ? [(0, _logger2.default)()] : []
	});
	
	exports.default = store;

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bg1.0e82090.jpg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bg2.4ee6a70.jpg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bg3.71c006c.jpg";

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(304)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(191),
	  /* template */
	  __webpack_require__(414),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(194),
	  /* template */
	  __webpack_require__(441),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(216),
	  /* template */
	  __webpack_require__(459),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(329)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(217),
	  /* template */
	  __webpack_require__(454),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(319)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(229),
	  /* template */
	  __webpack_require__(434),
	  /* scopeId */
	  "data-v-5dcab279",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
		fake_backend: false
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _SetPassword = __webpack_require__(361);
	
	var _SetPassword2 = _interopRequireDefault(_SetPassword);
	
	var _Error = __webpack_require__(358);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _Login = __webpack_require__(359);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _App = __webpack_require__(85);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ConfirmName = __webpack_require__(357);
	
	var _ConfirmName2 = _interopRequireDefault(_ConfirmName);
	
	var _SelectAccount = __webpack_require__(360);
	
	var _SelectAccount2 = _interopRequireDefault(_SelectAccount);
	
	var _Dashboard = __webpack_require__(365);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Users = __webpack_require__(396);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _Roles = __webpack_require__(395);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _BusinessManager = __webpack_require__(362);
	
	var _BusinessManager2 = _interopRequireDefault(_BusinessManager);
	
	var _Users3 = __webpack_require__(375);
	
	var _Users4 = _interopRequireDefault(_Users3);
	
	var _Roles3 = __webpack_require__(374);
	
	var _Roles4 = _interopRequireDefault(_Roles3);
	
	var _Regions = __webpack_require__(371);
	
	var _Regions2 = _interopRequireDefault(_Regions);
	
	var _Locations = __webpack_require__(366);
	
	var _Locations2 = _interopRequireDefault(_Locations);
	
	var _Users5 = __webpack_require__(377);
	
	var _Users6 = _interopRequireDefault(_Users5);
	
	var _Roles5 = __webpack_require__(376);
	
	var _Roles6 = _interopRequireDefault(_Roles5);
	
	var _Resources = __webpack_require__(378);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _Content = __webpack_require__(385);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Layout = __webpack_require__(386);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Playlist = __webpack_require__(387);
	
	var _Playlist2 = _interopRequireDefault(_Playlist);
	
	var _UNOgames = __webpack_require__(388);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = [{ path: '/', redirect: '/login' }, { path: '/login', component: _Login2.default, name: 'Login' }, { path: '/set_password', component: _SetPassword2.default, name: 'SetPassword' }, { path: '/set_password/:invitation_token', component: _SetPassword2.default, name: 'SetPassword_InvitationToken' }, { path: '/error', component: _Error2.default, name: 'Error', props: { message: '' } }, { path: '/app', redirect: '/app/dashboard' }, {
		path: '/app',
		component: _App2.default,
		name: 'App',
		children: [{ path: 'confirm_name', component: _ConfirmName2.default, name: 'Confirm Name' }, { path: 'select_account', component: _SelectAccount2.default, name: 'Select Account' }, { path: 'dashboard', component: _Dashboard2.default, name: 'Dashboard' }, { path: 'unoapp_signage', redirect: 'unoapp_signage/content' }, { path: 'unoapp_signage/content', name: 'UNOapp Signage Content', component: _Content2.default }, { path: 'unoapp_signage/layout', name: 'UNOapp Signage Layout', component: _Layout2.default }, { path: 'unoapp_signage/playlist', name: 'UNOapp Signage Playlist', component: _Playlist2.default }, { path: 'unoapp_business', redirect: 'unoapp_business/users' }, { path: 'unoapp_business/users', name: 'UNOapp Business Users', component: _Users2.default, children: [{ path: 'invite_user', name: 'UNOapp Business Users - Invite User' }] }, { path: 'unoapp_business/roles', name: 'UNOapp Business Roles', component: _Roles2.default, children: [{ path: 'create_role', name: 'UNOapp Business Roles - Create Role' }, { path: 'edit_role_name/:role_id', name: 'UNOapp Business Roles - Edit Role Name' }, { path: 'role_permissions/:role_id', name: 'UNOapp Business Roles - Role Permissions' }] }, { path: 'business_manager', name: 'Business Manager', component: _BusinessManager2.default, children: [{ path: 'create_business', name: 'Business Manager - Create Business' }, { path: 'edit_business/:business_id', name: 'Business Manager - Edit Business' }] }, { path: 'my_business', redirect: 'my_business/users' }, { path: 'my_business/users', name: 'My Business Users', component: _Users4.default, children: [{ path: 'invite_user', name: 'My Business Users - Invite User' }] }, { path: 'my_business/roles', name: 'My Business Roles', component: _Roles4.default, children: [{ path: 'create_role', name: 'My Business Roles - Create Role' }, { path: 'edit_role_name/:role_id', name: 'My Business Roles - Edit Role Name' }, { path: 'role_permissions/:role_id', name: 'My Business Roles - Role Permissions' }] }, { path: 'my_business/regions', name: 'My Business Regions', component: _Regions2.default, children: [{ path: 'create_region', name: 'My Business Regions - Create Region' }, { path: 'manage_locations/:region_id', name: 'My Business Regions - Manage Locations' }] }, { path: 'my_business/locations', name: 'My Business Locations', component: _Locations2.default, children: [{ path: 'create_location', name: 'My Business Locations - Create Location' }, { path: 'edit_location_details/:location_id', name: 'My Business Locations - Edit Location Details' }, { path: 'edit_location_address/:location_id', name: 'My Business Locations - Edit Location Address' }, { path: 'location_app_access/:location_id', name: 'My Business Locations - Location App Access' }] }, { path: 'my_location', redirect: 'my_location/users' }, { path: 'my_location/users', name: 'My Location Users', component: _Users6.default, children: [{ path: 'invite_user', name: 'My Location Users - Invite User' }] }, { path: 'my_location/roles', name: 'My Location Roles', component: _Roles6.default, children: [{ path: 'create_role', name: 'My Location Roles - Create Role' }, { path: 'edit_role_name/:role_id', name: 'My Location Roles - Edit Role Name' }, { path: 'role_permissions/:role_id', name: 'My Location Roles - Role Permissions' }] }, { path: 'uno_games', name: 'UNOgames', component: _UNOgames2.default, children: [{ path: 'create_campaign', name: 'UNOgames - Create Campaign' }, { path: 'edit_campaign_details/:campaign_id', name: 'UNOgames - Edit Campaign Details' }, { path: 'edit_contest_layout/:campaign_id', name: 'UNOgames - Edit Contest Layout' }, { path: 'edit_contest_prizes/:campaign_id', name: 'UNOgames - Edit Contest Prizes' }, { path: 'edit_skill_testing_questions/:campaign_id', name: 'UNOgames - Edit Skill Testing Questions' }, { path: 'edit_hashtags/:campaign_id', name: 'UNOgames - Edit Hashtags' }] }, { path: 'resources', name: 'Resources', component: _Resources2.default, children: [{ path: 'create_folder/:folder_id', name: 'Resources - Create Folder' }, { path: 'manage_folder/:folder_id', name: 'Resources - Manage Folder' }, { path: 'manage_resource/:resource_id', name: 'Resources - Manage Resource' }] }]
	}, { path: '*', redirect: '/' }];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		$ajax: function $ajax(options) {
			var endpoint = '//' + 'signage.staging.api.unoapp.io';
			options.url = endpoint + options.url;
			options.beforeSend = function (xhr) {};
			_jquery2.default.ajax(options);
		}
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.mutations = exports.actions = exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(63);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(94);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appList = [{ id: 9, app_id: 'resources_link', route: 'resources', fa: 'fa-file-image-o', title: 'Resources' }, { id: 11, app_id: 'uno_games_link', route: 'uno_games', fa: 'fa-trophy', title: 'UNOgames' }, { id: 12, app_id: 'ecomm_link', route: '', fa: 'fa-shopping-cart', title: 'Ecomm' }];
	
	var state = {
		userAccounts: [],
		activeAccount: {},
		businessLocationApps: [],
		roleApps: [],
		v3Token: ''
	};
	
	var getters = exports.getters = {
		selectedAccountId: function selectedAccountId(state) {
			return state.activeAccount.account_id;
		},
		userAccounts: function userAccounts(state) {
			return state.userAccounts;
		},
		userAccountsLength: function userAccountsLength(state) {
			return state.userAccounts.length;
		},
		firstUserAccount: function firstUserAccount(state) {
			return state.userAccounts.length ? state.userAccounts[0] : {};
		},
		activeAccount: function activeAccount(state) {
			return state.activeAccount;
		},
		unoappAccount: function unoappAccount(state) {
			return state.activeAccount.account_type === 'unoapp';
		},
		businessAccount: function businessAccount(state) {
			return state.activeAccount.account_type === 'business';
		},
		locationAccount: function locationAccount(state) {
			return state.activeAccount.account_type === 'location';
		},
		activeBusinessId: function activeBusinessId(state) {
			return state.activeAccount.business_id;
		},
		activeBusinessName: function activeBusinessName(state) {
			return state.activeAccount.business_name;
		},
		activeLocationId: function activeLocationId(state) {
			return state.activeAccount.location_id;
		},
		activeLocationName: function activeLocationName(state) {
			return state.activeAccount.location_name;
		},
		accessibleApps: function accessibleApps(state) {
			var localRoleApps = [].concat((0, _toConsumableArray3.default)(state.roleApps)).filter(function (app) {
				return app.access_level !== 'none';
			}).map(function (app) {
				return app.id;
			});
			var localApps = [].concat((0, _toConsumableArray3.default)(state.businessLocationApps)).filter(function (app) {
				return localRoleApps.indexOf(app.id) !== -1;
			});
	
			return localApps;
		},
		v3Token: function v3Token(state) {
			return state.v3Token;
		}
	};
	
	var actions = exports.actions = {
		setActiveUserAccounts: function setActiveUserAccounts(_ref, accountList) {
			var commit = _ref.commit;
	
			commit(types.SET_ACTIVE_USER_ACCOUNTS, {
				accountList: accountList
			});
		},
		setActiveAccount: function setActiveAccount(_ref2, account) {
			var commit = _ref2.commit;
	
			if (localStorage.getItem('activeBusiness')) {
				var business = JSON.parse(localStorage.getItem('activeBusiness'));
				if (business.business_id) {
					account.business_id = business.business_id;
					account.business_name = business.business_name;
				}
			}
	
			commit(types.SET_ACTIVE_ACCOUNT, {
				account: account
			});
	
			if (account.account_type === 'location') {
				_Roles2.default.getLocationRole(account.role_id).then(function (response) {
					var localAppList = [];
					response.payload.app_permissions.forEach(function (app) {
						appList.forEach(function (appListApp) {
							if (appListApp.id === app.app_id) {
								appListApp.access_level = app.access_level;
								localAppList.push(appListApp);
							}
						});
					});
	
					commit(types.SET_ROLE_APP_LIST, {
						apps: localAppList
					});
				}).catch(function (e) {
					console.log(e);
				});
			} else if (account.account_type === 'business') {
				_Roles2.default.getRole(account.role_id).then(function (response) {
					var localAppList = [];
					response.payload.app_permissions.forEach(function (app) {
						appList.forEach(function (appListApp) {
							if (appListApp.id === app.app_id) {
								appListApp.access_level = app.access_level;
								localAppList.push(appListApp);
							}
						});
					});
	
					commit(types.SET_ROLE_APP_LIST, {
						apps: localAppList
					});
				}).catch(function (e) {
					console.log(e);
				});
			} else if (account.account_type === 'unoapp') {
				commit(types.SET_ROLE_APP_LIST, {
					apps: appList
				});
			}
		},
		setActiveBusinessId: function setActiveBusinessId(_ref3, businessId) {
			var commit = _ref3.commit;
	
			if (!state.activeAccount.business_id || state.activeAccount.business_id !== businessId) {
				commit(types.CLEAR_ACTIVE_LOCATION);
			}
	
			commit(types.SET_ACTIVE_BUSINESS_ID, {
				businessId: businessId
			});
	
			_Business2.default.getBusinessDetails(businessId).then(function (response) {
				var localAppList = [];
				response.payload.apps.forEach(function (app) {
					appList.forEach(function (appListApp) {
						if (appListApp.id === app.app_id) {
							localAppList.push(appListApp);
						}
					});
				});
	
				commit(types.SET_APP_LIST, {
					localAppList: localAppList
				});
			}).catch(function (e) {
				console.log(e);
			});
		},
		setActiveBusinessName: function setActiveBusinessName(_ref4, businessName) {
			var commit = _ref4.commit;
	
			commit(types.SET_ACTIVE_BUSINESS_NAME, {
				businessName: businessName
			});
		},
		clearActiveBusiness: function clearActiveBusiness(_ref5) {
			var commit = _ref5.commit;
	
			commit(types.CLEAR_ACTIVE_BUSINESS);
		},
		setActiveLocationId: function setActiveLocationId(_ref6, locationId) {
			var commit = _ref6.commit;
	
			commit(types.SET_ACTIVE_LOCATION_ID, {
				locationId: locationId
			});
	
			_Location2.default.getLocationDetails(locationId).then(function (response) {
				var localAppList = [];
				response.payload.apps.forEach(function (app) {
					appList.forEach(function (appListApp) {
						if (appListApp.id === app.app_id) {
							localAppList.push(appListApp);
						}
					});
				});
	
				commit(types.SET_APP_LIST, {
					localAppList: localAppList
				});
			}).catch(function (e) {
				console.log(e);
			});
		},
		setActiveLocationName: function setActiveLocationName(_ref7, locationName) {
			var commit = _ref7.commit;
	
			commit(types.SET_ACTIVE_LOCATION_NAME, {
				locationName: locationName
			});
		},
		clearActiveLocation: function clearActiveLocation(_ref8) {
			var commit = _ref8.commit;
	
			commit(types.CLEAR_ACTIVE_LOCATION);
		},
		setV3Token: function setV3Token(_ref9, token) {
			var commit = _ref9.commit;
	
			commit(types.SET_V3_TOKEN, token);
		}
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_USER_ACCOUNTS, function (state, payload) {
		state.userAccounts = payload.accountList;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_ACCOUNT, function (state, payload) {
		if (!payload.account.location_id) {
			payload.account.location_id = 0;
			payload.account.location_name = '';
		}
		state.activeAccount = payload.account;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_BUSINESS_ID, function (state, payload) {
		state.activeAccount.business_id = payload.businessId;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_BUSINESS_NAME, function (state, payload) {
		state.activeAccount.business_name = payload.businessName;
	}), (0, _defineProperty3.default)(_mutations, types.CLEAR_ACTIVE_BUSINESS, function (state, payload) {
		state.activeAccount.business_name = '';
		state.activeAccount.business_id = 0;
	
		localStorage.removeItem('activeBusiness');
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_LOCATION_ID, function (state, payload) {
		state.activeAccount.location_id = payload.locationId;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_LOCATION_NAME, function (state, payload) {
		state.activeAccount.location_name = payload.locationName;
	}), (0, _defineProperty3.default)(_mutations, types.CLEAR_ACTIVE_LOCATION, function (state, payload) {
		state.activeAccount.location_name = '';
		state.activeAccount.location_id = 0;
	
		localStorage.removeItem('activeLocation');
	}), (0, _defineProperty3.default)(_mutations, types.CLEAR_ACCOUNT_VARIABLES, function (state, payload) {
		state.userAccounts = [];
		state.activeAccount = {};
	}), (0, _defineProperty3.default)(_mutations, types.SET_APP_LIST, function (state, payload) {
		state.businessLocationApps = payload.localAppList;
	}), (0, _defineProperty3.default)(_mutations, types.SET_ROLE_APP_LIST, function (state, payload) {
		state.roleApps = payload.apps;
	}), (0, _defineProperty3.default)(_mutations, types.SET_V3_TOKEN, function (state, token) {
		state.v3Token = token;
	}), _mutations);
	
	exports.default = {
		state: state,
		getters: getters,
		actions: actions,
		mutations: mutations
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.mutations = exports.actions = exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(63);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		googleFonts: []
	};
	
	var getters = exports.getters = {
		allGoogleFonts: function allGoogleFonts(state) {
			return state.googleFonts;
		}
	};
	
	var actions = exports.actions = {
		getGoogleFonts: function getGoogleFonts(_ref) {
			var commit = _ref.commit;
	
			return _global2.default.getGoogleFonts().then(function (response) {
				commit(types.SET_GOOGLE_FONTS, {
					fonts: response.items
				});
			}).catch(function (reason) {});
		}
	};
	
	var mutations = exports.mutations = (0, _defineProperty3.default)({}, types.SET_GOOGLE_FONTS, function (state, payload) {
		state.googleFonts = payload.fonts;
	});
	
	exports.default = {
		state: state,
		getters: getters,
		actions: actions,
		mutations: mutations
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.mutations = exports.actions = exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(63);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(49);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
		activeUser: {}
	};
	
	var getters = exports.getters = {
		activeUser: function activeUser(state) {
			return state.activeUser;
		},
		activeUserName: function activeUserName(state) {
			return state.activeUser.name;
		}
	};
	
	var actions = exports.actions = {
		setActiveUser: function setActiveUser(_ref, user) {
			var commit = _ref.commit;
	
			commit(types.SET_ACTIVE_USER, {
				user: user
			});
		},
		updateActiveUserName: function updateActiveUserName(_ref2, name) {
			var commit = _ref2.commit;
	
			commit(types.UPDATE_ACTIVE_USER_NAME, {
				name: name
			});
		}
	};
	
	var mutations = exports.mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_USER, function (state, payload) {
		state.activeUser = payload.user;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATE_ACTIVE_USER_NAME, function (state, payload) {
		state.activeUser.name = payload.name;
	}), (0, _defineProperty3.default)(_mutations, types.CLEAR_USER_VARIABLES, function (state, payload) {
		state.activeUser = {};
	}), _mutations);
	
	exports.default = {
		state: state,
		getters: getters,
		actions: actions,
		mutations: mutations
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Account = __webpack_require__(41);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _User = __webpack_require__(92);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _AppSidePanel = __webpack_require__(356);
	
	var _AppSidePanel2 = _interopRequireDefault(_AppSidePanel);
	
	var _lodash = __webpack_require__(7);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localTimeout = void 0;
	
	var globalInterval = void 0;
	
	var timer = 3 * 60 * 60 * 1000;
	
	var intervalCount = 5 * 60 * 1000;
	
	var timeoutCount = 3 * 60 * 1000;
	
	var throttleEventTimer = 3 * 60 * 1000;
	
	exports.default = {
		data: function data() {
			return {
				currentRoute: '',
				currentSubRoute: '',
				routeMessage: '',
				displayImStillHere: false,
				displayLoadingScreen: false,
				activeUser: {
					name: {},
					email: ''
				},
				waitingForData: true,
				activeTab: 0,
				locationSearch: {
					search: ''
				},
				businessSearch: {
					search: ''
				},
				locations: [],
				locationSearchResults: [],
				businessSearchResults: [],
				locationSearchError: '',
				businessSearchError: '',
				localBusinessId: 0
			};
		},
		created: function created() {
			var _this = this;
	
			var now = new Date().getTime();
	
			var sessionStart = localStorage.getItem('sessionStart');
			if (sessionStart != null) {
				if (now - sessionStart < timer + timeoutCount + 2000) {
					_Auth2.default.refresh().then(function (response) {
						_this.setV3Token(response.payload.token);
	
						_this.getCurrentUserDetails();
	
						_this.setCurrentRoute();
	
						localStorage.removeItem('sessionStart');
						_this.checkLocalStorage();
	
						if (globalInterval) {
							clearInterval(globalInterval);
						}
						globalInterval = setInterval(function () {
							_this.checkLocalStorage();
						}, intervalCount);
					}).catch(_this.$root.errorWrapper(function (e) {}));
				} else {
					this.displayLoadingScreen = false;
					this.logOut();
				}
			} else {
				this.displayLoadingScreen = false;
				this.setCurrentRoute();
				this.checkLocalStorage();
	
				if (globalInterval) {
					clearInterval(globalInterval);
				}
				globalInterval = setInterval(function () {
					_this.checkLocalStorage();
				}, intervalCount);
				_this.getCurrentUserDetails();
			}
		},
		mounted: function mounted() {
			this.displayLoadingScreen = true;
	
			(0, _jquery2.default)('body').addClass('page-header-fixed').addClass('page-sidebar-closed-hide-logo').addClass('page-content-white').addClass('page-md').addClass('app-body');
	
			_global2.default.init();
			_global2.default.initApp();
	
			this.initEvents();
		},
	
		computed: (0, _vuex.mapGetters)(['userAccountsLength', 'selectedAccountId', 'unoappAccount', 'businessAccount', 'locationAccount', 'activeBusinessId', 'activeBusinessName', 'activeLocationId', 'activeLocationName', 'accessibleApps', 'v3Token']),
		methods: (0, _extends3.default)({
			checkLocalStorage: function checkLocalStorage() {
				var now = new Date().getTime();
				var sessionStart = localStorage.getItem('sessionStart');
				if (sessionStart == null) {
					localStorage.setItem('sessionStart', now);
				} else {
					if (now - sessionStart > timer) {
						this.showImStillHere();
					}
				}
			},
			initEvents: function initEvents() {
				var _this = this;
	
				var throttledEvent = (0, _lodash.throttle)(function () {
					_this.imStillHere(true);
				}, throttleEventTimer, { 'trailing': false });
				(0, _jquery2.default)(window).on('click keyup', throttledEvent);
			},
			setCurrentRoute: function setCurrentRoute() {
				if (this.$route) {
					var firstIndex = this.$route.path.indexOf('/', 1);
					var secondIndex = this.$route.path.indexOf('/', firstIndex + 1);
	
					if (secondIndex === -1) {
						secondIndex = this.$route.path.length;
					}
					this.currentRoute = this.$route.path.substring(firstIndex + 1, secondIndex);
	
					if (secondIndex < this.$route.path.length - 1) {
						var thirdIndex = this.$route.path.indexOf('/', secondIndex + 1);
						if (thirdIndex === -1) {
							thirdIndex = this.$route.path.length;
						}
						this.currentSubRoute = this.$route.path.substring(secondIndex + 1, thirdIndex);
					}
				}
			},
			getCurrentUserAccounts: function getCurrentUserAccounts(confirmUser) {
				var _this = this;
	
				if (this.selectedAccountId) {
					if (confirmUser) {
						this.$router.push('confirm_name');
					} else {
						this.waitingForData = false;
					}
				} else {
					return _Account2.default.getUserAccounts().then(function (response) {
						_this.setActiveUserAccounts(response.payload.accounts);
						console.log('route params', _this.$route.params);
	
						if (confirmUser) {
							_this.$router.push('confirm_name');
						} else {
							_this.waitingForData = false;
	
							if (response.payload.accounts.length > 1) {
								_this.$router.push('select_account');
							} else if (response.payload.accounts.length === 1) {
								_this.loginToUserAccount(response.payload.accounts[0]);
							}
						}
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							(0, _jquery2.default)('body').removeClass('app-body');
							switch (e.responseJSON.declaration) {
								case 'no_accounts_found':
									_this.routeMessage = 'We were unable to find any accounts linked to your email. Please contact your admin.';
									_this.$router.message = _this.routeMessage;
									_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
									break;
	
								default:
							}
						}
					}));
				}
			},
			loginToUserAccount: function loginToUserAccount(account) {
				var _this2 = this;
	
				var _this = this;
	
				_Auth2.default.loginToAccount(account.account_id).then(function (response) {
					_this.setV3Token(response.payload.token);
					_this.getSelectedAccountDetails();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						_this2.displayLoadingScreen = false;
						(0, _jquery2.default)('body').removeClass('app-body');
						switch (e.responseJSON.declaration) {
							case 'invalid_account':
								_this.routeMessage = 'We were unable to find your account. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			},
			setActiveBusiness: function setActiveBusiness(business, fromLocalStorage) {
				if (fromLocalStorage) {
					business = JSON.parse(business);
				}
	
				this.setActiveBusinessId(business.business_id);
	
				this.localBusinessId = this.activeBusinessId;
				this.setActiveBusinessName(business.business_name);
	
				localStorage.setItem('activeBusiness', (0, _stringify2.default)(business));
			},
			setActiveLocation: function setActiveLocation(location, fromLocalStorage) {
				if (fromLocalStorage) {
					location = JSON.parse(location);
				}
	
				this.setActiveLocationId(location.location_id);
				this.setActiveLocationName(location.location_name);
	
				localStorage.setItem('activeLocation', (0, _stringify2.default)(location));
			},
			getSelectedAccountDetails: function getSelectedAccountDetails() {
				var _this = this;
	
				_Account2.default.getCurrentAccountDetails().then(function (response) {
					_this.setActiveAccount(response.payload);
					if (_this.unoappAccount) {
						_this.setActiveBusiness(response.payload);
					} else {
						var activeBusiness = localStorage.getItem('activeBusiness');
						if (activeBusiness != null) {
							_this.setActiveBusiness(activeBusiness, true);
						} else {
							_this.setActiveBusinessName(response.payload.business_name);
						}
	
						var activeLocation = localStorage.getItem('activeLocation');
						if (activeLocation != null) {
							_this.setActiveLocation(activeLocation, true);
						} else {}
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'account_not_found':
								_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			},
			checkIfActiveUserAccount: function checkIfActiveUserAccount(confirmUser) {
				var _this = this;
				return _Account2.default.getCurrentAccountDetails().then(function (response) {
					_this.setActiveAccount(response.payload);
	
					var activeBusiness = localStorage.getItem('activeBusiness');
					if (activeBusiness != null) {
						_this.setActiveBusiness(activeBusiness, true);
					} else {
						_this.setActiveBusinessId(response.payload.business_id);
						_this.setActiveBusinessName(response.payload.business_name);
					}
	
					var activeLocation = localStorage.getItem('activeLocation');
					if (activeLocation != null) {
						_this.setActiveLocation(activeLocation, true);
					} else {}
					_this.getCurrentUserAccounts(confirmUser);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'no_account_selected':
								_this.getCurrentUserAccounts(confirmUser);
								break;
	
							case 'account_not_found':
								_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			},
			getCurrentUserDetails: function getCurrentUserDetails() {
				var _this3 = this;
	
				var _this = this;
				return _User2.default.getCurrentUserDetails().then(function (response) {
					_this.activeUser = response.payload;
					_this3.setActiveUser(_this.activeUser);
	
					if (response.declaration === 'unconfirmed_user_name') {
						_this.waitingForData = false;
						_this.checkIfActiveUserAccount(true);
					} else if (response.declaration === 'user_found') {
						_this.checkIfActiveUserAccount();
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						_LoadingScreen2.default.methods.removeLoadingScreen();
						(0, _jquery2.default)('body').removeClass('app-body');
						switch (e.responseJSON.declaration) {
							case 'user_not_found':
								_this.logOut(false, true);
								break;
	
							default:
						}
					}
				}));
			},
			showImStillHere: function showImStillHere() {
				if (!this.displayImStillHere) {
					this.displayImStillHere = true;
	
					if (localTimeout) {
						clearTimeout(localTimeout);
					}
	
					var _this = this;
	
					localTimeout = setTimeout(function () {
						_this.logOut(1);
					}, timeoutCount);
				}
			},
			imStillHere: function imStillHere(userInteraction) {
				if (userInteraction && this.displayImStillHere) {} else {
					this.displayImStillHere = false;
	
					if (localTimeout) {
						clearTimeout(localTimeout);
					}
	
					var now = new Date().getTime();
					localStorage.removeItem('sessionStart');
					localStorage.setItem('sessionStart', now);
				}
			},
			toggleNavigation: function toggleNavigation(event) {
				var target = (0, _jquery2.default)(event.target).closest('.nav-item');
				if (!target.hasClass('active')) {
					if (target.hasClass('open')) {
						target.removeClass('open');
						target.find('.arrow').removeClass('open');
					} else {
						target.addClass('open');
						target.find('.arrow').addClass('open');
					}
				}
			},
			toggleQuickSidebar: function toggleQuickSidebar() {
				if (!this.locationAccount) {
					(0, _jquery2.default)('body').toggleClass('page-quick-sidebar-open');
				}
			},
			toggleSidebarCollapse: function toggleSidebarCollapse() {
				var body = (0, _jquery2.default)('body');
				var sidebarMenu = (0, _jquery2.default)('.page-sidebar-menu');
	
				if (body.hasClass('page-sidebar-closed')) {
					body.removeClass('page-sidebar-closed');
					sidebarMenu.removeClass('page-sidebar-menu-closed');
				} else {
					body.addClass('page-sidebar-closed');
					sidebarMenu.addClass('page-sidebar-menu-closed');
				}
			},
			clearSearchError: function clearSearchError(type) {
				if (type === 'location') {
					this.locationSearchError = '';
				} else if (type === 'business') {
					this.businessSearchError = '';
				}
			},
	
			getLocationSearchResults: (0, _lodash.debounce)(function () {
				var _this = this;
	
				if (_this.locationSearch.search.length >= 3) {
					_Account2.default.getLocationSearchResults().then(function (response) {
						_this.clearSearchError('location');
						_this.locationSearchResults = response.payload.locations;
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_matching_locations_found':
									_this.locationSearchError = 'There are no matching records. Please try again.';
									break;
								default:
							}
						}
					}));
				} else {
					_this.locationSearchResults = [];
				}
			}, 500),
			changeAccount: function changeAccount() {
				this.$router.push('select_account');
			},
			logOut: function logOut(userIdle, fatalError) {
				if (userIdle) {
					var now = new Date().getTime();
					var sessionStart = localStorage.getItem('sessionStart');
					if (sessionStart != null) {
						if (now - sessionStart + timer < timeoutCount) {
							return;
						}
					}
				}
				if (globalInterval) {
					clearInterval(globalInterval);
				}
				var _this = this;
				return _Auth2.default.logOut(_global2.default.convertBooleanToInt(userIdle)).then(function (response) {
					localStorage.removeItem('sessionStart');
					localStorage.removeItem('activeBusiness');
					localStorage.removeItem('activeLocation');
					if (fatalError) {
						_this.$router.push('/error');
					} else {
						_this.$router.push('/login');
					}
				}).catch(_this.$root.errorWrapper(function (e) {}));
			}
		}, (0, _vuex.mapActions)(['setActiveUser', 'setActiveUserAccounts', 'setActiveAccount', 'setActiveBusinessId', 'setActiveBusinessName', 'setActiveLocationId', 'setActiveLocationName', 'setV3Token'])),
		watch: {
			'$route': function $route() {
				this.setCurrentRoute();
			},
			'locationSearch.search': function locationSearchSearch() {
				this.getLocationSearchResults();
			},
			'activeBusinessId': function activeBusinessId() {
				if (this.activeBusinessId !== this.localBusinessId) {
					this.localBusinessId = this.activeBusinessId;
				}
			}
		},
		components: {
			Modal: _Modal2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			AppSidePanel: _AppSidePanel2.default
		}
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(7);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app-side-panel',
		data: function data() {
			return {
				locationSearch: {
					search: ''
				},
				businessSearch: {
					search: ''
				},
				locationSearchResults: [],
				businessSearchResults: [],
				locationSearchError: '',
				businessSearchError: '',
				loadingBusinessData: false,
				loadingLocationData: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.debouncedBusinessSearch = (0, _lodash.debounce)(function () {
				_this2.getBusinessSearchResults();
			}, 500);
	
			this.debouncedLocationSearch = (0, _lodash.debounce)(function () {
				_this2.getLocationSearchResults();
			}, 500);
		},
	
		computed: (0, _vuex.mapGetters)(['unoappAccount', 'businessAccount', 'activeBusinessId', 'activeBusinessName', 'activeLocationId', 'activeLocationName']),
		methods: (0, _extends3.default)({
			clearSearch: function clearSearch(type) {
				if (type === 'location') {
					this.locationSearchResults = [];
					this.locationSearch.search = '';
				} else if (type === 'business') {
					this.businessSearchResults = [];
					this.businessSearch.search = '';
				}
			},
			clearSearchError: function clearSearchError(type) {
				if (type === 'location') {
					this.locationSearchError = '';
				} else if (type === 'business') {
					this.businessSearchError = '';
				}
			},
			getBusinessSearchResults: function getBusinessSearchResults() {
				var _this = this;
	
				if (this.businessSearch.search.length >= 3) {
					var searchCriteria = {
						search_query: this.businessSearch.search,
						search_in: 'business_name'
					};
					var sortCriteria = {
						sort_by: 'business_name',
						sort_order: 'asc'
					};
	
					this.clearSearchError('business');
					this.loadingBusinessData = true;
					_Business2.default.getBusinesses(1, 25, searchCriteria, sortCriteria).then(function (response) {
						setTimeout(function () {
							_this.businessSearchResults = response.payload.businesses;
							_this.loadingBusinessData = false;
						}, 200);
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_businesses_found':
									_this.loadingBusinessData = false;
									_this.businessSearchError = 'There are no matching records. Please try again.';
									break;
								default:
							}
						}
					}));
				} else if (this.businessSearch.search.length) {
					this.businessSearchResults = [];
					this.businessSearchError = 'In order to use the search field your term must be at least 3 characters.';
				} else {
					this.businessSearchResults = [];
				}
			},
			setActiveBusiness: function setActiveBusiness(business) {
				this.setActiveBusinessId(business.business_id);
				this.setActiveBusinessName(business.business_name);
	
				localStorage.setItem('activeBusiness', (0, _stringify2.default)(business));
	
				this.clearSearch('business');
			},
			setActiveLocation: function setActiveLocation(location) {
				this.setActiveLocationId(location.location_id);
				this.setActiveLocationName(location.location_name);
	
				localStorage.setItem('activeLocation', (0, _stringify2.default)(location));
	
				this.clearSearch('location');
			},
			getLocationSearchResults: function getLocationSearchResults() {
				var _this = this;
	
				if (this.locationSearch.search.length >= 3) {
					var pageNumber = 1;
					var pageResults = 25;
					var businessId = this.activeBusinessId;
					var searchCriteria = {
						search_query: this.locationSearch.search,
						search_in: 'name'
					};
					var sortCriteria = {
						sort_by: 'name',
						sort_order: 'asc'
					};
	
					this.clearSearchError('location');
					this.loadingLocationData = true;
					return _Location2.default.getLocations(businessId, pageNumber, pageResults, searchCriteria, sortCriteria).then(function (response) {
						_this.locationSearchResults = response.payload.locations;
						_this.loadingLocationData = false;
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'locations_not_found':
									_this.loadingLocationData = false;
									_this.locationSearchError = 'There are no matching records. Please try again.';
									break;
								default:
							}
						}
					}));
				} else if (this.locationSearch.search.length) {
					this.locationSearchResults = [];
					this.locationSearchError = 'In order to use the search field your term must be at least 3 characters.';
				} else {
					this.locationSearchResults = [];
				}
			},
			selectMasterAccount: function selectMasterAccount() {
				this.clearActiveLocation();
				this.clearSearch('location');
				this.clearSearchError('location');
			},
			selectMasterUNOappAccount: function selectMasterUNOappAccount() {
				this.clearActiveLocation();
				this.clearSearch('location');
				this.clearSearchError('location');
				this.clearActiveBusiness();
				this.clearSearch('business');
				this.clearSearchError('business');
			}
		}, (0, _vuex.mapActions)(['setActiveBusinessId', 'setActiveBusinessName', 'clearActiveBusiness', 'setActiveLocationId', 'setActiveLocationName', 'clearActiveLocation'])),
		components: {
			LoadingScreen: _LoadingScreen2.default
		},
		watch: {
			'businessSearch.search': function businessSearchSearch() {
				this.debouncedBusinessSearch();
			},
			'locationSearch.search': function locationSearchSearch() {
				this.debouncedLocationSearch();
			}
		}
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _User = __webpack_require__(92);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _App = __webpack_require__(85);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Account = __webpack_require__(41);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				errorMessage: '',
				showNameConfirmationModal: false,
				activeUser: {}
			};
		},
		mounted: function mounted() {
			if (this.activeUserName) {
				this.activeUser = (0, _assign2.default)({}, this.activeUserName);
				this.showNameConfirmationModal = true;
			} else {
				_App2.default.logOut();
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeUserName', 'userAccountsLength', 'firstUserAccount', 'selectedAccountId']),
		methods: (0, _extends3.default)({
			validateUserData: function validateUserData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.activeUser.first_name.length) {
						reject('Your first name cannot be blank');
					} else if (!_this.activeUser.last_name.length) {
						reject('Your last name cannot be blank');
					}
					resolve('Hurray');
				});
			},
			showAlert: function showAlert(event) {
				var _this2 = this;
	
				var _this = this;
				return _this.validateUserData().then(function (response) {
					_this.errorMessage = '';
					_this2.$swal({
						title: 'Are you sure?',
						text: 'You will not be able to change your name after this!',
						type: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Yes, confirm name!',
						cancelButtonText: 'No, change name',
						allowEnterKey: false
					}).then(function () {
						_this.confirmUserName(event);
					}, function (dismiss) {});
				}).catch(function (reason) {
					_this.errorMessage = reason;
				});
			},
			clearError: function clearError() {
				this.errorMessage = '';
			},
			confirmUserName: function confirmUserName(event) {
				var _this3 = this;
	
				var _this = this;
				_User2.default.confirmUserName(_this.activeUser).then(function (response) {
					_this3.updateActiveUserName(_this.activeUser);
	
					if (_this.selectedAccountId) {
						_this.$router.push('dashboard');
					} else {
						if (_this.userAccountsLength > 1) {
							_this.$router.push('select_account');
						} else if (_this.userAccountsLength === 1) {
							_this.loginToSelectedAccount(_this.firstUserAccount.account_id);
						}
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'already_confirmed':
								_this3.updateActiveUserName(_this.activeUser);
	
								if (_this.selectedAccountId) {
									_this.$router.push('dashboard');
								} else {
									if (_this.userAccountsLength > 1) {
										_this.$router.push('select_account');
									} else if (_this.userAccountsLength === 1) {
										_this.loginToSelectedAccount(_this.firstUserAccount.account_id);
									}
								}
								break;
	
							default:
						}
					}
				}));
			},
			loginToSelectedAccount: function loginToSelectedAccount(accountId) {
				var _this = this;
	
				_Auth2.default.loginToAccount(accountId).then(function (response) {
					_this.getSelectedAccountDetails();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'invalid_account':
								_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			},
			getSelectedAccountDetails: function getSelectedAccountDetails() {
				var _this = this;
	
				_Account2.default.getCurrentAccountDetails().then(function (response) {
					_this.setActiveAccount(response.payload);
					_this.setActiveBusinessName(response.payload.business_name);
					_this.$router.push('dashboard');
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'account_not_found':
								_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			}
		}, (0, _vuex.mapActions)(['updateActiveUserName', 'setActiveAccount', 'setActiveBusinessName'])),
		components: {
			Modal: _Modal2.default
		}
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {};
		},
	
		props: {
			message: {
				type: String,
				default: ''
			}
		},
		methods: {
			routeToLogin: function routeToLogin() {
				this.$router.message = '';
				this.$router.push('/login');
			}
		}
	};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _backgroundRotator = __webpack_require__(90);
	
	var _App = __webpack_require__(85);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var img1 = __webpack_require__(126);
	var img2 = __webpack_require__(127);
	var img3 = __webpack_require__(128);
	
	var timer = 3 * 60 * 60 * 1000;
	
	var timeoutCount = 3 * 60 * 1000;
	
	var emailPattern = /^.+@.+\..+$/;
	
	exports.default = {
		name: 'login',
		data: function data() {
			return {
				forgotPassword: false,
				user: {
					email: '',
					password: ''
				},
				errorMessage: '',
				emailSent: false,
				showMobileAppPopup: false,
				deviceType: '',
				appStoreDetails: {
					type: '',
					url: ''
				}
			};
		},
		created: function created() {
			var now = new Date().getTime();
			var activeBusiness = localStorage.getItem('activeBusiness');
			if (activeBusiness != null) {
				localStorage.removeItem('activeBusiness');
			}
			var sessionStart = localStorage.getItem('sessionStart');
	
			if (sessionStart != null) {
				if (now - sessionStart < timer + timeoutCount + 2000) {
					var _this = this;
					_Auth2.default.refresh().then(function (response) {
						_this.setV3Token(response);
	
						_this.$router.push('/app');
					}).catch(function (reason) {
						localStorage.removeItem('sessionStart');
					});
				} else {
					_App2.default.methods.logOut();
				}
			}
		},
		mounted: function mounted() {
			(0, _jquery2.default)('body').removeClass();
	
			var elm = (0, _jquery2.default)('.login-bg');
			var images = [img1, img2, img3];
	
			var options = { fade: 1000, duration: 6000 };
	
			(0, _backgroundRotator.BackgroundRotator)(elm, images, options).init();
	
			var sessionStart = localStorage.getItem('sessionStart');
			if (sessionStart == null) {
				var userAgent = navigator.userAgent.toLowerCase();
				if (userAgent.indexOf('android') !== -1) {
					this.deviceType = 'Android';
					this.appStoreDetails.type = 'Google Play';
					this.appStoreDetails.url = 'http://play.google.com/store/apps/';
					this.showMobileAppPopup = true;
				} else if (userAgent.indexOf('iphone') !== -1) {
					this.deviceType = 'iPhone';
					this.appStoreDetails.type = 'App Store';
					this.appStoreDetails.url = 'http://play.google.com/store/apps/';
					this.showMobileAppPopup = true;
				} else if (userAgent.indexOf('ipad') !== -1) {
					this.deviceType = 'iPad';
					this.appStoreDetails.type = 'App Store';
					this.appStoreDetails.url = 'http://play.google.com/store/apps/';
					if (screen.availWidth <= 767) {
						this.showMobileAppPopup = true;
					}
				}
			}
	
			window.addEventListener('resize', this.handleResize);
		},
	
		methods: (0, _extends3.default)({
			handleResize: function handleResize(event) {
				if (this.showMobileAppPopup && screen.availWidth > 767) {
					this.showMobileAppPopup = false;
				}
			},
			showForgotPassword: function showForgotPassword() {
				this.forgotPassword = true;
				this.clearError();
			},
			goBack: function goBack() {
				this.forgotPassword = false;
				this.emailSent = false;
				this.clearError();
			},
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateLoginData: function validateLoginData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.user.email.length) {
						reject('Your email cannot be blank');
					} else if (!_this.user.password.length) {
						reject('Your password cannot be blank');
					} else if (!emailPattern.test(_this.user.email)) {
						reject('Please enter a valid email');
					} else if (_this.user.password.length < 8) {
						reject('Invalid credentials. Please check your email and password and try again.');
					}
					resolve('Hurray');
				});
			},
			validateEmail: function validateEmail() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.user.email.length) {
						reject('Your email cannot be blank');
					} else if (!emailPattern.test(_this.user.email)) {
						reject('Please enter a valid email');
					}
					resolve('Hurray');
				});
			},
			login: function login(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.clearError();
				return _this.validateLoginData().then(function (response) {
					_Auth2.default.login(_this.user.email, _this.user.password).then(function (response) {
						localStorage.clear();
						_this.clearVuexStore();
						_this.$router.push('/app');
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_matching_user':
									_this.errorMessage = 'Invalid credentials. Please check your email and password and try again.';
									break;
	
								case 'invalid_input':
									if (e.responseJSON.payload.email) {
										_this.errorMessage = 'Your email must be a valid email.';
									}
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			submitForgotPassword: function submitForgotPassword(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateEmail().then(function (response) {
					_Auth2.default.forgotPassword(_this.user.email).then(function (response) {
						_this.emailSent = true;
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'email_failed':
									_this.errorMessage = 'Unable to send email. Please check your email address and try again.';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			}
		}, (0, _vuex.mapActions)(['clearVuexStore', 'setV3Token'])),
		components: {
			Modal: _Modal2.default
		}
	};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Account = __webpack_require__(41);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'select-account',
		data: function data() {
			return {
				showAccountModal: false,
				activeAccount: {},
				selectedAccountId: '',
				errorMessage: '',
				routeMessage: ''
			};
		},
		created: function created() {
			if (this.activeUser && !this.userAccountsLength) {
				this.getUserAccounts();
			}
		},
		mounted: function mounted() {
			this.showAccountModal = true;
		},
	
		computed: (0, _vuex.mapGetters)(['activeUser', 'userAccountsLength', 'userAccounts']),
		methods: (0, _extends3.default)({
			selectAccount: function selectAccount(accountId) {
				if (this.selectedAccountId !== accountId) {
					this.selectedAccountId = accountId;
				}
			},
			loginToSelectedAccount: function loginToSelectedAccount(event) {
				if (this.selectedAccountId) {
					var _this = this;
					var disabledButton = _global2.default.disableButton(event);
	
					_Auth2.default.loginToAccount(this.selectedAccountId).then(function (response) {
						_this.setV3Token(response.payload.token);
	
						_this.getSelectedAccountDetails();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							(0, _jquery2.default)('body').removeClass('app-body');
							switch (e.responseJSON.declaration) {
								case 'invalid_account':
									_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
									_this.$router.message = _this.routeMessage;
									_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				} else {
					return;
				}
			},
			getSelectedAccountDetails: function getSelectedAccountDetails() {
				var _this = this;
	
				_Account2.default.getCurrentAccountDetails().then(function (response) {
					_this.setActiveAccount(response.payload);
					_this.setActiveBusinessName(response.payload.business_name);
					_this.$router.push('dashboard');
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						(0, _jquery2.default)('body').removeClass('app-body');
						switch (e.responseJSON.declaration) {
							case 'account_not_found':
								_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			},
			getUserAccounts: function getUserAccounts() {
				var _this = this;
	
				_Account2.default.getUserAccounts().then(function (response) {
					_this.setActiveUserAccounts(response.payload.accounts);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						(0, _jquery2.default)('body').removeClass('app-body');
						switch (e.responseJSON.declaration) {
							case 'no_accounts_found':
								_this.routeMessage = 'We were unable to find any accounts linked to your email. Please contact your admin.';
								_this.$router.message = _this.routeMessage;
								_this.$router.push({ path: '/error', props: { message: _this.routeMessage } });
								break;
	
							default:
						}
					}
				}));
			}
		}, (0, _vuex.mapActions)(['setActiveUserAccounts', 'setActiveAccount', 'setActiveBusinessName', 'setV3Token'])),
		components: {
			Modal: _Modal2.default
		}
	};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _backgroundRotator = __webpack_require__(90);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var img1 = __webpack_require__(126);
	var img2 = __webpack_require__(127);
	var img3 = __webpack_require__(128);
	
	var invitationToken = void 0;
	
	var userIsStaff = false;
	
	var checkIfStaffPassword = function checkIfStaffPassword(email) {
		if (email.indexOf('@unoapp.com') !== -1) {
			userIsStaff = true;
		}
	};
	
	var checkMatchingPasswords = function checkMatchingPasswords(password, confirmPassword) {
		if (password === confirmPassword) {
			return true;
		} else {
			return false;
		}
	};
	
	exports.default = {
		name: 'set-password',
		data: function data() {
			return {
				password: '',
				confirmPassword: '',
				strength: '',
				passwordsMatch: false,
				errorMessage: '',
				currentView: ''
			};
		},
		created: function created() {
			var _this = this;
	
			if (_this.$route) {
				invitationToken = _this.$route.params.invitation_token;
			}
	
			if (!invitationToken || !invitationToken.length) {
				this.currentView = 'expired_token';
			} else {
				_Auth2.default.checkInvitationTokenExpiry(invitationToken).then(function (response) {
					_this.currentView = 'set_password_form';
					checkIfStaffPassword(response.payload.email);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'token_invalid':
								_this.currentView = 'expired_token';
								break;
	
							case 'token_expired':
								_this.currentView = 'expired_token';
								break;
	
							default:
						}
					}
				}));
			}
		},
		mounted: function mounted() {
			(0, _jquery2.default)('body').removeClass();
	
			var elm = (0, _jquery2.default)('.login-bg');
			var images = [img1, img2, img3];
	
			var options = { fade: 1000, duration: 6000 };
	
			(0, _backgroundRotator.BackgroundRotator)(elm, images, options).init();
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validatePasswordData: function validatePasswordData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.password.length) {
						reject('Your password cannot be blank');
					} else if (_this.password.length < 8) {
						reject('Your password must be 8 characters minimum');
					} else if (_this.strength === 'Very Weak') {
						reject('Your password needs to be stronger');
					} else if (_this.strength === 'Weak' && userIsStaff) {
						reject('Your password needs to be stronger');
					} else if (!_this.passwordsMatch) {
						reject('Your passwords don\'t match');
					}
					resolve('Hurray');
				});
			},
			setPassword: function setPassword(event) {
				var _this2 = this;
	
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.clearError();
				return _this.validatePasswordData().then(function (response) {
					_Auth2.default.setPassword(invitationToken, _this.password).then(function (response) {
						_this2.currentView = 'password_success';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'weak_password':
									_this.errorMessage = 'Your password needs to be stronger';
									break;
	
								case 'token_invalid':
									_this.currentView = 'expired_token';
									break;
	
								case 'token_expired':
									_this.currentView = 'expired_token';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			routeToLogin: function routeToLogin() {
				this.$router.push('/login');
			}
		},
		watch: {
			password: function password() {
				if (this.password.length === 0) {
					this.strength = '';
					return;
				}
	
				this.strength = _global2.default.passwordStrengthCheck(this.password);
	
				if (this.confirmPassword.length) {
					this.passwordsMatch = checkMatchingPasswords(this.password, this.confirmPassword);
				}
			},
			confirmPassword: function confirmPassword() {
				if (this.confirmPassword.length) {
					this.passwordsMatch = checkMatchingPasswords(this.password, this.confirmPassword);
				}
			}
		}
	};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _NoResults = __webpack_require__(47);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _lodash = __webpack_require__(7);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _CreateBusiness = __webpack_require__(363);
	
	var _CreateBusiness2 = _interopRequireDefault(_CreateBusiness);
	
	var _EditBusiness = __webpack_require__(364);
	
	var _EditBusiness2 = _interopRequireDefault(_EditBusiness);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'Business Manager', link: false }],
				activePanel: true,
				advancedSearch: {
					search: '',
					searchOptions: [{ name: 'Business Name', value: 'business_name', checked: true }]
				},
				sortBy: {
					field: 'business_name',
					order: 'asc'
				},
				sortOptions: {
					business_name: 'Business Name'
				},
				searchCollapse: true,
				searchError: '',
				computedHeight: 0,
				pageResultsValue: 0,
				numPages: 0,
				totalResults: 0,
				activePage: 1,
				loadingBusinessData: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createBusiness();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== 'Business Manager') {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
		},
	
		computed: {
			computedSearchOptions: function computedSearchOptions() {
				return this.advancedSearch.searchOptions.filter(function (option) {
					return option.checked;
				});
			}
		},
		methods: (0, _extends3.default)({
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/business_manager');
			},
			createBusiness: function createBusiness() {
				this.$router.push('/app/business_manager/create_business');
			},
			toggleSearchPanel: function toggleSearchPanel() {
				this.searchCollapse = !this.searchCollapse;
			},
			advancedBusinessSearch: function advancedBusinessSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else if (this.advancedSearch.search.length && !this.computedSearchOptions.length) {
					this.searchError = 'In order to use the search field you must select at least one field to search by.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getBusinesses(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			resetBusinessSearch: function resetBusinessSearch() {
				this.advancedSearch = {
					search: '',
					searchOptions: [{ name: 'Business Name', value: 'business_name', checked: true }]
				};
				this.clearSearchError();
			},
			pageResultsUpdate: function pageResultsUpdate(val) {
				if (parseInt(this.pageResultsValue) !== parseInt(val)) {
					this.pageResultsValue = val;
					if (parseInt(this.activePage) === 1) {
						this.getBusinesses(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			activePageUpdate: function activePageUpdate(val) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					this.getBusinesses(this.activePage);
				}
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {};
	
				if (this.advancedSearch.search.length > 2 && this.computedSearchOptions.length) {
					searchCriteria.search_query = this.advancedSearch.search;
					var searchIn = '';
					for (var key in this.computedSearchOptions) {
						if (parseInt(key) !== 0) {
							searchIn += ',';
						}
						searchIn += this.computedSearchOptions[key].value;
					}
					searchCriteria.search_in = searchIn;
				}
	
				return searchCriteria;
			},
			getBusinesses: function getBusinesses(pageNumber) {
				this.loadingBusinessData = true;
				var _this = this;
	
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
	
				return _Business2.default.getBusinesses(pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(function (response) {
					_this.businesses = response.payload.businesses;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
	
					setTimeout(function () {
						_this.loadingBusinessData = false;
					}, 500);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'no_businesses_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							case 'invalid_page_number':
								_this.numPages = e.responseJSON.payload.number_of_pages;
								_this.totalResults = e.responseJSON.payload.number_of_records;
								if (_this.numPages !== 0) {
									_this.getBusinesses(e.responseJSON.payload.number_of_pages);
								}
								break;
							default:
						}
					}
					_this.loadingBusinessData = false;
				}));
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getBusinesses(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			selectBusiness: function selectBusiness(business) {
				this.setActiveBusinessId(business.business_id);
				this.setActiveBusinessName(business.business_name);
	
				localStorage.setItem('activeBusiness', (0, _stringify2.default)(business));
	
				var _this = this;
				this.$swal({
					html: 'Do you want to continue to the location page for ' + business.business_name + '?',
					type: 'info',
					showCancelButton: true,
					confirmButtonText: 'Continue',
					cancelButtonText: 'No, Stay Here',
					showLoaderOnConfirm: true
				}).then(function () {
					_this.$router.push('/app/my_business/locations');
				}, function (dismiss) {});
			},
			addToBlacklist: function addToBlacklist(business) {
				var _this = this;
	
				return _Business2.default.addToBlacklist(business.business_id).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: '<b>' + business.business_name + '</b> has been successfully blacklisted.',
						type: 'success'
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'already_exists':
								_this.$swal({
									title: 'Error',
									html: 'This business is already blacklisted.',
									type: 'warning'
								});
								break;
	
							case 'business_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'permissions_denied':
								_this.$swal({
									title: 'Error',
									html: 'You don\'t have permission to blacklist businesses.',
									type: 'warning'
								});
								break;
	
							default:
						}
					}
				}));
			},
			removeFromBlacklist: function removeFromBlacklist(business) {
				var _this = this;
	
				return _Business2.default.removeFromBlacklist(business.business_id).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: '<b>' + business.business_name + '</b> has been successfully removed from the blacklist.',
						type: 'success'
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_blacklisted':
								_this.$swal({
									title: 'Error',
									html: 'This business wasn\'t blacklisted.',
									type: 'warning'
								});
								break;
	
							case 'permissions_denied':
								_this.$swal({
									title: 'Error',
									html: 'You don\'t have permission to blacklist businesses.',
									type: 'warning'
								});
								break;
	
							default:
						}
					}
				}));
			},
			editBusiness: function editBusiness(businessId) {
				this.$router.push('/app/business_manager/edit_business/' + businessId);
			}
		}, (0, _vuex.mapActions)(['setActiveBusinessId', 'setActiveBusinessName'])),
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			NoResults: _NoResults2.default,
			LoadingScreen: _LoadingScreen2.default,
			CreateBusiness: _CreateBusiness2.default,
			EditBusiness: _EditBusiness2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== 'Business Manager') {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getBusinesses(this.activePage);
				}
			},
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getBusinesses(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			}
		}
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _InfoPopover = __webpack_require__(60);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _Typeahead = __webpack_require__(61);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	var _Account = __webpack_require__(41);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _App = __webpack_require__(91);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _lodash = __webpack_require__(7);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-business',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				newBusiness: {
					business_name: '',
					salesforce_id: '',
					blacklisted: false,
					thirty_day_trial: false,
					sales_rep: {},
					account_rep: {},
					service_package: '',
					business_credits: 0,
					location_credits: 0
				},
				users: [],
				multiSearchKeys: [{ key: 'first_name', parent_key: 'name' }, { key: 'last_name', parent_key: 'name' }, { key: 'email', sub_string: true }],
				steps: [{ key: 'step_1', name: 'Business Info' }, { key: 'step_2', name: 'Service Package' }, { key: 'step_3', name: 'Product Package' }],
				apps: [],
				createBusinessNextActions: [{ title: 'Invite the SuperAdmin', icon_class: 'fa fa-user', main_action: true, description: 'Every Business requires a SuperAdmin to function. The SuperAdmin is the top of the Role Hierarchy and will be repsonsible for passing down all Approval Permissions.', click_event: 'inviteSuperadmin' }, { title: 'Create the First Location', icon_class: 'fa fa-map-marker', description: 'Locations are a representation of each individual business location.', click_event: 'createLocation' }, { title: 'Create Business Roles', icon_class: 'fa fa-user', description: 'Business Roles are used to control Approval Permissions for actions taken within the platform. Roles can also be used to specific which apps a role is able to access.', click_event: 'createRole' }, { title: 'Create Business Regions', icon_class: 'fa fa-sitemap', description: 'Business Regions are groups of locations based on a regional hierarchy. Regions can be used to assign specific users to a location group as well as to manage region specific content for those locations.', click_event: 'createRegion' }, { title: 'Create Another Business', icon_class: 'fa fa-briefcase', click_event: 'resetProcess' }, { title: 'Return to Business Manager Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }],
				createdBusinessId: 0
			};
		},
		created: function created() {
			if (this.$route.name === 'Business Manager - Create Business') {
				this.activePanel = true;
				this.getUserAccounts();
				this.getAppList();
			}
		},
	
		methods: (0, _extends3.default)({
			clearError: function clearError() {
				this.errorMessage = '';
			},
			updateSalesRep: function updateSalesRep(val) {
				if (val) {
					this.newBusiness.sales_rep = val;
				} else {
					this.newBusiness.sales_rep = {};
				}
			},
			updateAccountRep: function updateAccountRep(val) {
				if (val) {
					this.newBusiness.account_rep = val;
				} else {
					this.newBusiness.account_rep = {};
				}
			},
			getUserAccounts: function getUserAccounts() {
				var businessId = 1;
				var _this = this;
				var searchCriteria = {
					invite_status: 'accepted'
				};
				var sortCriteria = {
					sort_by: 'first_name',
					sort_order: 'asc'
				};
	
				return _Account2.default.getUsers(businessId, 1, 100, 'unoapp', searchCriteria, sortCriteria).then(function (response) {
					_this.users = response.payload.accounts;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			getAppList: function getAppList() {
				var _this = this;
	
				return _App2.default.getApps().then(function (response) {
					var defaultApps = { business_access: false, location_default: false };
					_this.apps = response.payload.business_apps;
	
					_this.apps.forEach(function (apps, index, allApps) {
						allApps[index] = (0, _assign2.default)({}, apps, defaultApps);
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (_this.newBusiness.business_name.length < 3) {
								reject('Business name must be at least 3 characters');
							}
	
							break;
	
						case 'step_2':
							if (!_this.newBusiness.service_package.length) {
								reject('A Business must have a Service Package');
							}
							break;
	
						case 'step_3':
							var businessAppsSelected = _this.apps.filter(function (app) {
								return app.business_access;
							}).length >= 1;
	
	
							if (!businessAppsSelected) {
								return _this.$swal({
									title: 'Are you sure?',
									html: 'Do you want to create this business with no app access?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonText: 'Create Business',
									confirmButtonColor: '#d9534f',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									showLoaderOnConfirm: true
								}).then(function () {
									resolve();
								}, function (dismiss) {
									reject();
								});
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				return;
			},
			formatAppData: function formatAppData() {
				var appData = [];
	
				var filteredApps = this.apps.filter(function (app) {
					return app.business_access;
				});
	
				filteredApps.forEach(function (app) {
					appData.push(app.app_id);
				});
	
				return appData;
			},
			createBusiness: function createBusiness(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.newBusiness.apps = this.formatAppData();
	
				return _this.validateFormData('step_3').then(function (response) {
					_this.clearError();
					_Business2.default.createBusiness(_this.newBusiness).then(function (response) {
						_this.createdBusinessId = response.payload.business_id;
						_this.clearForm();
						_this.process = 'next_actions';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A business with this name already exists. Please choose a different name.';
									_this.process = 'step_1';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			closePanel: function closePanel() {
				this.createdBusinessId = 0;
				this.process = 'step_1';
				this.$router.push('/app/business_manager');
			},
			selectServicePackage: function selectServicePackage(type) {
				this.newBusiness.service_package = type;
			},
			forceAppSelection: function forceAppSelection(type, app) {
				switch (type) {
					case 'business_access':
						if (app.business_access === false) {
							app.location_default = false;
						}
						break;
	
					case 'location_default':
						if (app.location_default === true) {
							app.business_access = true;
						}
						break;
	
					default:
				}
	
				return;
			},
			clearForm: function clearForm() {
				this.newBusiness = {
					business_name: '',
					salesforce_id: '',
					blacklisted: false,
					thirty_day_trial: false,
					sales_rep: {},
					account_rep: {},
					service_package: '',
					business_credits: 0,
					location_credits: 0
				};
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			resetProcess: function resetProcess() {
				this.process = 'step_1';
				this.createdBusinessId = 0;
	
				this.apps.forEach(function (app) {
					app.location_access = false;
				});
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			},
			getBusinessDetails: function getBusinessDetails() {
				var _this2 = this;
	
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					_Business2.default.getBusinessDetails(_this2.createdBusinessId).then(function (response) {
						_this2.setActiveBusinessId(response.payload.business_id);
						_this2.setActiveBusinessName(response.payload.business_name);
	
						localStorage.setItem('activeBusiness', (0, _stringify2.default)(response.payload));
						resolve();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							reject(e.responseJSON.declaration);
						} else {
							reject();
						}
					}));
				});
			},
			createLocation: function createLocation() {
				var _this3 = this;
	
				this.getBusinessDetails().then(function (response) {
					_this3.$router.push('/app/my_business/locations');
				}).catch(function (reason) {});
			},
			inviteSuperadmin: function inviteSuperadmin() {
				var _this4 = this;
	
				this.getBusinessDetails().then(function (response) {
					_this4.$router.push('/app/my_business/users');
				}).catch(function (reason) {});
			},
			createRole: function createRole() {
				var _this5 = this;
	
				this.getBusinessDetails().then(function (response) {
					_this5.$router.push('/app/my_business/roles');
				}).catch(function (reason) {});
			},
			createRegion: function createRegion() {
				var _this6 = this;
	
				this.getBusinessDetails().then(function (response) {
					_this6.$router.push('/app/my_business/regions');
				}).catch(function (reason) {});
			}
		}, (0, _vuex.mapActions)(['setActiveBusinessId', 'setActiveBusinessName'])),
		components: {
			InfoPopover: _InfoPopover2.default,
			Typeahead: _Typeahead2.default,
			NextActions: _NextActions2.default,
			StepCounter: _StepCounter2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'Business Manager - Create Business') {
					this.activePanel = true;
					this.process = 'step_1';
					this.getUserAccounts();
					this.getAppList();
					this.clearForm();
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _App = __webpack_require__(91);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _lodash = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-business',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				process: 'step_1',
				businessId: 0,
				editingBusiness: {
					business_name: ''
				},
				steps: [{ key: 'step_1', name: 'Business Info' }, { key: 'step_2', name: 'Product Package' }],
				apps: [],
				updatedValues: {
					business_name: false,
					apps: false
				}
			};
		},
		created: function created() {
			if (this.$route.name === 'Business Manager - Edit Business') {
				this.activePanel = true;
				if (this.$route.params.business_id && this.$route.params.business_id !== 'undefined' && parseInt(this.$route.params.business_id) !== 0) {
					this.businessId = this.$route.params.business_id;
					this.getBusinessDetails();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/business_manager');
			},
			getBusinessDetails: function getBusinessDetails() {
				var _this2 = this;
	
				var _this = this;
	
				_Business2.default.getBusinessDetails(this.businessId).then(function (response) {
					_this.editingBusiness = response.payload;
					_this2.getAppList();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {}
				}));
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (_this.editingBusiness.business_name.length < 3) {
								reject('Business name must be at least 3 characters');
							}
							break;
	
						case 'step_2':
							var businessAppsSelected = _this.apps.filter(function (app) {
								return app.business_access;
							}).length >= 1;
	
							if (!businessAppsSelected) {
								return _this.$swal({
									title: 'Are you sure?',
									html: 'Do you want to remove all app access from this business?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonText: 'Update Business',
									confirmButtonColor: '#d9534f',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									showLoaderOnConfirm: true
								}).then(function () {
									resolve();
								}, function (dismiss) {
									reject();
								});
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				return;
			},
			getAppList: function getAppList() {
				var _this = this;
	
				return _App2.default.getApps().then(function (response) {
					var defaultApps = { business_access: false, location_default: false };
					_this.apps = response.payload.business_apps;
	
					_this.apps.forEach(function (apps, index, allApps) {
						allApps[index] = (0, _assign2.default)({}, apps, defaultApps);
	
						_this.editingBusiness.apps.forEach(function (app) {
							if (app.app_id === apps.app_id) {
								allApps[index].business_access = true;
							}
						});
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			forceAppSelection: function forceAppSelection(type, app) {
				this.updatedValues.apps = true;
	
				switch (type) {
					case 'business_access':
						if (app.business_access === false) {
							app.location_default = false;
						}
						break;
	
					case 'location_default':
						if (app.location_default === true) {
							app.business_access = true;
						}
						break;
	
					default:
				}
	
				return;
			},
			businessNameUpdated: function businessNameUpdated() {
				this.updatedValues.business_name = true;
			},
			formatAppData: function formatAppData() {
				var appData = [];
	
				var filteredApps = this.apps.filter(function (app) {
					return app.business_access;
				});
	
				filteredApps.forEach(function (app) {
					appData.push(app.app_id);
				});
	
				return appData;
			},
			editBusiness: function editBusiness(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.editingBusiness.apps = this.formatAppData();
	
				return _this.validateFormData('step_2').then(function (response) {
					_this.clearError();
					var params = {};
					if (_this.updatedValues.business_name) {
						params.business_name = _this.editingBusiness.business_name;
					}
					if (_this.updatedValues.apps) {
						params.apps = _this.editingBusiness.apps;
					}
					if ((0, _lodash.isEmpty)(params)) {
						_this.closePanel();
						return;
					}
	
					_Business2.default.updateBusiness(_this.businessId, params).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A business with this name already exists. Please choose a different name.';
									_this.process = 'step_1';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.editingBusiness = {
					business_name: ''
				};
				this.apps = [];
				this.updatedValues = {
					business_name: false,
					apps: false
				};
	
				this.process = 'step_1';
			}
		},
		components: {
			StepCounter: _StepCounter2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'Business Manager - Edit Business') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.business_id && this.$route.params.business_id !== 'undefined' && parseInt(this.$route.params.business_id) !== 0) {
						this.businessId = this.$route.params.business_id;
						this.getBusinessDetails();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navElement = void 0;
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'Dashboard', link: false }],
				toDos: [{ app: 'unoapp_business', subApp: 'users', color: 'font-green-haze', title: 'Add your first UNOapp user', text: 'Learn how to create and manage UNOapp staff users through the UNOapp Business Users App.', icon_class: 'icon-user', type: 'unoapp' }, { app: 'my_business', subApp: 'users', color: 'font-green-haze', title: 'Add your first business user', text: 'Learn how to create and manage users through the My Business Users App.', icon_class: 'icon-user', type: 'business' }, { app: 'unoapp_business', subApp: 'roles', color: 'font-blue-sharp', title: 'Create your first UNOapp role', text: 'Learn how to create and manage UNOapp roles where you can group your users to give them specialized privileges through the UNOapp Business Roles App.', icon_class: 'fa fa-sitemap', type: 'unoapp' }, { app: 'my_business', subApp: 'roles', color: 'font-blue-sharp', title: 'Create your first business role', text: 'Learn how to create and manage roles where you can group your users to give them specialized privileges through the My Business Roles App.', icon_class: 'fa fa-sitemap', type: 'business' }, { app: 'my_business', subApp: 'locations', color: 'font-purple-studio', title: 'Create your first business location', text: 'Learn how to create and manage locations through the My Business Locations App.', icon_class: 'icon-pointer', type: 'business' }, { app: 'business_manager', color: 'font-purple-studio', title: 'Create your first Business', text: 'Learn how to create and manage Business\'s through the Business Manager App.', icon_class: 'fa fa-briefcase', type: 'unoapp' }]
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeAccount']),
		methods: {
			initializeOnboardingLink: function initializeOnboardingLink(app, subApp) {
				var htmlElement = (0, _jquery2.default)('.page-sidebar').find('#' + app + '_link');
	
				return {
					init: function init() {
						htmlElement.addClass('onboard-link');
						var _this = this;
	
						htmlElement.bind('click', function () {
							_this.cancel();
						});
					},
					cancel: function cancel() {
						this.destroy();
	
						if (subApp) {
							htmlElement = (0, _jquery2.default)('.page-sidebar').find('#' + app + '_' + subApp + '_link');
							this.init();
	
							subApp = false;
						}
					},
					destroy: function destroy() {
						htmlElement.unbind('click');
						htmlElement.removeClass('onboard-link');
					}
				};
			},
			startOnboarding: function startOnboarding(app, subApp) {
				if (navElement) {
					navElement.destroy();
				}
	
				var appLink = (0, _jquery2.default)('.page-sidebar').find('#' + app + '_link');
	
				if (appLink.find('.sub-menu').length) {
					if (appLink.hasClass('open')) {
						navElement = this.initializeOnboardingLink(app + '_' + subApp);
	
						if (!(0, _jquery2.default)('.page-sidebar').find('#' + app + '_' + subApp + '_link').hasClass('onboard-link')) {
							navElement.init();
						}
					} else {
						navElement = this.initializeOnboardingLink(app, subApp);
						if (!(0, _jquery2.default)('.page-sidebar').find('#' + app + '_link').hasClass('onboard-link')) {
							navElement.init();
						}
					}
				} else {
					navElement = this.initializeOnboardingLink(app);
	
					if (!(0, _jquery2.default)('.page-sidebar').find('#' + app + '_link').hasClass('onboard-link')) {
						navElement.init();
					}
				}
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default
		}
	};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _NoResults = __webpack_require__(47);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _lodash = __webpack_require__(7);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _CreateLocation = __webpack_require__(367);
	
	var _CreateLocation2 = _interopRequireDefault(_CreateLocation);
	
	var _EditLocationDetails = __webpack_require__(369);
	
	var _EditLocationDetails2 = _interopRequireDefault(_EditLocationDetails);
	
	var _EditLocationAddress = __webpack_require__(368);
	
	var _EditLocationAddress2 = _interopRequireDefault(_EditLocationAddress);
	
	var _LocationAppAccess = __webpack_require__(370);
	
	var _LocationAppAccess2 = _interopRequireDefault(_LocationAppAccess);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Business', link: false }, { name: 'Locations', link: false }],
				activePanel: true,
				computedHeight: 0,
				locations: [],
				searchCollapse: true,
				searchError: '',
				advancedSearch: {
					search: '',
					searchOptions: [{ name: 'Location Name', value: 'name', checked: true }]
				},
				sortBy: {
					field: 'name',
					order: 'asc'
				},
				sortOptions: {
					name: 'Location Name'
				},
				pageResultsValue: 0,
				numPages: 0,
				totalResults: 0,
				activePage: 1,
				loadingLocationData: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createLocation();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== 'My Business Locations') {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
		},
	
		computed: (0, _extends3.default)({
			computedSearchOptions: function computedSearchOptions() {
				return this.advancedSearch.searchOptions.filter(function (option) {
					return option.checked;
				});
			}
		}, (0, _vuex.mapGetters)(['activeBusinessId'])),
		methods: (0, _extends3.default)({
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/my_business/locations');
			},
			createLocation: function createLocation() {
				this.$router.push('/app/my_business/locations/create_location');
			},
			toggleSearchPanel: function toggleSearchPanel() {
				this.searchCollapse = !this.searchCollapse;
			},
			advancedLocationSearch: function advancedLocationSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else if (this.advancedSearch.search.length && !this.computedSearchOptions.length) {
					this.searchError = 'In order to use the search field you must select at least one field to search by.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getLocations(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			resetLocationSearch: function resetLocationSearch() {
				this.advancedSearch = {
					search: '',
					searchOptions: [{ name: 'Location Name', value: 'location_name', checked: true }]
				};
				this.clearSearchError();
			},
			pageResultsUpdate: function pageResultsUpdate(val) {
				if (parseInt(this.pageResultsValue) !== parseInt(val)) {
					this.pageResultsValue = val;
					if (parseInt(this.activePage) === 1) {
						this.getLocations(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			activePageUpdate: function activePageUpdate(val) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					this.getLocations(this.activePage);
				}
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getLocations(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {};
	
				if (this.advancedSearch.search.length > 2 && this.computedSearchOptions.length) {
					searchCriteria.search_query = this.advancedSearch.search;
					var searchIn = '';
					for (var key in this.computedSearchOptions) {
						if (parseInt(key) !== 0) {
							searchIn += ',';
						}
						searchIn += this.computedSearchOptions[key].value;
					}
					searchCriteria.search_in = searchIn;
				}
	
				return searchCriteria;
			},
			getLocations: function getLocations(pageNumber) {
				this.loadingLocationData = true;
				this.locations = [];
	
				var _this = this;
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
				var businessId = this.activeBusinessId;
	
				return _Location2.default.getLocations(businessId, pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(function (response) {
					_this.locations = response.payload.locations;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
	
					setTimeout(function () {
						_this.loadingLocationData = false;
					}, 500);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'no_locations_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							case 'business_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_business':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_page_number':
								_this.numPages = e.responseJSON.payload.number_of_pages;
								_this.totalResults = e.responseJSON.payload.number_of_records;
								if (_this.numPages !== 0) {
									_this.getLocations(e.responseJSON.payload.number_of_pages);
								}
								break;
							default:
						}
					}
					_this.loadingLocationData = false;
				}));
			},
			selectLocation: function selectLocation(location) {
				this.setActiveLocationId(location.location_id);
				this.setActiveLocationName(location.location_name);
	
				localStorage.setItem('activeLocation', (0, _stringify2.default)(location));
			},
			editLocationDetails: function editLocationDetails(locationId) {
				this.$router.push('/app/my_business/locations/edit_location_details/' + locationId);
			},
			editLocationAddress: function editLocationAddress(locationId) {
				this.$router.push('/app/my_business/locations/edit_location_address/' + locationId);
			},
			editLocationAppAccess: function editLocationAppAccess(locationId) {
				this.$router.push('/app/my_business/locations/location_app_access/' + locationId);
			}
		}, (0, _vuex.mapActions)(['setActiveLocationId', 'setActiveLocationName'])),
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			NoResults: _NoResults2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			CreateLocation: _CreateLocation2.default,
			EditLocationDetails: _EditLocationDetails2.default,
			EditLocationAddress: _EditLocationAddress2.default,
			LocationAppAccess: _LocationAppAccess2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== 'My Business Locations') {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getLocations(this.activePage);
				}
			},
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getLocations(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			}
		}
	};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _GoogleMapsPinConfirmation = __webpack_require__(132);
	
	var _GoogleMapsPinConfirmation2 = _interopRequireDefault(_GoogleMapsPinConfirmation);
	
	var _GooglePlacesSearch = __webpack_require__(133);
	
	var _GooglePlacesSearch2 = _interopRequireDefault(_GooglePlacesSearch);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _lodash = __webpack_require__(7);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _Region = __webpack_require__(48);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-location',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				newLocation: {
					location_name: '',
					unoapp_defined_name: '',
					store_number: '',
					salesforce_id: '',
					region: {}
				},
				confirmationMessage: 'Click <b class="font-green-sharp">&#39;Continue&#39;</b> to confirm that this is your location.',
				steps: [{ key: 'step_1', name: 'Location Info' }, { key: 'step_2', name: 'Google Location' }, { key: 'step_3', name: 'Verify Location' }, { key: 'step_4', name: 'Select Region' }, { key: 'step_5', name: 'Product Package' }],
				apps: [],
				regions: [],
				regionPath: [],
				loadingRegionData: false,
				createLocationNextActions: [{ title: 'Set Up Location Profile', icon_class: 'fa fa-map-marker', main_action: true, description: 'A location profile contails details about your location.' }, { title: 'Create Another Location', icon_class: 'fa fa-map-marker', click_event: 'resetProcess' }, { title: 'Return to Locations Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }]
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Locations - Create Location') {
				this.activePanel = true;
				this.getAppList();
				this.getRegions();
			}
		},
	
		computed: (0, _extends3.default)({
			computedRegions: function computedRegions() {
				if (!this.regionPath.length) {
					return this.regions;
				} else {
					return this.regionPath[this.regionPath.length - 1].children;
				}
			}
		}, (0, _vuex.mapGetters)(['activeBusinessId'])),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/my_business/locations');
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (_this.newLocation.location_name.length < 3) {
								reject('Location name must be at least 3 characters');
							}
							break;
	
						case 'step_2':
							if (!_this.newLocation.selected_location || !_this.newLocation.selected_location.id) {
								reject('You must select a location before continuing.');
							}
							break;
	
						case 'step_4':
							if (!_this.newLocation.region || !_this.newLocation.region.id) {
								reject('You must select a region before continuing.');
							}
							break;
	
						case 'step_5':
							var locationAppsSelected = _this.apps.filter(function (app) {
								return app.location_access;
							}).length >= 1;
	
							if (!locationAppsSelected) {
								return _this.$swal({
									title: 'Are you sure?',
									html: 'Do you want to create this location with no app access?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonText: 'Create Location',
									confirmButtonColor: '#d9534f',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									showLoaderOnConfirm: true
								}).then(function () {
									resolve();
								}, function (dismiss) {
									reject();
								});
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				this.clearError();
	
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				if (this.process !== 'step_2') {
					if ((0, _jquery2.default)(document).find('.pac-container').length) {
						(0, _jquery2.default)(document).find('.pac-container').remove();
					}
				}
	
				return;
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			getAppList: function getAppList() {
				var _this = this;
	
				return _Business2.default.getBusinessDetails(this.activeBusinessId).then(function (response) {
					var defaultApps = { location_access: false };
					_this.apps = response.payload.apps;
	
					_this.apps.forEach(function (apps, index, allApps) {
						allApps[index] = (0, _assign2.default)({}, apps, defaultApps);
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			formatAppData: function formatAppData() {
				var appData = [];
	
				var filteredApps = (0, _lodash.filter)(this.apps, 'location_access');
	
				(0, _lodash.forEach)(filteredApps, function (value) {
					appData.push(value.app_id);
				});
	
				return appData;
			},
			getRegions: function getRegions(parentId) {
				this.loadingRegionData = true;
	
				var _this = this;
				var businessId = this.activeBusinessId;
	
				return _Region2.default.getRegions(businessId, parentId).then(function (response) {
					if (parentId) {
						(function () {
							var i = 0;
							var runningRegion = {};
							while (i < _this.regionPath.length) {
								if (i > 0) {
									runningRegion.children.forEach(function (region) {
										if (region.id === _this.regionPath[i].id) {
											if (region.id === parentId) {
												region.children = response.payload.regions;
												_this.regionPath.splice(i, 1, region);
											} else {
												runningRegion = region;
											}
										}
									});
								} else {
									_this.regions.forEach(function (region) {
										if (region.id === _this.regionPath[i].id) {
											if (region.id === parentId) {
												region.children = response.payload.regions;
												_this.regionPath.splice(i, 1, region);
											} else {
												runningRegion = region;
											}
										}
									});
								}
								i += 1;
							}
						})();
					} else {
						_this.regions = response.payload.regions;
					}
					setTimeout(function () {
						_this.loadingRegionData = false;
					}, 100);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_region':
								break;
	
							case 'regions_not_found':
								if (!parentId) {
									_this.noRegions = true;
								}
								break;
	
							case 'parent_region_not_found':
								break;
	
							default:
						}
					}
					setTimeout(function () {
						_this.loadingRegionData = false;
					}, 100);
				}));
			},
			selectRegion: function selectRegion(region) {
				if (region.has_children) {
					this.drillDown(region);
				} else {
					this.newLocation.region = region;
				}
			},
			drillDown: function drillDown(region) {
				this.regionPath.push(region);
				this.getRegions(region.id);
			},
			goUpOneLevel: function goUpOneLevel() {
				this.regionPath.pop();
			},
			createLocation: function createLocation(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.newLocation.apps = this.formatAppData();
	
				return _this.validateFormData('step_5').then(function (response) {
					_this.clearError();
	
					if (!_this.newLocation.unoapp_defined_name) {
						_this.newLocation.unoapp_defined_name = _this.newLocation.location_name;
					}
	
					_Location2.default.createLocation(_this.activeBusinessId, _this.newLocation).then(function (response) {
						_this.clearForm();
						_this.process = 'next_actions';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A location with this name already exists. Please choose a different name.';
									_this.process = 'step_1';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			selectedLocationUpdated: function selectedLocationUpdated(val) {
				this.newLocation.selected_location = val;
			},
			locationLatLngUpdated: function locationLatLngUpdated(val) {
				this.newLocation.selected_location.coordinates = val;
			},
			clearForm: function clearForm() {
				this.newLocation = {
					location_name: '',
					unoapp_defined_name: '',
					store_number: '',
					salesforce_id: '',
					region: {},
					selected_location: {}
				};
				this.regionPath = [];
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			resetProcess: function resetProcess() {
				this.process = 'step_1';
	
				(0, _lodash.forEach)(this.apps, function (value) {
					value.location_access = false;
				});
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			}
		},
		components: {
			GoogleMapsPinConfirmation: _GoogleMapsPinConfirmation2.default,
			GooglePlacesSearch: _GooglePlacesSearch2.default,
			LoadingScreen: _LoadingScreen2.default,
			NextActions: _NextActions2.default,
			StepCounter: _StepCounter2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Locations - Create Location') {
					this.activePanel = true;
					this.process = 'step_1';
					this.getAppList();
					this.getRegions();
					this.clearForm();
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _GoogleMapsPinConfirmation = __webpack_require__(132);
	
	var _GoogleMapsPinConfirmation2 = _interopRequireDefault(_GoogleMapsPinConfirmation);
	
	var _GooglePlacesSearch = __webpack_require__(133);
	
	var _GooglePlacesSearch2 = _interopRequireDefault(_GooglePlacesSearch);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _lodash = __webpack_require__(7);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-location-address',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				editingLocation: {},
				confirmationMessage: 'Click <b class="font-green-sharp">&#39;Continue&#39;</b> to confirm that this is your location.',
				locationId: 0,
				steps: [{ key: 'step_1', name: 'Google Location' }, { key: 'step_2', name: 'Verify Location' }]
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Locations - Edit Location Address') {
				this.activePanel = true;
				if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
					this.locationId = this.$route.params.location_id;
					this.getLocation();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			getLocation: function getLocation() {
				var _this = this;
	
				_Location2.default.getLocation(_this.locationId).then(function (response) {
					_this.editingLocation = response.payload;
				}).catch(function (reason) {
					if (reason.responseJSON) {
						switch (reason.responseJSON.declaration) {
							case 'location_not_found':
								_this.closePanel();
								break;
	
							default:
						}
					}
				});
			},
			selectedLocationUpdated: function selectedLocationUpdated(val) {
				this.editingLocation.selected_location = val;
			},
			locationLatLngUpdated: function locationLatLngUpdated(val) {
				this.editingLocation.selected_location.coordinates = val;
			},
			modifyLocation: function modifyLocation(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				_this.clearError();
				return _Location2.default.modifyLocation(_this.editingLocation).then(function (response) {
					_this.closePanel();
					disabledButton.complete();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'already_exists':
								_this.errorMessage = 'A location with this name already exists. Please choose a different name.';
								break;
	
							default:
						}
					}
					disabledButton.cancel();
				}));
			},
			clearForm: function clearForm() {
				this.editingLocation = {};
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			closePanel: function closePanel() {
				this.$router.push('/app/my_business/locations');
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				if (this.process !== 'step_1') {
					if ((0, _jquery2.default)(document).find('.pac-container').length) {
						(0, _jquery2.default)(document).find('.pac-container').remove();
					}
				}
	
				return;
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (!_this.editingLocation.selected_location || !_this.editingLocation.selected_location.id) {
								reject('You must select a location before continuing.');
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			}
		},
		components: {
			GoogleMapsPinConfirmation: _GoogleMapsPinConfirmation2.default,
			GooglePlacesSearch: _GooglePlacesSearch2.default,
			StepCounter: _StepCounter2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Locations - Edit Location Address') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
						this.locationId = this.$route.params.location_id;
						this.getLocation();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-location-details',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				editingLocation: {
					location_name: '',
					store_number: '',
					salesforce_id: ''
				},
				locationId: 0
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Locations - Edit Location Details') {
				this.activePanel = true;
				if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
					this.locationId = this.$route.params.location_id;
					this.getLocation();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateLocationData: function validateLocationData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (_this.editingLocation.location_name.length < 3) {
						reject('Location name must be at least 3 characters');
					}
					resolve();
				});
			},
			getLocation: function getLocation() {
				var _this = this;
	
				_Location2.default.getLocation(_this.locationId).then(function (response) {
					_this.editingLocation = response.payload;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'location_not_found':
								_this.closePanel();
								break;
	
							default:
						}
					}
				}));
			},
			modifyLocation: function modifyLocation(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateLocationData().then(function (response) {
					_this.clearError();
					_Location2.default.modifyLocation(_this.editingLocation).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A location with this name already exists. Please choose a different name.';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.editingLocation = {
					location_name: '',
					store_number: '',
					salesforce_id: ''
				};
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			closePanel: function closePanel() {
				this.$router.push('/app/my_business/locations');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Locations - Edit Location Details') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
						this.locationId = this.$route.params.location_id;
						this.getLocation();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(7);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Location = __webpack_require__(26);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'location-app-access',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				locationId: 0,
				apps: []
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Locations - Location App Access') {
				this.activePanel = true;
				if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
					this.locationId = this.$route.params.location_id;
					this.getAppList();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateLocationData: function validateLocationData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					var locationAppsSelected = _this.apps.filter(function (app) {
						return app.location_access;
					}).length >= 1;
	
					if (!locationAppsSelected) {
						return _this.$swal({
							title: 'Are you sure?',
							html: 'Do you want to remove all app access from this location?',
							type: 'warning',
							showCancelButton: true,
							confirmButtonText: 'Update Location',
							confirmButtonColor: '#d9534f',
							cancelButtonText: 'Cancel',
							allowOutsideClick: false,
							allowEscapeKey: false,
							allowEnterKey: false,
							showLoaderOnConfirm: true
						}).then(function () {
							resolve();
						}, function (dismiss) {
							reject();
						});
					} else {
						resolve();
					}
				});
			},
			getLocationDetails: function getLocationDetails() {
				var _this = this;
	
				_Location2.default.getLocationDetails(_this.locationId).then(function (response) {
					_this.editingLocation = response.payload;
	
					_this.apps.forEach(function (app, i) {
						_this.editingLocation.apps.forEach(function (locApp) {
							if (app.app_id === locApp.app_id) {
								app.location_access = true;
								_this.$set(_this.apps, i, app);
							}
						});
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'location_not_found':
								_this.closePanel();
								break;
	
							default:
						}
					}
				}));
			},
			getAppList: function getAppList() {
				var _this = this;
	
				return _Business2.default.getBusinessDetails(_this.activeBusinessId).then(function (response) {
					var defaultApps = { location_access: false };
					_this.apps = response.payload.apps;
	
					_this.apps.forEach(function (apps, index, allApps) {
						allApps[index] = (0, _assign2.default)({}, apps, defaultApps);
					});
	
					_this.getLocationDetails();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			formatAppData: function formatAppData() {
				var appData = [];
	
				var filteredApps = (0, _lodash.filter)(this.apps, 'location_access');
	
				(0, _lodash.forEach)(filteredApps, function (value) {
					appData.push(value.app_id);
				});
	
				return appData;
			},
			modifyLocation: function modifyLocation(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.editingLocation.apps = this.formatAppData();
	
				return _this.validateLocationData().then(function (response) {
					_this.clearError();
					_Location2.default.modifyLocation(_this.editingLocation).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A location with this name already exists. Please choose a different name.';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.editingLocation = {
					apps: []
				};
			},
			closePanel: function closePanel() {
				this.$router.push('/app/my_business/locations');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Locations - Location App Access') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
					if (this.$route.params.location_id && this.$route.params.location_id !== 'undefined' && parseInt(this.$route.params.location_id) !== 0) {
						this.locationId = this.$route.params.location_id;
						this.getAppList();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _lodash = __webpack_require__(7);
	
	var _Region = __webpack_require__(48);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _CreateRegion = __webpack_require__(372);
	
	var _CreateRegion2 = _interopRequireDefault(_CreateRegion);
	
	var _ManageLocations = __webpack_require__(373);
	
	var _ManageLocations2 = _interopRequireDefault(_ManageLocations);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Business', link: false }, { name: 'Regions', link: false }],
				activePanel: true,
				computedHeight: 0,
				regions: [],
				currentRegion: {},
				regionPath: [],
				noRegions: false,
				loadingRegionData: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createRegion();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== 'My Business Regions') {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
	
			setTimeout(function () {
				_this2.getRegions();
			}, 100);
		},
	
		computed: (0, _extends3.default)({
			computedRegions: function computedRegions() {
				if (!this.regionPath.length) {
					return this.regions;
				} else {
					return this.regionPath[this.regionPath.length - 1].children;
				}
			}
		}, (0, _vuex.mapGetters)(['activeBusinessId'])),
		methods: {
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/my_business/regions');
			},
			createRegion: function createRegion(parentId) {
				if (parentId) {
					this.$router.parent_id = parentId;
					this.$router.push('/app/my_business/regions/create_region');
				}
			},
			manageLocations: function manageLocations(parentId) {
				this.$router.push('/app/my_business/regions/manage_locations/' + parentId);
			},
			getRegions: function getRegions(parentId) {
				this.loadingRegionData = true;
	
				var _this = this;
				var businessId = this.activeBusinessId;
	
				return _Region2.default.getRegions(businessId, parentId).then(function (response) {
					if (parentId) {
						(function () {
							var i = 0;
							var runningRegion = {};
							while (i < _this.regionPath.length) {
								if (i > 0) {
									runningRegion.children.forEach(function (region) {
										if (region.id === _this.regionPath[i].id) {
											if (region.id === parentId) {
												region.children = response.payload.regions;
												_this.regionPath.splice(i, 1, region);
											} else {
												runningRegion = region;
											}
										}
									});
								} else {
									_this.regions.forEach(function (region) {
										if (region.id === _this.regionPath[i].id) {
											if (region.id === parentId) {
												region.children = response.payload.regions;
												_this.regionPath.splice(i, 1, region);
											} else {
												runningRegion = region;
											}
										}
									});
								}
								i += 1;
							}
						})();
					} else {
						_this.regions = response.payload.regions;
					}
					_this.loadingRegionData = false;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_region':
								break;
	
							case 'regions_not_found':
								if (!parentId) {
									_this.noRegions = true;
								}
								break;
	
							case 'parent_region_not_found':
								break;
	
							default:
						}
					}
					_this.loadingRegionData = false;
				}));
			},
			drillDown: function drillDown(region) {
				if (region.has_children) {
					this.regionPath.push(region);
					this.getRegions(region.id);
				}
			},
			goUpOneLevel: function goUpOneLevel() {
				this.regionPath.pop();
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			CreateRegion: _CreateRegion2.default,
			ManageLocations: _ManageLocations2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== 'My Business Regions') {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getRegions(this.regionPath[this.regionPath.length - 1].id);
				}
			}
		}
	};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Region = __webpack_require__(48);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-region',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				newRegion: {
					region_name: ''
				},
				createRegionNextActions: [{ title: 'Return to Regions Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }]
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Regions - Create Region') {
				this.activePanel = true;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/my_business/regions');
			},
			validateFormData: function validateFormData() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (_this.newRegion.region_name.length < 3) {
						reject('Region name must be as least 3 characters');
					}
					resolve();
				});
			},
			createRegion: function createRegion(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
				var businessId = this.activeBusinessId;
				return _this.validateFormData().then(function (response) {
					_this.clearError();
					var parentId = void 0;
					if (_this.$router.parent_id) {
						parentId = _this.$router.parent_id;
					}
					_Region2.default.createRegion(businessId, _this.newRegion.region_name, parentId).then(function (response) {
						_this.clearForm();
						_this.process = 'next_actions';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						console.log(e);
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.newRegion = {
					region_name: ''
				};
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			}
		},
		components: {
			NextActions: _NextActions2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Regions - Create Region') {
					this.activePanel = true;
					this.process = 'step_1';
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Region = __webpack_require__(48);
	
	var _Region2 = _interopRequireDefault(_Region);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'manage-locations',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				editingRegion: {
					locations: []
				},
				regionId: 0
			};
		},
		created: function created() {
			if (this.$route.name === 'My Business Regions - Manage Locations') {
				this.activePanel = true;
	
				if (this.$route.params.region_id && this.$route.params.region_id !== 'undefined' && parseInt(this.$route.params.region_id) !== 0) {
					this.regionId = this.$route.params.region_id;
					this.getRegionLocations();
				} else {
					this.closePanel();
				}
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId']),
		methods: {
			getRegionLocations: function getRegionLocations() {
				var _this = this;
				return _Region2.default.getRegionLocations(this.activeBusinessId, this.regionId).then(function (response) {
					_this.editingRegion.locations = response.payload.locations;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							default:
						}
					}
				}));
			},
			closePanel: function closePanel() {
				this.$router.push('app/my_business/regions');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'My Business Regions - Manage Locations') {
					this.activePanel = true;
					this.process = 'step_1';
					if (this.$route.params.region_id && this.$route.params.region_id !== 'undefined' && parseInt(this.$route.params.region_id) !== 0) {
						this.regionId = this.$route.params.region_id;
						this.getRegionLocations();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Roles = __webpack_require__(86);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Business', link: false }, { name: 'Roles', link: false }]
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId']),
		components: {
			Roles: _Roles2.default
		}
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Users = __webpack_require__(87);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Business', link: false }, { name: 'Users', link: false }]
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId']),
		components: {
			Users: _Users2.default
		}
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Roles = __webpack_require__(86);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Location', link: false }, { name: 'Roles', link: false }]
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId']),
		components: {
			Roles: _Roles2.default
		}
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Users = __webpack_require__(87);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'My Location', link: false }, { name: 'Users', link: false }]
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId']),
		components: {
			Users: _Users2.default
		}
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _lodash = __webpack_require__(7);
	
	var _CreateFolder = __webpack_require__(379);
	
	var _CreateFolder2 = _interopRequireDefault(_CreateFolder);
	
	var _ManageFolder = __webpack_require__(380);
	
	var _ManageFolder2 = _interopRequireDefault(_ManageFolder);
	
	var _ManageResource = __webpack_require__(381);
	
	var _ManageResource2 = _interopRequireDefault(_ManageResource);
	
	var _ResourceFolder = __webpack_require__(131);
	
	var _ResourceFolder2 = _interopRequireDefault(_ResourceFolder);
	
	var _FileUpload = __webpack_require__(130);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'Resources', link: false }],
				activePanel: true,
				filterCollapse: true,
				computedHeight: 0,
				folders: {},
				currentResources: [],
				activeFolder: {},
				showZoomModal: false,
				activeResource: {},
				numPages: 0,
				totalResults: 0,
				activePage: 1,
				loadingResourceData: false,
				isSaving: false,
				searchError: '',
				tags: [],
				fileTypes: [{ name: 'image', icon: 'fa fa-file-image-o', active: false }, { name: 'video', icon: 'fa fa-file-video-o', active: false }, { name: 'documents', icon: 'fa fa-file-text-o', active: false }, { name: 'other', icon: 'fa fa-file-o', active: false }],
				advancedSearch: {
					search: '',
					range: 'this_folder',
					searchOptions: [{ name: 'All Folders', value: 'all_folders' }, { name: 'This Folder', value: 'this_folder' }]
				},
				sortBy: {
					field: 'name',
					order: 'asc'
				},
				sortOptions: {
					name: 'Name',
					size: 'Size',
					created_at: 'Date Added'
				},
				allFoldersView: false,
				folderRefresh: {},
				folderUpdateRefresh: {}
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function (folder) {
				_this2.createFolder(folder);
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== 'Resources') {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
				_this.calculateImageHeight();
			}, 200));
	
			this.getFolders();
			this.getTags();
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeBusinessName', 'activeLocationId', 'activeLocationName']),
		methods: {
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/resources');
			},
			toggleFilterPanel: function toggleFilterPanel() {
				this.filterCollapse = !this.filterCollapse;
			},
			createFolder: function createFolder(folder) {
				this.folderRefresh = folder;
				this.$router.push('/app/resources/create_folder/' + folder.id);
			},
			manageFolder: function manageFolder(folder) {
				this.folderUpdateRefresh = folder;
				this.$router.push('/app/resources/manage_folder/' + folder.id);
			},
			manageResource: function manageResource(resource) {
				this.$router.push('/app/resources/manage_resource/' + resource.id);
			},
			getFolders: function getFolders(parentId, folder) {
				var _this = this;
				var businessId = this.activeBusinessId;
				var pageNumber = 1;
				var recordsPerPage = 100;
				if (!parentId) {
					parentId = 0;
				}
				var locationId = this.activeLocationId;
	
				return _Resources2.default.getFolders(businessId, locationId, parentId, pageNumber, recordsPerPage).then(function (response) {
					if (parentId === 0) {
						_this.folders = (0, _assign2.default)({}, _this.folders, response.payload.folders[0]);
						_this.$set(_this.folders, 'expanded', false);
						_this.$set(_this.folders, 'children_fetched', false);
					} else {
						_this.$set(folder, 'children_fetched', true);
						_this.$set(folder, 'children', response.payload.folders);
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'folder_not_found':
								_this.$set(folder, 'children_fetched', true);
								_this.$set(folder, 'children', []);
								break;
	
							case 'business_not_found':
								break;
	
							case 'invalid_page_number':
								break;
	
							default:
						}
					}
				}));
			},
			getTags: function getTags() {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var pageNumber = 1;
				var recordsPerPage = 100;
	
				return _Resources2.default.getTags(businessId, locationId, pageNumber, recordsPerPage).then(function (response) {
					_this.tags = response.payload.tags.map(function (tag) {
						tag.active = false;
						return tag;
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'tags_not_found':
								_this.tags = [];
								break;
							default:
						}
					}
				}));
			},
			expandNode: function expandNode(folder) {
				if (folder.expanded) {
					this.$set(folder, 'expanded', false);
				} else {
					this.$set(folder, 'expanded', true);
	
					this.getFolders(folder.id, folder);
				}
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {};
	
				if (this.advancedSearch.search.length > 2) {
					searchCriteria.search_query = this.advancedSearch.search;
					searchCriteria.search_in = 'name';
				}
	
				searchCriteria.tags = [];
				this.tags.forEach(function (tag) {
					if (tag.active) {
						searchCriteria.tags.push(tag.id);
					}
				});
	
				return searchCriteria;
			},
			preloadImages: function preloadImages() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (!_this.currentResources.length) {
						resolve();
					}
	
					_this.currentResources.forEach(function (resource) {
						var img = new Image();
						img.src = resource.url;
					});
	
					resolve();
				});
			},
			getResources: function getResources(folder, pageNumber) {
				var _this3 = this;
	
				this.loadingResourceData = true;
				this.currentResources = [];
	
				var _this = this;
				var businessId = this.activeBusinessId;
				var recordsPerPage = 27;
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
				var locationId = this.activeLocationId;
	
				if (!pageNumber) {
					pageNumber = this.activePage;
				}
	
				var folderId = folder.id;
				if (this.advancedSearch.range === 'all_folders') {
					folderId = null;
					this.allFoldersView = true;
					this.activeFolder = (0, _assign2.default)({});
				} else {
					this.allFoldersView = false;
					this.activeFolder = (0, _assign2.default)({}, folder);
				}
	
				console.log('getResources', businessId, locationId, folderId, pageNumber, recordsPerPage, searchCriteria, sortCriteria);
				return _Resources2.default.getResources(businessId, locationId, folderId, pageNumber, recordsPerPage, searchCriteria, sortCriteria).then(function (response) {
					_this.currentResources = response.payload.files;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
	
					_this.preloadImages().then(function (response) {
						setTimeout(function () {
							_this.loadingResourceData = false;
							setTimeout(function () {
								_this.calculateImageHeight();
							}, 0);
						}, 500);
					}).catch(function (error) {
						console.log(error);
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'file_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							case 'business_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_page_number':
								_this.numPages = e.responseJSON.payload.number_of_pages;
								_this.totalResults = e.responseJSON.payload.number_of_records;
								if (_this.numPages !== 0) {
									_this.getResources(_this3.activeFolder, e.responseJSON.payload.number_of_pages);
								}
								break;
	
							default:
						}
					}
					_this.loadingResourceData = false;
				}));
			},
			calculateImageHeight: function calculateImageHeight() {
				if (!this.$refs.resource || !this.$refs.resource.length) {
					return;
				}
	
				var height = window.getComputedStyle(this.$refs.resource[0]).width;
	
				this.$refs.resource.forEach(function (ref) {
					ref.style.height = height;
				});
			},
			zoom: function zoom(resource) {
				this.showZoomModal = true;
				this.activeResource = (0, _assign2.default)({}, resource);
			},
			checkSaving: function checkSaving(val) {
				this.isSaving = val;
			},
			imageUploaded: function imageUploaded(val) {
				this.manageResource({ id: val });
				this.getResources(this.activeFolder, this.activePage);
			},
			toggleTag: function toggleTag(tag) {
				tag.active = !tag.active;
			},
			toggleFileType: function toggleFileType(type) {
				type.active = !type.active;
			},
			activePageUpdate: function activePageUpdate(val, folder, override) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					if (folder) {
						this.getResources(folder, this.activePage);
					} else {
						this.getResources(this.activeFolder, this.activePage);
					}
				} else if (override) {
					if (folder) {
						this.getResources(folder, this.activePage);
					} else {
						this.getResources(this.activeFolder, this.activePage);
					}
				}
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			},
			resetResourceSearch: function resetResourceSearch() {
				this.advancedSearch = {
					search: '',
					range: 'this_folder',
					searchOptions: [{ name: 'All Folders', value: 'all_folders' }, { name: 'This Folder', value: 'this_folder' }]
				};
	
				this.tags.forEach(function (tag) {
					tag.active = false;
				});
				this.fileTypes.forEach(function (type) {
					type.active = false;
				});
	
				this.clearSearchError();
			},
			advancedResourceSearch: function advancedResourceSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			findFolderInTree: function findFolderInTree(folder, folderId) {
				if (folder.id === folderId) {
					return folder;
				} else if (folder.children && folder.children.length) {
					var result = null;
					for (var i = 0, x = folder.children.length; result === null && i < x; i++) {
						result = this.findFolderInTree(folder.children[i], folderId);
					}
	
					return result;
				}
				return null;
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			Modal: _Modal2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			CreateFolder: _CreateFolder2.default,
			ManageFolder: _ManageFolder2.default,
			ManageResource: _ManageResource2.default,
			ResourceFolder: _ResourceFolder2.default,
			FileUpload: _FileUpload2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== 'Resources') {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					if (!this.folders.id) {
						this.getFolders();
					} else {
						if (this.folderRefresh.id) {
							this.getFolders(this.folderRefresh.id, this.folderRefresh);
							this.folderRefresh = (0, _assign2.default)({});
						} else if (this.folderUpdateRefresh.id) {
							var localFolder = this.findFolderInTree(this.folders, this.folderUpdateRefresh.parent_id);
							this.getFolders(this.folderUpdateRefresh.parent_id, localFolder);
							this.folderUpdateRefresh = (0, _assign2.default)({});
						}
					}
				}
			},
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			}
		}
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-folder',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				newFolder: {
					name: '',
					is_shared: false
				},
				parentFolderId: 0
			};
		},
		created: function created() {
			if (this.$route.name === 'Resources - Create Folder') {
				this.activePanel = true;
				if (this.$route.params.folder_id && this.$route.params.folder_id !== 'undefined' && parseInt(this.$route.params.folder_id) !== 0) {
					this.parentFolderId = this.$route.params.folder_id;
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateFormData: function validateFormData() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (!_this.newFolder.name.length) {
						reject('Folder name cannot be blank.');
					}
	
					resolve();
				});
			},
			createFolder: function createFolder(event) {
				var _this2 = this;
	
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData().then(function (response) {
					_this.clearError();
					var businessId = _this2.activeBusinessId;
					var locationId = _this2.activeLocationId;
	
					_Resources2.default.createFolder(businessId, locationId, _this.newFolder, _this.parentFolderId).then(function (response) {
						_this.closePanel();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.newFolder = {
					name: '',
					is_shared: false
				};
			},
			closePanel: function closePanel() {
				this.$router.push('/app/resources');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'Resources - Create Folder') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.folder_id && this.$route.params.folder_id !== 'undefined' && parseInt(this.$route.params.folder_id) !== 0) {
						this.parentFolderId = this.$route.params.folder_id;
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _from = __webpack_require__(50);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATUS_INITIAL = 0;
	var STATUS_SAVING = 1;
	var STATUS_SUCCESS = 2;
	var STATUS_FAILED = 3;
	
	exports.default = {
		name: 'file-upload',
		props: {
			folderId: {
				default: 0
			}
		},
		data: function data() {
			return {
				uploadedFiles: [],
				uploadError: null,
				currentStatus: null,
				uploadFieldName: 'file'
			};
		},
		created: function created() {
			this.reset();
		},
	
		computed: (0, _extends3.default)({
			isInitial: function isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving: function isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess: function isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed: function isFailed() {
				return this.currentStatus === STATUS_FAILED;
			}
		}, (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId'])),
		methods: {
			reset: function reset() {
				this.currentStatus = STATUS_INITIAL;
				this.uploadedFiles = [];
				this.uploadError = null;
			},
			filesChange: function filesChange(fieldName, fileList) {
				var formData = new FormData();
	
				if (!fileList.length) return;
	
				(0, _from2.default)(Array(fileList.length).keys()).map(function (x) {
					formData.append(fieldName, fileList[x], fileList[x].name);
				});
	
				this.upload(formData);
			},
			upload: function upload(form) {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				this.currentStatus = STATUS_SAVING;
				this.$emit('savingUpdate', true);
	
				return _Resources2.default.upload(businessId, locationId, _this.folderId, form).then(function (response) {
					setTimeout(function () {
						_this.currentStatus = STATUS_INITIAL;
						_this.$emit('savingUpdate', false);
						_this.$emit('success', response.payload.file_id);
					}, 200);
				}).catch(_this.$root.errorWrapper(function (e) {
					setTimeout(function () {
						_this.currentStatus = STATUS_INITIAL;
						_this.$emit('savingUpdate', false);
					}, 200);
				}));
			}
		},
		components: {
			LoadingScreen: _LoadingScreen2.default
		}
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'manage-folder',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				editingFolder: {
					name: '',
					is_shared: false
				},
				folderId: 0,
				rootFolder: false
			};
		},
		created: function created() {
			if (this.$route.name === 'Resources - Manage Folder') {
				this.activePanel = true;
				if (this.$route.params.folder_id && this.$route.params.folder_id !== 'undefined' && parseInt(this.$route.params.folder_id) !== 0) {
					this.folderId = this.$route.params.folder_id;
					this.getFolder();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeBusinessName', 'activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/resources');
			},
			getFolder: function getFolder() {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
	
				return _Resources2.default.getFolder(businessId, locationId, _this.folderId).then(function (response) {
					_this.editingFolder = (0, _assign2.default)({}, response.payload);
	
					if (_this.editingFolder.name === 'root') {
						_this.rootFolder = true;
						_this.editingFolder.name = _this.activeBusinessName + ' Resources';
					} else {
						_this.rootFolder = false;
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							default:
						}
					}
				}));
			},
			validateFormData: function validateFormData() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (!_this.editingFolder.name.length) {
						reject('Folder name cannot be blank.');
					}
	
					resolve();
				});
			},
			updateFolder: function updateFolder(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
	
				return _this.validateFormData().then(function (response) {
					_this.clearError();
					var folderName = _this.rootFolder ? 'root' : _this.editingFolder.name;
					_Resources2.default.updateFolder(businessId, locationId, _this.editingFolder.id, folderName, _this.editingFolder.is_shared).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								default:
							}
						}
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'Resources - Manage Folder') {
					this.activePanel = true;
					this.clearError();
	
					if (this.$route.params.folder_id && this.$route.params.folder_id !== 'undefined' && parseInt(this.$route.params.folder_id) !== 0) {
						this.folderId = this.$route.params.folder_id;
						this.getFolder();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'manage-resource',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				editingResource: {
					user_defined_name: ''
				},
				resourceId: 0,
				tags: []
			};
		},
		created: function created() {
			if (this.$route.name === 'Resources - Manage Resource') {
				this.activePanel = true;
				if (this.$route.params.resource_id && this.$route.params.resource_id !== 'undefined' && parseInt(this.$route.params.resource_id) !== 0) {
					this.resourceId = this.$route.params.resource_id;
					this.getResource();
					this.getTags();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/resources');
			},
			getResource: function getResource() {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
	
				return _Resources2.default.getResource(businessId, locationId, _this.resourceId).then(function (response) {
					_this.editingResource = (0, _assign2.default)({}, response.payload.file);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							default:
						}
					}
				}));
			},
			getTags: function getTags() {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var pageNumber = 1;
				var recordsPerPage = 100;
	
				return _Resources2.default.getTags(businessId, locationId, pageNumber, recordsPerPage).then(function (response) {
					_this.tags = response.payload.tags.map(function (tag) {
						tag.active = false;
						return tag;
					});
	
					_this.tags.forEach(function (tag) {
						_this.editingResource.tags.forEach(function (selectedTag) {
							if (selectedTag.id === tag.id) {
								tag.active = true;
							}
						});
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'tags_not_found':
								_this.tags = [];
								break;
							default:
						}
					}
				}));
			},
			toggleTag: function toggleTag(tag) {
				tag.active = !tag.active;
			},
			validateFormData: function validateFormData() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (!_this.editingResource.user_defined_name.length) {
						reject('Resource name cannot be blank.');
					}
	
					resolve();
				});
			},
			formatTags: function formatTags() {
				var tags = [];
	
				this.tags.forEach(function (tag) {
					if (tag.active) {
						tags.push(tag.id);
					}
				});
	
				return tags;
			},
			updateResource: function updateResource(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
	
				return _this.validateFormData().then(function (response) {
					_this.clearError();
					_Resources2.default.updateResource(businessId, locationId, _this.editingResource.id, _this.editingResource.user_defined_name).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								default:
							}
						}
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'Resources - Manage Resource') {
					this.activePanel = true;
					this.clearError();
	
					if (this.$route.params.resource_id && this.$route.params.resource_id !== 'undefined' && parseInt(this.$route.params.resource_id) !== 0) {
						this.resourceId = this.$route.params.resource_id;
						this.getResource();
						this.getTags();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuex = __webpack_require__(3);
	
	exports.default = {
		name: 'resource-folder',
		data: function data() {
			return {};
		},
	
		props: {
			folder: {
				type: Object,
				required: true,
				default: function _default() {
					return {};
				}
			},
			last: {
				type: Boolean,
				required: true,
				default: false
			},
			activeFolder: {
				type: Number,
				required: false,
				default: 0
			},
			selectOnly: {
				type: Boolean,
				default: false
			}
		},
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			expandNode: function expandNode(passedFolder) {
				if (passedFolder) {
					this.$emit('expandNode', passedFolder);
				} else {
					this.$emit('expandNode', this.folder);
				}
			},
			createFolder: function createFolder(passedFolder) {
				if (passedFolder) {
					this.$emit('createFolder', passedFolder);
				} else {
					this.$emit('createFolder', this.folder);
				}
			},
			manageFolder: function manageFolder(passedFolder) {
				if (passedFolder) {
					this.$emit('manageFolder', passedFolder);
				} else {
					this.$emit('manageFolder', this.folder);
				}
			},
			getResources: function getResources(pageNumber, passedFolder) {
				if (passedFolder) {
					this.$emit('getResources', pageNumber, passedFolder, true);
				} else {
					this.$emit('getResources', pageNumber, this.folder, true);
				}
			}
		}
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _NoResults = __webpack_require__(47);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Typeahead = __webpack_require__(61);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	var _lodash = __webpack_require__(7);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _CreateRole = __webpack_require__(382);
	
	var _CreateRole2 = _interopRequireDefault(_CreateRole);
	
	var _EditRoleName = __webpack_require__(383);
	
	var _EditRoleName2 = _interopRequireDefault(_EditRoleName);
	
	var _EditRolePermissions = __webpack_require__(384);
	
	var _EditRolePermissions2 = _interopRequireDefault(_EditRolePermissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'roles',
		props: {
			breadcrumbs: {
				type: Array,
				required: true,
				default: function _default() {
					return [];
				}
			},
			note: {
				type: String,
				default: ''
			},
			businessId: {
				type: Number,
				required: true
			},
			locationId: {
				type: Number,
				required: false
			},
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				activePanel: true,
				computedHeight: 0,
				roles: [],
				apps: [],
				appFocused: false,
				searchCollapse: true,
				loadingRoleData: false,
				advancedSearch: {
					search: '',
					searchOptions: [{ name: 'Role Name', value: 'role_name', checked: true }],
					app: { app_name: 'Any App' },
					approval_permission: '',
					access_level: ''
				},
				sortBy: {
					field: 'role_name',
					order: 'asc'
				},
				sortOptions: {
					num_accounts: '# of Accounts',
					role_name: 'Role Name'
				},
				searchError: '',
				pageResultsValue: 0,
				numPages: 0,
				totalResults: 0,
				activePage: 1
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createRole();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== this.baseRouteName) {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
		},
	
		computed: {
			computedSearchOptions: function computedSearchOptions() {
				return this.advancedSearch.searchOptions.filter(function (option) {
					return option.checked;
				});
			}
		},
		methods: {
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push(this.baseRoute);
			},
			toggleSearchPanel: function toggleSearchPanel() {
				this.searchCollapse = !this.searchCollapse;
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			updateApp: function updateApp(val) {
				if (val && val.app_name) {
					this.advancedSearch.app = val;
				} else {
					this.advancedSearch.app = { app_name: 'Any App' };
				}
			},
			appFocus: function appFocus() {
				if (!this.appFocused) {
					this.appFocused = true;
					this.getApps();
				}
			},
			advancedRoleSearch: function advancedRoleSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else if (this.advancedSearch.search.length && !this.computedSearchOptions.length) {
					this.searchError = 'In order to use the search field you must select at least one field to search by.';
				} else if (this.advancedSearch.app.app_id && !this.advancedSearch.access_level) {
					this.searchError = 'In order to use the app search field you must choose an access level to search by.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getRoles(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			resetRoleSearch: function resetRoleSearch() {
				this.advancedSearch = {
					search: '',
					searchOptions: [{ name: 'Role Name', value: 'role_name', checked: true }],
					app: { app_name: 'Any App' },
					approval_permission: '',
					access_level: ''
				};
				this.clearSearchError();
			},
			pageResultsUpdate: function pageResultsUpdate(val) {
				if (parseInt(this.pageResultsValue) !== parseInt(val)) {
					this.pageResultsValue = val;
					if (parseInt(this.activePage) === 1) {
						this.getRoles(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			activePageUpdate: function activePageUpdate(val) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					this.getRoles(this.activePage);
				}
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getRoles(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {};
	
				if (this.advancedSearch.app.app_name !== 'Any App') {
					searchCriteria.app_id = this.advancedSearch.app.app_id;
					searchCriteria.access_level = this.advancedSearch.access_level;
				}
	
				if (this.advancedSearch.search.length > 2 && this.computedSearchOptions.length) {
					searchCriteria.search_query = this.advancedSearch.search;
					var searchIn = '';
					for (var key in this.computedSearchOptions) {
						if (parseInt(key) !== 0) {
							searchIn += ',';
						}
						searchIn += this.computedSearchOptions[key].value;
					}
					searchCriteria.search_in = searchIn;
				}
	
				if (parseInt(this.advancedSearch.approval_permission) === 1 || parseInt(this.advancedSearch.approval_permission) === 0) {
					searchCriteria.approval_permission = parseInt(this.advancedSearch.approval_permission);
				}
	
				return searchCriteria;
			},
			getRoles: function getRoles(pageNumber) {
				var _this3 = this;
	
				if (!this.businessId) {
					return;
				}
	
				this.loadingRoleData = true;
				this.roles = [];
	
				var _this = this;
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
				if (!this.locationId) {
					return _Roles2.default.getRolePages(this.businessId, pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(function (response) {
						_this.roles = response.payload.roles;
						_this.numPages = response.payload.number_of_pages;
						_this.totalResults = response.payload.number_of_records;
						_this3.loadingRoleData = false;
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_roles_found':
									_this.numPages = 0;
									_this.totalResults = 0;
									break;
	
								case 'business_not_found':
									_this.numPages = 0;
									_this.totalResults = 0;
									_this.$swal({
										title: 'Error',
										html: 'There is an issue with your business account. Please contact your admin.',
										type: 'warning'
									});
									break;
	
								case 'invalid_business':
									_this.numPages = 0;
									_this.totalResults = 0;
									_this.$swal({
										title: 'Error',
										html: 'There is an issue with your business account. Please contact your admin.',
										type: 'warning'
									});
									break;
	
								case 'invalid_page_number':
									_this.numPages = e.responseJSON.payload.number_of_pages;
									_this.totalResults = e.responseJSON.payload.number_of_records;
									if (_this.numPages !== 0) {
										_this.getRoles(e.responseJSON.payload.number_of_pages);
									}
									break;
								default:
							}
						}
						_this.loadingRoleData = false;
					}));
				} else {
					return _Roles2.default.getLocationRolePages(this.businessId, this.locationId, pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(function (response) {
						_this.roles = response.payload.roles;
						_this.numPages = response.payload.number_of_pages;
						_this.totalResults = response.payload.number_of_records;
						_this3.loadingRoleData = false;
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_roles_found':
									_this.numPages = 0;
									_this.totalResults = 0;
									break;
	
								case 'invalid_page_number':
									_this.numPages = e.responseJSON.payload.number_of_pages;
									_this.totalResults = e.responseJSON.payload.number_of_records;
									if (_this.numPages !== 0) {
										_this.getRoles(e.responseJSON.payload.number_of_pages);
									}
									break;
								default:
							}
						}
						_this.loadingRoleData = false;
					}));
				}
			},
			getApps: function getApps() {
				var _this = this;
	
				return _Business2.default.getBusinessDetails(this.businessId).then(function (response) {
					_this.apps = response.payload.apps;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_business':
								_this.$swal({
									title: 'Error',
									html: 'You do not have access to this business.',
									type: 'warning'
								});
								break;
	
							default:
						}
					}
				}));
			},
			modifyApprovalPermissions: function modifyApprovalPermissions(role, type, bypassConflict) {
				switch (type) {
					case 'remove':
						role.approval_permission = false;
						break;
	
					case 'add':
						role.approval_permission = true;
						break;
	
					default:
						return;
				}
	
				var _this = this;
				_Roles2.default.modifyRole(role, bypassConflict).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: 'Approval permission has been ' + type + (type === 'remove' ? 'd' : 'ed') + ' to the role <b>' + role.role_name + '</b>.',
						type: 'success'
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'already_exists':
								_this.$swal({
									title: 'Error',
									html: 'A role with this name already exists. Please choose a different name.',
									type: 'warning'
								});
	
								switch (type) {
									case 'remove':
										role.approval_permission = true;
										break;
	
									case 'add':
										role.approval_permission = false;
										break;
	
									default:
								}
								break;
	
							case 'role_not_found':
								_this.$swal({
									title: 'Error',
									html: 'The role you are trying to edit could not be found. Please try selecting another role.',
									type: 'warning'
								});
	
								switch (type) {
									case 'remove':
										role.approval_permission = true;
										break;
	
									case 'add':
										role.approval_permission = false;
										break;
	
									default:
								}
								break;
	
							case 'locked_role':
								_this.$swal({
									title: 'Error',
									html: 'The role you are trying to edit is a locked role. You cannot perform this action.',
									type: 'warning'
								});
	
								switch (type) {
									case 'remove':
										role.approval_permission = true;
										break;
	
									case 'add':
										role.approval_permission = false;
										break;
	
									default:
								}
								break;
	
							case 'role_conflict':
								_this.$swal({
									title: 'Are you sure?',
									html: 'There is already a role that has these permissions. Do you still want to modify the approval permission?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonText: 'Continue',
									confirmButtonColor: '#d9534f',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									showLoaderOnConfirm: true
								}).then(function () {
									_this.modifyApprovalPermissions(role, type, true);
								}, function (dismiss) {
									switch (type) {
										case 'remove':
											role.approval_permission = true;
											break;
	
										case 'add':
											role.approval_permission = false;
											break;
	
										default:
									}
								});
								break;
	
							case 'invalid_role':
								_this.$swal({
									title: 'Error',
									html: 'You don\t have access to modify this role. Please try selecting another role.',
									type: 'warning'
								});
	
								switch (type) {
									case 'remove':
										role.approval_permission = true;
										break;
	
									case 'add':
										role.approval_permission = false;
										break;
	
									default:
								}
								break;
	
							case 'invalid_input':
								_this.$swal({
									title: 'Error',
									html: 'There was an error on our end. Please try again.',
									type: 'warning'
								});
	
								switch (type) {
									case 'remove':
										role.approval_permission = true;
										break;
	
									case 'add':
										role.approval_permission = false;
										break;
	
									default:
								}
								break;
	
							default:
						}
					}
				}));
			},
			deleteRoleConfirmation: function deleteRoleConfirmation(type, role) {
				var _this = this;
				var roleName = role.role_name;
				var buttonText = '';
				var messageText = '';
				var successMessage = '';
				var bypassConflict = role.num_accounts > 0;
	
				if (type === 'delete') {
					buttonText = 'Delete Role';
					if (role.num_accounts > 0) {
						messageText = 'All users with this role will be changed to the <b>Staff</b> role. You won\'t be able to reverse this action.';
					} else {
						messageText = 'You won\'t be able to reverse this action.';
					}
					successMessage = '<b>' + roleName + '</b> has been deleted.';
				}
	
				this.$swal({
					title: 'Are you sure?',
					html: messageText,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: buttonText,
					confirmButtonColor: '#d9534f',
					cancelButtonText: 'Cancel',
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return new _promise2.default(function (resolve, reject) {
							_Roles2.default.deleteRole(role.role_id, bypassConflict).then(function () {
								resolve('role_deleted');
							}).catch(_this.$root.errorWrapper(function (e) {
								if (e.responseJSON) {
									switch (e.responseJSON.declaration) {
										case 'role_not_found':
											reject('The role you are trying to remove could not be found.');
											break;
	
										case 'role_in_use':
											break;
	
										case 'locked_role':
											reject('The role you are trying to remove is locked. You cannot remove this role.');
											break;
	
										default:
									}
								}
							}));
						});
					}
				}).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: successMessage,
						type: 'success',
						showCancelButton: true
					}).then(function () {
						_this.getRoles(_this.activePage);
					}, function (dismiss) {
						_this.getRoles(_this.activePage);
					});
				}, function (dismiss) {});
			},
			createRole: function createRole() {
				this.$router.push(this.baseRoute + '/create_role');
			},
			editRoleName: function editRoleName(roleId) {
				this.$router.push(this.baseRoute + '/edit_role_name/' + roleId);
			},
			editRolePermissions: function editRolePermissions(roleId) {
				this.$router.push(this.baseRoute + '/role_permissions/' + roleId);
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			NoResults: _NoResults2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			Typeahead: _Typeahead2.default,
			CreateRole: _CreateRole2.default,
			EditRoleName: _EditRoleName2.default,
			EditRolePermissions: _EditRolePermissions2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== this.baseRouteName) {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getRoles(this.activePage);
				}
			},
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getRoles(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			}
		}
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-role',
		props: {
			businessId: {
				type: Number,
				required: true
			},
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				process: 'form',
				activePanel: false,
				errorMessage: '',
				apps: [],
				newRole: {
					name: '',
					approval_permission: false,
					app_permissions: []
				},
				createRoleNextActions: [{ title: 'Create Another Role', icon_class: 'fa fa-user', click_event: 'resetProcess' }, { title: 'Return to Roles Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }]
			};
		},
		created: function created() {
			if (this.$route.name === this.baseRouteName + ' - Create Role') {
				this.activePanel = true;
				if (!this.apps.length) {
					this.getBusinessDetails();
				} else {
					this.resetApps();
				}
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			resetApps: function resetApps() {
				this.apps.forEach(function (app, index, apps) {
					apps[index].access_level = 'none';
				});
			},
			getBusinessDetails: function getBusinessDetails() {
				var _this = this;
	
				return _Business2.default.getBusinessDetails(this.businessId).then(function (response) {
					_this.apps = response.payload.apps;
	
					_this.apps.forEach(function (app, index, apps) {
						apps[index].access_level = 'none';
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_found':
								break;
	
							default:
						}
					}
				}));
			},
			validateRoleData: function validateRoleData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.newRole.name.length) {
						reject('Role name cannot be blank');
					}
					resolve();
				});
			},
			createRole: function createRole(event, bypassConflict) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.newRole.app_permissions = this.apps;
	
				return _this.validateRoleData().then(function (response) {
					_this.clearError();
					_Roles2.default.createRole(_this.businessId, _this.newRole, bypassConflict).then(function (response) {
						_this.clearForm();
						_this.process = 'next_actions';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A role with this name already exists. Please choose a different name.';
									_this.process = 'form';
									break;
	
								case 'role_conflict':
									_this.$swal({
										title: 'Are you sure?',
										html: 'There is already a role that has these permissions. Do you still want to create this role?',
										type: 'warning',
										showCancelButton: true,
										confirmButtonText: 'Create Role',
										confirmButtonColor: '#d9534f',
										cancelButtonText: 'Cancel',
										allowOutsideClick: false,
										allowEscapeKey: false,
										allowEnterKey: false,
										showLoaderOnConfirm: true
									}).then(function () {
										_this.createRole(false, true);
									}, function (dismiss) {});
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.newRole = {
					name: '',
					approval_permission: false,
					app_permissions: []
				};
				this.resetApps();
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			},
			advanceForm: function advanceForm() {
				this.process = 'form_advanced';
			},
			resetProcess: function resetProcess() {
				this.process = 'form';
			},
			closePanel: function closePanel() {
				this.process = 'form';
				this.$router.push(this.baseRoute);
			},
			redirectToAppAccess: function redirectToAppAccess() {
				this.process = 'form';
				this.$router.push(this.baseRoute + '/app_access');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === this.baseRouteName + ' - Create Role') {
					this.activePanel = true;
					this.process = 'form';
					this.clearError();
					this.clearForm();
					if (!this.apps.length) {
						this.getBusinessDetails();
					} else {
						this.resetApps();
					}
				} else {
					this.activePanel = false;
				}
			}
		},
		components: {
			NextActions: _NextActions2.default
		}
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-role-name',
		props: {
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				editingRole: {
					role_name: ''
				},
				roleId: 0
			};
		},
		created: function created() {
			if (this.$route.name === this.baseRouteName + ' - Edit Role Name') {
				this.activePanel = true;
				if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
					this.roleId = this.$route.params.role_id;
					this.getRole();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateRoleData: function validateRoleData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.editingRole.role_name.length) {
						reject('Role name cannot be blank');
					}
					resolve();
				});
			},
			getRole: function getRole() {
				var _this = this;
	
				_Roles2.default.getRole(_this.roleId).then(function (response) {
					_this.editingRole = response.payload;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'role_not_found':
								_this.closePanel();
								break;
	
							default:
						}
					}
				}));
			},
			modifyRole: function modifyRole(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateRoleData().then(function (response) {
					_this.clearError();
					_Roles2.default.modifyRole(_this.editingRole).then(function (response) {
						_this.closePanel();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'already_exists':
									_this.errorMessage = 'A role with this name already exists. Please choose a different name.';
									break;
	
								case 'role_conflict':
									_this.closePanel();
									break;
	
								case 'role_not_found':
									_this.errorMessage = 'The role you are trying to edit could not be found. Please try selecting another role.';
									break;
	
								case 'locked_role':
									_this.errorMessage = 'The role you are trying to edit is a locked role. You cannot perform this action.';
									break;
	
								case 'invalid_role':
									_this.errorMessage = 'You don\t have access to modify this role. Please try selecting another role.';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.editingRole = {
					role_name: ''
				};
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			closePanel: function closePanel() {
				this.$router.push(this.baseRoute);
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === this.baseRouteName + ' - Edit Role Name') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
						this.roleId = this.$route.params.role_id;
						this.getRole();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _Business = __webpack_require__(18);
	
	var _Business2 = _interopRequireDefault(_Business);
	
	var _lodash = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-role-permissions',
		props: {
			businessId: {
				type: Number,
				required: true
			},
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				apps: [],
				editingRole: {
					app_permission: []
				},
				roleId: 0
			};
		},
		created: function created() {
			if (this.$route.name === this.baseRouteName + ' - Role Permissions') {
				this.activePanel = true;
				if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
					this.roleId = this.$route.params.role_id;
					this.resetApps();
					this.getBusinessDetails();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			resetApps: function resetApps() {
				this.apps.forEach(function (app, index, apps) {
					apps[index].access_level = 'none';
				});
			},
			getBusinessDetails: function getBusinessDetails() {
				var _this2 = this;
	
				var _this = this;
	
				return _Business2.default.getBusinessDetails(this.businessId).then(function (response) {
					_this.apps = response.payload.apps;
	
					_this2.apps.forEach(function (app, index, apps) {
						apps[index].access_level = 'none';
					});
					_this2.getRole();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'business_not_found':
								break;
	
							default:
						}
					}
				}));
			},
			getRole: function getRole() {
				var _this = this;
	
				_Roles2.default.getRole(_this.roleId).then(function (response) {
					_this.editingRole = response.payload;
	
					_this.apps.forEach(function (app, index, apps) {
						var localApp = (0, _lodash.find)(_this.editingRole.app_permissions, ['app_id', apps[index].app_id]);
						if (localApp) {
							apps[index].access_level = localApp.access_level;
						}
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'role_not_found':
								_this.closePanel();
								break;
	
							default:
						}
					}
				}));
			},
			modifyRole: function modifyRole(event, bypassConflict) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				this.clearError();
				_Roles2.default.modifyRole(_this.editingRole, bypassConflict).then(function (response) {
					_this.closePanel();
					disabledButton.complete();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'already_exists':
								_this.closePanel();
								break;
	
							case 'role_conflict':
								_this.$swal({
									title: 'Are you sure?',
									html: 'There is already a role that has these permissions. Do you still want to set these permissions?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonText: 'Continue',
									confirmButtonColor: '#d9534f',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									showLoaderOnConfirm: true
								}).then(function () {
									_this.modifyRole(false, true);
								}, function (dismiss) {});
								break;
	
							case 'role_not_found':
								_this.errorMessage = 'The role you are trying to edit could not be found. Please try selecting another role.';
								break;
	
							case 'locked_role':
								_this.errorMessage = 'The role you are trying to edit is a locked role. You cannot perform this action.';
								break;
	
							case 'invalid_role':
								_this.errorMessage = 'You don\t have access to modify this role. Please try selecting another role.';
								break;
	
							default:
						}
					}
					disabledButton.cancel();
				}));
			},
			clearForm: function clearForm() {
				this.editingRole = {
					app_permissions: []
				};
			},
			closePanel: function closePanel() {
				this.$router.push(this.baseRoute);
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === this.baseRouteName + ' - Role Permissions') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
	
					if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
						this.roleId = this.$route.params.role_id;
						this.resetApps();
						this.getBusinessDetails();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _from = __webpack_require__(50);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Signage = __webpack_require__(62);
	
	var _Signage2 = _interopRequireDefault(_Signage);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				schedule: [],
				startTime: '',
				dateRange: '',
				multipleDays: [],
				days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
				day: '',
				value1: '',
				step: 0,
				note: 'Signage Schedule',
				breadcrumbArray: [{ name: 'UNOapp Signage', link: false }, { name: 'Schedule Manager', link: false }],
				displayCount: 1,
				scheduleHeight: 1080,
				scheduleWidth: 1920,
				visualHeight: 1080,
				visualWidth: 1920,
				regionList: [],
				dragndrop: [],
				selectedRegion: 0,
				scale: 0.5,
				fullscreen: false,
				beforeFullscreen: null,
				grid: 10,
				miniMap: [],
				scheduleList: [],
				type: 0,
				edit: false,
				name: '',
				padding: 60,
				scheduleId: 0,
				displayNumber: 0,
				deleteRegions: [],
				presentationList: [],
				selectedPresentation: 0,
				selectedScheduleId: 0,
				flaggedPresentations: []
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId', 'activeBusinessId']),
		mounted: function mounted() {
			window.addEventListener('keyup', this.keypress);
		},
	
		methods: {
			clear: function clear() {
				this.value1 = '';
				this.multipleDays = [];
				this.startTime = '';
				this.dateRange = '';
				this.flaggedPresentations = [];
			},
			padZero: function padZero(val) {
				var a = void 0;
				if (val < 10) {
					a = '0' + val;
				} else {
					a = val;
				}
				return a;
			},
			timeFormat: function timeFormat(date) {
				var utc = this.padZero(date.getHours()) + ':' + this.padZero(date.getMinutes()) + ':' + this.padZero(date.getSeconds());
				return utc;
			},
			dateFormat: function dateFormat(date) {
				var utc = date.getUTCFullYear() + '-' + this.padZero(date.getUTCMonth()) + '-' + this.padZero(date.getUTCDay()) + ' ' + this.padZero(date.getUTCHours()) + ':' + this.padZero(date.getUTCMinutes()) + ':' + this.padZero(date.getUTCSeconds());
				console.log(utc);
				return utc;
			},
			selectPres: function selectPres(i) {
				this.schedule = [];
				this.selectedPresentation = this.presentationList[i];
				console.log(this.selectedPresentation);
				if (this.edit === true) {
					this.getScheduleEntries(this.selectedScheduleId);
				}
				this.setStep(1);
			},
			getPresentations: function getPresentations() {
				var _this = this;
	
				return _Signage2.default.getPresentations(this.activeLocationId).then(function (response) {
					_this.presentationList = response.payload.presentations;
					console.log(response);
				}).catch(function (e) {});
			},
			setActiveSchedule: function setActiveSchedule(i) {
				this.selectedScheduleId = i;
				this.getScheduleEntries(i);
			},
			addToList: function addToList(val) {
				this.schedule.push(val);
			},
			save: function save() {
				if (!this.edit) {
					this.createSchedule();
				} else {
					this.deleteSchedule(this.selectedScheduleId);
				}
			},
			createSchedule: function createSchedule() {
				var _this2 = this;
	
				var obj = {
					location_id: this.activeLocationId
				};
				return _Signage2.default.createSchedule(obj).then(function (response) {
					_this2.schedule.forEach(function (x) {
						var entryObj = x;
						entryObj.schedule_id = response.payload.schedule_id;
						_this2.createScheduleEntry(entryObj);
					});
				}).then(function (x) {
					_this2.$notify({
						title: 'Schedule saved',
						message: 'Schedule saved successfully',
						type: 'success'
					});
				}).catch(function (e) {});
			},
			getPresentationById: function getPresentationById(id) {
				var _this3 = this;
	
				return _Signage2.default.getPresentations(this.activeLocationId).then(function (response) {
					response.payload.presentations.forEach(function (x, i) {
						if (x.presentation_id === id) {
							_this3.flaggedPresentations.push(i);
						}
					});
				}).catch(function (e) {});
			},
			getScheduleEntries: function getScheduleEntries(id) {
				var _this4 = this;
	
				return _Signage2.default.getScheduleEntries(id).then(function (response) {
					console.log(response);
					_this4.getPresentationById(response.payload.entries[0].presentation_id);
					_this4.schedule = response.payload.entries;
				}).catch(function (e) {});
			},
			createScheduleEntry: function createScheduleEntry(obj) {
				return _Signage2.default.createScheduleEntry(obj).then(function (response) {
					console.log(response);
				}).catch(function (e) {});
			},
			deleteSchedule: function deleteSchedule(id) {
				var _this5 = this;
	
				var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				return _Signage2.default.deleteSchedule(id).then(function (response) {
					console.log(response);
					if (index !== false) {
						_this5.scheduleList.splice(index, 1);
					}
					if (_this5.edit === true) {
						_this5.createSchedule();
					}
				}).catch(function (e) {});
			},
			getSchedules: function getSchedules() {
				var _this6 = this;
	
				return _Signage2.default.getSchedules(this.activeLocationId).then(function (response) {
					console.log(response);
					_this6.scheduleList = response.payload.schedules;
				}).catch(function (e) {});
			},
			selectRegion: function selectRegion(val) {
				this.selectedRegion = val;
				for (var i = 0; i < this.regionList.length - 1; i++) {
					if (this.regionList[i].background === 'transparent') {
						this.regionList.splice(i, 1);
						break;
					}
				}
			},
			onEnd: function onEnd(e) {
				var _this7 = this;
	
				var arr = (0, _from2.default)(e.to.children);
				arr.forEach(function (x, i) {
					_this7.regionList[parseInt(x.id.substr(-1))].z = Math.abs(i - (arr.length - 1));
				});
			},
			keypress: function keypress(e) {},
			toggle: function toggle() {
				this.$refs.fs.toggle();
				this.$fs.toggle(this.$el.querySelector('.schedule-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				});
			},
			fullscreenChange: function fullscreenChange(fullscreen) {
				console.log(fullscreen);
				this.fullscreen = fullscreen;
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.scale);
					this.beforeFullscreen = this.scale;
					this.scale = 1;
					console.log(this.beforeFullscreen);
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.scale = this.beforeFullscreen;
					this.beforeFullscreen = null;
				}
			},
			deleteRegion: function deleteRegion() {
				console.log(this.selectedRegion);
				console.log(this.regionList);
				if (this.selectedRegion !== null) {
					this.deleteZone(this.regionList[this.selectedRegion].zone_id);
					this.regionList[this.selectedRegion].background = 'transparent';
	
					var count = this.regionList.reduce(function (t, x) {
						if (x.background !== 'transparent') {
							t++;
						}
						return t;
					}, 0);
					if (count === 0) {
						this.regionList = [];
					}
					this.selectedRegion = null;
				}
			},
			addNewRegion: function addNewRegion() {
				var _this8 = this;
	
				this.$prompt('Name this Zone', 'Zone', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Email'
				}).then(function (value) {
					_this8.regionList = _this8.regionList.map(function (x) {
						var obj = x;
						x.z++;
						return obj;
					});
					_this8.updateZones();
					var obj = {
						height: 100,
						width: 100,
						x: 0,
						y: 0,
						z: 1,
						background: 'transparent',
						name: value.value
					};
					_this8.createZone(obj);
				}).catch(function () {});
			},
			onResize: function onResize(x, y, width, height, i) {
				this.selectedRegion = i;
				var r = this.regionList[i];
				r.x = x;
				r.y = y;
				r.width = width;
				r.height = height;
			},
			onDrag: function onDrag(x, y, w, h, i, p) {
				this.selectedRegion = i;
				var r = this.regionList[i];
				r.x = x;
				r.y = y;
			},
			setStep: function setStep(val) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
				var i = arguments[2];
	
				if (val === 0) {
					this.edit = false;
				}
				this.step = val;
				this.type = type;
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default
		}
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _from = __webpack_require__(50);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vueDraggableResizable = __webpack_require__(134);
	
	var _vueDraggableResizable2 = _interopRequireDefault(_vueDraggableResizable);
	
	var _vueFullscreen = __webpack_require__(129);
	
	var _vueFullscreen2 = _interopRequireDefault(_vueFullscreen);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuedraggable = __webpack_require__(135);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _Signage = __webpack_require__(62);
	
	var _Signage2 = _interopRequireDefault(_Signage);
	
	var _md = __webpack_require__(123);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueFullscreen2.default, { name: 'fs' });
	exports.default = {
		data: function data() {
			return {
				step: 0,
				note: 'Signage Layout',
				breadcrumbArray: [{ name: 'UNOapp Signage', link: false }, { name: 'Layout', link: false }],
				displayCount: 1,
				layoutHeight: 1080,
				layoutWidth: 1920,
				visualHeight: 1080,
				visualWidth: 1920,
				regionList: [],
				dragndrop: [],
				selectedRegion: 0,
				scale: 0.5,
				fullscreen: false,
				beforeFullscreen: null,
				grid: 10,
				miniMap: [],
				layoutList: [],
				type: 0,
				name: '',
				padding: 60,
				layoutId: 0,
				displayNumber: 0,
				deleteRegions: []
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		mounted: function mounted() {
			window.addEventListener('keyup', this.keypress);
		},
	
		methods: {
			prevDisplay: function prevDisplay() {
				if (this.displayNumber > 0) {
					this.displayNumber--;
					this.getZones();
				}
			},
			nextDisplay: function nextDisplay() {
				if (this.displayNumber < this.displayCount - 1) {
					this.displayNumber++;
					this.getZones();
				}
			},
			setActiveLayout: function setActiveLayout(index) {
				if (this.layoutList[index].width % 1080 === 0) {
					this.layoutWidth = 1080;
					this.layoutHeight = 1920;
					this.padding = -(this.layoutHeight * (1 - this.scale)) + 20;
					this.displayCount = this.layoutList[index].width / 1080;
				} else {
					this.layoutWidth = 1920;
					this.layoutHeight = 1080;
					this.padding = -(this.layoutHeight * (1 - this.scale)) + 20;
					this.displayCount = this.layoutList[index].width / 1920;
				}
				this.layoutId = this.layoutList[index].layout_id;
				this.name = this.layoutList[index].name;
				this.getZones();
			},
			updatePadding: function updatePadding(val) {
				this.padding = -(this.layoutHeight * (1 - val)) + 20;
			},
			updateZones: function updateZones() {
				var _this = this;
	
				var zeroIndex = false;
				this.regionList.forEach(function (x) {
					if (x.z === 0) {
						zeroIndex = true;
					}
				});
				if (zeroIndex) {
					this.regionList = this.regionList.map(function (x) {
						var obj = x;
						x.z++;
						return obj;
					});
				}
				this.regionList.forEach(function (x) {
					if (x.screen === _this.displayNumber) {
						var obj = {
							width: x.width,
							height: x.height,
							z_index: x.z,
							x: x.x + _this.displayNumber * _this.layoutWidth,
							y: x.y,
							label: x.name,
							zone_id: x.zone_id,
							layout_id: _this.layoutId
						};
						return _Signage2.default.updateZones(obj).then(function (response) {
							_this.$notify({
								title: 'Success',
								message: 'Successfully Updated Zone: ' + x.name,
								type: 'success'
							});
						}).catch(function (e) {
							_this.$notify.error({
								title: 'Error',
								message: e
							});
						});
					}
				});
			},
			createZone: function createZone(region) {
				var _this2 = this;
	
				var obj = {
					layout_id: this.layoutId,
					label: region.name,
					width: region.width,
					height: region.height,
					x: region.x + this.layoutWidth * this.displayNumber,
					y: region.y,
					z_index: region.z
				};
				return _Signage2.default.createZone(obj).then(function (response) {
					console.log(response);
					_this2.getZones();
				}).catch(function (e) {
					_this2.$notify.error({
						title: 'Error',
						message: e.responseJSON.payload.label[0]
					});
				});
			},
			deleteZone: function deleteZone(id) {
				return _Signage2.default.deleteZone(id).then(function (response) {
					console.log(response);
				}).catch(function (e) {});
			},
			getZones: function getZones() {
				var _this3 = this;
	
				this.regionList = [];
				return _Signage2.default.getZones(this.layoutId).then(function (response) {
					var temp = response.payload.zones.map(function (x) {
						var obj = {
							width: x.width,
							height: x.height,
							z: x.z_index,
							y: x.y,
							x: x.x - (x.x / _this3.layoutWidth >> 0) * _this3.layoutWidth,
							background: _this3.colorHash(x.label, x.zone_id),
							name: x.label,
							zone_id: x.zone_id,
							screen: x.x / _this3.layoutWidth >> 0
						};
						console.log(obj);
						return obj;
					});
					_this3.regionList = temp.sort(function (a, b) {
						return parseFloat(b.z) - parseFloat(a.z);
					});
				}).catch(function (e) {});
			},
			createLayout: function createLayout() {
				var _this4 = this;
	
				var obj = {
					location_id: this.activeLocationId,
					name: this.name,
					width: this.layoutWidth * this.displayCount,
					height: this.layoutHeight
				};
				return _Signage2.default.createLayout(obj).then(function (response) {
					console.log(response);
					_this4.getLayouts();
					_this4.setStep(2);
				}).catch(function (e) {});
			},
			deleteLayout: function deleteLayout(id, index) {
				var _this5 = this;
	
				return _Signage2.default.deleteLayout(id).then(function (response) {
					console.log(response);
					_this5.layoutList.splice(index, 1);
				}).catch(function (e) {});
			},
			getLayouts: function getLayouts() {
				var _this6 = this;
	
				return _Signage2.default.getLayouts(this.activeLocationId).then(function (response) {
					console.log(response);
					_this6.layoutList = response.payload.layouts;
				}).catch(function (e) {});
			},
			selectRegion: function selectRegion(val) {
				this.selectedRegion = val;
				for (var i = 0; i < this.regionList.length - 1; i++) {
					if (this.regionList[i].background === 'transparent') {
						this.regionList.splice(i, 1);
						break;
					}
				}
			},
			onEnd: function onEnd(e) {
				var _this7 = this;
	
				var arr = (0, _from2.default)(e.to.children);
				arr.forEach(function (x, i) {
					_this7.regionList[parseInt(x.id.substr(-1))].z = Math.abs(i - (arr.length - 1));
				});
			},
			keypress: function keypress(e) {},
			toggle: function toggle() {
				this.$refs.fs.toggle();
				this.$fs.toggle(this.$el.querySelector('.layout-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				});
			},
			fullscreenChange: function fullscreenChange(fullscreen) {
				console.log(fullscreen);
				this.fullscreen = fullscreen;
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.scale);
					this.beforeFullscreen = this.scale;
					this.scale = 1;
					console.log(this.beforeFullscreen);
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.scale = this.beforeFullscreen;
					this.beforeFullscreen = null;
				}
			},
			colorHash: function colorHash(name, id) {
				var str = (0, _md2.default)(id + name);
				console.log(str);
				var bytes = [];
				for (var i = 0; i < str.length; ++i) {
					var code = str.charCodeAt(i);
					bytes = bytes.concat([code]);
				}
				var bytesTotal = bytes.reduce(function (total, x) {
					total += x;
					return total;
				}, 0);
				var val = bytesTotal / bytes.length;
				var normalize = val / 255;
				var normalize2 = normalize * 10 / 9;
				console.log(normalize);
				return '#' + Math.floor(normalize2 * 0x1000000).toString(16).padStart(6, 0);
			},
			test: function test() {
				if (this.selectedRegion !== null) {
					this.selectedRegion = null;
				}
				console.log('test');
			},
			deleteRegion: function deleteRegion() {
				console.log(this.selectedRegion);
				console.log(this.regionList);
				if (this.selectedRegion !== null) {
					this.deleteZone(this.regionList[this.selectedRegion].zone_id);
					this.regionList[this.selectedRegion].background = 'transparent';
	
					var count = this.regionList.reduce(function (t, x) {
						if (x.background !== 'transparent') {
							t++;
						}
						return t;
					}, 0);
					if (count === 0) {
						this.regionList = [];
					}
					this.selectedRegion = null;
				}
			},
			addNewRegion: function addNewRegion() {
				var _this8 = this;
	
				this.$prompt('Name this Zone', 'Zone', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Email'
				}).then(function (value) {
					_this8.regionList = _this8.regionList.map(function (x) {
						var obj = x;
						x.z++;
						return obj;
					});
					_this8.updateZones();
					var obj = {
						height: 100,
						width: 100,
						x: 0,
						y: 0,
						z: 1,
						background: 'transparent',
						name: value.value
					};
					_this8.createZone(obj);
				}).catch(function () {});
			},
			onResize: function onResize(x, y, width, height, i) {
				this.selectedRegion = i;
				var r = this.regionList[i];
				r.x = x;
				r.y = y;
				r.width = width;
				r.height = height;
			},
			onDrag: function onDrag(x, y, w, h, i, p) {
				this.selectedRegion = i;
				var r = this.regionList[i];
				r.x = x;
				r.y = y;
			},
			setStep: function setStep(val) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
				var i = arguments[2];
	
				this.step = val;
				this.type = type;
			},
			setLayoutSize: function setLayoutSize(width, height) {
				this.layoutHeight = height;
				this.layoutWidth = width;
			},
			syncWithVisual: function syncWithVisual() {
				this.layoutWidth = this.visualWidth;
				this.layoutHeight = this.visualHeight;
			},
			getVisualPosition: function getVisualPosition(id) {
				var width = (0, _jquery2.default)(window).innerWidth();
				if (id !== null) {
					return [Math.floor((0, _jquery2.default)(id).position().top / width * 100 * 60), Math.floor((0, _jquery2.default)(id).position().left / width * 100 * 60)];
				} else {
					return false;
				}
			},
			getVisualDimensions: function getVisualDimensions(id) {
				var width = (0, _jquery2.default)(window).innerWidth();
				if (id !== null) {
					var w = Math.floor((0, _jquery2.default)(id).css('width').slice(0, -2) / width * 100 * 60);
					var h = Math.floor((0, _jquery2.default)(id).css('height').slice(0, -2) / width * 100 * 60);
					return [w, h];
				} else {
					return false;
				}
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			VueDraggableResizable: _vueDraggableResizable2.default,
			draggable: _vuedraggable2.default
		}
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(94);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(35);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vueDraggableResizable = __webpack_require__(134);
	
	var _vueDraggableResizable2 = _interopRequireDefault(_vueDraggableResizable);
	
	var _selector = __webpack_require__(400);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _vueFullscreen = __webpack_require__(129);
	
	var _vueFullscreen2 = _interopRequireDefault(_vueFullscreen);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuedraggable = __webpack_require__(135);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _Signage = __webpack_require__(62);
	
	var _Signage2 = _interopRequireDefault(_Signage);
	
	var _md = __webpack_require__(123);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _ResourceModal = __webpack_require__(399);
	
	var _ResourceModal2 = _interopRequireDefault(_ResourceModal);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueFullscreen2.default, { name: 'fs' });
	exports.default = {
		data: function data() {
			return {
				loadedSavedData: false,
				groups: [],
				selectedGroup: null,
				timer: null,
				player: 0,
				play: false,
				startVal: 0,
				endVal: 0,
				step: 0,
				scale: 10,
				demoScale: 0.5,
				grid: 10,
				oldScale: 10,
				maxTime: 120,
				note: 'Signage Layout',
				breadcrumbArray: [{ name: 'UNOapp Signage', link: false }, { name: 'Presentation Editor', link: false }],
				layoutId: 0,
				displayCount: 1,
				displayNumber: 0,
				layoutHeight: 1080,
				layoutWidth: 1920,
				selectedRegion: 0,
				selectedPlaylist: 0,
				zones: [],
				name: '',
				regionList: [],
				layoutList: [],
				regionNames: [],
				padding: 0,
				height: 50,
				animationStep: null,
				fullscreen: false,
				beforeFullscreen: null,
				players: [],
				actualWidth: 0,
				loading: false,
				groupModeOn: false,
				showButtons: false,
				presentationList: [],
				selectedPresentation: {},
				nowPlaying: [[]],
				showModal: false,
				startTime: null,
				dateRange: null,
				multipleDays: null,
				daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
				days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
				selectedPlaylistIndex: 0,
				limited: [],
				limitedZones: [],
				limitedRegion: []
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId', 'activeBusinessId']),
		components: {
			Breadcrumb: _Breadcrumb2.default,
			VueDraggableResizable: _vueDraggableResizable2.default,
			draggable: _vuedraggable2.default,
			Selector: _selector2.default,
			ResourceModal: _ResourceModal2.default
		},
		methods: {
			padZero: function padZero(val) {
				var a = void 0;
				if (val < 10) {
					a = '0' + val;
				} else {
					a = val;
				}
				return a;
			},
			timeFormat: function timeFormat(date) {
				var utc = this.padZero(date.getHours()) + ':' + this.padZero(date.getMinutes()) + ':' + this.padZero(date.getSeconds());
				return utc;
			},
			dateFormat: function dateFormat(date) {
				var utc = date.getUTCFullYear() + '-' + this.padZero(date.getUTCMonth()) + '-' + this.padZero(date.getUTCDay()) + ' ' + this.padZero(date.getUTCHours()) + ':' + this.padZero(date.getUTCMinutes()) + ':' + this.padZero(date.getUTCSeconds());
				console.log(utc);
				return utc;
			},
			getIndexOfStartGroup: function getIndexOfStartGroup(groupId) {
				var _this2 = this;
	
				var val = 0;
				var maxTime = 0;
				this.regionList.forEach(function (x, i) {
					x.forEach(function (y) {
						if (_this2.zones[i].group === groupId && y.x / _this2.scale + y.width / _this2.scale > maxTime) {
							val = i;
							maxTime = y.x / _this2.scale + y.width / _this2.scale;
						}
					});
				});
				return val;
			},
			showLimitedModal: function showLimitedModal(i) {
				console.log(i);
				this.selectedPlaylistIndex = i;
				this.showModal = true;
			},
			addLimitedTimePlaylist: function addLimitedTimePlaylist(obj) {
				console.log(obj);
				var newZone = JSON.parse((0, _stringify2.default)(this.zones[this.selectedPlaylistIndex]));
				newZone.limited = obj;
				newZone.group = false;
	
				this.zones.splice(this.selectedPlaylistIndex + 1, 0, newZone);
				this.regionList.splice(this.selectedPlaylistIndex + 1, 0, []);
				console.log(this.regionList);
				console.log(this.zones);
				this.$forceUpdate();
				this.closeModal();
			},
			removePlaylist: function removePlaylist(i) {
				this.zones.splice(i, 1);
				this.regionList.splice(i, 1);
			},
			closeModal: function closeModal() {
				this.showModal = false;
				this.startTime = null;
				this.dateRange = null;
				this.multipleDays = null;
			},
			getResource: function getResource(id) {
				return _Resources2.default.getResource(this.activeBusinessId, this.activeLocationId, id).then(function (response) {
					return response.payload.file;
				}).catch(function (e) {});
			},
			createLayoutPlaylist: function createLayoutPlaylist(id) {
				var _this3 = this;
	
				var obj = {
					presentation_id: id,
					playlist_type: 'default'
				};
				return _Signage2.default.createLayoutPlaylist(obj).then(function (response) {
					_this3.createLayoutPlaylistEntry(response.payload.playlist_id);
				}).catch(function (e) {
					_this3.getLayoutPlaylist();
				});
			},
			getLayoutPlaylist: function getLayoutPlaylist() {
				var _this4 = this;
	
				var obj = {
					presentation_id: this.selectedPresentation.presentation_id
				};
				return _Signage2.default.getLayoutPlaylists(obj).then(function (response) {
					_this4.createLayoutPlaylistEntry(response.payload.playlist_id);
				}).catch(function (e) {});
			},
			getLayoutPlaylistEntries: function getLayoutPlaylistEntries(id) {
				var _this5 = this;
	
				return _Signage2.default.getLayoutPlaylistEntries(id).then(function (response) {
					response.payload.entries.forEach(function (x) {
						_this5.deleteLayoutPlaylistEntry(x.entry_id);
					});
				}).catch(function (e) {});
			},
			deleteLayoutPlaylistEntry: function deleteLayoutPlaylistEntry(id) {
				return _Signage2.default.deleteLayoutPlaylistEntry(id).then(function (response) {
					console.log(response);
				}).catch(function (e) {});
			},
			createLayoutPlaylistEntry: function createLayoutPlaylistEntry(id) {
				this.getLayoutPlaylistEntries(id);
				var obj = {
					playlist_id: id,
					layout_id: this.layoutId,
					start_time: 0
				};
				return _Signage2.default.createLayoutPlaylistEntry(obj).then(function (response) {
					console.log('done');
				}).catch(function (e) {});
			},
			saveToDb: function saveToDb(id) {
				var _this6 = this;
	
				var obj = {
					playlist_type: 'default',
					presentation_id: id
				};
				this.createLayoutPlaylist(id);
				var temp = JSON.parse((0, _stringify2.default)(this.regionList));
				var a = [];
				var b = [];
				b = this.regionList.map(function (x) {
					return [];
				});
				temp.forEach(function (x, i) {
					console.log(x);
					if (_this6.zones[i].group === false) {
						a.push(x);
						a.forEach(function (y, j) {
							a[j].forEach(function (z, k) {
								if (!a[j][k].zone_id) {
									a[j][k].zone_id = _this6.zones[i].zone_id;
								}
								if (!a[j][k].limited) {
									a[j][k].limited = _this6.zones[i].limited;
								}
							});
						});
					} else {
						var _b$zones$i$group;
	
						console.log(_this6.zones[i]);
						(_b$zones$i$group = b[_this6.zones[i].group]).push.apply(_b$zones$i$group, (0, _toConsumableArray3.default)(x));
						b[_this6.zones[i].group].forEach(function (x, j) {
							if (!b[_this6.zones[i].group][j].zone_id) {
								b[_this6.zones[i].group][j].zone_id = _this6.zones[i].zone_id;
							}
							if (!b[_this6.zones[i].group][j].limited) {
								b[_this6.zones[i].group][j].limited = _this6.zones[i].limited;
							}
						});
					}
				});
	
				console.log('a:', a);
				console.log('b:', b);
				a.forEach(function (x, i) {
					console.log(x);
					if (x[0]) {
						if (x[0].limited) {
							obj.playlist_type = x[0].limited.playlist_type;
							obj.start_time = x[0].limited.start_time;
							obj.start_datetime_range = x[0].limited.start_datetime_range;
							obj.end_datetime_range = x[0].limited.end_datetime_range;
							obj.day_of_week = x[0].limited.day_of_week;
						}
					}
					console.log(obj);
					_Signage2.default.createPlaylist(obj).then(function (response) {
						x.forEach(function (y) {
							console.log(y);
							var type = 'image';
							var entry = {};
							if (y.resource) {
								if (y.resource.extension === 'mp4' || y.resource.extension === 'webm' || y.resource.extension === 'ogg') {
									type = 'video';
								}
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: y.resource.id,
									content_url: y.resource.url,
									content_type: type,
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / _this6.scale) * 1000,
									duration: parseInt(y.width / _this6.scale) * 1000
								};
							} else {
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: 1,
									content_type: 'none',
									content_url: 'none',
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / _this6.scale) * 1000,
									duration: parseInt(y.width / _this6.scale) * 1000
								};
							}
							_Signage2.default.createPlaylistEntry(entry).then(function (response) {});
						});
					});
				});
				b.forEach(function (x, i) {
					if (x[0]) {
						if (x[0].limited) {
							obj.playlist_type = x[0].limited.playlist_type;
							obj.start_time = x[0].limited.start_time;
							obj.start_datetime_range = x[0].limited.start_datetime_range;
							obj.end_datetime_range = x[0].limited.end_datetime_range;
							obj.day_of_week = x[0].limited.day_of_week;
						}
					}
					console.log(obj);
					_Signage2.default.createPlaylist(obj).then(function (response) {
						x.forEach(function (y) {
							console.log(y);
							console.log(_this6.zones);
							var type = 'image';
							var entry = {};
							if (y.resource) {
								if (y.resource.extension === 'mp4' || y.resource.extension === 'webm' || y.resource.extension === 'ogg') {
									type = 'video';
								}
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: y.resource.id,
									content_type: type,
									content_url: y.resource.url,
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / _this6.scale) * 1000,
									duration: parseInt(y.width / _this6.scale) * 1000
								};
							} else {
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: 1,
									content_type: 'none',
									content_url: 'none',
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / _this6.scale) * 1000,
									duration: parseInt(y.width / _this6.scale) * 1000
								};
							}
							_Signage2.default.createPlaylistEntry(entry).then(function (response) {});
						});
					});
				});
				this.$notify({
					title: 'Presentation Saved',
					message: 'Presentation Saved successfully',
					type: 'success'
				});
			},
			save: function save(id) {
				var _this7 = this;
	
				this.deleteAllPlaylists(id).then(function (x) {
					_this7.saveToDb(id);
				});
			},
			selectPres: function selectPres(i) {
				this.selectedPresentation = this.presentationList[i];
				console.log(this.selectedPresentation);
				this.getLayouts();
				this.loadedSavedData = true;
				this.setStep(1);
			},
			createPres: function createPres() {
				var _this8 = this;
	
				this.$prompt('Name this presentation', 'Presentation', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Name'
				}).then(function (value) {
					_this8.createPresentation(value.value);
				}).then(function (x) {
					_this8.setStep(1);
				}).catch(function () {});
			},
			deletePres: function deletePres(id, i) {
				var _this9 = this;
	
				return _Signage2.default.deletePresentation(id).then(function (response) {
					console.log(response);
					_this9.presentationList.splice(i, 1);
				}).catch(function (e) {});
			},
			createPresentation: function createPresentation(str) {
				var _this10 = this;
	
				return _Signage2.default.createPresentation(str, this.activeLocationId).then(function (response) {
					console.log(response);
					_this10.selectedPresentation = {
						presentation_id: response.payload.presentation_id,
						name: str
					};
				}).catch(function (e) {});
			},
			getPresentations: function getPresentations() {
				var _this11 = this;
	
				return _Signage2.default.getPresentations(this.activeLocationId).then(function (response) {
					_this11.presentationList = response.payload.presentations;
					console.log(response);
				}).catch(function (e) {});
			},
			getPlaylists: function getPlaylists(id) {
				var _this12 = this;
	
				return _Signage2.default.getPlaylists(id).then(function (response) {
					response.payload.playlists.forEach(function (x, i) {
						_this12.getPlaylistEntries(x.playlist_id, i, x);
					});
				}).catch(function (e) {});
			},
			deleteAllPlaylists: function deleteAllPlaylists(id) {
				var _this13 = this;
	
				return _Signage2.default.getPlaylists(id).then(function (response) {
					response.payload.playlists.forEach(function (x, i) {
						_this13.deletePlaylist(x.playlist_id);
					});
				}).catch(function (e) {});
			},
			getPlaylistEntries: function getPlaylistEntries(id, i, playlist) {
				var _this14 = this;
	
				var group = false;
				return _Signage2.default.getPlaylistEntries(id).then(function (response) {
					console.log(response);
					if (response.payload.entries.length > 1) {
						group = i;
					}
					response.payload.entries.forEach(function (y, j) {
						_this14.zones.forEach(function (x, i) {
							if (y.zone_id === x.zone_id) {
								console.log(y);
								console.log(playlist);
								_this14.regionList[i].push({
									height: 50,
									width: y.duration / 1000 * _this14.scale,
									x: y.start_time / 1000 * _this14.scale,
									y: 0,
									z: 0,
									content: {
										type: y.content_type,
										id: y.content_id
									},
									background: 'white',
									del: false,
									group: group,
									id: y.entry_id,
									limited: playlist,
									type: playlist.playlist_type
								});
								_this14.zones[i].group = group;
							}
						});
					});
					_this14.regionList = _this14.regionList.map(function (y, i) {
						return y.map(function (x) {
							var obj = x;
							console.log(x);
							if (x.content) {
								if (x.content.type !== 'none') {
									_this14.getResource(x.content.id).then(function (z) {
										delete obj.content;
										obj.resource = z;
									});
								} else {
									delete obj.content;
								}
							}
							return obj;
						});
					});
	
					_this14.start();
	
					console.log(_this14.regionList);
				}).catch(function (e) {
					console.log(e);
					_this14.deletePlaylist(id);
				});
			},
			deletePlaylist: function deletePlaylist(id) {
				return _Signage2.default.deletePlaylist(id).then(function (response) {}).catch(function (e) {
					console.log(id);
				});
			},
			hoverButton: function hoverButton(i, j) {
				this.showButtons = [i, j];
			},
			leaveButton: function leaveButton() {
				this.showButtons = false;
			},
			regionFromTime: function regionFromTime(i, time) {
				var value = 0;
	
				if (this.zones[i].group === false) {
					for (var j = 0; j < this.regionList[i].length; j++) {
						if (this.regionList[i][j].x / this.scale < time && time < this.regionList[i][j].x / this.scale + this.regionList[i][j].width / this.scale) {
							value = j;
						}
					}
				} else {
					for (var _j = 0; _j < this.regionList[this.getIndexOfStartGroup(this.zones[i].group)].length; _j++) {
						if (this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][_j].x / this.scale < this.players[this.getIndexOfStartGroup(this.zones[i].group)] && this.players[this.getIndexOfStartGroup(this.zones[i].group)] < this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][_j].x / this.scale + this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][_j].width / this.scale) {
							value = _j;
						}
					}
				}
				return value;
			},
			showOne: function showOne() {
				this.displayNumber = 0;
				this.demoScale = 0.5;
				this.loading = true;
				this.getZones();
			},
			showAll: function showAll() {
				this.displayNumber = false;
				this.loading = true;
				this.demoScale = 0.5 / this.displayCount;
				this.getZones();
			},
			clickInvisibleButton: function clickInvisibleButton(i, j) {
				this.selectedPlaylist = i;
				this.selectedRegion = j;
				console.log((0, _jquery2.default)('#invisible-button > button'));
				(0, _jquery2.default)('#invisible-button > button').click();
			},
			selectedResource: function selectedResource(e) {
				console.log(e);
				console.log(this.selectedPlaylist, this.selectedRegion);
				console.log(this.regionList[this.selectedPlaylist][this.selectedRegion]);
				this.regionList[this.selectedPlaylist][this.selectedRegion].resource = e;
				this.$forceUpdate();
				this.$nextTick(function (x) {
					var a = document.getElementsByClassName('autoPlayMe');
					for (var i = 0; i < a.length; i++) {
						a[i].pause();
						a[i].currentTime = 0;
					}
				});
			},
			groupMode: function groupMode() {
				var max = this.zones.reduce(function (t, x) {
					if (x.group !== false) {
						console.log(x);
						if (x.group > t) {
							t = x.group;
						}
					}
					return t;
				}, -1);
				if (this.zones[this.selectedPlaylist].group === false) {
					this.selectedGroup = max + 1;
				} else {
					this.selectedGroup = this.zones[this.selectedPlaylist].group;
				}
				this.groupModeOn = !this.groupModeOn;
			},
			groupToggle: function groupToggle(val) {
				if (this.groupModeOn) {
					if (this.zones[val].group !== this.selectedGroup) {
						this.zones[val].group = this.selectedGroup;
					} else {
						this.zones[val].group = false;
					}
				}
			},
			groupModeOff: function groupModeOff() {
				this.groupModeOn = false;
	
				this.selectedGroup = null;
			},
			prevDisplay: function prevDisplay() {
				if (this.displayNumber > 0) {
					this.displayNumber--;
					this.getZones();
				}
			},
			nextDisplay: function nextDisplay() {
				if (this.displayNumber < this.displayCount - 1) {
					this.displayNumber++;
					this.getZones();
				}
			},
			setActiveLayout: function setActiveLayout(index) {
				this.step = 2;
				if (this.layoutList[index].width % 1080 === 0) {
					this.layoutWidth = 1080;
					this.layoutHeight = 1920;
					this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20;
					this.displayCount = this.layoutList[index].width / 1080;
				} else {
					this.layoutWidth = 1920;
					this.layoutHeight = 1080;
					this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20;
					this.displayCount = this.layoutList[index].width / 1920;
				}
				this.actualWidth = this.layoutList[index].width;
				this.name = this.layoutList[index].name;
				this.layoutId = this.layoutList[index].layout_id;
				this.getZones();
			},
			getLayouts: function getLayouts() {
				var _this15 = this;
	
				return _Signage2.default.getLayouts(this.activeLocationId).then(function (response) {
					console.log(response);
					_this15.layoutList = response.payload.layouts;
				}).catch(function (e) {});
			},
			getZones: function getZones() {
				var _this16 = this;
	
				this.zones = [];
				this.regionList = [];
				this.regionNames = [];
				return _Signage2.default.getZones(this.layoutId).then(function (response) {
					_this16.regionList = response.payload.zones.map(function (x, i) {
						var obj = [];
						console.log(obj);
						return obj;
					});
					_this16.regionNames = response.payload.zones.map(function (x) {
						return x.label;
					});
					_this16.zones = response.payload.zones.map(function (x, i) {
						var obj = {
							width: x.width,
							height: x.height,
							z: x.z_index,
							y: x.y,
							x: x.x - (x.x / _this16.layoutWidth >> 0) * _this16.layoutWidth,
							actual_x: x.x,
							background: _this16.colorHash(x.label, x.zone_id),
							name: x.label,
							zone_id: x.zone_id,
							screen: x.x / _this16.layoutWidth >> 0,
							group: false
						};
						return obj;
					});
	
					_this16.loading = false;
					console.log(_this16.zones);
				}).then(function (x) {
					console.log('zones loaded');
					_this16.getPlaylists(_this16.selectedPresentation.presentation_id);
					_this16.$forceUpdate();
				}).catch(function (e) {});
			},
			colorHash: function colorHash(name, id) {
				var str = (0, _md2.default)(id + name);
				var bytes = [];
				for (var i = 0; i < str.length; ++i) {
					var code = str.charCodeAt(i);
					bytes = bytes.concat([code]);
				}
				var bytesTotal = bytes.reduce(function (total, x) {
					total += x;
					return total;
				}, 0);
				var val = bytesTotal / bytes.length;
				var normalize = val / 255;
				var normalize2 = normalize * 10 / 9;
				return '#' + Math.floor(normalize2 * 0x1000000).toString(16).padStart(6, 0);
			},
			toggle: function toggle() {
				this.$refs.fs.toggle();
				this.$fs.toggle(this.$el.querySelector('.layout-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				});
			},
			fullscreenChange: function fullscreenChange(fullscreen) {
				console.log(fullscreen);
				this.fullscreen = fullscreen;
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.demoScale);
					this.beforeFullscreen = this.demoScale;
					this.demoScale = 1;
					console.log(this.beforeFullscreen);
					var a = document.getElementsByClassName('autoPlayMe');
					for (var i = 0; i < a.length; i++) {
						a[i].play();
					}
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.demoScale = this.beforeFullscreen;
					this.beforeFullscreen = null;
					var _a = document.getElementsByClassName('autoPlayMe');
					for (var _i = 0; _i < _a.length; _i++) {
						_a[_i].play();
					}
				}
			},
			reset: function reset() {
				this.play = false;
				window.cancelAnimationFrame(this.animationStep);
				this.players = this.players.map(function (x) {
					return 0;
				});
				this.start();
			},
			stop: function stop() {
				var _this17 = this;
	
				this.play = false;
				(0, _jquery2.default)('.playlist .el-slider__bar').removeClass('playing');
				window.cancelAnimationFrame(this.animationStep);
				var a = document.getElementsByClassName('autoPlayMe');
				this.regionList.map(function (x, i) {
					if (x.length > 0) {
						_this17.players[i] = 0;
					}
				});
				for (var i = 0; i < a.length; i++) {
					a[i].pause();
					a[i].currentTime = 0;
				}
			},
			start: function start() {
				var _this18 = this;
	
				var a = document.getElementsByClassName('autoPlayMe');
				for (var i = 0; i < a.length; i++) {
					a[i].pause();
					a[i].currentTime = 0;
					a[i].play();
				}
				console.log(this.regionList);
				this.players = [];
				this.regionList.map(function (x, i) {
					if (x.length > 0) {
						_this18.players[i] = 0;
					}
				});
				this.play = true;
				var _this = this;
				var startTimes;
				var reset;
				var baseTimes = [];
				console.log(this.players);
				function startCounting() {
					startTimes = _this.players.map(function (x) {
						return Date.now();
					});
					_this.animationStep = window.requestAnimationFrame(step);
					baseTimes = _this.players.map(function (x) {
						return x;
					});
				}
				function step(timestamp) {
					var progress = startTimes.map(function (x, i) {
						if (!isNaN(reset)) {
							startTimes[reset] = Date.now();
							reset = null;
						}
						return Date.now() - x;
					});
					_this.players = baseTimes.map(function (x, i) {
						return x + progress[i] / 1000;
					});
					for (var _i2 = 0; _i2 < _this.players.length; _i2++) {
						var max = _this.regionList[_i2].reduce(function (total, x) {
							if (x.width + x.x > total) {
								total = x.width + x.x;
							}
							return total;
						}, 0);
	
						if (_this.players[_i2] >= max / _this.scale) {
							reset = _i2;
						}
					}
					_this.animationStep = window.requestAnimationFrame(step);
				}
				startCounting();
				(0, _jquery2.default)('.playlist .el-slider__bar').addClass('playing');
			},
			pause: function pause() {
				this.play = false;
				window.cancelAnimationFrame(this.animationStep);
			},
			clickSelector: function clickSelector(i) {
				this.selectedRegion = i;
				console.log('selector');
			},
			selectPlaylist: function selectPlaylist(i) {
				this.selectedPlaylist = i;
			},
			update: function update(left, width, i, j) {},
			deleteQueue: function deleteQueue() {
				for (var i = 0; i < this.regionList[this.selectedPlaylist].length; i++) {
					console.log(this.regionList[this.selectedPlaylist][i]);
					if (this.regionList[this.selectedPlaylist][i].del === true) {
						console.log('delete');
						this.regionList[this.selectedPlaylist].splice(i, 1);
						break;
					}
				}
			},
			deleteRegion: function deleteRegion() {
				this.regionList[this.selectedPlaylist][this.regionList[this.selectedPlaylist].length - 1].del = true;
				this.deleteQueue();
				this.selectedRegion = this.regionList[this.selectedPlaylist].length - 1;
			},
			addNewRegion: function addNewRegion() {
				var max = 0;
				var maxw = 0;
				this.regionList[this.selectedPlaylist].forEach(function (x) {
					if (x.x >= max && x.del === false) {
						max = x.x;
						maxw = x.width;
					}
				});
	
				var newX = max + maxw;
				var obj = {
					height: 50,
					width: 200,
					x: newX,
					y: 0,
					z: 0,
					background: 'white',
					del: false
				};
				if (obj.x + obj.width > this.maxTime * this.scale) {
					obj.width = this.maxTime * this.scale - obj.x;
				}
				console.log(obj.x, this.maxTime * this.scale);
				if (obj.x < this.maxTime * this.scale) {
					this.regionList[this.selectedPlaylist].push(obj);
					this.selectedRegion = this.regionList[this.selectedPlaylist].length - 1;
				} else {
					this.$notify.error({
						title: 'Error',
						message: 'You cannot add any more, max time reached!'
					});
				}
			},
			onResize: function onResize(x, y, width, height, index, playlist) {
				this.selectedRegion = index;
				this.selectedPlaylist = playlist;
				this.regionList[playlist][index].x = x;
				this.regionList[playlist][index].width = width;
			},
			onDrag: function onDrag(x, y, width, height, index, playlist) {
				this.selectedRegion = index;
				this.selectedPlaylist = playlist;
				this.regionList[playlist][index].x = x;
				this.regionList[playlist][index].width = width;
			},
			setStep: function setStep(val) {
				this.step = val;
			}
		},
		watch: {
			displayNumber: function displayNumber(val) {
				this.stop();
			},
			demoScale: function demoScale(val) {
				this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20;
			},
			scale: function scale(val) {
				var _this19 = this;
	
				this.playlist.forEach(function (x, j) {
					x.forEach(function (y, i) {
						y.width = y.width / _this19.oldScale * val;
	
						y.x = y.x / _this19.oldScale * val;
						_this19.$nextTick(function () {
							document.getElementById('region-' + j + '-' + i).style.left = y.x + 'px';
							document.getElementById('region-' + j + '-' + i).style.width = y.width + 'px';
						});
					});
				});
				this.oldScale = val;
			}
		}
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _NoResults = __webpack_require__(47);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _lodash = __webpack_require__(7);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	var _CreateCampaign = __webpack_require__(390);
	
	var _CreateCampaign2 = _interopRequireDefault(_CreateCampaign);
	
	var _EditCampaignDetails = __webpack_require__(391);
	
	var _EditCampaignDetails2 = _interopRequireDefault(_EditCampaignDetails);
	
	var _EditContestLayout = __webpack_require__(392);
	
	var _EditContestLayout2 = _interopRequireDefault(_EditContestLayout);
	
	var _EditContestPrizes = __webpack_require__(393);
	
	var _EditContestPrizes2 = _interopRequireDefault(_EditContestPrizes);
	
	var _EditSkillTestingQuestions = __webpack_require__(394);
	
	var _EditSkillTestingQuestions2 = _interopRequireDefault(_EditSkillTestingQuestions);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				activePanel: true,
				breadcrumbArray: [{ name: 'UNOgames', link: false }],
				computedHeight: 0,
				advancedSearch: {
					status: 'all',
					type: 'all'
				},
				numPages: 0,
				totalResults: 0,
				activePage: 1,
				loadingCampaignData: false,
				campaigns: []
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createCampaign();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== 'UNOgames') {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
		},
	
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['activeBusinessId', 'activeLocationId'])),
		methods: {
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/uno_games');
			},
			pageResultsUpdate: function pageResultsUpdate(val) {
				if (parseInt(this.pageResultsValue) !== parseInt(val)) {
					this.pageResultsValue = val;
					if (parseInt(this.activePage) === 1) {
						this.getCampaigns(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			activePageUpdate: function activePageUpdate(val) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					this.getCampaigns(this.activePage);
				}
			},
			getCampaigns: function getCampaigns(pageNumber) {
				this.loadingCampaignData = true;
	
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var searchCriteria = { campaign_type: this.advancedSearch.type, status: this.advancedSearch.status };
	
				return _UNOgames2.default.getCampaigns(businessId, locationId, pageNumber, this.pageResultsValue, searchCriteria).then(function (response) {
					_this.campaigns = response.payload.campaigns;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
					_this.loadingCampaignData = false;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'campaigns_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							default:
						}
					}
					_this.loadingCampaignData = false;
				}));
			},
			filterDateString: function filterDateString(date) {
				var fullDate = new Date(date);
				var formattedDate = '';
				var formattedTime = '';
	
				formattedDate = fullDate.getFullYear() + '-' + (fullDate.getMonth() + 1 < 10 ? '0' + (fullDate.getMonth() + 1) : fullDate.getMonth() + 1) + '-' + (fullDate.getDate() < 10 ? '0' + fullDate.getDate() : fullDate.getDate());
				formattedTime = (fullDate.getHours() > 12 ? fullDate.getHours() - 12 : fullDate.getHours()) + ':' + fullDate.getMinutes() + ' ' + (fullDate.getHours() > 12 & fullDate.getHours() !== 24 ? 'PM' : 'AM');
				return formattedDate + ' at ' + formattedTime;
			},
			calculateProgressWidth: function calculateProgressWidth(campaign) {
				var percent = 0;
				var startDate = new Date(campaign.starts_at);
				var endDate = new Date(campaign.ends_at);
				var campaignLength = endDate - startDate;
				var currentDistance = new Date() - startDate;
	
				if (currentDistance > 0 && currentDistance < campaignLength) {
					percent = currentDistance / campaignLength * 100;
				} else if (currentDistance > campaignLength) {
					percent = 100;
				}
				return percent + '%';
			},
			createCampaign: function createCampaign() {
				this.$router.push('/app/uno_games/create_campaign');
			},
			editCampaignDetails: function editCampaignDetails(campaignId) {
				this.$router.push('/app/uno_games/edit_campaign_details/' + campaignId);
			},
			editContestDesign: function editContestDesign(campaignId) {
				this.$router.push('/app/uno_games/edit_contest_layout/' + campaignId);
			},
			editContestPrizes: function editContestPrizes(campaignId) {
				this.$router.push('/app/uno_games/edit_contest_prizes/' + campaignId);
			},
			editSkillTestingQuestions: function editSkillTestingQuestions(campaignId) {
				this.$router.push('/app/uno_games/edit_skill_testing_questions/' + campaignId);
			},
			setSearchStatus: function setSearchStatus(status) {
				if (status !== this.advancedSearch.status) {
					this.advancedSearch.status = status;
					if (parseInt(this.activePage) === 1) {
						this.getCampaigns(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			setSearchType: function setSearchType(type) {
				if (type !== this.advancedSearch.type) {
					this.advancedSearch.type = type;
					if (parseInt(this.activePage) === 1) {
						this.getCampaigns(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			deleteCampaignConfirmation: function deleteCampaignConfirmation(campaign) {
				var _this = this;
				var buttonText = 'Delete Campaign';
				var messageText = 'You won\'t be able to reverse this action.';
				var successMessage = '<b>' + campaign.name + '</b> has been deleted.';
	
				this.$swal({
					title: 'Are you sure?',
					html: messageText,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: buttonText,
					confirmButtonColor: '#d9534f',
					cancelButtonText: 'Cancel',
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return new _promise2.default(function (resolve, reject) {
							_UNOgames2.default.deleteCampaign(_this.activeLocationId, campaign.id).then(function () {
								resolve('campaign_deleted');
							}).catch(_this.$root.errorWrapper(function (e) {
								if (e.responseJSON) {
									switch (e.responseJSON.declaration) {}
								}
							}));
						});
					}
				}).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: successMessage,
						type: 'success',
						showCancelButton: true
					}).then(function () {
						_this.getCampaigns(_this.activePage);
					}, function (dismiss) {
						_this.getCampaigns(_this.activePage);
					});
				}, function (dismiss) {});
			},
			updateStatus: function updateStatus(campaign, status) {
				var _this = this;
				var locationId = this.activeLocationId;
	
				return _UNOgames2.default.updateCampaignStatus(locationId, campaign.id, status).then(function (response) {
					campaign.status = status;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'missing_components':
								var payload = e.responseJSON.payload.components_attached;
								if (!payload.text2win) {
									_this.$swal({
										title: 'Error',
										html: 'There seems to be a fatal error with your campaign. Try deleting and recreating the campaign.',
										type: 'warning'
									});
								} else if (!payload.contest) {
									_this.$swal({
										title: 'Error',
										html: 'You cannot run a campaign without creating a contest layout.',
										type: 'warning',
										showCancelButton: true,
										confirmButtonText: 'Create Contest Layout',
										confirmButtonColor: '#3598dc',
										cancelButtonText: 'Cancel',
										allowOutsideClick: false,
										allowEscapeKey: false,
										allowEnterKey: false,
										showLoaderOnConfirm: true
									}).then(function () {
										_this.editContestDesign(campaign.id);
									});
								} else {
									if (campaign.campaign_type === 'ig') {
										if (!payload.instagram_credentials) {
											_this.$swal({
												title: 'Error',
												html: 'You cannot run a campaign without proper Instagram credentials.',
												type: 'warning'
											});
										}
									} else if (campaign.campaign_type === 'sw') {
										if (!payload.prize) {
											_this.$swal({
												title: 'Error',
												html: 'You cannot run a campaign without creating prizes.',
												type: 'warning',
												showCancelButton: true,
												confirmButtonText: 'Create Contest Prizes',
												confirmButtonColor: '#3598dc',
												cancelButtonText: 'Cancel',
												allowOutsideClick: false,
												allowEscapeKey: false,
												allowEnterKey: false,
												showLoaderOnConfirm: true
											}).then(function () {
												_this.editContestPrizes(campaign.id);
											});
										}
									}
								}
								break;
	
							default:
						}
					}
				}));
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			NoResults: _NoResults2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			CreateCampaign: _CreateCampaign2.default,
			EditCampaignDetails: _EditCampaignDetails2.default,
			EditContestLayout: _EditContestLayout2.default,
			EditContestPrizes: _EditContestPrizes2.default,
			EditSkillTestingQuestions: _EditSkillTestingQuestions2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== 'UNOgames') {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getCampaigns(this.activePage);
				}
			}
		}
	};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'contest-preview',
		props: {
			design: {
				default: {}
			},
			form: {
				default: {}
			},
			agreement: {
				default: {}
			}
		}
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(7);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _InfoPopover = __webpack_require__(60);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'create-campaign',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				mergeErrorMessage: '',
				campaignId: 0,
				newCampaign: {
					campaign_type: 'none',
					name: '',
					image: '',
					start_date: new Date(),
					end_date: new Date(),
					alternate_flow: false,
					details: {
						type: '',
						twilio_account: {},
						response_message: '',
						redeem_message: '',
						expiry_message: '',
						exceeded_message: '',
						max_redemptions: 0,
						max_redemptions_per_day: 0,
						max_redemptions_per_day_per_user: 0,
						keywords: []
					}
				},
				steps: [{ key: 'step_1', name: 'Create Campaign' }, { key: 'step_2', name: 'Keywords' }, { key: 'step_3', name: 'SMS Details' }],
				campaignTypes: {
					none: 'Select a Campaign Type',
					sw: 'Scratch and Win',
					ig: 'Instagage'
				},
				useTypes: {
					'single_use_case': 'Single Use',
					'multiple_use_case': 'Multiple Use'
				},
				datepickerStartOptions: {
					disabledDate: function disabledDate(time) {
						return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
					}
				},
				datepickerEndOptions: {
					disabledDate: function disabledDate(time) {
						return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
					}
				},
				twilioAccounts: [],
				showKeywordUI: false,
				keywordInput: '',
				createCampaignNextActions: [{ title: 'Design Contest Layout', icon_class: 'fa fa-paint-brush', main_action: true, description: 'Design the look of the contest page that your users will be sent to in order to enter the contest.', click_event: 'createDesign' }, { title: 'Create Prize', icon_class: 'fa fa-gift', description: 'Set up the details of the prize for your contest.', click_event: 'createPrize' }, { title: 'Return to Campaign Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }],
				transitionComplete: true
			};
		},
		created: function created() {
			var _this2 = this;
	
			if (this.$route.name === 'UNOgames - Create Campaign') {
				this.activePanel = true;
				this.transitionComplete = false;
				setTimeout(function () {
					_this2.transitionComplete = true;
				}, 600);
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			setGameType: function setGameType(type) {
				this.newCampaign.campaign_type = type;
			},
			setTwilioAccount: function setTwilioAccount(account) {
				this.newCampaign.details.twilio_account = account;
			},
			setText2WinType: function setText2WinType(type) {
				this.newCampaign.details.type = type;
			},
			openKeywordUI: function openKeywordUI() {
				this.showKeywordUI = true;
	
				setTimeout(function () {
					(0, _jquery2.default)('#keyword-textarea').focus();
				}, 0);
			},
			addKeywords: function addKeywords() {
				var _this3 = this;
	
				var keywords = this.keywordInput.split(',');
				this.showKeywordUI = false;
	
				if (keywords.length) {
					keywords.forEach(function (keyword) {
						if (_this3.newCampaign.details.keywords.indexOf(keyword.trim()) === -1 && keyword.trim().length) {
							_this3.newCampaign.details.keywords.push(keyword.trim());
						}
					});
				}
	
				this.keywordInput = '';
			},
			removeKeyword: function removeKeyword(index) {
				this.newCampaign.details.keywords.splice(index, 1);
			},
			insertMergeField: function insertMergeField(field) {
				if (this.newCampaign.details.response_message.indexOf(field) !== -1) {
					this.mergeErrorMessage = 'Each merge field can only be used once.';
					return;
				} else {
					this.mergeErrorMessage = '';
				}
	
				var length = this.newCampaign.details.response_message.length;
				if (length && this.newCampaign.details.response_message[length - 1] !== ' ') {
					this.newCampaign.details.response_message += ' ' + field + ' ';
				} else {
					this.newCampaign.details.response_message += field + ' ';
				}
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/uno_games');
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (_this.newCampaign.campaign_type === 'none') {
								reject('You must choose a campaign type');
							}
							if (_this.newCampaign.name.length < 3) {
								reject('Campaign name must be at least 3 characters');
							}
							if (!_this.newCampaign.image.length) {
								reject('Campaign image cannot be blank');
							}
							if (new Date() - _this.newCampaign.start_date > 1200000) {
								reject('Campaign start date must be past the current date and time');
							}
							if (_this.newCampaign.end_date <= _this.newCampaign.start_date) {
								reject('Campaign end date must be past the start date and time');
							}
							break;
	
						case 'step_2':
							if (!_this.newCampaign.details.twilio_account.id) {
								reject('You must choose a phone number');
							}
							if (!_this.newCampaign.details.keywords.length) {
								reject('Your campaign must have at least 1 keyword');
							}
							if (_this.newCampaign.details.type === '') {
								reject('You must choose a Text2Win type');
							}
	
							break;
	
						case 'step_3':
							if (_this.newCampaign.details.response_message === '') {
								reject('You must have an SMS Response message');
							}
							if (_this.newCampaign.details.redeem_message === '') {
								reject('You must have a Redeemed Response message');
							}
							if (_this.newCampaign.details.expiry_message === '') {
								reject('You must have a Campaign Expired Response message');
							}
							if (_this.newCampaign.details.exceeded_message === '') {
								reject('You must choose a Max Exceeded Response message');
							}
							if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions && _this.newCampaign.details.max_redemptions !== 0) {
								reject('You must set Max Entries for Campaign');
							}
							if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions_per_day && _this.newCampaign.details.max_redemptions_per_day !== 0) {
								reject('You must set Max Entries Per Day');
							}
							if (_this.newCampaign.campaign_type === 'sw' && !_this.newCampaign.details.max_redemptions_per_day_per_user && _this.newCampaign.details.max_redemptions_per_day_per_user !== 0) {
								reject('You must set Max Entries Per Day/Per User');
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
	
						if (step === 'step_2') {
							_this.getTwilioAccounts();
						}
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				return;
			},
			getTwilioAccounts: function getTwilioAccounts() {
				var _this = this;
	
				return _UNOgames2.default.getTwilioAccounts(_this.activeLocationId).then(function (response) {
					_this.twilioAccounts = response.payload.accounts;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {}
					}
				}));
			},
			createCampaign: function createCampaign(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData('step_3').then(function (response) {
					_this.clearError();
					if (_this.campaignId) {
						_this.createCampaignDetails(disabledButton);
					} else {
						var localStartDate = _this.newCampaign.start_date.getFullYear() + '-' + (_this.newCampaign.start_date.getMonth() + 1) + '-' + _this.newCampaign.start_date.getDate() + ' ' + _this.newCampaign.start_date.getHours() + ':' + _this.newCampaign.start_date.getMinutes() + ':' + _this.newCampaign.start_date.getSeconds();
						var localEndDate = _this.newCampaign.end_date.getFullYear() + '-' + (_this.newCampaign.end_date.getMonth() + 1) + '-' + _this.newCampaign.end_date.getDate() + ' ' + _this.newCampaign.end_date.getHours() + ':' + _this.newCampaign.end_date.getMinutes() + ':' + _this.newCampaign.end_date.getSeconds();
						_this.newCampaign.start_date = localStartDate;
						_this.newCampaign.end_date = localEndDate;
						return _UNOgames2.default.createCampaign(_this.activeLocationId, _this.newCampaign).then(function (response) {
							_this.campaignId = response.payload.campaign_id;
							_this.createCampaignDetails(disabledButton);
						}).catch(_this.$root.errorWrapper(function (e) {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {
									default:
								}
							}
							disabledButton.cancel();
						}));
					}
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			},
			createCampaignDetails: function createCampaignDetails(disabledButton) {
				var _this = this;
	
				return _UNOgames2.default.createCampaignDetails(_this.activeLocationId, _this.campaignId, _this.newCampaign.details).then(function (response) {
					_this.clearForm();
					_this.process = 'next_actions';
					disabledButton.complete();
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'campaign_expired':
								_this.$swal({
									title: 'Error',
									html: 'You can\'t edit details of an expired campaign.',
									type: 'warning'
								});
								break;
	
							case 'keyphrase_already_exist':
								var keywords = '';
								if (e.responseJSON.payload.campaigns.length > 1) {
									keywords += 's';
								}
								keywords += ' ';
	
								e.responseJSON.payload.campaigns.forEach(function (campaign, index) {
									if (index === e.responseJSON.payload.campaigns.length - 1) {
										if (index !== 0) {
											keywords += 'and ' + campaign.keyphrase + ' ';
										} else {
											keywords += campaign.keyphrase + ' ';
										}
									} else {
										keywords += campaign.keyphrase + ', ';
									}
								});
	
								if (e.responseJSON.payload.campaigns.length > 1) {
									keywords += 'are';
								} else {
									keywords += 'is';
								}
	
								_this.errorMessage = 'The keyword' + keywords + ' already in use.';
								_this.reverseForm();
	
								break;
	
							default:
						}
					}
					disabledButton.cancel();
				}));
			},
			clearForm: function clearForm() {
				this.newCampaign = {
					campaign_type: 'none',
					name: '',
					image: '',
					start_date: new Date(),
					end_date: new Date(),
					alternate_flow: false,
					details: {
						type: '',
						twilio_account: {},
						response_message: '',
						redeem_message: '',
						expiry_message: '',
						exceeded_message: '',
						max_redemptions: 0,
						max_redemptions_per_day: 0,
						max_redemptions_per_day_per_user: 0,
						keywords: []
					}
				};
				this.twilioAccounts = [];
				this.showKeywordUI = false;
				this.keywordInput = '';
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			},
			createDesign: function createDesign() {
				this.$router.push('/app/uno_games/edit_contest_layout/' + this.campaignId);
			},
			createPrize: function createPrize() {
				this.$router.push('/app/uno_games/edit_contest_prizes/' + this.campaignId);
			}
		},
		watch: {
			'$route': function $route() {
				var _this4 = this;
	
				if (this.$route.name === 'UNOgames - Create Campaign') {
					this.activePanel = true;
					this.process = 'step_1';
					this.clearForm();
	
					this.transitionComplete = false;
					setTimeout(function () {
						_this4.transitionComplete = true;
					}, 600);
				} else {
					this.activePanel = false;
				}
			}
		},
		components: {
			Dropdown: _Dropdown2.default,
			InfoPopover: _InfoPopover2.default,
			NextActions: _NextActions2.default,
			StepCounter: _StepCounter2.default
		}
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-campaign-details',
		data: function data() {
			return {
				activePanel: false,
				errorMessage: '',
				campaignId: 0,
				editingCampaign: {
					start_date: new Date(),
					end_date: new Date()
				},
				initialStartDate: new Date(),
				initialEndDate: new Date(),
				datepickerStartOptions: {
					disabledDate: function disabledDate(time) {
						return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
					}
				},
				datepickerEndOptions: {
					disabledDate: function disabledDate(time) {
						return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
					}
				}
			};
		},
		created: function created() {
			if (this.$route.name === 'UNOgames - Edit Campaign Details') {
				this.activePanel = true;
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id;
					this.getCampaignDetails();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.$router.push('/app/uno_games');
			},
			getCampaignDetails: function getCampaignDetails() {
				var _this = this;
	
				_UNOgames2.default.getCampaign(_this.activeLocationId, _this.campaignId).then(function (response) {
					_this.editingCampaign.start_date = new Date(response.payload.campaign.starts_at);
					_this.initialStartDate = _this.editingCampaign.start_date;
					_this.editingCampaign.end_date = new Date(response.payload.campaign.ends_at);
					_this.initialEndDate = _this.editingCampaign.end_date;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
	
							default:
						}
					}
				}));
			},
			validateFormData: function validateFormData() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (_this.editingCampaign.start_date !== _this.initialStartDate && new Date() - _this.newCampaign.start_date > 1200000) {
						reject('Campaign start date must be past the current date and time');
					}
					if (_this.editingCampaign.end_date < _this.editingCampaign.start_date) {
						reject('Campaign end date must be past the start date and time');
					}
	
					resolve();
				});
			},
			updateCampaign: function updateCampaign(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData().then(function (response) {
					_this.clearError();
	
					var updatedCampaign = {};
	
					if (_this.editingCampaign.start_date !== _this.initialStartDate) {
						var localStartDate = _this.editingCampaign.start_date.getFullYear() + '-' + (_this.editingCampaign.start_date.getMonth() + 1) + '-' + _this.editingCampaign.start_date.getDate() + ' ' + _this.editingCampaign.start_date.getHours() + ':' + _this.editingCampaign.start_date.getMinutes() + ':' + _this.editingCampaign.start_date.getSeconds();
	
						updatedCampaign.start_date = localStartDate;
					}
					if (_this.editingCampaign.end_date !== _this.initialEndDate) {
						var localEndDate = _this.editingCampaign.end_date.getFullYear() + '-' + (_this.editingCampaign.end_date.getMonth() + 1) + '-' + _this.editingCampaign.end_date.getDate() + ' ' + _this.editingCampaign.end_date.getHours() + ':' + _this.editingCampaign.end_date.getMinutes() + ':' + _this.editingCampaign.end_date.getSeconds();
						updatedCampaign.end_date = localEndDate;
					}
	
					return _UNOgames2.default.updateCampaign(_this.activeLocationId, _this.campaignId, updatedCampaign).then(function (response) {
						_this.closePanel();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					if (reason) {
						_this.errorMessage = reason;
					}
					disabledButton.cancel();
				});
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'UNOgames - Edit Campaign Details') {
					this.activePanel = true;
					this.clearError();
					if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
						this.campaignId = this.$route.params.campaign_id;
						this.getCampaignDetails();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FontPicker = __webpack_require__(398);
	
	var _FontPicker2 = _interopRequireDefault(_FontPicker);
	
	var _InfoPopover = __webpack_require__(60);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _StepCounter = __webpack_require__(40);
	
	var _StepCounter2 = _interopRequireDefault(_StepCounter);
	
	var _ContestPreview = __webpack_require__(389);
	
	var _ContestPreview2 = _interopRequireDefault(_ContestPreview);
	
	var _lodash = __webpack_require__(7);
	
	var _webfontloader = __webpack_require__(469);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-contest-layout',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				campaignId: 0,
				contestId: 0,
				campaignType: '',
				contestLayout: {
					form: {
						skip_form: false,
						language: 'english',
						form_instructions: '',
						thank_you_text: '',
						no_age: false,
						fields: {
							full_name: {
								request: true,
								require: false
							},
							email: {
								request: true,
								require: false
							},
							phone: {
								request: true,
								require: false
							},
							dob: {
								request: true,
								require: false
							}
						},
						thank_you_email: false,
						email_fields: {
							sender: '',
							subject: '',
							body: ''
						}
					},
					design: {
						text_color: '',
						input_text_color: '',
						background_color: '',
						background_image: '',
						header_image: '',
						footer_image: '',
						footer_background_color: '',
						footer_border_color: '',
						input_background_color: '',
						input_placeholder_color: '',
						button_text_color: '',
						button_background_color: '',
						button_background_hover_color: '',
						font_family: {},
						font_weight: 400
					},
					agreement: {
						urls: [{
							url: '',
							name: ''
						}, {
							url: '',
							name: ''
						}],
						terms_error: '',
						require_access_code: false,
						access_code: ''
					}
				},
				steps: [{ key: 'step_1', name: 'Form Details' }, { key: 'step_2', name: 'Page Design' }, { key: 'step_3', name: 'Agreement Details' }],
				fontWeights: [{ weight: 100, name: '100' }, { weight: 200, name: '200' }, { weight: 300, name: '300' }, { weight: 400, name: 'regular' }, { weight: 500, name: '500' }, { weight: 600, name: '600' }, { weight: 700, name: '700' }, { weight: 800, name: '800' }, { weight: 900, name: '900' }],
				editContestLayoutNextActions: [{ title: 'Return to Campaign Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }],
				transitionComplete: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			if (this.$route.name === 'UNOgames - Edit Contest Layout') {
				this.activePanel = true;
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id;
	
					this.transitionComplete = false;
					setTimeout(function () {
						_this2.transitionComplete = true;
					}, 600);
	
					this.getContestDetails();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/uno_games');
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				return;
			},
			setFormLanguage: function setFormLanguage(language) {
				this.contestLayout.form.language = language;
			},
			forceFieldSelection: function forceFieldSelection(type, field) {
				switch (type) {
					case 'require':
						if (this.contestLayout.form.fields[field].require === true) {
							this.contestLayout.form.fields[field].request = true;
						}
						break;
	
					case 'request':
						if (this.contestLayout.form.fields[field].request === false) {
							this.contestLayout.form.fields[field].require = false;
						}
						break;
	
					default:
				}
	
				return;
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_1':
							if (_this.contestLayout.form.skip_form) {
								resolve();
							}
							if (!_this.contestLayout.form.language) {
								reject('Language cannot be blank.');
							}
							if (!_this.contestLayout.form.form_instructions) {
								reject('Form instructions cannot be blank.');
							}
							if (_this.campaignType === 'ig' && !_this.contestLayout.form.thank_you_text) {
								reject('Thank you message cannot be blank.');
							}
							if (!_this.contestLayout.form.min_age && !_this.contestLayout.form.no_age) {
								reject('Age limit cannot be blank.');
							}
							if (_this.contestLayout.form.thank_you_email) {
								if (!_this.contestLayout.form.email_fields.sender) {
									reject('Email sender name cannot be blank.');
								}
								if (!_this.contestLayout.form.email_fields.subject) {
									reject('Email subject cannot be blank.');
								}
								if (!_this.contestLayout.form.email_fields.body) {
									reject('Email body cannot be blank.');
								}
							}
							break;
	
						case 'step_2':
							if (!_this.contestLayout.design.text_color.length) {
								reject('Text Color cannot be blank.');
							}
							if (!_this.contestLayout.form.skip_form) {
								if (!_this.contestLayout.design.input_text_color.length) {
									reject('Input Text Color cannot be blank.');
								}
							}
							if (!_this.contestLayout.design.background_color.length && !_this.contestLayout.design.background_image.length) {
								reject('Your design must have either a background color or background image.');
							}
							if (!_this.contestLayout.design.header_image.length) {
								reject('Header Image cannot be blank.');
							}
							if (!_this.contestLayout.form.skip_form) {
								if (!_this.contestLayout.design.input_background_color.length) {
									reject('Input Background Color cannot be blank.');
								}
								if (!_this.contestLayout.design.input_placeholder_color.length) {
									reject('Input Placeholder Color cannot be blank.');
								}
							}
							if (!_this.contestLayout.design.button_text_color.length) {
								reject('Button Text Color cannot be blank.');
							}
							if (!_this.contestLayout.design.button_background_color.length) {
								reject('Button Background Color cannot be blank.');
							}
							if (!_this.contestLayout.design.button_background_hover_color.length) {
								reject('Button Hover Color cannot be blank.');
							}
							break;
	
						case 'step_3':
							if (_this.contestLayout.agreement.require_access_code) {
								if (!_this.contestLayout.agreement.access_code.length) {
									reject('Access Code cannot be blank if you require an access code.');
								}
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			advanceForm: function advanceForm(event, step, currentStep) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return this.validateFormData(currentStep).then(function (response) {
					_this.clearError();
					disabledButton.complete().then(function () {
						_this.process = step;
					});
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			setFontFamily: function setFontFamily(font) {
				this.contestLayout.design.font_family = font;
	
				if (this.contestLayout.design.font_weight) {
					if (this.contestLayout.design.font_family.variants.indexOf(this.contestLayout.design.font_weight.toString()) === -1) {
						this.contestLayout.design.font_weight = 400;
					}
				}
	
				_webfontloader2.default.load({
					google: {
						families: [font.family + ':' + this.contestLayout.design.font_weight]
					}
				});
			},
			setFontWeight: function setFontWeight(weight) {
				this.contestLayout.design.font_weight = weight.weight;
	
				_webfontloader2.default.load({
					google: {
						families: [this.contestLayout.design.font_family.family + ':' + weight.weight]
					}
				});
			},
			updateContestLayout: function updateContestLayout(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData('step_3').then(function (response) {
					_this.clearError();
					if (_this.contestLayout.form.skip_form) {
						delete _this.contestLayout.form.language;
						delete _this.contestLayout.form.form_instructions;
						delete _this.contestLayout.form.thank_you_text;
						delete _this.contestLayout.form.no_age;
						delete _this.contestLayout.form.fields;
						delete _this.contestLayout.form.thank_you_email;
						delete _this.contestLayout.form.email_fields;
					} else {
						for (var key in _this.contestLayout.form.fields) {
							_this.contestLayout.form[key] = _this.contestLayout.form.fields[key].request;
	
							_this.contestLayout.form[key + '_req'] = _this.contestLayout.form.fields[key].require;
						}
	
						if (_this.contestLayout.form.no_age) {
							_this.contestLayout.form.min_age = 0;
						}
	
						if (_this.campaignType === 'sw') {
							delete _this.contestLayout.form.thank_you_text;
						}
					}
	
					if (_this.contestId) {
						_UNOgames2.default.updateContestLayout(_this.activeLocationId, _this.campaignId, _this.contestLayout.form, _this.contestLayout.design, _this.contestLayout.agreement, _this.contestId).then(function (response) {
							_this.clearForm();
							_this.process = 'next_actions';
							disabledButton.complete();
						}).catch(_this.$root.errorWrapper(function (e) {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {
									case 'contest_already_exists':
										break;
	
									default:
								}
							}
							disabledButton.cancel();
						}));
					} else {
						_UNOgames2.default.createContestLayout(_this.activeLocationId, _this.campaignId, _this.contestLayout.form, _this.contestLayout.design, _this.contestLayout.agreement).then(function (response) {
							_this.clearForm();
							_this.process = 'next_actions';
							disabledButton.complete();
						}).catch(_this.$root.errorWrapper(function (e) {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {
									case 'contest_already_exists':
										break;
	
									default:
								}
							}
							disabledButton.cancel();
						}));
					}
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			getContestDetails: function getContestDetails() {
				var _this = this;
	
				_UNOgames2.default.getContestDetails(_this.activeLocationId, _this.campaignId).then(function (response) {
					_this.formatContestData(response.payload);
					_this.contestId = response.payload.contest.id;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'contest_not_found':
								break;
	
							default:
						}
					}
				}));
			},
			formatContestData: function formatContestData(data) {
				this.contestLayout.form.skip_form = data.contest.skip_form;
				this.contestLayout.form.language = data.contest.language;
				this.contestLayout.form.form_instructions = data.contest.form_instructions;
				this.contestLayout.form.thank_you_text = data.contest.thank_you_text;
				this.contestLayout.form.fields.full_name.request = data.contest.full_name;
				this.contestLayout.form.fields.full_name.require = data.contest.full_name_req;
				this.contestLayout.form.fields.email.request = data.contest.email;
				this.contestLayout.form.fields.email.require = data.contest.email_req;
				this.contestLayout.form.fields.phone.request = data.contest.phone;
				this.contestLayout.form.fields.phone.require = data.contest.phone_req;
				this.contestLayout.form.fields.dob.request = data.contest.dob;
				this.contestLayout.form.fields.dob.require = data.contest.dob_req;
				this.contestLayout.form.email_fields.sender = data.contest.email_sender;
				this.contestLayout.form.email_fields.subject = data.contest.email_subject;
				this.contestLayout.form.email_fields.body = data.contest.email_body;
				this.contestLayout.form.thank_you_email = data.contest.thank_you_email;
	
				if (data.contest.min_age === 0) {
					this.contestLayout.form.no_age = true;
				} else {
					this.contestLayout.form.min_age = data.contest.min_age;
				}
	
				this.contestLayout.design.text_color = data.contest.text_color;
				this.contestLayout.design.background_color = data.contest.background_color;
				this.contestLayout.design.background_image = data.contest.background_image;
				this.contestLayout.design.button_background_color = data.contest.button_background_color;
				this.contestLayout.design.button_background_hover_color = data.contest.button_background_hover_color;
				this.contestLayout.design.button_text_color = data.contest.button_text_color;
				this.contestLayout.design.font_family = data.contest.font_family;
				this.contestLayout.design.font_weight = data.contest.font_weight;
				this.contestLayout.design.footer_background_color = data.contest.footer_background_color;
				this.contestLayout.design.footer_border_color = data.contest.footer_border_color;
				this.contestLayout.design.footer_image = data.contest.footer_image;
				this.contestLayout.design.header_image = data.contest.header_image;
				this.contestLayout.design.input_background_color = data.contest.input_background_color;
				this.contestLayout.design.input_placeholder_color = data.contest.input_placeholder_color;
				this.contestLayout.design.input_text_color = data.contest.input_text_color;
	
				this.contestLayout.agreement.urls = [{ url: data.contest.agreement_url_1, name: data.contest.agreement_name_1 }, { url: data.contest.agreement_url_2, name: data.contest.agreement_name_2 }];
			},
			clearForm: function clearForm() {
				this.contestLayout = {
					form: {
						skip_form: false,
						language: 'english',
						form_instructions: '',
						thank_you_text: '',
						no_age: false,
						fields: {
							full_name: {
								request: true,
								require: false
							},
							email: {
								request: true,
								require: false
							},
							phone: {
								request: true,
								require: false
							},
							dob: {
								request: true,
								require: false
							}
						},
						thank_you_email: false,
						email_fields: {
							sender: '',
							subject: '',
							body: ''
						}
					},
					design: {
						text_color: '',
						input_text_color: '',
						background_color: '',
						background_image: '',
						header_image: '',
						footer_image: '',
						footer_background_color: '',
						footer_border_color: '',
						input_background_color: '',
						input_placeholder_color: '',
						button_text_color: '',
						button_background_color: '',
						button_background_hover_color: '',
						font_family: {},
						font_weight: 400
					},
					agreement: {
						urls: [{
							url: '',
							name: ''
						}, {
							url: '',
							name: ''
						}],
						terms_error: '',
						require_access_code: false,
						access_code: ''
					}
				};
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			}
		},
		components: {
			ContestPreview: _ContestPreview2.default,
			Dropdown: _Dropdown2.default,
			FontPicker: _FontPicker2.default,
			InfoPopover: _InfoPopover2.default,
			NextActions: _NextActions2.default,
			StepCounter: _StepCounter2.default
		},
		watch: {
			'$route': function $route() {
				var _this3 = this;
	
				if (this.$route.name === 'UNOgames - Edit Contest Layout') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
					if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
						this.campaignId = this.$route.params.campaign_id;
	
						this.transitionComplete = false;
						setTimeout(function () {
							_this3.transitionComplete = true;
						}, 600);
	
						this.getContestDetails();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			},
			'campaignId': function campaignId() {
				if (this.campaignId !== 0) {
					var _this = this;
	
					_UNOgames2.default.getCampaign(_this.activeLocationId, _this.campaignId).then(function (response) {
						_this.campaignType = response.payload.campaign.campaign_type;
					}).catch(function (reason) {
						if (reason.responseJSON) {
							switch (reason.responseJSON.declaration) {}
						}
					});
				}
			}
		}
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _InfoPopover = __webpack_require__(60);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _lodash = __webpack_require__(7);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = ['#4b77be', '#1bbc9b', '#5e738b', '#29b4b6', '#e7505a', '#d91e18', '#f3c200', '#e87e04', '#8e44ad', '#796799'];
	
	exports.default = {
		name: 'edit-contest-prizes',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				campaignId: 0,
				newPrize: {
					name: '',
					image: '',
					quantity: '',
					unlimited_quantity: false,
					weight: '',
					claim_type: '',
					claim: '',
					claim_post_request_params: ''
				},
				newRule: {
					starts_at: '',
					ends_at: '',
					specific_day: false,
					date: '',
					weight: '',
					max_redemptions: 0
				},
				steps: [{ key: 'step_1', name: 'View Prizes' }, { key: 'step_2', name: 'Create Prize' }, { key: 'step_3', name: 'Add Prize Rule' }],
				prizes: [],
				unusedColors: [],
				activePrize: {},
				currentCoverage: 0,
				editingPrizeId: 0
			};
		},
		created: function created() {
			var _this2 = this;
	
			if (this.$route.name === 'UNOgames - Edit Contest Prizes') {
				this.activePanel = true;
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id;
					this.getPrizes();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createPrize();
			}, 500, { 'trailing': false });
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/uno_games');
			},
			reverseForm: function reverseForm() {
				this.process = 'step_1';
	
				this.clearForm(true);
	
				return;
			},
			createPrize: function createPrize() {
				if (this.currentCoverage === 100) {
					this.$swal({
						html: 'You can\'t create another prize as you already have 100% prize coverage?',
						type: 'info',
						confirmButtonText: 'Ok',
						showLoaderOnConfirm: true
					}).then(function (response) {}, function (dismiss) {});
				} else {
					this.activePrize = (0, _assign2.default)({});
					this.process = 'step_2';
				}
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_2':
							if (_this.newPrize.name.length < 3) {
								reject('Prize name must be at least 3 characters');
							}
							if (!_this.newPrize.image.length) {
								reject('Prize image cannot be blank. I don\'t know why, but it can\'t');
							}
							if (!_this.newPrize.quantity && !_this.newPrize.unlimited_quantity) {
								reject('Prize quantity cannot be blank.');
							}
							if (_this.newPrize.quantity < 1 && !_this.newPrize.unlimited_quantity) {
								reject('Prize quantity cannot be less than 1.');
							}
							if (!_this.newPrize.weight) {
								reject('Prize must have an odds of winning.');
							}
							if (_this.newPrize.weight > 100) {
								reject('Odds of winning a prize cannot be more than 100%.');
							}
							if (100 - _this.currentCoverage < _this.newPrize.weight) {
								reject('Odds of winning all prizes cannot be more than 100%. Reduce odds of winning to be less than or equal to ' + (100 - _this.currentCoverage) + '%');
							}
							if (!_this.newPrize.claim_type.length) {
								reject('You must choose a claim type.');
							}
							if (_this.newPrize.claim_type.length && _this.newPrize.claim_type !== 'none') {
								if (!_this.newPrize.claim.length) {
									reject('Claim details cannot be blank.');
								}
							}
							break;
	
						case 'step_3':
							if (!(_this.newRule.starts_at instanceof Date)) {
								reject('Start time is required.');
							}
							if (!(_this.newRule.ends_at instanceof Date)) {
								reject('End time is required.');
							}
							if (!_this.newRule.max_redemptions && _this.newRule.max_redemptions !== 0) {
								reject('Max Redemptions cannot be blank.');
							}
							if (_this.newRule.max_redemptions < 1) {
								reject('Max Redemptions must be at least 1.');
							}
							if (!_this.newRule.weight) {
								reject('Rule must have an odds of winning.');
							}
							if (_this.newRule.weight > 100) {
								reject('Odds of winning a prize cannot be more than 100%.');
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			createContestPrize: function createContestPrize(event) {
				var _this3 = this;
	
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData('step_2').then(function (response) {
					_this.clearError();
	
					if (_this.newPrize.unlimited_quantity) {
						_this.newPrize.quantity = 0;
					}
	
					if (_this.newPrize.claim_type !== 'post_request') {
						delete _this.newPrize.claim_post_request_params;
					}
	
					if (_this3.editingPrizeId) {
						_UNOgames2.default.updateContestPrize(_this.activeLocationId, _this.campaignId, _this.editingPrizeId, _this.newPrize).then(function (response) {
							_this.getPrizes();
							_this.process = 'step_1';
							_this.clearForm();
							_this.editingPrizeId = 0;
							disabledButton.complete();
						}).catch(_this.$root.errorWrapper(function (e) {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {}
							}
							disabledButton.cancel();
						}));
					} else {
						_UNOgames2.default.createContestPrize(_this.activeLocationId, _this.campaignId, _this.newPrize).then(function (response) {
							_this.getPrizes();
							_this.process = 'step_1';
							_this.clearForm();
							disabledButton.complete();
						}).catch(_this.$root.errorWrapper(function (e) {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {}
							}
							disabledButton.cancel();
						}));
					}
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			setClaimType: function setClaimType(type) {
				this.newPrize.claim_type = type;
			},
			clearForm: function clearForm(keepPrizes) {
				if (!keepPrizes) {
					this.prizes = [];
					this.activePrize = {};
				}
				this.newPrize = {
					name: '',
					image: '',
					quantity: '',
					unlimited_quantity: false,
					weight: '',
					claim_type: '',
					claim: '',
					claim_post_request_params: ''
				};
				this.newRule = {
					starts_at: '',
					ends_at: '',
					specific_day: false,
					date: '',
					weight: '',
					max_redemptions: 0
				};
			},
			getPrizes: function getPrizes() {
				var _this = this;
	
				_UNOgames2.default.getPrizes(_this.activeLocationId, _this.campaignId).then(function (response) {
					_this.unusedColors = (0, _assign2.default)([], colors);
					_this.prizes = response.payload.prize.sort(function (a, b) {
						return b.weight - a.weight;
					});
					_this.currentCoverage = 0;
					_this.prizes.forEach(function (prize) {
						prize.color = _this.generateColor();
						_this.currentCoverage += prize.weight;
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'prizes_not_found':
								_this.prizes = [];
								break;
	
							default:
						}
					}
				}));
			},
			generateColor: function generateColor() {
				var index = Math.floor(Math.random() * this.unusedColors.length - 1 + 1);
				var selectedColor = this.unusedColors[index];
				this.unusedColors.splice(index, 1);
	
				return selectedColor;
			},
			selectPrize: function selectPrize(prize) {
				if (this.activePrize.id !== prize.id) {
					this.activePrize = prize;
				}
			},
			editPrize: function editPrize(prize) {
				this.process = 'step_2';
				this.editingPrizeId = prize.id;
				this.newPrize = prize;
	
				if (this.newPrize.quantity === 0) {
					this.newPrize.unlimited_quantity = true;
				}
			},
			addRule: function addRule() {
				this.process = 'step_3';
			},
			createPrizeRule: function createPrizeRule(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData('step_3').then(function (response) {
					_this.clearError();
	
					_UNOgames2.default.createContestPrizeRule(_this.activeLocationId, _this.campaignId, _this.activePrize.id, _this.newRule).then(function (response) {
						_this.getPrizes();
						_this.process = 'step_1';
						_this.clearForm();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			}
		},
		components: {
			Dropdown: _Dropdown2.default,
			InfoPopover: _InfoPopover2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'UNOgames - Edit Contest Prizes') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
					if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
						this.campaignId = this.$route.params.campaign_id;
						this.getPrizes();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _lodash = __webpack_require__(7);
	
	var _vuex = __webpack_require__(3);
	
	var _UNOgames = __webpack_require__(34);
	
	var _UNOgames2 = _interopRequireDefault(_UNOgames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'edit-contest-prizes',
		data: function data() {
			return {
				process: 'step_1',
				activePanel: false,
				errorMessage: '',
				campaignId: 0,
				newQuestion: {
					question: '',
					answer: ''
				},
				steps: [{ key: 'step_1', name: 'View Skill Testing Questions' }, { key: 'step_2', name: 'Create Skill Testing Question' }],
				questions: []
			};
		},
		created: function created() {
			var _this2 = this;
	
			if (this.$route.name === 'UNOgames - Edit Skill Testing Questions') {
				this.activePanel = true;
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id;
					this.getSkillTestingQuestions();
				} else {
					this.closePanel();
				}
			} else {
				this.activePanel = false;
			}
	
			this.throttledCreate = (0, _lodash.throttle)(function () {
				_this2.createSkillTestingQuestion();
			}, 500, { 'trailing': false });
		},
	
		computed: (0, _vuex.mapGetters)(['activeLocationId']),
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			closePanel: function closePanel() {
				this.process = 'step_1';
				this.$router.push('/app/uno_games');
			},
			clearForm: function clearForm() {
				this.newQuestion = {
					question: '',
					answer: ''
				};
			},
			getSkillTestingQuestions: function getSkillTestingQuestions() {
				var _this = this;
	
				_UNOgames2.default.getSkillTestingQuestions(_this.activeLocationId, _this.campaignId).then(function (response) {
					_this.questions = response.payload.questions;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'questions_not_found':
								_this.questions = [];
								break;
							default:
						}
					}
				}));
			},
			reverseForm: function reverseForm() {
				var index = (0, _lodash.findIndex)(this.steps, ['key', this.process]);
				if (index) {
					this.process = this.steps[index - 1].key;
				}
	
				this.clearForm();
	
				return;
			},
			createSkillTestingQuestion: function createSkillTestingQuestion() {
				this.process = 'step_2';
			},
			validateFormData: function validateFormData(step) {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					switch (step) {
						case 'step_2':
							if (!_this.newQuestion.question.length) {
								reject('Question cannot be blank.');
							}
							if (!_this.newQuestion.answer.length) {
								reject('Answer cannot be blank.');
							}
							break;
	
						default:
							resolve();
					}
	
					resolve();
				});
			},
			createQuestion: function createQuestion(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateFormData('step_2').then(function (response) {
					_this.clearError();
	
					_UNOgames2.default.createSkillTestingQuestion(_this.activeLocationId, _this.campaignId, _this.newQuestion).then(function (response) {
						_this.getSkillTestingQuestions();
						_this.process = 'step_1';
						_this.clearForm();
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			deleteQuestionConfirmation: function deleteQuestionConfirmation(question) {
				var _this = this;
				var buttonText = '';
				var messageText = '';
				var successMessage = '';
	
				buttonText = 'Delete Question';
				messageText = 'You won\'t be able to reverse this action.';
				successMessage = 'Your question has been deleted.';
	
				this.$swal({
					title: 'Are you sure?',
					html: messageText,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: buttonText,
					confirmButtonColor: '#d9534f',
					cancelButtonText: 'Cancel',
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return new _promise2.default(function (resolve, reject) {
							_UNOgames2.default.deleteSkillTestingQuestion(_this.activeLocationId, _this.campaignId, question.id).then(function () {
								resolve('skill_testing_question_deleted');
							}).catch(_this.$root.errorWrapper(function (e) {
								if (e.responseJSON) {
									switch (e.responseJSON.declaration) {}
								}
							}));
						});
					}
				}).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: successMessage,
						type: 'success',
						showCancelButton: true
					}).then(function () {
						_this.getSkillTestingQuestions();
					}, function (dismiss) {
						_this.getSkillTestingQuestions();
					});
				}, function (dismiss) {});
			}
		},
		components: {
			Dropdown: _Dropdown2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === 'UNOgames - Edit Skill Testing Questions') {
					this.activePanel = true;
					this.clearError();
					this.clearForm();
					if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
						this.campaignId = this.$route.params.campaign_id;
						this.getSkillTestingQuestions();
					} else {
						this.closePanel();
					}
				} else {
					this.activePanel = false;
				}
			}
		}
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Roles = __webpack_require__(86);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'UNOapp Business', link: false }, { name: 'Roles', link: false }]
			};
		},
	
		components: {
			Roles: _Roles2.default
		}
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Users = __webpack_require__(87);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				breadcrumbArray: [{ name: 'UNOapp Business', link: false }, { name: 'Users', link: false }]
			};
		},
	
		components: {
			Users: _Users2.default
		}
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Breadcrumb = __webpack_require__(17);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _NoResults = __webpack_require__(47);
	
	var _NoResults2 = _interopRequireDefault(_NoResults);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Typeahead = __webpack_require__(61);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	var _lodash = __webpack_require__(7);
	
	var _Account = __webpack_require__(41);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _InviteUser = __webpack_require__(397);
	
	var _InviteUser2 = _interopRequireDefault(_InviteUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'users',
		props: {
			breadcrumbs: {
				type: Array,
				required: true,
				default: function _default() {
					return [];
				}
			},
			note: {
				type: String,
				default: ''
			},
			businessId: {
				type: Number,
				required: true
			},
			locationId: {
				type: Number,
				required: false
			},
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				activePanel: true,
				computedHeight: 0,
				users: [],
				roles: [],
				roleFocused: false,
				searchCollapse: true,
				advancedSearch: {
					search: '',
					searchOptions: [{ name: 'First Name', value: 'first_name', checked: true }, { name: 'Last Name', value: 'last_name', checked: true }, { name: 'Email', value: 'email', checked: true }],
					role: { role_name: 'Any Role' },
					status: 'any_status'
				},
				sortBy: {
					field: 'first_name',
					order: 'asc'
				},
				searchError: '',
				pageResultsValue: 0,
				numPages: 1,
				totalResults: 0,
				activePage: 1,
				loadingUserData: false
			};
		},
		created: function created() {
			var _this2 = this;
	
			this.throttledInvite = (0, _lodash.throttle)(function () {
				_this2.inviteUser();
			}, 500, { 'trailing': false });
	
			if (this.$route.name !== this.baseRouteName) {
				this.activePanel = false;
			}
	
			var _this = this;
	
			this.computeHeight();
	
			(0, _jquery2.default)(window).on('resize', (0, _lodash.debounce)(function () {
				_this.computeHeight();
			}, 200));
		},
	
		computed: {
			computedSearchOptions: function computedSearchOptions() {
				return this.advancedSearch.searchOptions.filter(function (option) {
					return option.checked;
				});
			}
		},
		methods: {
			computeHeight: function computeHeight() {
				var height = (0, _jquery2.default)(window).height() - 50;
				this.computedHeight = height + 'px';
			},
			closePanel: function closePanel() {
				this.$router.push(this.baseRoute);
			},
			toggleSearchPanel: function toggleSearchPanel() {
				this.searchCollapse = !this.searchCollapse;
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			updateRole: function updateRole(val) {
				if (val && val.role_name) {
					this.advancedSearch.role = val;
				} else {
					this.advancedSearch.role = { role_name: 'Any Role' };
				}
			},
			roleFocus: function roleFocus() {
				if (!this.roleFocused) {
					this.roleFocused = true;
					this.getRoles();
				}
			},
			advancedUserSearch: function advancedUserSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else if (this.advancedSearch.search.length && !this.computedSearchOptions.length) {
					this.searchError = 'In order to use the search field you must select at least one field to search by.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getUsers(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			resetUserSearch: function resetUserSearch() {
				this.advancedSearch = {
					search: '',
					searchOptions: [{ name: 'First Name', value: 'first_name', checked: true }, { name: 'Last Name', value: 'last_name', checked: true }, { name: 'Email', value: 'email', checked: true }],
					role: { role_name: 'Any Role' },
					status: 'any_status'
				};
				this.clearSearchError();
			},
			pageResultsUpdate: function pageResultsUpdate(val) {
				if (parseInt(this.pageResultsValue) !== parseInt(val)) {
					this.pageResultsValue = val;
					if (parseInt(this.activePage) === 1) {
						this.getUsers(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			activePageUpdate: function activePageUpdate(val) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					this.getUsers(this.activePage);
				}
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getUsers(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			},
			capitalize: function capitalize(val) {
				var output = void 0;
	
				val = val.replace(/_/g, ' ');
				var index = val.indexOf(' ');
	
				if (index !== -1) {
					output = val.substring(0, 1).toUpperCase() + val.substring(1, index + 1) + val.substring(index + 1, index + 2).toUpperCase() + val.substring(index + 2);
				} else {
					output = val.substring(0, 1).toUpperCase() + val.substring(1);
				}
				return output;
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {
					invite_status: 'any'
				};
	
				if (this.advancedSearch.role.role_name !== 'Any Role') {
					searchCriteria.role_id = this.advancedSearch.role.role_id;
				}
	
				if (this.advancedSearch.status !== 'any_status') {
					searchCriteria.invite_status = this.advancedSearch.status;
				}
	
				if (this.advancedSearch.search.length > 2 && this.computedSearchOptions.length) {
					searchCriteria.search_query = this.advancedSearch.search;
					var searchIn = '';
					for (var key in this.computedSearchOptions) {
						if (parseInt(key) !== 0) {
							searchIn += ',';
						}
						searchIn += this.computedSearchOptions[key].value;
					}
					searchCriteria.search_in = searchIn;
				}
	
				return searchCriteria;
			},
			getUsers: function getUsers(pageNumber) {
				if (!this.businessId) {
					return;
				}
	
				this.loadingUserData = true;
				this.users = [];
	
				var _this = this;
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
	
				var accountType = 'business';
				if (this.locationId) {
					accountType = 'location';
				}
	
				return _Account2.default.getUsers(this.businessId, this.locationId, accountType, pageNumber, this.pageResultsValue, searchCriteria, sortCriteria).then(function (response) {
					_this.users = response.payload.accounts;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
	
					setTimeout(function () {
						_this.loadingUserData = false;
					}, 500);
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'no_accounts_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							case 'invalid_business':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'business_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_page_number':
								_this.numPages = e.responseJSON.payload.number_of_pages;
								_this.totalResults = e.responseJSON.payload.number_of_records;
								if (_this.numPages !== 0) {
									_this.getUsers(e.responseJSON.payload.number_of_pages);
								}
								break;
							default:
						}
					}
					_this.loadingUserData = false;
				}));
			},
			getRoles: function getRoles() {
				var _this = this;
	
				if (!this.locationId) {
					return _Roles2.default.getRoles(this.businessId).then(function (response) {
						_this.roles = response.payload.roles;
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'no_roles_found':
									break;
	
								case 'business_not_found':
									_this.$swal({
										title: 'Error',
										html: 'There is an issue with your business account. Please contact your admin.',
										type: 'warning'
									});
									break;
	
								case 'invalid_business':
									_this.$swal({
										title: 'Error',
										html: 'You do not have access to this business.',
										type: 'warning'
									});
									break;
	
								default:
							}
						}
					}));
				}
			},
			deleteUserConfirmation: function deleteUserConfirmation(type, user) {
				var _this = this;
				var username = user.name.first_name && user.name.last_name ? user.name.first_name + ' ' + user.name.last_name : user.email;
				var buttonText = '';
				var successMessage = '';
	
				if (type === 'delete') {
					buttonText = 'Delete User';
					successMessage = '<b>' + username + '</b> has been deleted.';
				} else if (type === 'cancel_invitation') {
					buttonText = 'Cancel Invitation';
					successMessage = 'The user invitation has been cancelled.';
				}
	
				this.$swal({
					title: 'Are you sure?',
					html: '<b>' + username + '</b> will no longer be able to access your business.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: buttonText,
					confirmButtonColor: '#d9534f',
					cancelButtonText: 'Cancel',
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
					showLoaderOnConfirm: true,
					preConfirm: function preConfirm() {
						return new _promise2.default(function (resolve, reject) {
							_Account2.default.deleteUser(user.account_id).then(function () {
								resolve();
							}).catch(_this.$root.errorWrapper(function (e) {
								if (e.responseJSON) {
									switch (e.responseJSON.declaration) {
										case 'account_not_found':
											reject('The account you are trying to remove could not be found.');
											break;
	
										default:
									}
								}
							}));
						});
					}
				}).then(function () {
					_this.$swal({
						title: 'Success',
						html: successMessage,
						type: 'success',
						timer: 2000
					}).then(function () {
						_this.getUsers(_this.activePage);
					}, function (dismiss) {
						_this.getUsers(_this.activePage);
					});
				}, function (dismiss) {});
			},
			resendUserInvitation: function resendUserInvitation(user) {
				var _this = this;
				var username = user.name.first_name && user.name.last_name ? user.name.first_name + ' ' + user.name.last_name : user.email;
	
				return _Auth2.default.resendInvite(user.account_id).then(function (response) {
					_this.$swal({
						title: 'Success',
						html: 'Invitation was sent to ' + username + '.',
						type: 'success',
						timer: 2000
					});
	
					user.invite_status = 'pending';
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'email_failed':
								_this.$swal({
									title: 'Error',
									html: 'There was an error sending the invitation to ' + username + '.',
									type: 'warning',
									timer: 2000
								});
								break;
	
							case 'already_accepted':
								_this.$swal({
									title: 'Error',
									html: username + ' has already accepted their invitation.',
									type: 'warning',
									timer: 2000
								});
								break;
	
							case 'account_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There was an error sending the invitation to ' + username + '.',
									type: 'warning',
									timer: 2000
								}).then(function () {
									_this.getUsers(_this.activePage);
								}, function (dismiss) {
									_this.getUsers(_this.activePage);
								});
								break;
	
							default:
						}
					}
				}));
			},
			inviteUser: function inviteUser() {
				this.$router.push(this.baseRoute + '/invite_user');
			}
		},
		components: {
			Breadcrumb: _Breadcrumb2.default,
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			NoResults: _NoResults2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			Typeahead: _Typeahead2.default,
			InviteUser: _InviteUser2.default
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name !== this.baseRouteName) {
					this.activePanel = false;
				} else {
					this.activePanel = true;
					this.getUsers(this.activePage);
				}
			},
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getUsers(1);
					} else {
						this.activePageUpdate(1);
					}
				}
			}
		}
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NextActions = __webpack_require__(31);
	
	var _NextActions2 = _interopRequireDefault(_NextActions);
	
	var _global = __webpack_require__(4);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Auth = __webpack_require__(25);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Roles = __webpack_require__(28);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _Typeahead = __webpack_require__(61);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emailPattern = /^.+@.+\..+$/;
	
	exports.default = {
		name: 'invite-user',
		props: {
			businessId: {
				type: Number,
				required: true
			},
			locationId: {
				type: Number,
				required: false
			},
			baseRoute: {
				type: String,
				required: true
			},
			baseRouteName: {
				type: String,
				required: true
			}
		},
		data: function data() {
			return {
				process: 'form',
				activePanel: false,
				errorMessage: '',
				invitedUser: {
					name: {
						first_name: '',
						last_name: ''
					},
					email: '',
					role: ''
				},
				roleFocused: false,
				roles: [],
				locationRoleFocused: false,
				locationRoles: [],
				inviteUserNextActions: [{ title: 'Invite another user', icon_class: 'fa fa-user', click_event: 'resetProcess' }, { title: 'Return to User Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel' }]
			};
		},
		created: function created() {
			if (this.$route.name === this.baseRouteName + ' - Invite User') {
				this.activePanel = true;
			}
		},
	
		methods: {
			clearError: function clearError() {
				this.errorMessage = '';
			},
			validateUserData: function validateUserData() {
				var _this = this;
				return new _promise2.default(function (resolve, reject) {
					if (!_this.invitedUser.email.length) {
						reject('User email cannot be blank');
					} else if (!emailPattern.test(_this.invitedUser.email)) {
						reject('Please enter a valid email');
					} else if (_this.locationId && !_this.invitedUser.location_role || !_this.locationId && !_this.invitedUser.role) {
						reject('User role cannot be blank');
					}
					resolve('Hurray');
				});
			},
			inviteUser: function inviteUser(event) {
				var disabledButton = _global2.default.disableButton(event);
				var _this = this;
	
				return _this.validateUserData().then(function (response) {
					_this.clearError();
					_Auth2.default.inviteUser(_this.invitedUser, _this.businessId, _this.locationId).then(function (response) {
						_this.clearForm();
						_this.process = 'next_actions';
						disabledButton.complete();
					}).catch(_this.$root.errorWrapper(function (e) {
						if (e.responseJSON) {
							switch (e.responseJSON.declaration) {
								case 'email_failed':
									_this.errorMessage = 'We were unable to process the request. Please check the email and try again.';
									break;
	
								case 'invalid_business':
									_this.errorMessage = 'You lack proper permissions for this invitation. Please contact the admin.';
									break;
	
								case 'already_invited':
									_this.errorMessage = 'This user is already a member of your business.';
									break;
	
								case 'business_not_found':
									_this.errorMessage = 'The business you are inviting the user to doesn’t exist. Please contact the admin.';
									break;
	
								case 'too_many_accounts':
									_this.errorMessage = 'The user you are inviting has too many contacts. Try another email.';
									break;
	
								default:
							}
						}
						disabledButton.cancel();
					}));
				}).catch(function (reason) {
					_this.errorMessage = reason;
					disabledButton.cancel();
				});
			},
			clearForm: function clearForm() {
				this.invitedUser = {
					name: {
						first_name: '',
						last_name: ''
					},
					email: '',
					role: ''
				};
				(0, _jquery2.default)('.invite-user-form').find('input, select').removeClass('edited');
			},
			runFunction: function runFunction(functionName, params) {
				if (!params) {
					this[functionName]();
				} else {
					this[functionName](params[0]);
				}
			},
			resetProcess: function resetProcess() {
				this.process = 'form';
			},
			closePanel: function closePanel() {
				this.process = 'form';
				this.$router.push(this.baseRoute);
			},
			updateRole: function updateRole(val) {
				if (val) {
					this.invitedUser.role = val;
				} else {
					this.invitedUser.role = {};
				}
			},
			updateLocationRole: function updateLocationRole(val) {
				if (val) {
					this.invitedUser.location_role = val;
				} else {
					this.invitedUser.location_role = {};
				}
			},
			roleFocus: function roleFocus() {
				if (!this.roleFocused) {
					this.roleFocused = true;
					this.getRoles();
				}
			},
			locationRoleFocus: function locationRoleFocus() {
				if (!this.locationRoleFocused) {
					this.locationRoleFocused = true;
					this.getLocationRoles();
				}
			},
			getRoles: function getRoles() {
				var _this = this;
	
				return _Roles2.default.getRoles(this.businessId).then(function (response) {
					_this.roles = response.payload.roles;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'no_roles_found':
								break;
	
							case 'business_not_found':
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_business':
								_this.$swal({
									title: 'Error',
									html: 'You do not have access to this business.',
									type: 'warning'
								});
								break;
	
							default:
						}
					}
				}));
			},
			getLocationRoles: function getLocationRoles() {
				var _this = this;
	
				return _Roles2.default.getLocationRoles(this.locationId).then(function (response) {
					_this.locationRoles = response.payload.roles;
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							default:
						}
					}
				}));
			},
			redirectToPermissions: function redirectToPermissions() {
				this.process = 'form';
				this.$router.push(this.baseRoute + '/approval_permissions');
			}
		},
		watch: {
			'$route': function $route() {
				if (this.$route.name === this.baseRouteName + ' - Invite User') {
					this.activePanel = true;
					this.process = 'form';
				} else {
					this.activePanel = false;
				}
			}
		},
		components: {
			NextActions: _NextActions2.default,
			Typeahead: _Typeahead2.default
		}
	};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'breadcrumb',
		props: {
			crumbs: {
				default: []
			}
		}
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				open: false,
				displayLeft: false,
				id: 0
			};
		},
	
		props: {
			isLi: {
				default: false
			},
			show: {
				default: false
			},
			passedClass: null,
			disabled: {
				default: false
			},
			text: {
				default: null
			},
			type: {
				default: 'btn-default'
			},
			maxHeight: {
				type: Number,
				default: null
			},
			forceUpdate: {
				type: Boolean,
				default: false
			}
		},
		created: function created() {
			this.id = this.generateId();
	
			var _this = this;
			(0, _jquery2.default)(window).click(function (e) {
				if (!_this.isLi) {
					if ((0, _jquery2.default)(e.target).closest('button').parent().attr('id')) {
						if ((0, _jquery2.default)(e.target).closest('button').parent().attr('id') !== (0, _jquery2.default)(_this.$el).attr('id')) {
							_this.open = false;
						}
					}
				}
			});
		},
	
		computed: {
			classes: function classes() {
				return [{ open: this.open, disabled: this.disabled }, this.passedClass, this.isLi ? 'dropdown' : this.inInput ? 'input-group-btn' : 'btn-group', this.displayLeft ? 'left' : ''];
			},
			getElementsRestrictiveParent: function getElementsRestrictiveParent() {
				var tempEl = (0, _jquery2.default)(this.$el);
				if (tempEl.parent().is('body')) {
					return tempEl.parent();
				}
	
				while (!tempEl.parent().is('body')) {
					tempEl = tempEl.parent();
					if (tempEl.css('overflow') === 'hidden' || tempEl.css('overflow') === 'scroll' || tempEl.css('overflow') === 'auto') {
						return tempEl;
					}
				}
	
				return (0, _jquery2.default)('body');
			}
		},
		mounted: function mounted() {
			var _this2 = this;
	
			this.open = this.show;
	
			var $el = (0, _jquery2.default)(this.$el);
	
			$el.find('a, button.dropdown-toggle').on('click', function (e) {
				if (_this2.disabled) {
					return false;
				}
				_this2.open = !_this2.open;
			});
	
			$el.find('ul').on('click', 'li>a', function (e) {
				_this2.open = false;
			});
	
			if (this.maxHeight) {
				(0, _jquery2.default)('.dropdown-menu').css({ 'overflow': 'auto', 'max-height': this.maxHeight + 'px' });
			}
	
			this.checkLeft();
			this.checkTop();
	
			(0, _jquery2.default)(window).on('resize', function () {
				_this2.checkLeft();
				_this2.checkTop();
			});
		},
	
		methods: {
			generateId: function generateId() {
				var text = '';
				var possibleChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
				for (var i = 0; i < 5; i++) {
					text += possibleChar.charAt(Math.floor(Math.random() * possibleChar.length));
				}
	
				if ((0, _jquery2.default)(document).find('#dropdown-id-' + text).length) {
					this.generateId();
				} else {
					return text;
				}
			},
			checkLeft: function checkLeft() {
				var $el = (0, _jquery2.default)(this.$el);
	
				var leftDistance = (0, _jquery2.default)(window).width() - $el.offset().left;
				var ulWidth = $el.find('ul').width();
	
				if (leftDistance < ulWidth) {
					this.displayLeft = true;
				} else {
					this.displayLeft = false;
				}
			},
			checkTop: function checkTop() {
				var $el = (0, _jquery2.default)(this.$el);
	
				var bottomDistance = (0, _jquery2.default)(this.getElementsRestrictiveParent).offset().top + (0, _jquery2.default)(this.getElementsRestrictiveParent).height();
	
				var ulHeight = $el.find('ul').height();
	
				var buttonHeight = $el.height();
	
				var elementOffsetTop = $el.offset().top;
	
				if (bottomDistance < ulHeight + buttonHeight + elementOffsetTop) {
					$el.find('ul').css('top', -ulHeight);
				} else {
					$el.find('ul').css('top', '100%');
				}
			}
		},
		watch: {
			'forceUpdate': function forceUpdate(newVal) {
				if (newVal) {
					this.checkLeft();
				}
			}
		},
		beforeDestroy: function beforeDestroy() {
			var $el = (0, _jquery2.default)(this.$el);
			(0, _jquery2.default)(document).unbind('click');
			$el.find('a,button').off();
			$el.find('ul').off();
		}
	};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'font-picker',
		props: {
			passedFont: {
				default: {}
			}
		},
		created: function created() {
			var _this = this;
	
			if (!this.allGoogleFonts.length) {
				this.getGoogleFonts().then(function () {
					if (!_this.passedFont.family) {
						_this.setOpenSans();
					}
				});
			} else {
				if (!this.passedFont.family) {
					this.setOpenSans();
				}
			}
		},
	
		computed: (0, _vuex.mapGetters)(['allGoogleFonts']),
		methods: (0, _extends3.default)({
			setOpenSans: function setOpenSans() {
				var minIndex = 0;
				var maxIndex = this.allGoogleFonts.length;
				var currentIndex = void 0;
	
				while (minIndex <= maxIndex) {
					currentIndex = (minIndex + maxIndex) / 2 | 0;
	
					var currentName = this.allGoogleFonts[currentIndex].family;
					if (currentName === 'Open Sans') {
						this.emitFontFamily(this.allGoogleFonts[currentIndex]);
						break;
					} else if (currentName < 'Open Sans') {
						minIndex = currentIndex + 1;
					} else if (currentName > 'Open Sans') {
						maxIndex = currentIndex - 1;
					}
				}
			},
			emitFontFamily: function emitFontFamily(font) {
				this.$emit('updateFont', font);
			}
		}, (0, _vuex.mapActions)(['getGoogleFonts'])),
		components: {
			Dropdown: _Dropdown2.default
		}
	};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _googleMapsApiLoader = __webpack_require__(122);
	
	var _googleMapsApiLoader2 = _interopRequireDefault(_googleMapsApiLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var map = void 0,
	    marker = void 0;
	
	exports.default = {
		name: 'google-maps-pin-confirmation',
		props: {
			passedValue: {
				type: Object,
				default: {},
				required: true
			}
		},
		created: function created() {
			var _this = this;
	
			(0, _googleMapsApiLoader2.default)({
				libraries: ['places'],
				apiKey: 'AIzaSyBTLgkSK3g81GRBpZATw0UmxkwlbbRXwVg'
			}).then(function (googleApi) {
				var position = { lat: _this.passedValue.coordinates.lat, lng: _this.passedValue.coordinates.lng };
				map = new googleApi.maps.Map(document.getElementById('map'), {
					center: position,
					zoom: 15
				});
	
				marker = new googleApi.maps.Marker({
					position: position,
					map: map,
					draggable: true
				});
	
				marker.addListener('dragend', _this.updateMarkerLatLng);
			}, function (err) {
				console.error(err);
			});
		},
	
		methods: {
			updateMarkerLatLng: function updateMarkerLatLng(val) {
				var coordinates = { lat: val.latLng.lat(), lng: val.latLng.lng() };
				this.$emit('updateLocationLatLng', coordinates);
			}
		}
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _googleMapsApiLoader = __webpack_require__(122);
	
	var _googleMapsApiLoader2 = _interopRequireDefault(_googleMapsApiLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'google-places-search',
		props: {
			passedValue: {
				type: String,
				default: ''
			},
			confirmationMessage: {
				type: String,
				default: ''
			},
			currentSelectedLocation: {
				type: Object
			}
		},
		data: function data() {
			return {
				searchTerm: '',
				selectedLocation: {}
			};
		},
		created: function created() {
			var _this2 = this;
	
			if (this.currentSelectedLocation && this.currentSelectedLocation.id) {
				var routeName = void 0,
				    city = void 0,
				    province = void 0,
				    country = void 0;
	
				for (var i = 0, x = this.currentSelectedLocation.address_components.length; i < x; i++) {
					for (var j = 0, y = this.currentSelectedLocation.address_components[i].types.length; j < y; j++) {
						switch (this.currentSelectedLocation.address_components[i].types[j]) {
							case 'route':
								routeName = this.currentSelectedLocation.address_components[i].long_name;
								break;
	
							case 'locality':
								city = this.currentSelectedLocation.address_components[i].long_name;
								break;
	
							case 'administrative_area_level_1':
								province = this.currentSelectedLocation.address_components[i].short_name;
								break;
	
							case 'country':
								country = this.currentSelectedLocation.address_components[i].long_name;
								break;
	
							default:
						}
					}
				}
				var tempTerm = this.currentSelectedLocation.name;
				if (routeName && routeName.length) {
					tempTerm += ', ' + routeName;
				}
				if (city && city.length) {
					tempTerm += ', ' + city;
				}
				if (province && province.length) {
					tempTerm += ', ' + province;
				}
				if (country && country.length) {
					tempTerm += ', ' + country;
				}
				this.searchTerm = tempTerm;
	
				this.selectedLocation = this.currentSelectedLocation;
			} else if (this.passedValue.length) {
				this.searchTerm = this.passedValue;
			}
	
			var _this = this;
	
			setTimeout(function () {
				(0, _googleMapsApiLoader2.default)({
					libraries: ['places'],
					apiKey: 'AIzaSyBTLgkSK3g81GRBpZATw0UmxkwlbbRXwVg'
				}).then(function (googleApi) {
					var input = document.getElementById('google_places_search');
					var autocomplete = new googleApi.maps.places.Autocomplete(input);
					autocomplete.setTypes(['establishment']);
	
					if ((!_this2.currentSelectedLocation || !_this2.currentSelectedLocation.id) && _this2.passedValue.length) {
						_this.inputFocus();
					}
	
					autocomplete.addListener('place_changed', function () {
						_this.searchTerm = input.value;
						_this.selectedLocation = autocomplete.getPlace();
						_this.formatSelectedLocationData();
					});
				}, function (err) {
					console.error(err);
				});
			}, 500);
		},
	
		methods: {
			formatSelectedLocationData: function formatSelectedLocationData() {
				if (this.selectedLocation.photos) {
					this.selectedLocation.main_photo = this.selectedLocation.photos[0].getUrl({ maxWidth: 640 });
				}
				this.selectedLocation.coordinates = {
					lat: this.selectedLocation.geometry.location.lat(),
					lng: this.selectedLocation.geometry.location.lng()
				};
				this.emitSelectedLocation();
			},
			inputFocus: function inputFocus() {
				var _this3 = this;
	
				if ((0, _jquery2.default)(document).find('.pac-container').length) {
					(0, _jquery2.default)('#google_places_search').focus();
				} else {
					setTimeout(function () {
						_this3.inputFocus();
					}, 100);
				}
			},
			emitSelectedLocation: function emitSelectedLocation() {
				this.$emit('selectedLocation', this.selectedLocation);
			}
		}
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				open: false,
				id: 0,
				rightSide: false
			};
		},
	
		props: {
			content: {
				default: ''
			}
		},
		created: function created() {
			this.id = this.generateId();
	
			var _this = this;
			(0, _jquery2.default)(window).click(function (e) {
				var infoPopoverElement = (0, _jquery2.default)(_this.$el).find('.fa-question-circle');
				if (!(0, _jquery2.default)(e.target).hasClass('fa-question-circle') || (0, _jquery2.default)(e.target).hasClass('fa-question-circle') && e.target.id !== infoPopoverElement.attr('id')) {
					_this.open = false;
				}
			});
		},
	
		methods: {
			generateId: function generateId() {
				var text = '';
				var possibleChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
				for (var i = 0; i < 5; i++) {
					text += possibleChar.charAt(Math.floor(Math.random() * possibleChar.length));
				}
	
				if ((0, _jquery2.default)(document).find('#popover-id-' + text).length) {
					this.generateId();
				} else {
					return text;
				}
			},
			openPopover: function openPopover() {
				this.open = true;
	
				if ((0, _jquery2.default)(window).width() - (0, _jquery2.default)(this.$el).offset().left < 100) {
					this.rightSide = true;
				} else {
					this.rightSide = false;
				}
			}
		}
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: {
			appBackground: {
				default: false
			},
			color: {
				default: 'white'
			},
			show: {
				default: false
			},
			autoStop: {
				default: false
			},
			display: {
				default: null
			},
			position: {
				default: null
			},
			size: {
				default: null
			}
		},
		data: function data() {
			return {
				timeout: '',
				activeSpinner: false
			};
		},
		mounted: function mounted() {
			if (this.show) {
				this.startLoading();
			} else if (this.activeSpinner) {
				this.removeLoadingScreen();
			}
		},
	
		methods: {
			startLoading: function startLoading() {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
	
				var $el = (0, _jquery2.default)(this.$el);
				$el.show();
	
				if (this.appBackground) {
					(0, _jquery2.default)('body').prepend('<div class="app-bg"></div>');
				}
				if (this.autoStop) {
					this.stopLoading();
				}
	
				this.activeSpinner = true;
			},
			stopLoading: function stopLoading() {
				var _this = this;
	
				var $el = (0, _jquery2.default)(this.$el);
	
				this.timeout = setTimeout(function () {
					$el.fadeOut(500);
					if (_this.appBackground) {
						(0, _jquery2.default)('.app-bg').fadeOut(1000);
					}
					_this.activeSpinner = false;
					_this.emitStop();
				}, 2000);
			},
			removeLoadingScreen: function removeLoadingScreen() {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				if (this.appBackground) {
					(0, _jquery2.default)('.app-bg').remove();
				}
	
				var $el = (0, _jquery2.default)(this.$el);
				$el.hide();
	
				this.activeSpinner = false;
				this.emitStop();
			},
			emitStop: function emitStop() {
				this.$emit('stopLoadingScreen');
			}
		},
		watch: {
			show: function show(val) {
				if (val) {
					this.startLoading();
				} else if (this.activeSpinner) {
					this.removeLoadingScreen();
				}
			}
		}
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _isInteger = __webpack_require__(230);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getScrollBarWidth = function getScrollBarWidth() {
		if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
			return 0;
		}
		var inner = document.createElement('p');
		inner.style.width = '100%';
		inner.style.height = '200px';
	
		var outer = document.createElement('div');
		outer.style.position = 'absolute';
		outer.style.top = '0px';
		outer.style.left = '0px';
		outer.style.visibility = 'hidden';
		outer.style.width = '200px';
		outer.style.height = '150px';
		outer.style.overflow = 'hidden';
		outer.appendChild(inner);
	
		document.body.appendChild(outer);
		var w1 = inner.offsetWidth;
		outer.style.overflow = 'scroll';
		var w2 = inner.offsetWidth;
		if (w1 === w2) w2 = outer.clientWidth;
	
		document.body.removeChild(outer);
	
		return w1 - w2;
	};
	
	exports.default = {
		name: 'modal',
		props: {
			backdrop: {
				default: false
			},
			cancelText: {
				default: 'Close'
			},
			effect: {
				default: null
			},
			okText: {
				default: 'Save'
			},
			show: {
				required: true
			},
			title: {
				default: ''
			},
			width: {
				default: null
			}
		},
		computed: {
			computedWidth: function computedWidth() {
				if (this.width === null) {
					return null;
				} else if ((0, _isInteger2.default)(this.width)) {
					return this.width + 'px';
				}
				return this.width;
			}
		},
		methods: {
			close: function close() {
				this.$emit('update:show', false);
			},
			callback: function callback() {
				this.$emit('callback');
			}
		},
		watch: {
			show: function show(val) {
				var _this = this;
	
				var el = this.$el;
				var body = document.body;
				var scrollBarWidth = getScrollBarWidth();
				if (val) {
					(0, _jquery2.default)(el).find('.modal-content').focus();
					el.style.display = 'block';
					setTimeout(function () {
						return (0, _jquery2.default)(el).addClass('in');
					}, 0);
					(0, _jquery2.default)(body).addClass('modal-open');
					if (scrollBarWidth !== 0) {
						body.style.paddingRight = scrollBarWidth + 'px';
					}
					if (this.backdrop) {
						(0, _jquery2.default)(el).on('click', function (e) {
							if (e.target === el) _this.$emit('update:show', false);
						});
					}
				} else {
					body.style.paddingRight = null;
					(0, _jquery2.default)(body).removeClass('modal-open');
					(0, _jquery2.default)(el).removeClass('in').on('transitionend', function () {
						(0, _jquery2.default)(el).off('click transitionend');
						el.style.display = 'none';
					});
				}
			}
		}
	};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'next-actions',
		props: {
			actionsList: {
				default: []
			}
		},
		methods: {
			emitFunction: function emitFunction(functionName, params) {
				this.$emit('runFunction', functionName, params);
			}
		}
	};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'no-results',
		props: {
			show: {
				default: false
			},
			type: {
				default: 'results'
			}
		},
		data: function data() {
			return {
				display: false
			};
		},
		created: function created() {
			this.display = this.show;
		},
	
		watch: {
			show: function show(val) {
				if (val) {
					this.display = true;
				} else {
					this.display = false;
				}
			}
		}
	};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultResults = 25;
	
	exports.default = {
		name: 'page-results',
		props: {
			totalResults: {
				default: 0
			},
			activePage: {
				default: 1
			},
			allowPageChange: {
				default: true
			},
			resultsPerPageOverride: {
				default: null
			}
		},
		data: function data() {
			return {
				resultsPerPage: defaultResults,
				resultOptions: [25, 50, 100]
			};
		},
		created: function created() {
			if (this.checkLocalStorage()) {
				this.resultsPerPage = parseInt(this.checkLocalStorage());
			} else {
				this.setLocalStorage(defaultResults);
			}
			this.emitResults();
		},
	
		computed: {
			pageStart: function pageStart() {
				var localPageStart = 0;
				var pageResultsAmount = this.resultsPerPageOverride ? this.resultsPerPageOverride : this.resultsPerPage;
				if (this.activePage) {
					localPageStart = (this.activePage - 1) * pageResultsAmount + 1;
				}
				return localPageStart;
			},
			pageEnd: function pageEnd() {
				var localPageEnd = 0;
				var pageResultsAmount = this.resultsPerPageOverride ? this.resultsPerPageOverride : this.resultsPerPage;
				if (this.activePage) {
					localPageEnd = this.activePage * pageResultsAmount;
				}
				if (localPageEnd > this.totalResults) {
					localPageEnd = this.totalResults;
				}
				return localPageEnd;
			}
		},
		methods: {
			checkLocalStorage: function checkLocalStorage() {
				if (localStorage.getItem('pageResults')) {
					return localStorage.getItem('pageResults');
				} else {
					return 0;
				}
			},
			setLocalStorage: function setLocalStorage(results) {
				localStorage.setItem('pageResults', results);
			},
			updateResultsPerPage: function updateResultsPerPage(results) {
				if (this.resultsPerPage === results) {
					return;
				}
	
				this.resultsPerPage = results;
				this.setLocalStorage(results);
				this.emitResults();
			},
			emitResults: function emitResults() {
				this.$emit('pageResults', this.resultsPerPage);
			}
		},
		components: {
			Dropdown: _Dropdown2.default
		}
	};

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'pagination',
		props: {
			numPages: {
				default: 1
			},
			passedPage: {}
		},
		data: function data() {
			return {
				activePage: 1
			};
		},
		created: function created() {
			if (this.passedPage) {
				if (this.passedPage <= this.numPages) {
					if (this.activePage !== this.passedPage) {
						this.activePage = this.passedPage;
					}
				} else {
					this.activePage = 1;
				}
			}
		},
		updated: function updated() {
			if (this.passedPage) {
				if (this.passedPage <= this.numPages) {
					if (this.activePage !== this.passedPage) {
						this.activePage = this.passedPage;
					}
				} else {
					this.activePage = 1;
				}
			}
		},
	
		computed: {
			pagesArray: function pagesArray() {
				var localPagesArray = [];
				for (var i = 1, x = this.numPages; i <= x; i++) {
					localPagesArray.push(i);
				}
				return localPagesArray;
			}
		},
		methods: {
			setActivePage: function setActivePage(page) {
				if (page !== this.activePage && page !== 0 && page <= this.numPages) {
					this.activePage = page;
					this.emitActivePage();
				}
			},
			emitActivePage: function emitActivePage() {
				this.$emit('activePageChange', this.activePage);
			},
			showPageIndex: function showPageIndex(index) {
				if (index === 0 || index === this.pagesArray.length - 1) {
					return false;
				}
	
				if (index === this.activePage - 1) {
					return true;
				}
	
				if (index === this.activePage - 2 || index === this.activePage) {
					return true;
				}
	
				return false;
			}
		}
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(2);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(16);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Dropdown = __webpack_require__(9);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _LoadingScreen = __webpack_require__(15);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	var _Modal = __webpack_require__(39);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PageResults = __webpack_require__(32);
	
	var _PageResults2 = _interopRequireDefault(_PageResults);
	
	var _Pagination = __webpack_require__(33);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _ResourceFolder = __webpack_require__(131);
	
	var _ResourceFolder2 = _interopRequireDefault(_ResourceFolder);
	
	var _FileUpload = __webpack_require__(130);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _Resources = __webpack_require__(27);
	
	var _Resources2 = _interopRequireDefault(_Resources);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'resource-modal',
		props: {
			buttonText: {
				type: String,
				default: 'Select Resource'
			}
		},
		data: function data() {
			return {
				showResourceModal: false,
				filterCollapse: true,
				folders: {},
				activeFolder: {},
				currentResources: [],
				numPages: 0,
				totalResults: 0,
				activePage: 1,
				loadingResourceData: false,
				allFoldersView: false,
				advancedSearch: {
					search: '',
					range: 'this_folder',
					searchOptions: [{ name: 'All Folders', value: 'all_folders' }, { name: 'This Folder', value: 'this_folder' }]
				},
				sortBy: {
					field: 'name',
					order: 'asc'
				},
				sortOptions: {
					name: 'Name',
					size: 'Size',
					created_at: 'Date Added'
				},
				isSaving: false,
				searchError: '',
				tags: [],
				fileTypes: [{ name: 'image', icon: 'fa fa-file-image-o', active: false }, { name: 'video', icon: 'fa fa-file-video-o', active: false }, { name: 'documents', icon: 'fa fa-file-text-o', active: false }, { name: 'other', icon: 'fa fa-file-o', active: false }],
				selectedResource: {}
			};
		},
	
		computed: (0, _vuex.mapGetters)(['activeBusinessId', 'activeBusinessName', 'activeLocationId', 'activeLocationName']),
		methods: {
			openResourceModal: function openResourceModal() {
				this.showResourceModal = true;
				this.getFolders();
				this.getTags();
			},
			closeResourceModal: function closeResourceModal() {
				this.showResourceModal = false;
			},
			getFolders: function getFolders(parentId, folder) {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var pageNumber = 1;
				var recordsPerPage = 100;
				if (!parentId) {
					parentId = 0;
				}
	
				return _Resources2.default.getFolders(businessId, locationId, parentId, pageNumber, recordsPerPage).then(function (response) {
					if (parentId === 0) {
						_this.folders = (0, _assign2.default)({}, _this.folders, response.payload.folders[0]);
						_this.$set(_this.folders, 'expanded', false);
						_this.$set(_this.folders, 'children_fetched', false);
					} else {
						_this.$set(folder, 'children_fetched', true);
						_this.$set(folder, 'children', response.payload.folders);
					}
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'folder_not_found':
								_this.$set(folder, 'children_fetched', true);
								_this.$set(folder, 'children', []);
								break;
	
							case 'business_not_found':
								break;
	
							case 'invalid_page_number':
								break;
	
							default:
						}
					}
				}));
			},
			expandNode: function expandNode(folder) {
				if (folder.expanded) {
					this.$set(folder, 'expanded', false);
				} else {
					this.$set(folder, 'expanded', true);
	
					this.getFolders(folder.id, folder);
				}
			},
			activePageUpdate: function activePageUpdate(val, folder, override) {
				if (parseInt(this.activePage) !== parseInt(val)) {
					this.activePage = val;
					if (folder) {
						this.getResources(folder, this.activePage);
					} else {
						this.getResources(this.activeFolder, this.activePage);
					}
				} else if (override) {
					if (folder) {
						this.getResources(folder, this.activePage);
					} else {
						this.getResources(this.activeFolder, this.activePage);
					}
				}
			},
			formatSearchCriteria: function formatSearchCriteria() {
				var searchCriteria = {};
	
				if (this.advancedSearch.search.length > 2) {
					searchCriteria.search_query = this.advancedSearch.search;
					searchCriteria.search_in = 'name';
				}
	
				searchCriteria.tags = [];
				this.tags.forEach(function (tag) {
					if (tag.active) {
						searchCriteria.tags.push(tag.id);
					}
				});
	
				return searchCriteria;
			},
			preloadImages: function preloadImages() {
				var _this = this;
	
				return new _promise2.default(function (resolve, reject) {
					if (!_this.currentResources.length) {
						resolve();
					}
	
					_this.currentResources.forEach(function (resource) {
						var img = new Image();
						img.src = resource.url;
					});
	
					resolve();
				});
			},
			getResources: function getResources(folder, pageNumber) {
				var _this2 = this;
	
				this.loadingResourceData = true;
				this.currentResources = [];
	
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var recordsPerPage = 27;
				var searchCriteria = this.formatSearchCriteria();
				var sortCriteria = { sort_by: this.sortBy.field, sort_order: this.sortBy.order };
	
				if (!pageNumber) {
					pageNumber = this.activePage;
				}
	
				var folderId = folder.id;
				if (this.advancedSearch.range === 'all_folders') {
					folderId = null;
					this.allFoldersView = true;
					this.activeFolder = (0, _assign2.default)({});
				} else {
					this.allFoldersView = false;
					this.activeFolder = (0, _assign2.default)({}, folder);
				}
	
				return _Resources2.default.getResources(businessId, locationId, folderId, pageNumber, recordsPerPage, searchCriteria, sortCriteria).then(function (response) {
					_this.currentResources = response.payload.files;
					_this.numPages = response.payload.number_of_pages;
					_this.totalResults = response.payload.number_of_records;
	
					_this.preloadImages().then(function (response) {
						setTimeout(function () {
							_this.loadingResourceData = false;
							setTimeout(function () {
								_this.calculateImageHeight();
							}, 0);
						}, 500);
					}).catch(function (error) {
						console.log(error);
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
							case 'file_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								break;
	
							case 'business_not_found':
								_this.numPages = 0;
								_this.totalResults = 0;
								_this.$swal({
									title: 'Error',
									html: 'There is an issue with your business account. Please contact your admin.',
									type: 'warning'
								});
								break;
	
							case 'invalid_page_number':
								_this.numPages = e.responseJSON.payload.number_of_pages;
								_this.totalResults = e.responseJSON.payload.number_of_records;
								if (_this.numPages !== 0) {
									_this.getResources(_this2.activeFolder, e.responseJSON.payload.number_of_pages);
								}
								break;
	
							default:
						}
					}
					_this.loadingResourceData = false;
				}));
			},
			getTags: function getTags() {
				var _this = this;
				var businessId = this.activeBusinessId;
				var locationId = this.activeLocationId;
				var pageNumber = 1;
				var recordsPerPage = 100;
	
				return _Resources2.default.getTags(businessId, locationId, pageNumber, recordsPerPage).then(function (response) {
					_this.tags = response.payload.tags.map(function (tag) {
						tag.active = false;
						return tag;
					});
				}).catch(_this.$root.errorWrapper(function (e) {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {}
					}
				}));
			},
			checkSaving: function checkSaving(val) {
				this.isSaving = val;
			},
			imageUploaded: function imageUploaded(val) {
				this.getResources(this.activeFolder, this.activePage);
			},
			setSortField: function setSortField(field) {
				if (field !== this.sortBy.field) {
					this.sortBy.field = field;
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			},
			toggleFilterPanel: function toggleFilterPanel() {
				this.filterCollapse = !this.filterCollapse;
			},
			calculateImageHeight: function calculateImageHeight() {
				if (!this.$refs.resource || !this.$refs.resource.length) {
					return;
				}
	
				var height = window.getComputedStyle(this.$refs.resource[0]).width;
	
				this.$refs.resource.forEach(function (ref) {
					ref.style.height = height;
				});
			},
			toggleTag: function toggleTag(tag) {
				tag.active = !tag.active;
			},
			toggleFileType: function toggleFileType(type) {
				type.active = !type.active;
			},
			clearSearchError: function clearSearchError() {
				this.searchError = '';
			},
			advancedResourceSearch: function advancedResourceSearch() {
				this.clearSearchError();
				if (this.advancedSearch.search.length && this.advancedSearch.search.length < 3) {
					this.searchError = 'In order to use the search field your term must be at least 3 characters.';
				} else {
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			},
			setResource: function setResource(resource) {
				this.selectedResource = (0, _assign2.default)({}, resource);
			},
			resetResourceSearch: function resetResourceSearch() {
				this.advancedSearch = {
					search: '',
					range: 'this_folder',
					searchOptions: [{ name: 'All Folders', value: 'all_folders' }, { name: 'This Folder', value: 'this_folder' }]
				};
	
				this.tags.forEach(function (tag) {
					tag.active = false;
				});
				this.fileTypes.forEach(function (type) {
					type.active = false;
				});
	
				this.clearSearchError();
			},
			resourceSelectionComplete: function resourceSelectionComplete() {
				this.$emit('selected', this.selectedResource);
				this.closeResourceModal();
			}
		},
		components: {
			Dropdown: _Dropdown2.default,
			LoadingScreen: _LoadingScreen2.default,
			Modal: _Modal2.default,
			PageResults: _PageResults2.default,
			Pagination: _Pagination2.default,
			FileUpload: _FileUpload2.default,
			ResourceFolder: _ResourceFolder2.default
		},
		watch: {
			'sortBy.order': function sortByOrder() {
				if (this.sortBy.field) {
					if (parseInt(this.activePage) === 1) {
						this.getResources(this.activeFolder, 1);
					} else {
						this.activePageUpdate(1, this.activeFolder);
					}
				}
			}
		}
	};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'step-counter',
		props: {
			steps: {
				type: Array,
				default: function _default() {
					return [];
				}
			},
			process: {
				required: true,
				type: String
			}
		},
		computed: {
			computedStepText: function computedStepText() {
				var text = '';
				for (var i = 0, x = this.steps.length; i < x; i++) {
					if (this.process === this.steps[i].key) {
						text = i + 1 + '. ' + this.steps[i].name;
					}
				}
				return text;
			}
		}
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'typeahead',
		props: {
			data: {
				type: Array,
				required: true,
				default: function _default() {
					return [];
				}
			},
			emitter: {
				type: String
			},
			filter: {},
			helpBlock: {
				type: String
			},
			label: {
				default: '',
				type: String
			},
			limit: {
				type: Number,
				default: 8
			},
			objectKey: {
				type: String,
				default: null
			},
			placeholder: {
				type: String
			},
			passedValue: {
				default: null
			},
			tabindex: {
				default: 0
			},
			onFirstFocus: {
				default: false
			},
			multiSearch: {
				default: false
			},
			multiSearchKeys: {
				default: function _default() {
					return [];
				}
			}
		},
		data: function data() {
			return {
				showDropdown: false,
				noResult: true,
				current: 0,
				items: [],
				value: '',
				predictiveValue: ''
			};
		},
		created: function created() {
			this.items = this.primitiveData;
			this.runFilter();
			if (this.passedValue) {
				if (this.multiSearch) {
					if (!(0, _lodash.isEmpty)(this.passedValue)) {
						this.value = this.buildText(this.passedValue);
					}
				} else if (this.objectKey) {
					this.value = this.passedValue[this.objectKey];
				} else {
					this.value = this.passedValue;
				}
			}
		},
	
		computed: {
			primitiveData: function primitiveData() {
				var _this = this;
	
				if (this.data.length) {
					return this.data.filter(function (value) {
						if (!_this.value.length && _this.onFirstFocus) {
							return _this.data.slice(0, _this.limit);
						}
						var query = _this.value.toLowerCase();
						var isValueTrue = false;
						if (_this.multiSearch) {
							for (var i = 0, x = _this.multiSearchKeys.length; i < x; i++) {
								if (value[_this.multiSearchKeys[i].parent_key]) {
									if (value[_this.multiSearchKeys[i].parent_key][_this.multiSearchKeys[i].key] && value[_this.multiSearchKeys[i].parent_key][_this.multiSearchKeys[i].key].toLowerCase().indexOf(query) !== -1) {
										isValueTrue = true;
									}
								} else if (value[_this.multiSearchKeys[i].key] && value[_this.multiSearchKeys[i].key].toLowerCase().indexOf(query) !== -1) {
									isValueTrue = true;
								}
							}
						} else if (_this.objectKey) {
							value = value[_this.objectKey].toLowerCase();
							if (value.indexOf(query) !== -1) {
								isValueTrue = true;
							}
						} else {
							value = value.toLowerCase();
							if (value.indexOf(query) !== -1) {
								isValueTrue = true;
							}
						}
						return isValueTrue;
					}).slice(0, this.limit);
				} else {
					return [];
				}
			},
			sortedPredictionList: function sortedPredictionList() {
				var _this2 = this;
	
				return this.items.sort(function (a, b) {
					if (_this2.multiSearch) {
						if (_this2.multiSearchKeys[0].parent_key) {
							if (a[_this2.multiSearchKeys[0].parent_key][_this2.multiSearchKeys[0].key] < b[_this2.multiSearchKeys[0].parent_key][_this2.multiSearchKeys[0].key]) return -1;
							if (a[_this2.multiSearchKeys[0].parent_key][_this2.multiSearchKeys[0].key] > b[_this2.multiSearchKeys[0].parent_key][_this2.multiSearchKeys[0].key]) return 1;
						} else {
							if (a[_this2.multiSearchKeys[0].key] < b[_this2.multiSearchKeys[0].key]) return -1;
							if (a[_this2.multiSearchKeys[0].key] > b[_this2.multiSearchKeys[0].key]) return 1;
						}
					} else if (_this2.objectKey) {
						if (a[_this2.objectKey] < b[_this2.objectKey]) return -1;
						if (a[_this2.objectKey] > b[_this2.objectKey]) return 1;
					} else {
						if (a < b) return -1;
						if (a > b) return 1;
					}
					return 0;
				});
			}
		},
		methods: {
			update: function update() {
				if (!this.value) {
					this.reset();
					this.$emit(this.emitter, '');
					return false;
				}
	
				if (this.data) {
					this.items = this.primitiveData;
					this.runFilter();
					this.showDropdown = true;
					this.calculatePredictiveValue();
				}
			},
			reset: function reset() {
				if (this.onFirstFocus) {
					this.items = this.data.slice(0, this.limit);
					this.runFilter();
					this.showDropdown = true;
				} else {
					this.items = [];
					this.showDropdown = false;
				}
				this.value = '';
			},
			setActive: function setActive(index) {
				this.current = index;
			},
			isActive: function isActive(index) {
				return this.current === index;
			},
			hit: function hit(e, override) {
				this.predictiveValue = '';
				if (e) {
					e.preventDefault();
				}
	
				var currentOverride = this.current;
				if (override || override === 0) {
					currentOverride = override;
				}
	
				if (this.items[currentOverride]) {
					this.showDropdown = false;
					if (this.multiSearch) {
						this.value = this.buildText(this.items[currentOverride]);
						this.$emit(this.emitter, this.items[currentOverride]);
					} else if (this.objectKey) {
						this.value = this.items[currentOverride][this.objectKey];
						this.$emit(this.emitter, this.items[currentOverride]);
					} else {
						this.value = this.items[currentOverride];
						this.$emit(this.emitter, this.value);
					}
				}
			},
			up: function up() {
				if (this.current > 0) {
					this.current--;
				}
			},
			down: function down() {
				if (this.current < this.items.length - 1) {
					this.current++;
				}
			},
			onFocus: function onFocus() {
				this.$emit('onFocus');
				(0, _jquery2.default)(this.$el).find('.prediction-output-input').select();
				if (this.onFirstFocus) {
					this.showDropdown = true;
				}
			},
			buildText: function buildText(item) {
				var text = '';
				for (var i = 0, x = this.multiSearchKeys.length; i < x; i++) {
					if (item[this.multiSearchKeys[i].parent_key]) {
						if (this.multiSearchKeys[i].sub_string && text.length) {
							text += '- ';
						}
						if (item[this.multiSearchKeys[i].parent_key][this.multiSearchKeys[i].key].length) {
							text += item[this.multiSearchKeys[i].parent_key][this.multiSearchKeys[i].key];
							if (i + 1 !== x) {
								text += ' ';
							}
						}
					} else {
						if (this.multiSearchKeys[i].sub_string && text.length) {
							text += '- ';
						}
						if (item[this.multiSearchKeys[i].key].length) {
							text += item[this.multiSearchKeys[i].key];
							if (i + 1 !== x) {
								text += ' ';
							}
						}
					}
				}
				return text;
			},
			highlight: function highlight(phrase) {
				return phrase.replace(new RegExp('(' + this.value + ')', 'gi'), '<strong>$1</strong>');
			},
			calculatePredictiveValue: function calculatePredictiveValue() {
				if (!this.value.length) {
					this.predictiveValue = '';
					return;
				}
	
				var updated = false;
				var minIndex = 0;
				var maxIndex = this.sortedPredictionList.length - 1;
				var currentIndex = void 0;
				var currentElement = void 0;
	
				while (minIndex <= maxIndex) {
					currentIndex = (minIndex + maxIndex) / 2 | 0;
					if (this.multiSearch) {
						currentElement = this.buildText(this.sortedPredictionList[currentIndex]);
					} else if (this.objectKey) {
						currentElement = this.sortedPredictionList[currentIndex][this.objectKey];
					} else {
						currentElement = this.sortedPredictionList[currentIndex];
					}
					if (currentElement.toLowerCase().indexOf(this.value.toLowerCase()) === 0) {
						var frankensteinElement = this.value + currentElement.substring(this.value.length);
						this.predictiveValue = frankensteinElement;
						updated = true;
						break;
					} else if (currentElement.toLowerCase() < this.value.toLowerCase()) {
						minIndex = currentIndex + 1;
					} else if (currentElement.toLowerCase() > this.value.toLowerCase()) {
						maxIndex = currentIndex - 1;
					}
				}
	
				if (!updated) {
					this.predictiveValue = '';
				}
			},
			hidePredictiveValue: function hidePredictiveValue() {
				this.predictiveValue = '';
			},
			selectPredictiveOption: function selectPredictiveOption() {
				this.value = this.predictiveValue;
	
				var currentOverride = void 0;
				for (var i = 0, x = this.items.length; i < x; i++) {
					if (this.multiSearch) {
						if (this.buildText(this.items[i]).toLowerCase() === this.value.toLowerCase()) {
							currentOverride = i;
						}
					} else if (this.objectKey) {
						if (this.items[i][this.objectKey].toLowerCase() === this.value.toLowerCase()) {
							currentOverride = i;
						}
					} else {
						if (this.items[i].toLowerCase() === this.value.toLowerCase()) {
							currentOverride = i;
						}
					}
				}
	
				this.hit(false, currentOverride);
				this.hidePredictiveValue();
			},
			runFilter: function runFilter() {
				if (this.filter) {
					if (Array.isArray(this.filter)) {} else {
						for (var i = 0, x = this.items.length; i < x; i++) {
							if (this.multiSearch) {} else if (this.objectKey) {
								if (this.items[i][this.objectKey] === this.filter[this.objectKey]) {
									this.items.splice(i, 1);
									return;
								}
							} else {
								if (this.items[i] === this.filter) {
									this.items.splice(i, 1);
									return;
								}
							}
						}
					}
				}
			}
		},
		watch: {
			'passedValue': function passedValue() {
				if (this.multiSearch) {
					if (!(0, _lodash.isEmpty)(this.passedValue)) {
						this.value = this.buildText(this.passedValue);
					}
				} else if (this.objectKey) {
					if (this.passedValue[this.objectKey] !== this.value) {
						this.value = this.passedValue[this.objectKey];
					}
				} else {
					if (this.passedValue !== this.value) {
						this.value = this.passedValue;
					}
				}
			}
		}
	};

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		replace: true,
		name: 'selector',
		props: {
			index: {
				type: Number,
				default: 0
			},
			playlist: {
				type: Number,
				default: 0
			},
			active: {
				type: Boolean, default: false
			},
			draggable: {
				type: Boolean, default: true
			},
			resizable: {
				type: Boolean, default: true
			},
			w: {
				type: Number,
				default: 200,
				validator: function validator(val) {
					return val > 0;
				}
			},
			h: {
				type: Number,
				default: 200,
				validator: function validator(val) {
					return val > 0;
				}
			},
			minw: {
				type: Number,
				default: 50,
				validator: function validator(val) {
					return val > 0;
				}
			},
			minh: {
				type: Number,
				default: 50,
				validator: function validator(val) {
					return val > 0;
				}
			},
			x: {
				type: Number,
				default: 0,
				validator: function validator(val) {
					return typeof val === 'number';
				}
			},
			y: {
				type: Number,
				default: 0,
				validator: function validator(val) {
					return typeof val === 'number';
				}
			},
			z: {
				type: Number,
				default: 0,
				validator: function validator(val) {
					return typeof val === 'number';
				}
			},
			handles: {
				type: Array,
				default: function _default() {
					return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
				}
			},
			axis: {
				type: String,
				default: 'both',
				validator: function validator(val) {
					return ['x', 'y', 'both'].indexOf(val) !== -1;
				}
			},
			grid: {
				type: Array,
				default: function _default() {
					return [1, 1];
				}
			},
			parent: {
				type: Boolean, default: false
			},
			maximize: {
				type: Boolean, default: false
			}
		},
		created: function created() {
			this.parentX = 0;
			this.parentW = 9999;
			this.parentY = 0;
			this.parentH = 9999;
			this.mouseX = 0;
			this.mouseY = 0;
			this.lastMouseX = 0;
			this.lastMouseY = 0;
			this.mouseOffX = 0;
			this.mouseOffY = 0;
			this.elmX = 0;
			this.elmY = 0;
			this.elmW = 0;
			this.elmH = 0;
		},
		mounted: function mounted() {
			document.documentElement.addEventListener('mousemove', this.handleMove, true);
			document.documentElement.addEventListener('mousedown', this.deselect, true);
			document.documentElement.addEventListener('mouseup', this.handleUp, true);
			this.elmX = parseInt(this.$el.style.left);
			this.elmY = parseInt(this.$el.style.top);
			this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
			this.elmH = this.$el.offsetHeight || this.$el.clientHeight;
			this.reviewDimensions();
		},
		beforeDestroy: function beforeDestroy() {
			document.documentElement.removeEventListener('mousemove', this.handleMove, true);
			document.documentElement.removeEventListener('mousedown', this.deselect, true);
			document.documentElement.removeEventListener('mouseup', this.handleUp, true);
		},
		data: function data() {
			return {
				top: this.y,
				left: this.x,
				width: this.w,
				height: this.h,
				resizing: false,
				dragging: false,
				enabled: this.active,
				handle: null,
				zIndex: this.z
			};
		},
		methods: {
			reviewDimensions: function reviewDimensions() {
				if (this.minw > this.w) this.width = this.minw;
				if (this.minh > this.h) this.height = this.minh;
				if (this.parent) {
					var parentW = parseInt(this.$el.parentNode.clientWidth, 10);
					var parentH = parseInt(this.$el.parentNode.clientHeight, 10);
					this.parentW = parentW;
					this.parentH = parentH;
					if (this.w > this.parentW) this.width = parentW;
					if (this.h > this.parentH) this.height = parentH;
					if (this.x + this.w > this.parentW) this.width = parentW - this.x;
					if (this.y + this.h > this.parentH) this.height = parentH - this.y;
				}
				this.elmW = this.width;
				this.elmH = this.height;
				this.$emit('resizing', this.left, this.top, this.width, this.height, this.index, this.playlist);
			},
			elmDown: function elmDown(e) {
				var _this = this;
	
				this.width = this.w;
				var target = e.target || e.srcElement;
	
				if (this.$el.contains(target)) {
					this.reviewDimensions();
					if (!this.enabled) {
						this.enabled = true;
						if (target.id) {
							this.$emit('updateData', target.style.left, target.style.width, this.index, this.playlist);
						}
						this.$nextTick(function () {
							_this.$emit('activated');
							_this.$emit('update:active', true);
						});
					}
					if (this.draggable) {
						this.dragging = true;
					}
				}
			},
			deselect: function deselect(e) {
				this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
				this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
				this.lastMouseX = this.mouseX;
				this.lastMouseY = this.mouseY;
				var target = e.target || e.srcElement;
				var regex = new RegExp('handle-([trmbl]{2})', '');
				if (!this.$el.contains(target) && !regex.test(target.className)) {
					if (this.enabled) {
						this.enabled = false;
						this.$emit('deactivated');
						this.$emit('update:active', false);
					}
				}
			},
			handleDown: function handleDown(handle, e) {
				this.handle = handle;
				if (e.stopPropagation) e.stopPropagation();
				if (e.preventDefault) e.preventDefault();
				this.resizing = true;
			},
			fillParent: function fillParent(e) {
				var _this2 = this;
	
				if (!this.parent || !this.resizable || !this.maximize) return;
				var done = false;
				var animate = function animate() {
					if (!done) {
						window.requestAnimationFrame(animate);
					}
					if (_this2.axis === 'x') {
						if (_this2.width === _this2.parentW && _this2.left === _this2.parentX) done = true;
					} else if (_this2.axis === 'y') {
						if (_this2.height === _this2.parentH && _this2.top === _this2.parentY) done = true;
					} else if (_this2.axis === 'both') {
						if (_this2.width === _this2.parentW && _this2.height === _this2.parentH && _this2.top === _this2.parentY && _this2.left === _this2.parentX) done = true;
					}
					if (_this2.axis === 'x' || _this2.axis === 'both') {
						if (_this2.width < _this2.parentW) {
							_this2.width++;
							_this2.elmW++;
						}
						if (_this2.left > _this2.parentX) {
							_this2.left--;
							_this2.elmX--;
						}
					}
					if (_this2.axis === 'y' || _this2.axis === 'both') {
						if (_this2.height < _this2.parentH) {
							_this2.height++;
							_this2.elmH++;
						}
						if (_this2.top > _this2.parentY) {
							_this2.top--;
							_this2.elmY--;
						}
					}
					_this2.$emit('resizing', _this2.left, _this2.top, _this2.width, _this2.height, _this2.index, _this2.playlist);
				};
				window.requestAnimationFrame(animate);
			},
			handleMove: function handleMove(e) {
				this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
				this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
				var diffX = this.mouseX - this.lastMouseX + this.mouseOffX;
				var diffY = this.mouseY - this.lastMouseY + this.mouseOffY;
				this.mouseOffX = this.mouseOffY = 0;
				this.lastMouseX = this.mouseX;
				this.lastMouseY = this.mouseY;
				var dX = diffX;
				var dY = diffY;
				if (this.resizing) {
					if (this.handle.indexOf('t') >= 0) {
						if (this.elmH - dY < this.minh) this.mouseOffY = dY - (diffY = this.elmH - this.minh);else if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);
						this.elmY += diffY;
						this.elmH -= diffY;
					}
					if (this.handle.indexOf('b') >= 0) {
						if (this.elmH + dY < this.minh) this.mouseOffY = dY - (diffY = this.minh - this.elmH);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
						this.elmH += diffY;
					}
					if (this.handle.indexOf('l') >= 0) {
						if (this.elmW - dX < this.minw) this.mouseOffX = dX - (diffX = this.elmW - this.minw);else if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);
						this.elmX += diffX;
						this.elmW -= diffX;
					}
					if (this.handle.indexOf('r') >= 0) {
						if (this.elmW + dX < this.minw) this.mouseOffX = dX - (diffX = this.minw - this.elmW);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
						this.elmW += diffX;
					}
					this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
					this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
					this.width = Math.round(this.elmW / this.grid[0]) * this.grid[0];
					this.height = Math.round(this.elmH / this.grid[1]) * this.grid[1];
					this.$emit('resizing', this.left, this.top, this.width, this.height, this.index, this.playlist);
				} else if (this.dragging) {
					if (this.parent) {
						if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
						if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
					}
					this.elmX += diffX;
					this.elmY += diffY;
					if (this.axis === 'x' || this.axis === 'both') {
						this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
					}
					if (this.axis === 'y' || this.axis === 'both') {
						this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
					}
					this.$emit('dragging', this.left, this.top, this.w, this.h, this.index, this.playlist);
				}
			},
			handleUp: function handleUp(e) {
				this.handle = null;
				if (this.resizing) {
					this.resizing = false;
					this.$emit('resizestop', this.left, this.top, this.width, this.height, this.index, this.playlist);
				}
				if (this.dragging) {
					this.dragging = false;
					this.$emit('dragstop', this.left, this.top, this.index, this.playlist);
				}
				this.elmX = this.left;
				this.elmY = this.top;
			}
		},
		computed: {
			style: function style() {
				return {
					top: this.top + 'px',
					left: this.left + 'px',
					width: this.width + 'px',
					height: this.height + 'px',
					zIndex: 99999
				};
			}
		},
		watch: {
			active: function active(val) {
				this.enabled = val;
			}
		}
	};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		replace: true,
		name: 'vue-draggable-resizable',
		props: {
			index: {
				default: 0
			},
			playlist: {
				type: Number,
				default: 0
			},
			active: {
				type: Boolean, default: false
			},
			draggable: {
				type: Boolean, default: true
			},
			resizable: {
				type: Boolean, default: true
			},
			w: {
				type: Number,
				default: 200,
				validator: function validator(val) {
					return val > 0;
				}
			},
			h: {
				type: Number,
				default: 200,
				validator: function validator(val) {
					return val > 0;
				}
			},
			minw: {
				type: Number,
				default: 50,
				validator: function validator(val) {
					return val > 0;
				}
			},
			minh: {
				type: Number,
				default: 50,
				validator: function validator(val) {
					return val > 0;
				}
			},
			x: {
				type: Number,
				default: 0,
				validator: function validator(val) {
					return typeof val === 'number';
				}
			},
			y: {
				type: Number,
				default: 0,
				validator: function validator(val) {
					return typeof val === 'number';
				}
			},
			z: {
				type: [String, Number],
				default: 'auto',
				validator: function validator(val) {
					var valid = typeof val === 'string' ? val === 'auto' : val >= 0;
					return valid;
				}
			},
			handles: {
				type: Array,
				default: function _default() {
					return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
				}
			},
			axis: {
				type: String,
				default: 'both',
				validator: function validator(val) {
					return ['x', 'y', 'both'].indexOf(val) !== -1;
				}
			},
			grid: {
				type: Array,
				default: function _default() {
					return [1, 1];
				}
			},
			parent: {
				type: Boolean, default: false
			},
			maximize: {
				type: Boolean, default: false
			}
		},
		created: function created() {
			this.parentX = 0;
			this.parentW = 9999;
			this.parentY = 0;
			this.parentH = 9999;
			this.mouseX = 0;
			this.mouseY = 0;
			this.lastMouseX = 0;
			this.lastMouseY = 0;
			this.mouseOffX = 0;
			this.mouseOffY = 0;
			this.elmX = 0;
			this.elmY = 0;
			this.elmW = 0;
			this.elmH = 0;
		},
		mounted: function mounted() {
			document.documentElement.addEventListener('mousemove', this.handleMove, true);
			document.documentElement.addEventListener('mousedown', this.deselect, true);
			document.documentElement.addEventListener('mouseup', this.handleUp, true);
			this.elmX = parseInt(this.$el.style.left);
			this.elmY = parseInt(this.$el.style.top);
			this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
			this.elmH = this.$el.offsetHeight || this.$el.clientHeight;
			this.reviewDimensions();
		},
		beforeDestroy: function beforeDestroy() {
			document.documentElement.removeEventListener('mousemove', this.handleMove, true);
			document.documentElement.removeEventListener('mousedown', this.deselect, true);
			document.documentElement.removeEventListener('mouseup', this.handleUp, true);
		},
		data: function data() {
			return {
				top: this.y,
				left: this.x,
				width: this.w,
				height: this.h,
				resizing: false,
				dragging: false,
				enabled: this.active,
				handle: null,
				zIndex: this.z
			};
		},
		methods: {
			mouseOver: function mouseOver() {
				this.$emit('mouseOver', this.index, this.playlist);
			},
			mouseLeave: function mouseLeave() {
				this.$emit('mouseLeave');
			},
	
			reviewDimensions: function reviewDimensions() {
				if (this.minw > this.w) this.width = this.minw;
				if (this.minh > this.h) this.height = this.minh;
				if (this.parent) {
					var parentW = parseInt(this.$el.parentNode.clientWidth, 10);
					var parentH = parseInt(this.$el.parentNode.clientHeight, 10);
					this.parentW = parentW;
					this.parentH = parentH;
					if (this.w > this.parentW) this.width = parentW;
					if (this.h > this.parentH) this.height = parentH;
					if (this.x + this.w > this.parentW) this.width = parentW - this.x;
					if (this.y + this.h > this.parentH) this.height = parentH - this.y;
				}
				this.elmW = this.width;
				this.elmH = this.height;
				this.$emit('resizing', this.left, this.top, this.width, this.height, this.index, this.playlist);
			},
			elmDown: function elmDown(e) {
				var _this = this;
	
				this.width = this.w;
				var target = e.target || e.srcElement;
	
				if (this.$el.contains(target)) {
					this.reviewDimensions();
					if (!this.enabled) {
						this.enabled = true;
						if (target.id) {
							this.$emit('updateData', target.style.left, target.style.width, this.index, this.playlist);
						}
						this.$nextTick(function () {
							_this.$emit('activated');
							_this.$emit('update:active', true);
						});
					}
					if (this.draggable) {
						this.dragging = true;
					}
				}
			},
			deselect: function deselect(e) {
				this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
				this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
				this.lastMouseX = this.mouseX;
				this.lastMouseY = this.mouseY;
				var target = e.target || e.srcElement;
				var regex = new RegExp('handle-([trmbl]{2})', '');
				if (!this.$el.contains(target) && !regex.test(target.className)) {
					if (this.enabled) {
						this.enabled = false;
						this.$emit('deactivated');
						this.$emit('update:active', false);
					}
				}
			},
			handleDown: function handleDown(handle, e) {
				this.handle = handle;
				if (e.stopPropagation) e.stopPropagation();
				if (e.preventDefault) e.preventDefault();
				this.resizing = true;
			},
			fillParent: function fillParent(e) {
				var _this2 = this;
	
				if (!this.parent || !this.resizable || !this.maximize) return;
				var done = false;
				var animate = function animate() {
					if (!done) {
						window.requestAnimationFrame(animate);
					}
					if (_this2.axis === 'x') {
						if (_this2.width === _this2.parentW && _this2.left === _this2.parentX) done = true;
					} else if (_this2.axis === 'y') {
						if (_this2.height === _this2.parentH && _this2.top === _this2.parentY) done = true;
					} else if (_this2.axis === 'both') {
						if (_this2.width === _this2.parentW && _this2.height === _this2.parentH && _this2.top === _this2.parentY && _this2.left === _this2.parentX) done = true;
					}
					if (_this2.axis === 'x' || _this2.axis === 'both') {
						if (_this2.width < _this2.parentW) {
							_this2.width++;
							_this2.elmW++;
						}
						if (_this2.left > _this2.parentX) {
							_this2.left--;
							_this2.elmX--;
						}
					}
					if (_this2.axis === 'y' || _this2.axis === 'both') {
						if (_this2.height < _this2.parentH) {
							_this2.height++;
							_this2.elmH++;
						}
						if (_this2.top > _this2.parentY) {
							_this2.top--;
							_this2.elmY--;
						}
					}
					_this2.$emit('resizing', _this2.left, _this2.top, _this2.width, _this2.height, _this2.index, _this2.playlist);
				};
				window.requestAnimationFrame(animate);
			},
			handleMove: function handleMove(e) {
				this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
				this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
				var diffX = this.mouseX - this.lastMouseX + this.mouseOffX;
				var diffY = this.mouseY - this.lastMouseY + this.mouseOffY;
				this.mouseOffX = this.mouseOffY = 0;
				this.lastMouseX = this.mouseX;
				this.lastMouseY = this.mouseY;
				var dX = diffX;
				var dY = diffY;
				if (this.resizing) {
					if (this.handle.indexOf('t') >= 0) {
						if (this.elmH - dY < this.minh) this.mouseOffY = dY - (diffY = this.elmH - this.minh);else if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);
						this.elmY += diffY;
						this.elmH -= diffY;
					}
					if (this.handle.indexOf('b') >= 0) {
						if (this.elmH + dY < this.minh) this.mouseOffY = dY - (diffY = this.minh - this.elmH);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
						this.elmH += diffY;
					}
					if (this.handle.indexOf('l') >= 0) {
						if (this.elmW - dX < this.minw) this.mouseOffX = dX - (diffX = this.elmW - this.minw);else if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);
						this.elmX += diffX;
						this.elmW -= diffX;
					}
					if (this.handle.indexOf('r') >= 0) {
						if (this.elmW + dX < this.minw) this.mouseOffX = dX - (diffX = this.minw - this.elmW);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
						this.elmW += diffX;
					}
					this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
					this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
					this.width = Math.round(this.elmW / this.grid[0]) * this.grid[0];
					this.height = Math.round(this.elmH / this.grid[1]) * this.grid[1];
					this.$emit('resizing', this.left, this.top, this.width, this.height, this.index, this.playlist);
				} else if (this.dragging) {
					if (this.parent) {
						if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
						if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
					}
					this.elmX += diffX;
					this.elmY += diffY;
					if (this.axis === 'x' || this.axis === 'both') {
						this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
					}
					if (this.axis === 'y' || this.axis === 'both') {
						this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
					}
					this.$emit('dragging', this.left, this.top, this.w, this.h, this.index, this.playlist);
				}
			},
			handleUp: function handleUp(e) {
				this.handle = null;
				if (this.resizing) {
					this.resizing = false;
					this.$emit('resizestop', this.left, this.top, this.width, this.height, this.index, this.playlist);
				}
				if (this.dragging) {
					this.dragging = false;
					this.$emit('dragstop', this.left, this.top, this.index, this.playlist);
				}
				this.elmX = this.left;
				this.elmY = this.top;
			}
		},
		computed: {
			style: function style() {
				return {
					top: this.top + 'px',
					left: this.left + 'px',
					width: this.width + 'px',
					height: this.height + 'px',
					zIndex: this.zIndex
				};
			}
		},
		watch: {
			active: function active(val) {
				this.enabled = val;
			},
			z: function z(val) {
				if (val >= 0 || val === 'auto') {
					this.zIndex = val;
				}
			}
		}
	};

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/02.e114cc9.jpg";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-refresh.ed2f7d1.png";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(328)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(453),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(308)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(417),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(169),
	  /* template */
	  __webpack_require__(425),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(323)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(170),
	  /* template */
	  __webpack_require__(439),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(326)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(171),
	  /* template */
	  __webpack_require__(449),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(311)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(172),
	  /* template */
	  __webpack_require__(420),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(408),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(325)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(174),
	  /* template */
	  __webpack_require__(443),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(457),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(316)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(176),
	  /* template */
	  __webpack_require__(430),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(177),
	  /* template */
	  __webpack_require__(410),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(302)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(178),
	  /* template */
	  __webpack_require__(411),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(179),
	  /* template */
	  __webpack_require__(413),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(180),
	  /* template */
	  __webpack_require__(440),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(181),
	  /* template */
	  __webpack_require__(427),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(298)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(182),
	  /* template */
	  __webpack_require__(402),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(183),
	  /* template */
	  __webpack_require__(435),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(184),
	  /* template */
	  __webpack_require__(428),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(185),
	  /* template */
	  __webpack_require__(422),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(186),
	  /* template */
	  __webpack_require__(421),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(187),
	  /* template */
	  __webpack_require__(448),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(188),
	  /* template */
	  __webpack_require__(447),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(327)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(189),
	  /* template */
	  __webpack_require__(451),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(190),
	  /* template */
	  __webpack_require__(461),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(192),
	  /* template */
	  __webpack_require__(407),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(193),
	  /* template */
	  __webpack_require__(463),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(196),
	  /* template */
	  __webpack_require__(446),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(197),
	  /* template */
	  __webpack_require__(452),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(198),
	  /* template */
	  __webpack_require__(464),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(306)
	__webpack_require__(307)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(199),
	  /* template */
	  __webpack_require__(416),
	  /* scopeId */
	  "data-v-2bf7cd3b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(332)
	__webpack_require__(333)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(200),
	  /* template */
	  __webpack_require__(458),
	  /* scopeId */
	  "data-v-cacf7e50",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(313)
	__webpack_require__(314)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(201),
	  /* template */
	  __webpack_require__(426),
	  /* scopeId */
	  "data-v-46a28600",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(299)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(202),
	  /* template */
	  __webpack_require__(403),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(312)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(203),
	  /* template */
	  __webpack_require__(423),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(305)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(204),
	  /* template */
	  __webpack_require__(415),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(205),
	  /* template */
	  __webpack_require__(405),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(309)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(206),
	  /* template */
	  __webpack_require__(418),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(334)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(207),
	  /* template */
	  __webpack_require__(462),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(208),
	  /* template */
	  __webpack_require__(432),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(209),
	  /* template */
	  __webpack_require__(445),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(210),
	  /* template */
	  __webpack_require__(444),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(212),
	  /* template */
	  __webpack_require__(460),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(215),
	  /* template */
	  __webpack_require__(424),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(317)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(225),
	  /* template */
	  __webpack_require__(431),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(320)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(228),
	  /* template */
	  __webpack_require__(436),
	  /* scopeId */
	  "data-v-63feeb4c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "page-breadcrumb"
	  }, _vm._l((_vm.crumbs), function(crumb, index) {
	    return _c('li', [(crumb.link) ? _c('router-link', {
	      attrs: {
	        "to": crumb.link
	      }
	    }, [_vm._v(_vm._s(crumb.name))]) : _vm._e(), _vm._v(" "), (!crumb.link) ? _c('span', [_vm._v(_vm._s(crumb.name))]) : _vm._e(), _vm._v(" "), (index != _vm.crumbs.length - 1) ? _c('i', {
	      staticClass: "fa fa-circle"
	    }) : _vm._e()], 1)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Regions")]), _vm._v(" "), _c('div', {
	    staticClass: "note note-info"
	  }, [_vm._v("\n\t\t\tCreate and manage your business regions.\n\t\t")]), _vm._v(" "), (_vm.noRegions) ? _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create Your First Region")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-40"
	  }, [_c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingRegionData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingRegionData === false) ? _c('div', [(_vm.regionPath.length) ? _c('span', {
	    staticClass: "caption-subject font-blue bold uppercase"
	  }, [_vm._v("Regions in " + _vm._s(_vm.regionPath[_vm.regionPath.length - 1].name))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mt-element-list"
	  }, [_c('div', {
	    staticClass: "mt-list-container list-simple ext-1 group no-border"
	  }, [(_vm.regionPath.length) ? _c('a', {
	    staticClass: "list-toggle-container",
	    on: {
	      "click": function($event) {
	        _vm.goUpOneLevel()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "list-toggle not-selected"
	  }, [_c('span', {
	    staticClass: "fa fa-chevron-left margin-right-10"
	  }), _vm._v("\n\t\t\t\t\t\t\t\t\tGo back to " + _vm._s(_vm.regionPath.length > 1 ? _vm.regionPath[_vm.regionPath.length - 2].name : 'global regions') + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedRegions), function(region) {
	    return [_c('a', {
	      staticClass: "list-toggle-container"
	    }, [_c('div', {
	      staticClass: "list-toggle uppercase",
	      class: {
	        'not-selected': _vm.currentRegion.id !== region.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.drillDown(region)
	        }
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + "\n\t\t\t\t\t\t\t\t\t\t"), (region.has_children) ? _c('span', {
	      staticClass: "pull-right fa fa-chevron-right"
	    }) : _vm._e(), _vm._v(" "), _c('dropdown', {
	      staticClass: "pull-right margin-right-10 skinny-dropdown",
	      class: {
	        'margin-right-25': !region.has_children
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	        }
	      },
	      slot: "dropdown-menu"
	    }, [(!region.has_children) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.createRegion(region.id)
	        }
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd children to "), _c('b', [_vm._v(_vm._s(region.name))])])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.manageLocations(region.id)
	        }
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tManage "), _c('b', [_vm._v(_vm._s(region.name))]), _vm._v(" locations\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])], 1)])]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [(_vm.regionPath.length) ? _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createRegion(_vm.regionPath[_vm.regionPath.length - 1].id)
	      }
	    }
	  }, [_vm._v("Add region in " + _vm._s(_vm.regionPath[_vm.regionPath.length - 1].name))]) : _vm._e()])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-region'), _vm._v(" "), _c('manage-locations')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("UNOgames")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Campaign")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingCampaignData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingCampaignData === false) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tCampaign Status"), _c('b', [_vm._v(": " + _vm._s(_vm.advancedSearch.status))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'all'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchStatus('all')
	      }
	    }
	  }, [_vm._v("All")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'running'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchStatus('running')
	      }
	    }
	  }, [_vm._v("Running")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'pending'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchStatus('pending')
	      }
	    }
	  }, [_vm._v("Pending")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'paused'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchStatus('paused')
	      }
	    }
	  }, [_vm._v("Paused")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'expired'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchStatus('expired')
	      }
	    }
	  }, [_vm._v("Expired")])])])]), _vm._v(" "), _c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tCampaign Type"), _c('b', [_vm._v(": " + _vm._s(_vm.advancedSearch.type))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'all'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchType('all')
	      }
	    }
	  }, [_vm._v("All")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'ig'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchType('ig')
	      }
	    }
	  }, [_vm._v("Instagage")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.advancedSearch.status === 'sw'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSearchType('sw')
	      }
	    }
	  }, [_vm._v("Scratch To Win")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage
	    },
	    on: {
	      "pageResults": _vm.pageResultsUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "margin-top-20 unogames-table"
	  }, [_c('div', [_c('table', {
	    staticClass: "table table-hover"
	  }, [_c('tbody', [_vm._l((_vm.campaigns), function(campaign) {
	    return [_c('tr', [_c('td', {
	      staticClass: "unogames-table-column-icon"
	    }, [(campaign.campaign_type === 'sw') ? _c('i', {
	      staticClass: "fa fa-lg fa-star-half-o"
	    }) : _vm._e(), _vm._v(" "), (campaign.campaign_type === 'ig') ? _c('i', {
	      staticClass: "fa fa-lg fa-instagram"
	    }) : _vm._e()]), _vm._v(" "), _c('td', {
	      staticClass: "unogames-table-column"
	    }, [_c('p', [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('p', {
	      staticClass: "font-grey-cascade font-12"
	    }, [_vm._v("Created by: N/A")]), _vm._v(" "), _c('p', {
	      staticClass: "font-grey-cascade font-12"
	    }, [_vm._v("Created on: N/A")])]), _vm._v(" "), _c('td', {
	      staticClass: "unogames-table-column"
	    }, [_c('div', {
	      staticClass: "uno-progress-bar"
	    }, [_c('div', {
	      style: (("width: " + (_vm.calculateProgressWidth(campaign))))
	    })]), _vm._v(" "), _c('p', {
	      staticClass: "font-12"
	    }, [_vm._v("Starts: " + _vm._s(_vm.filterDateString(campaign.starts_at)))]), _vm._v(" "), _c('p', {
	      staticClass: "font-grey-cascade font-12"
	    }, [_vm._v("Ends: " + _vm._s(_vm.filterDateString(campaign.ends_at)))])]), _vm._v(" "), _c('td', {
	      staticClass: "unogames-table-column-icon"
	    }, [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-pencil"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editCampaignDetails(campaign.id)
	        }
	      }
	    }, [_vm._v("Edit Campaign Details")])]), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editContestDesign(campaign.id)
	        }
	      }
	    }, [_vm._v("Edit Contest Layout")])]), _vm._v(" "), (campaign.campaign_type === 'sw') ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editContestPrizes(campaign.id)
	        }
	      }
	    }, [_vm._v("Edit Contest Prizes")])]) : _vm._e(), _vm._v(" "), (campaign.campaign_type === 'sw') ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editSkillTestingQuestions(campaign.id)
	        }
	      }
	    }, [_vm._v("Edit Skill Testing Questions")])]) : _vm._e()])]), _vm._v(" "), (campaign.status === 'pending') ? _c('i', {
	      staticClass: "fa fa-play clickable",
	      on: {
	        "click": function($event) {
	          _vm.updateStatus(campaign, 'running')
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (campaign.status !== 'pending') ? _c('i', {
	      staticClass: "fa fa-pause clickable",
	      on: {
	        "click": function($event) {
	          _vm.updateStatus(campaign, 'pending')
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-line-chart clickable"
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-trash-o clickable",
	      on: {
	        "click": function($event) {
	          _vm.deleteCampaignConfirmation(campaign)
	        }
	      }
	    })], 1)])]
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
	    attrs: {
	      "show": _vm.numPages === 0,
	      "type": 'campaigns'
	    }
	  }), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel, 'full-width-content-fold': _vm.$route.name === 'UNOgames - Edit Contest Layout'
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-campaign'), _vm._v(" "), _c('edit-campaign-details'), _vm._v(" "), _c('edit-contest-layout'), _vm._v(" "), _c('edit-contest-prizes'), _vm._v(" "), _c('edit-skill-testing-questions')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "note note-info"
	  }, [_c('p', [_vm._v("Create and manage all UNOgames campaigns.")])])
	}]}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "search-page blue-hoki"
	  }, [_c('div', {
	    staticClass: "search-pagination pagination-rounded"
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, [_c('li', {
	    staticClass: "page-pre",
	    class: {
	      'disabled': _vm.activePage === 1
	    }
	  }, [_c('a', {
	    staticClass: "fa fa-angle-left",
	    on: {
	      "click": function($event) {
	        _vm.setActivePage(_vm.activePage - 1)
	      }
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "page-number",
	    class: {
	      'active': _vm.activePage === 1
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setActivePage(1)
	      }
	    }
	  }, [_vm._v("1")])]), _vm._v(" "), (_vm.activePage !== 1 && _vm.activePage !== 2 && _vm.activePage !== 3) ? _c('li', [_c('a', {
	    staticClass: "pagination-ellipsis"
	  }, [_vm._v(". . .")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagesArray), function(page, index) {
	    return (_vm.showPageIndex(index)) ? _c('li', {
	      staticClass: "page-number",
	      class: {
	        'active': _vm.activePage === page
	      }
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.setActivePage(page)
	        }
	      }
	    }, [_vm._v(_vm._s(page))])]) : _vm._e()
	  }), _vm._v(" "), (_vm.activePage !== _vm.pagesArray.length && _vm.activePage !== _vm.pagesArray.length - 1 && _vm.activePage !== _vm.pagesArray.length - 2) ? _c('li', [_c('a', {
	    staticClass: "pagination-ellipsis"
	  }, [_vm._v(". . .")])]) : _vm._e(), _vm._v(" "), (_vm.numPages !== 1) ? _c('li', {
	    staticClass: "page-number",
	    class: {
	      'active': _vm.activePage === _vm.pagesArray.length
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setActivePage(_vm.pagesArray.length)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.pagesArray.length))])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "page-next",
	    class: {
	      'disabled': _vm.activePage === _vm.numPages
	    }
	  }, [_c('a', {
	    staticClass: "fa fa-angle-right",
	    on: {
	      "click": function($event) {
	        _vm.setActivePage(_vm.activePage + 1)
	      }
	    }
	  })])], 2)])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.updateCampaign($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Start On")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": 'MMM dd, yyyy h:mm A',
	      "type": "datetime",
	      "placeholder": "Select Start Date*",
	      "editable": false,
	      "picker-options": _vm.datepickerStartOptions
	    },
	    model: {
	      value: (_vm.editingCampaign.start_date),
	      callback: function($$v) {
	        _vm.$set(_vm.editingCampaign, "start_date", $$v)
	      },
	      expression: "editingCampaign.start_date"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("End On")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": 'MMM dd, yyyy h:mm A',
	      "type": "datetime",
	      "placeholder": "Select End Date*",
	      "editable": false,
	      "picker-options": _vm.datepickerEndOptions
	    },
	    model: {
	      value: (_vm.editingCampaign.end_date),
	      callback: function($$v) {
	        _vm.$set(_vm.editingCampaign, "end_date", $$v)
	      },
	      expression: "editingCampaign.end_date"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-40"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    key: "edit-campaign-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\tEdit Campaign Details\n\t\t\t")])])
	}]}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "mt-element-list mt-element-overflow"
	  }, [_c('div', {
	    staticClass: "mt-list-container list-default no-border"
	  }, [_c('ul', _vm._l((_vm.actionsList), function(action) {
	    return _c('li', {
	      staticClass: "mt-list-item"
	    }, [_c('div', {
	      staticClass: "list-icon-container",
	      class: {
	        'done': action.main_action
	      }
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.emitFunction(action.click_event, action.function_params)
	        }
	      }
	    }, [_c('i', {
	      class: action.icon_class
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "list-item-content",
	      class: {
	        'no-description': !action.description
	      }
	    }, [_c('h3', {
	      staticClass: "uppercase bold"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.emitFunction(action.click_event, action.function_params)
	        }
	      }
	    }, [_vm._v(_vm._s(action.title))])]), _vm._v(" "), (action.description) ? _c('p', [_c('small', [_vm._v(_vm._s(action.description))])]) : _vm._e()])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption uppercase bold"
	  }, [_vm._v("\n\t\t\t\tSelect An Action\n\t\t\t")])])
	}]}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.updateFolder($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingFolder.name),
	      expression: "editingFolder.name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingFolder.name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "manage_folder_name",
	      "maxlength": "255",
	      "disabled": _vm.rootFolder
	    },
	    domProps: {
	      "value": (_vm.editingFolder.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingFolder, "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "manage_folder_name"
	    }
	  }, [_vm._v("Folder Name")])]), _vm._v(" "), (!_vm.activeLocationId) ? _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editingFolder.is_shared),
	      expression: "editingFolder.is_shared"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-privatize"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.editingFolder.is_shared) ? _vm._i(_vm.editingFolder.is_shared, null) > -1 : (_vm.editingFolder.is_shared)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.editingFolder.is_shared,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.editingFolder.is_shared = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.editingFolder.is_shared = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.editingFolder, "is_shared", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-privatize"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t                        \t\t\t\tMake this folder "), _c('b', [_vm._v("public")]), _vm._v(" to all locations.\n\t\t                        \t\t\t")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Resources Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tManage\n\t\t\t\t")])])
	}]}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Business Manager")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Business")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', [_c('div', {
	    staticClass: "portlet box blue-hoki"
	  }, [_c('div', {
	    staticClass: "portlet-title",
	    on: {
	      "click": function($event) {
	        _vm.toggleSearchPanel()
	      }
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('a', {
	    class: {
	      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.searchCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedBusinessSearch()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.computedSearchOptions.length) ? _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by "), _vm._l((_vm.computedSearchOptions), function(option, index) {
	    return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(option.name))])
	  }), _vm._v(".")], 2) : _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Select search terms below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-checkbox-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (option.checked),
	        expression: "option.checked"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("advanced_search_checkbox_" + (option.value))
	      },
	      domProps: {
	        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = option.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (option.checked = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (option.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(option, "checked", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_checkbox_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetBusinessSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "tabindex": _vm.activePanel ? 0 : -1
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingBusinessData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingBusinessData === false) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'business_name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('business_name')
	      }
	    }
	  }, [_vm._v("Business Name")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage
	    },
	    on: {
	      "pageResults": _vm.pageResultsUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "margin-top-30 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped table-condensed"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.businesses), function(business) {
	    return _c('tr', [_c('td', [_c('h3', [_vm._v(_vm._s(business.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(business.num_locations || 0))]), _vm._v(" " + _vm._s(business.num_locations === 1 ? 'location' : 'locations') + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [(business.blacklisted) ? _c('i', {
	      staticClass: "fa fa-check font-green-haze"
	    }) : _c('i', {
	      staticClass: "fa fa-close font-red-thunderbird"
	    })]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          _vm.selectBusiness(business)
	        }
	      }
	    }, [_c('a', [_vm._v("Select Business")])]), _vm._v(" "), _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.editBusiness(business.business_id)
	        }
	      }
	    }, [_c('a', [_vm._v("Edit Business")])]), _vm._v(" "), _c('li', [(business.blacklisted) ? _c('a', {
	      on: {
	        "click": function($event) {
	          _vm.removeFromBlacklist(business)
	        }
	      }
	    }, [_vm._v("Remove From Blacklist")]) : _c('a', {
	      on: {
	        "click": function($event) {
	          _vm.addToBlacklist(business)
	        }
	      }
	    }, [_vm._v("Add To Blacklist")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Suspend Business")])])])])], 1)])
	  }))])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
	    attrs: {
	      "show": _vm.numPages === 0,
	      "type": 'businesses'
	    }
	  }), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-business'), _vm._v(" "), _c('edit-business')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "note note-info"
	  }, [_c('p', [_vm._v("Create and manage all Businesses in UNOapp.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "caption"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v("\n\t\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "bg-blue"
	  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Blacklisted")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Actions")])])])])
	}]}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbs
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
	    staticClass: "note note-info"
	  }, [_c('p', [_vm._v(_vm._s(_vm.note))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledInvite()
	      }
	    }
	  }, [_vm._v("Invite a New User")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', [_c('div', {
	    staticClass: "portlet box blue-hoki"
	  }, [_c('div', {
	    staticClass: "portlet-title",
	    on: {
	      "click": function($event) {
	        _vm.toggleSearchPanel()
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('a', {
	    class: {
	      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.searchCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedUserSearch()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.computedSearchOptions.length) ? _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Searching by "), _vm._l((_vm.computedSearchOptions), function(option, index) {
	    return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(option.name))])
	  }), _vm._v(".")], 2) : _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Select search terms below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-checkbox-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (option.checked),
	        expression: "option.checked"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("advanced_search_checkbox_" + (option.value))
	      },
	      domProps: {
	        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = option.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (option.checked = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (option.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(option, "checked", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_checkbox_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t      \t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t      \t\t\t\t\t\t\t")])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.status),
	      expression: "advancedSearch.status"
	    }],
	    staticClass: "form-control edited",
	    attrs: {
	      "id": "search_options_status",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.advancedSearch, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "disabled": ""
	    }
	  }), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "any_status"
	    }
	  }, [_vm._v("Any User")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "accepted"
	    }
	  }, [_vm._v("Active Users")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "pending"
	    }
	  }, [_vm._v("Pending Users")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "expired"
	    }
	  }, [_vm._v("Expired User Invitations")])]), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_status"
	    }
	  }, [_vm._v("Status")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('typeahead', {
	    attrs: {
	      "data": _vm.roles,
	      "label": 'Role',
	      "emitter": 'role',
	      "objectKey": 'role_name',
	      "passedValue": _vm.advancedSearch.role,
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "role": _vm.updateRole,
	      "onFocus": _vm.roleFocus
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetUserSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "tabindex": _vm.activePanel ? 0 : -1
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingUserData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingUserData === false) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.capitalize(_vm.sortBy.field)) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'first_name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('first_name')
	      }
	    }
	  }, [_vm._v("First Name")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'last_name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('last_name')
	      }
	    }
	  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'email'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('email')
	      }
	    }
	  }, [_vm._v("Email")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'role'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('role')
	      }
	    }
	  }, [_vm._v("Role")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage
	    },
	    on: {
	      "pageResults": _vm.pageResultsUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "margin-top-30 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped table-condensed"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
	    return _c('tr', [_c('td', {
	      staticClass: "profile-image-table-row"
	    }, [_c('div', {
	      staticClass: "missing-profile-image"
	    }, [(user.name.first_name || user.name.last_name) ? _c('span', [_vm._v(_vm._s(user.name.first_name.toUpperCase().substring(0, 1)) + _vm._s(user.name.last_name.toUpperCase().substring(0, 1)))]) : _c('span', [_vm._v(_vm._s(user.email.toUpperCase().substring(0, 1)))])])]), _vm._v(" "), _c('td', [(user.name.first_name.length && user.name.last_name.length) ? _c('h3', [_vm._v(_vm._s(user.name.first_name) + " " + _vm._s(user.name.last_name) + " "), (user.invite_status !== 'accepted') ? _c('small', {
	      staticClass: "font-red-thunderbird"
	    }, [_vm._v("(Pending)")]) : _vm._e()]) : _c('h3', [(user.invite_status !== 'accepted') ? _c('small', {
	      staticClass: "font-red-thunderbird"
	    }, [_vm._v("(Pending)")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role_name))]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [_c('li', [_c('a', [_vm._v("Promote User")])]), _vm._v(" "), (user.invite_status !== 'pending') ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.deleteUserConfirmation('delete', user)
	        }
	      }
	    }, [_vm._v("Delete User")])]) : _vm._e(), _vm._v(" "), (user.invite_status === 'expired') ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.resendUserInvitation(user)
	        }
	      }
	    }, [_vm._v("Resend User Invitation")])]) : _vm._e(), (user.invite_status === 'pending') ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.deleteUserConfirmation('cancel_invitation', user)
	        }
	      }
	    }, [_vm._v("Cancel User Invitation")])]) : _vm._e()])])], 1)])
	  }))])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
	    attrs: {
	      "show": _vm.numPages === 0,
	      "type": 'users'
	    }
	  }), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('invite-user', {
	    attrs: {
	      "baseRoute": _vm.baseRoute,
	      "baseRouteName": _vm.baseRouteName,
	      "businessId": _vm.businessId,
	      "locationId": _vm.locationId
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "caption"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v("\n      \t\t\t\t\t\t\tSearch Panel\n      \t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "bg-blue"
	  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Role")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Actions")])])])])
	}]}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Locations")]), _vm._v(" "), _c('div', {
	    staticClass: "note note-info"
	  }, [_vm._v("\n\t\t\tCreate and manage your business locations.\n\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Location")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', [_c('div', {
	    staticClass: "portlet box blue-hoki"
	  }, [_c('div', {
	    staticClass: "portlet-title",
	    on: {
	      "click": function($event) {
	        _vm.toggleSearchPanel()
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('a', {
	    class: {
	      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.searchCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedLocationSearch()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.computedSearchOptions.length) ? _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by "), _vm._l((_vm.computedSearchOptions), function(option, index) {
	    return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(option.name))])
	  }), _vm._v(".")], 2) : _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Select search terms below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-checkbox-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (option.checked),
	        expression: "option.checked"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("advanced_search_checkbox_" + (option.value))
	      },
	      domProps: {
	        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = option.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (option.checked = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (option.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(option, "checked", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_checkbox_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetLocationSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "tabindex": _vm.activePanel ? 0 : -1
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingLocationData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingLocationData === false) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('location_name')
	      }
	    }
	  }, [_vm._v("Location Name")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage
	    },
	    on: {
	      "pageResults": _vm.pageResultsUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "margin-top-30 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped table-condensed"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.locations), function(location) {
	    return _c('tr', [_c('td', [_c('h3', [(location.store_number) ? _c('small', [_vm._v(" #" + _vm._s(location.store_number) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(location.location_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(location.city) + ", " + _vm._s(location.country))])])]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [_c('li', {
	      on: {
	        "click": function($event) {
	          _vm.selectLocation(location)
	        }
	      }
	    }, [_c('a', [_vm._v("Select Location")])]), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editLocationDetails(location.location_id)
	        }
	      }
	    }, [_vm._v("Edit Location Details")])]), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editLocationAddress(location.location_id)
	        }
	      }
	    }, [_vm._v("Edit Location Address")])]), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editLocationAppAccess(location.location_id)
	        }
	      }
	    }, [_vm._v("View Location App Access")])]), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.deleteLocationConfirmation(location)
	        }
	      }
	    }, [_vm._v("Delete Location")])])])])], 1)])
	  }))])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
	    attrs: {
	      "show": _vm.numPages === 0,
	      "type": 'locations'
	    }
	  }), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-location'), _vm._v(" "), _c('edit-location-details'), _vm._v(" "), _c('edit-location-address'), _vm._v(" "), _c('location-app-access')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "caption"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v("\n\t\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "bg-blue"
	  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Actions")])])])])
	}]}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createLocation($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newLocation.location_name),
	      expression: "newLocation.location_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newLocation.location_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_location_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newLocation.location_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newLocation, "location_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_location_name"
	    }
	  }, [_vm._v("Location Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newLocation.unoapp_defined_name),
	      expression: "newLocation.unoapp_defined_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newLocation.unoapp_defined_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_unoapp_defined_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newLocation.unoapp_defined_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newLocation, "unoapp_defined_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_unoapp_defined_name"
	    }
	  }, [_vm._v("UNOapp Reference Name")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The client will not see this name but can be used for internal reference.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newLocation.store_number),
	      expression: "newLocation.store_number",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newLocation.store_number
	    },
	    attrs: {
	      "type": "number",
	      "id": "create_location_store_number"
	    },
	    domProps: {
	      "value": (_vm.newLocation.store_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newLocation, "store_number", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_location_store_number"
	    }
	  }, [_vm._v("Store Number "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(optional)")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newLocation.salesforce_id),
	      expression: "newLocation.salesforce_id",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newLocation.salesforce_id
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_location_salesforce"
	    },
	    domProps: {
	      "value": (_vm.newLocation.salesforce_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newLocation, "salesforce_id", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_location_salesforce"
	    }
	  }, [_vm._v("Salesforce ID "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(optional)")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    key: "create-location-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('google-places-search', {
	    attrs: {
	      "passedValue": _vm.newLocation.location_name,
	      "confirmationMessage": _vm.confirmationMessage,
	      "currentSelectedLocation": _vm.newLocation.selected_location
	    },
	    on: {
	      "selectedLocation": _vm.selectedLocationUpdated
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-location-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_3', 'step_2')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
	    key: "step_3"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('google-maps-pin-confirmation', {
	    attrs: {
	      "passedValue": _vm.newLocation.selected_location
	    },
	    on: {
	      "updateLocationLatLng": _vm.locationLatLngUpdated
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-location-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_4', 'step_3')
	      }
	    }
	  }, [_vm._v("Confirm & Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_4') ? _c('div', {
	    key: "step_5"
	  }, [(!_vm.regions.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('span', [_vm._v("Regions are required to set up locations.")])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingRegionData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (!_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', {
	    staticClass: "mt-element-list mt-element-overflow"
	  }, [_c('div', {
	    staticClass: "mt-list-container list-default no-border"
	  }, [_c('ul', [_c('li', {
	    staticClass: "mt-list-item"
	  }, [_c('div', {
	    staticClass: "list-icon-container done"
	  }, [_c('a', [_c('i', {
	    staticClass: "fa fa-globe"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item-content"
	  }, [_c('h3', {
	    staticClass: "uppercase bold"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/app/my_business/regions"
	    }
	  }, [_vm._v("Go to the regions dashboard")])], 1), _vm._v(" "), _c('p', [_c('small', [_vm._v("Regions can be used to assign users as admins to groups of locations we well as to market location based content to a group of locations.")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', [_c('div', {
	    staticClass: "mt-element-list"
	  }, [_c('div', {
	    staticClass: "mt-list-container list-simple ext-1 group no-border"
	  }, [(_vm.regionPath.length) ? _c('a', {
	    staticClass: "list-toggle-container",
	    on: {
	      "click": function($event) {
	        _vm.goUpOneLevel()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "list-toggle not-selected"
	  }, [_c('span', {
	    staticClass: "fa fa-chevron-left margin-right-10"
	  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tGo back to " + _vm._s(_vm.regionPath.length > 1 ? _vm.regionPath[_vm.regionPath.length - 2].name : 'base regions') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedRegions), function(region) {
	    return [_c('a', {
	      staticClass: "list-toggle-container",
	      on: {
	        "click": function($event) {
	          _vm.selectRegion(region)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "list-toggle uppercase",
	      class: {
	        'not-selected': _vm.newLocation.region.id !== region.id
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (region.has_children) ? _c('span', {
	      staticClass: "pull-right fa fa-chevron-right"
	    }) : _vm._e()])])]
	  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.regions.length && _vm.loadingRegionData === false) ? _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-location-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_5', 'step_4')
	      }
	    }
	  }, [_vm._v("Confirm & Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.process === 'step_5') ? _c('div', {
	    key: "step_5"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-top-20 portlet-title-alternate"
	  }, [_vm._v("Build a Product Package")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Include App")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.location_access),
	        expression: "app.location_access"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("app_access_location_" + (app.app_id))
	      },
	      domProps: {
	        "checked": Array.isArray(app.location_access) ? _vm._i(app.location_access, null) > -1 : (app.location_access)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = app.location_access,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (app.location_access = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (app.location_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(app, "location_access", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_access_location_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-location-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.createLocationNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tCreate A Location\n\t\t\t\t")])])
	}]}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    class: {
	      'fade': _vm.effect === 'fade' || _vm.effect === 'custom', 'zoom': _vm.effect === 'zoom', 'custom': _vm.effect === 'custom'
	    },
	    attrs: {
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    style: ({
	      width: _vm.computedWidth
	    }),
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._t("modal-header", [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._t("title", [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t\t")])], 2)])]), _vm._v(" "), _vm._t("modal-body", [_c('div', {
	    staticClass: "modal-body"
	  })]), _vm._v(" "), _vm._t("modal-footer", [_c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.callback()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.okText))])])])], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.modifyLocation($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_1') ? _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('google-places-search', {
	    attrs: {
	      "passedValue": _vm.editingLocation.location_name,
	      "confirmationMessage": _vm.confirmationMessage,
	      "currentSelectedLocation": _vm.editingLocation.selected_location
	    },
	    on: {
	      "selectedLocation": _vm.selectedLocationUpdated
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('google-maps-pin-confirmation', {
	    attrs: {
	      "passedValue": _vm.editingLocation.selected_location
	    },
	    on: {
	      "updateLocationLatLng": _vm.locationLatLngUpdated
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), (_vm.process !== 'step_1') ? _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_1') ? _c('button', {
	    key: "create-location-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('button', {
	    key: "create-location-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tEdit Location Address\n\t\t\t\t")])])
	}]}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "file-upload"
	  }, [(_vm.isInitial || _vm.isSaving) ? _c('form', {
	    attrs: {
	      "enctype": "multipart/form-data",
	      "novalidate": ""
	    }
	  }, [_c('div', {
	    staticClass: "file-input-container",
	    class: {
	      'uploading': _vm.isSaving
	    }
	  }, [_c('input', {
	    staticClass: "file-input",
	    attrs: {
	      "id": "file-input",
	      "type": "file",
	      "multiple": "",
	      "name": _vm.uploadFieldName,
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "change": function($event) {
	        _vm.filesChange($event.target.name, $event.target.files);
	        _vm.fileCount = $event.target.files.length
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "file-input"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "width": "20",
	      "height": "17",
	      "viewBox": "0 0 20 17"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v("Choose a file…")])]), _vm._v(" "), (_vm.isSaving) ? _c('p', {
	    staticClass: "file-upload-loader"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": true,
	      "color": '#3598dc',
	      "display": 'inline',
	      "position": 'left',
	      "size": 'small'
	    }
	  }), _vm._v("\n\t\t\t\tUploading " + _vm._s(_vm.fileCount) + " file" + _vm._s(_vm.fileCount > 1 ? 's' : '') + "...\n\t\t\t")], 1) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createCampaign($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Campaign Type")]), _vm._v(" "), _c('dropdown', {
	    attrs: {
	      "forceUpdate": _vm.transitionComplete
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.campaignTypes[_vm.newCampaign.campaign_type]) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setGameType('sw')
	      }
	    }
	  }, [_vm._v("Scratch and Win")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setGameType('ig')
	      }
	    }
	  }, [_vm._v("Instagage")])])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newCampaign.name),
	      expression: "newCampaign.name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_campaign_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign, "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_campaign_name"
	    }
	  }, [_vm._v("Campaign Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newCampaign.image),
	      expression: "newCampaign.image",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.image.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_campaign_image",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.image)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign, "image", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_campaign_image"
	    }
	  }, [_vm._v("Campaign Image")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Start On")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": 'MMM dd, yyyy h:mm A',
	      "type": "datetime",
	      "picker-options": _vm.datepickerStartOptions,
	      "placeholder": "Select Start Date*",
	      "editable": false
	    },
	    model: {
	      value: (_vm.newCampaign.start_date),
	      callback: function($$v) {
	        _vm.$set(_vm.newCampaign, "start_date", $$v)
	      },
	      expression: "newCampaign.start_date"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("End On")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": 'MMM dd, yyyy h:mm A',
	      "type": "datetime",
	      "picker-options": _vm.datepickerEndOptions,
	      "placeholder": "Select Start Date*",
	      "editable": false
	    },
	    model: {
	      value: (_vm.newCampaign.end_date),
	      callback: function($$v) {
	        _vm.$set(_vm.newCampaign, "end_date", $$v)
	      },
	      expression: "newCampaign.end_date"
	    }
	  })], 1), _vm._v(" "), (_vm.newCampaign.campaign_type === 'sw') ? _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.alternate_flow),
	      expression: "newCampaign.alternate_flow"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-alternate-flow",
	      "disabled": _vm.process !== 'step_1'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newCampaign.alternate_flow) ? _vm._i(_vm.newCampaign.alternate_flow, null) > -1 : (_vm.newCampaign.alternate_flow)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newCampaign.alternate_flow,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newCampaign.alternate_flow = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newCampaign.alternate_flow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newCampaign, "alternate_flow", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-alternate-flow"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n                    \t\t\t\t\t\t\tUse alternate flow\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'By enabling this, the user will be presented with the prize first and then prompted for their information.'
	    }
	  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    key: "create-campaign-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown",
	      "disabled": _vm.showKeywordUI
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s((_vm.newCampaign.details.twilio_account.id) ? _vm.newCampaign.details.twilio_account.phone_number : 'Select a phone number') + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_vm._l((_vm.twilioAccounts), function(account) {
	    return [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.setTwilioAccount(account)
	        }
	      }
	    }, [_vm._v(_vm._s(account.phone_number))])])]
	  })], 2)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-bottom-20 keyword-section"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Campaign Keywords")]), _vm._v(" "), (!_vm.showKeywordUI) ? _c('a', {
	    staticClass: "quick-nav-trigger",
	    on: {
	      "click": function($event) {
	        _vm.openKeywordUI()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })]) : _vm._e(), _vm._v(" "), (_vm.showKeywordUI) ? _c('div', {
	    staticClass: "portlet box blue-hoki",
	    staticStyle: {
	      "border-top": "1px solid #869ab3"
	    }
	  }, [_c('div', {
	    staticClass: "portlet-body clearfix"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywordInput),
	      expression: "keywordInput"
	    }],
	    staticClass: "form-control no-border",
	    attrs: {
	      "placeholder": "Enter or paste the keywords that the user can text in to enter the contest. Separate your keywords by commas.",
	      "rows": "5",
	      "id": "keyword-textarea"
	    },
	    domProps: {
	      "value": (_vm.keywordInput)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keywordInput = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-sm blue pull-right",
	    on: {
	      "click": function($event) {
	        _vm.addKeywords()
	      }
	    }
	  }, [_vm._v("Add Keywords")])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "table-scrollable"
	  }, [_c('table', {
	    staticClass: "table table-hover table-light"
	  }, [_c('tbody', [_vm._l((_vm.newCampaign.details.keywords), function(keyword, index) {
	    return (_vm.newCampaign.details.keywords.length < 26) ? [_c('tr', [_c('td', [_vm._v(_vm._s(keyword))]), _vm._v(" "), _c('td', {
	      staticClass: "center clickable",
	      on: {
	        "click": function($event) {
	          _vm.removeKeyword(index)
	        }
	      }
	    }, [_vm._v("×")])])] : _vm._e()
	  }), _vm._v(" "), (_vm.newCampaign.details.keywords.length > 25) ? _c('tr', [_c('td', {
	    staticClass: "center"
	  }, [_c('small', [_vm._v("You have " + _vm._s(_vm.newCampaign.details.keywords.length) + " keywords.")])])]) : _vm._e(), _vm._v(" "), (!_vm.newCampaign.details.keywords.length) ? _c('tr', [_c('td', {
	    staticClass: "center"
	  }, [_c('small', [_vm._v("No campaign keywords added.")])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Text2Win Type")]), _vm._v(" "), _c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown",
	      "disabled": _vm.showKeywordUI
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.useTypes[_vm.newCampaign.details.type] || 'Select a Text2Win type')), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setText2WinType('single_use_case')
	      }
	    }
	  }, [_vm._v("Single Use")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setText2WinType('multiple_use_case')
	      }
	    }
	  }, [_vm._v("Multiple Use")])])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-60"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.showKeywordUI
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-campaign-continue-two",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.showKeywordUI
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_3', 'step_2')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
	    key: "step_3"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.response_message),
	      expression: "newCampaign.details.response_message"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.response_message.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "form_control_1"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.response_message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "response_message", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_control_1"
	    }
	  }, [_vm._v("SMS Response "), (_vm.mergeErrorMessage.length) ? _c('small', {
	    staticClass: "font-red-thunderbird"
	  }, [_vm._v("- " + _vm._s(_vm.mergeErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The response the user will receive when they text a valid keyword.")])]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "margin-top-40 dropdown-label-override"
	  }, [_vm._v("Insert Merge Fields: "), _c('info-popover', {
	    attrs: {
	      "content": 'Merge Fields will be replaced by the corresponding content when the SMS message is sent.'
	    }
	  })], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-xs blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.insertMergeField('{EXPIRY_DATE}')
	      }
	    }
	  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-xs blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.insertMergeField('{SHORT_LINK}')
	      }
	    }
	  }, [_vm._v("Short Link")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.redeem_message),
	      expression: "newCampaign.details.redeem_message"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.redeem_message.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "campaign_redeem_message"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.redeem_message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "redeem_message", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_redeem_message"
	    }
	  }, [_vm._v("Redeemed Response")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The response the user will receive if they have exceeded the entry limit.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.expiry_message),
	      expression: "newCampaign.details.expiry_message"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.expiry_message.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "campaign_expired_response"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.expiry_message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "expiry_message", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_expired_response"
	    }
	  }, [_vm._v("Campaign Expired Response")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The response the user will receive if the campaign has expired.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.exceeded_message),
	      expression: "newCampaign.details.exceeded_message"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.exceeded_message.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "campaign_max_response"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.exceeded_message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "exceeded_message", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_max_response"
	    }
	  }, [_vm._v("Max Exceeded Response")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The response the user will receive if the maximum redemption limits have been exceeded.")])]), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.max_redemptions),
	      expression: "newCampaign.details.max_redemptions"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.max_redemptions !== null
	    },
	    attrs: {
	      "type": "number",
	      "id": "campaign_max_redemptions"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.max_redemptions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "max_redemptions", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_max_redemptions"
	    }
	  }, [_vm._v("Max Entries for Campaign "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The maximum number of entries for the entire campaign.")])]) : _vm._e(), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.max_redemptions_per_day),
	      expression: "newCampaign.details.max_redemptions_per_day"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.max_redemptions_per_day !== null
	    },
	    attrs: {
	      "type": "number",
	      "id": "campaign_max_per_day"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.max_redemptions_per_day)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "max_redemptions_per_day", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_max_per_day"
	    }
	  }, [_vm._v("Max Entries Per Day "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The maximum number of entries allowed for a campaign in a single day for ALL users.")])]) : _vm._e(), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCampaign.details.max_redemptions_per_day_per_user),
	      expression: "newCampaign.details.max_redemptions_per_day_per_user"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newCampaign.details.max_redemptions_per_day_per_user !== null
	    },
	    attrs: {
	      "type": "number",
	      "id": "campaign_max_per_day_per_user"
	    },
	    domProps: {
	      "value": (_vm.newCampaign.details.max_redemptions_per_day_per_user)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newCampaign.details, "max_redemptions_per_day_per_user", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "campaign_max_per_day_per_user"
	    }
	  }, [_vm._v("Max Entries Per Day/Per User "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The maximum number of entries allowed for a campaign in a single day for a SINGLE user.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-60"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-campaign-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.createCampaignNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tCreate A Campaign\n\t\t\t\t")])])
	}]}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sideways-page-one"
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(3), _vm.getPresentations(), _vm.clear()
	      }
	    }
	  }, [_vm._v(" Create a new Schedule")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(2), _vm.getSchedules()
	      }
	    }
	  }, [_vm._v(" Edit existing Schedule")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.presentationList), function(pres, index) {
	    return [(_vm.flaggedPresentations.indexOf(index) !== -1) ? _c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPres(index)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(pres.name) + " ")]) : _c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "default"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPres(index)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(pres.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
	    staticClass: "flex-center"
	  }, [(!_vm.edit) ? _c('div', [_c('h1', [_vm._v(" Create new Schedule ")]), _vm._v(" "), _c('h3', [_vm._v(" Selected Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])]) : _c('div', [_c('h1', [_vm._v(" Edit Schedule ")]), _vm._v(" "), _c('h3', [_vm._v(" Selected Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])]), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.type = 1, _vm.clear()
	      }
	    }
	  }, [_vm._v("\n\t\t\t\tOne time\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.type = 2, _vm.clear()
	      }
	    }
	  }, [_vm._v("\n\t\t\t\tRecurring/Weekly\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.type = 3, _vm.clear()
	      }
	    }
	  }, [_vm._v("\n\t\t\t\tTime Limited/Weekly\n\t\t\t")])]), _vm._v(" "), (_vm.type === 1) ? _c('div', [_c('div', [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.multipleDays),
	      callback: function($$v) {
	        _vm.multipleDays = $$v
	      },
	      expression: "multipleDays"
	    }
	  }, _vm._l((_vm.days), function(item, i) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": i
	      }
	    })
	  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
	    attrs: {
	      "placeholder": "Select Start Time"
	    },
	    model: {
	      value: (_vm.startTime),
	      callback: function($$v) {
	        _vm.startTime = $$v
	      },
	      expression: "startTime"
	    }
	  }), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "datetimerange",
	      "range-separator": " - ",
	      "placeholder": "Select range",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date"
	    },
	    model: {
	      value: (_vm.dateRange),
	      callback: function($$v) {
	        _vm.dateRange = $$v
	      },
	      expression: "dateRange"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToList({
	          start_time: _vm.timeFormat(_vm.startTime),
	          presentation_id: _vm.selectedPresentation.presentation_id,
	          day_of_week: _vm.multipleDays,
	          schedule_type: 'one-time',
	          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
	          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
	        })
	      }
	    }
	  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('div', [_c('div', [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.multipleDays),
	      callback: function($$v) {
	        _vm.multipleDays = $$v
	      },
	      expression: "multipleDays"
	    }
	  }, _vm._l((_vm.days), function(item, i) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": i
	      }
	    })
	  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
	    attrs: {
	      "placeholder": "Select Start Time"
	    },
	    model: {
	      value: (_vm.startTime),
	      callback: function($$v) {
	        _vm.startTime = $$v
	      },
	      expression: "startTime"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToList({
	          presentation_id: _vm.selectedPresentation.presentation_id,
	          schedule_type: 'recurring/weekly',
	          day_of_week: _vm.multipleDays,
	          start_time: _vm.timeFormat(_vm.startTime)
	        })
	      }
	    }
	  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.type === 3) ? _c('div', [_c('div', [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.multipleDays),
	      callback: function($$v) {
	        _vm.multipleDays = $$v
	      },
	      expression: "multipleDays"
	    }
	  }, _vm._l((_vm.days), function(item, i) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": i
	      }
	    })
	  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
	    attrs: {
	      "placeholder": "Select Start Time"
	    },
	    model: {
	      value: (_vm.startTime),
	      callback: function($$v) {
	        _vm.startTime = $$v
	      },
	      expression: "startTime"
	    }
	  }), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "datetimerange",
	      "range-separator": " - ",
	      "placeholder": "Select range",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date"
	    },
	    model: {
	      value: (_vm.dateRange),
	      callback: function($$v) {
	        _vm.dateRange = $$v
	      },
	      expression: "dateRange"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToList({
	          start_time: _vm.timeFormat(_vm.startTime),
	          presentation_id: _vm.selectedPresentation.presentation_id,
	          day_of_week: _vm.multipleDays,
	          schedule_type: 'one-time',
	          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
	          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
	        })
	      }
	    }
	  }, [_vm._v(" Add ")])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.schedule), function(entry, i) {
	    return (entry.presentation_id === _vm.selectedPresentation.presentation_id) ? _c('div', [_c('el-button', {
	      attrs: {
	        "type": "default"
	      }
	    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.days[entry.day_of_week]) + ", " + _vm._s(entry.schedule_type) + " "), (entry.start_time) ? [_vm._v(" at " + _vm._s(entry.start_time) + " ")] : _vm._e(), _vm._v(" "), (entry.start_datetime_range) ? [_vm._v(" " + _vm._s(entry.start_datetime_range) + " to " + _vm._s(entry.end_datetime_range) + " ")] : _vm._e()], 2), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.schedule.splice(i, 1)
	        }
	      }
	    }, [_vm._v(" Delete ")])], 1) : _vm._e()
	  }), _vm._v(" "), _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._v(" Save ")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(0)
	      }
	    }
	  }, [_vm._v(" Cancel ")])], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._l((_vm.scheduleList), function(schedule, index) {
	    return [_c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setStep(3), _vm.getPresentations(), _vm.setActiveSchedule(schedule.schedule_id), _vm.edit = true
	        }
	      }
	    }, [_vm._v(" " + _vm._s(schedule.schedule_id) + " ")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.deleteSchedule(schedule.schedule_id, index)
	        }
	      }
	    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
	  })], 2)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Schedule Manager ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Select a Presentation ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Select a Schedule ")])])
	}]}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('modal', {
	    staticClass: "this-is-the-class",
	    attrs: {
	      "show": _vm.showNameConfirmationModal,
	      "effect": "custom"
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.showNameConfirmationModal = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header center",
	    attrs: {
	      "slot": "modal-header"
	    },
	    slot: "modal-header"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Welcome to UNOapp!")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [(_vm.activeUser.first_name) ? _c('h4', [_vm._v("Can we call you "), _c('b', [_vm._v(_vm._s(_vm.activeUser.first_name))]), _vm._v("? Confirm your name below if that's right.")]) : _c('h4', [_vm._v("We didn't catch your name. Let us know what we should call you.")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "novalidate": ""
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeUser.first_name),
	      expression: "activeUser.first_name"
	    }],
	    staticClass: "form-control",
	    class: {
	      'edited': _vm.activeUser.first_name
	    },
	    attrs: {
	      "type": "text",
	      "id": "form_control_1",
	      "maxlength": "20"
	    },
	    domProps: {
	      "value": (_vm.activeUser.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.activeUser, "first_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_control_1"
	    }
	  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activeUser.last_name),
	      expression: "activeUser.last_name"
	    }],
	    staticClass: "form-control",
	    class: {
	      'edited': _vm.activeUser.last_name
	    },
	    attrs: {
	      "type": "text",
	      "id": "form_control_2",
	      "maxlength": "20"
	    },
	    domProps: {
	      "value": (_vm.activeUser.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.activeUser, "last_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_control_2"
	    }
	  }, [_vm._v("Last Name")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showAlert($event)
	      }
	    }
	  }, [_vm._v("Confirm")])])])
	},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.updateContestLayout($event)
	      }
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "col-sm-7 scroll-column"
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.skip_form),
	      expression: "contestLayout.form.skip_form"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-skip-form-step",
	      "disabled": _vm.process !== 'step_1'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.skip_form) ? _vm._i(_vm.contestLayout.form.skip_form, null) > -1 : (_vm.contestLayout.form.skip_form)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contestLayout.form.skip_form,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.skip_form = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.skip_form = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form, "skip_form", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-skip-form-step"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t                    \t\t\t\t\t\t\tSkip Form Step\n\t                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'Enabling this will bypass the form and take the user directly to the digital scratch card.'
	    }
	  })], 1)])])]), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Language")]), _vm._v(" "), _c('dropdown', {
	    attrs: {
	      "forceUpdate": _vm.transitionComplete
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.contestLayout.form.language) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setFormLanguage('english')
	      }
	    }
	  }, [_vm._v("English")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setFormLanguage('french')
	      }
	    }
	  }, [_vm._v("French")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.form.form_instructions),
	      expression: "contestLayout.form.form_instructions",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.form_instructions.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_design_layout_form_instructions",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.form_instructions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form, "form_instructions", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_form_instructions"
	    }
	  }, [_vm._v("Form Instructions")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The instructions that will be presented to the user.")])]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'ig' && !_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.form.thank_you_text),
	      expression: "contestLayout.form.thank_you_text",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.thank_you_text.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_design_layout_thank_you",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.thank_you_text)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form, "thank_you_text", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_thank_you"
	    }
	  }, [_vm._v("Thank You Message")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The message that will be presented to the user.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.contestLayout.form.min_age),
	      expression: "contestLayout.form.min_age",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.min_age || _vm.contestLayout.form.min_age === 0
	    },
	    attrs: {
	      "type": "number",
	      "id": "edit_design_layout_form_min_age",
	      "disabled": _vm.contestLayout.form.no_age
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.min_age)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form, "min_age", _vm._n($event.target.value))
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_form_min_age"
	    }
	  }, [_vm._v("Age Limit")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Set the minimum age required for the user to enter the contest.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.no_age),
	      expression: "contestLayout.form.no_age"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-no-age-limit",
	      "disabled": _vm.process !== 'step_1'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.no_age) ? _vm._i(_vm.contestLayout.form.no_age, null) > -1 : (_vm.contestLayout.form.no_age)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contestLayout.form.no_age,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.no_age = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.no_age = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form, "no_age", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-no-age-limit"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t                \t\t\t\t\t\t\tNo age limit\n\t                \t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "portlet box blue-hoki"
	  }, [_c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v("\n\t                \t\t\t\t\t\tForm Information\n\t                \t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("Choose the fields to show on the form and which fields are required.")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Request Field")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Require Field")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('h4', [_vm._v("Full Name")])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.full_name.request),
	      expression: "contestLayout.form.fields.full_name.request"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_full_name_request"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.full_name.request) ? _vm._i(_vm.contestLayout.form.fields.full_name.request, null) > -1 : (_vm.contestLayout.form.fields.full_name.request)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.full_name.request,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.full_name.request = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.full_name.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.full_name, "request", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('request', 'full_name')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_full_name_request"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.full_name.require),
	      expression: "contestLayout.form.fields.full_name.require"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_full_name_require"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.full_name.require) ? _vm._i(_vm.contestLayout.form.fields.full_name.require, null) > -1 : (_vm.contestLayout.form.fields.full_name.require)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.full_name.require,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.full_name.require = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.full_name.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.full_name, "require", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('require', 'full_name')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_full_name_require"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Email")])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.email.request),
	      expression: "contestLayout.form.fields.email.request"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_email_request"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.email.request) ? _vm._i(_vm.contestLayout.form.fields.email.request, null) > -1 : (_vm.contestLayout.form.fields.email.request)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.email.request,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.email.request = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.email.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.email, "request", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('request', 'email')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_email_request"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.email.require),
	      expression: "contestLayout.form.fields.email.require"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_email_require"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.email.require) ? _vm._i(_vm.contestLayout.form.fields.email.require, null) > -1 : (_vm.contestLayout.form.fields.email.require)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.email.require,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.email.require = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.email.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.email, "require", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('require', 'email')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_email_require"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Phone #")])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.phone.request),
	      expression: "contestLayout.form.fields.phone.request"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_phone_request"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.phone.request) ? _vm._i(_vm.contestLayout.form.fields.phone.request, null) > -1 : (_vm.contestLayout.form.fields.phone.request)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.phone.request,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.phone.request = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.phone.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.phone, "request", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('request', 'phone')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_phone_request"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.phone.require),
	      expression: "contestLayout.form.fields.phone.require"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_phone_require"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.phone.require) ? _vm._i(_vm.contestLayout.form.fields.phone.require, null) > -1 : (_vm.contestLayout.form.fields.phone.require)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.phone.require,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.phone.require = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.phone.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.phone, "require", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('require', 'phone')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_phone_require"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Date of Birth")])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.dob.request),
	      expression: "contestLayout.form.fields.dob.request"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_dob_request"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.dob.request) ? _vm._i(_vm.contestLayout.form.fields.dob.request, null) > -1 : (_vm.contestLayout.form.fields.dob.request)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.dob.request,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.dob.request = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.dob.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.dob, "request", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('request', 'dob')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_dob_request"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])]), _vm._v(" "), _c('td', [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.fields.dob.require),
	      expression: "contestLayout.form.fields.dob.require"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "form_fields_dob_require"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.fields.dob.require) ? _vm._i(_vm.contestLayout.form.fields.dob.require, null) > -1 : (_vm.contestLayout.form.fields.dob.require)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.contestLayout.form.fields.dob.require,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.fields.dob.require = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.fields.dob.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form.fields.dob, "require", $$c)
	        }
	      }, function($event) {
	        _vm.forceFieldSelection('require', 'dob')
	      }]
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "form_fields_dob_require"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  })])])])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
	    staticClass: "form-md-checkboxes"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.form.thank_you_email),
	      expression: "contestLayout.form.thank_you_email"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-email-response",
	      "disabled": _vm.process !== 'step_1'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.form.thank_you_email) ? _vm._i(_vm.contestLayout.form.thank_you_email, null) > -1 : (_vm.contestLayout.form.thank_you_email)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contestLayout.form.thank_you_email,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.form.thank_you_email = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.form.thank_you_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.form, "thank_you_email", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-email-response"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n                    \t\t\t\t\t\t\tEnable response email\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'This will send the user an email response after entering the contest.'
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.form.email_fields.sender),
	      expression: "contestLayout.form.email_fields.sender",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.email_fields.sender.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_design_layout_email_sender",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.email_fields.sender)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form.email_fields, "sender", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_email_sender"
	    }
	  }, [_vm._v("Sender Name")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The email will send from do-not-reply@unoapp.com.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.form.email_fields.subject),
	      expression: "contestLayout.form.email_fields.subject",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.email_fields.subject.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_design_layout_email_subject",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.email_fields.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form.email_fields, "subject", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_email_subject"
	    }
	  }, [_vm._v("Subject")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.form.email_fields.body),
	      expression: "contestLayout.form.email_fields.body",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.form.email_fields.body.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_design_layout_email_body",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.form.email_fields.body)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.form.email_fields, "body", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_design_layout_email_body"
	    }
	  }, [_vm._v("Body")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    key: "edit-contest-design-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('contest-preview', {
	    attrs: {
	      "design": _vm.contestLayout.design,
	      "form": _vm.contestLayout.form,
	      "agreement": _vm.contestLayout.agreement
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('div', {
	    staticClass: "col-sm-7 scroll-column"
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.text_color),
	      expression: "contestLayout.design.text_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.text_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_text_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.text_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "text_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_text_color"
	    }
	  }, [_vm._v("Text Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.text_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "text_color", $$v)
	      },
	      expression: "contestLayout.design.text_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.input_text_color),
	      expression: "contestLayout.design.input_text_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.input_text_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_input_text_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.input_text_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "input_text_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_input_text_color"
	    }
	  }, [_vm._v("Input Text Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.input_text_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "input_text_color", $$v)
	      },
	      expression: "contestLayout.design.input_text_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.background_color),
	      expression: "contestLayout.design.background_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.background_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_background_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.background_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "background_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_background_color"
	    }
	  }, [_vm._v("Background Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.background_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "background_color", $$v)
	      },
	      expression: "contestLayout.design.background_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.design.background_image),
	      expression: "contestLayout.design.background_image",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.background_image.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_background_image"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.background_image)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "background_image", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_background_image"
	    }
	  }, [_vm._v("Background Image")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.design.header_image),
	      expression: "contestLayout.design.header_image",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.header_image.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_header_image"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.header_image)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "header_image", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_header_image"
	    }
	  }, [_vm._v("Header Image")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.design.footer_image),
	      expression: "contestLayout.design.footer_image",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.footer_image.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_footer_image"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.footer_image)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "footer_image", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_footer_image"
	    }
	  }, [_vm._v("Footer Image")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.footer_background_color),
	      expression: "contestLayout.design.footer_background_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.footer_background_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_footer_background_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.footer_background_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "footer_background_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_footer_background_color"
	    }
	  }, [_vm._v("Footer Background Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.footer_background_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "footer_background_color", $$v)
	      },
	      expression: "contestLayout.design.footer_background_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.footer_border_color),
	      expression: "contestLayout.design.footer_border_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.footer_border_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_footer_border_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.footer_border_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "footer_border_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_footer_border_color"
	    }
	  }, [_vm._v("Footer Border Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.footer_border_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "footer_border_color", $$v)
	      },
	      expression: "contestLayout.design.footer_border_color"
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.input_background_color),
	      expression: "contestLayout.design.input_background_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.input_background_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_input_background_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.input_background_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "input_background_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_input_background_color"
	    }
	  }, [_vm._v("Input Background Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.input_background_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "input_background_color", $$v)
	      },
	      expression: "contestLayout.design.input_background_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.input_placeholder_color),
	      expression: "contestLayout.design.input_placeholder_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.input_placeholder_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_input_placeholder_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.input_placeholder_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "input_placeholder_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_input_placeholder_color"
	    }
	  }, [_vm._v("Input Placeholder Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.input_placeholder_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "input_placeholder_color", $$v)
	      },
	      expression: "contestLayout.design.input_placeholder_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.button_text_color),
	      expression: "contestLayout.design.button_text_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.button_text_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_button_text_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.button_text_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "button_text_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_button_text_color"
	    }
	  }, [_vm._v("Button Text Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.button_text_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "button_text_color", $$v)
	      },
	      expression: "contestLayout.design.button_text_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.button_background_color),
	      expression: "contestLayout.design.button_background_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.button_background_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_button_background_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.button_background_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "button_background_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_button_background_color"
	    }
	  }, [_vm._v("Button Background Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.button_background_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "button_background_color", $$v)
	      },
	      expression: "contestLayout.design.button_background_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('div', {
	    staticClass: "input-icon right"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.design.button_background_hover_color),
	      expression: "contestLayout.design.button_background_hover_color"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.design.button_background_hover_color.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "design_button_background_hover_color"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.design.button_background_hover_color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.design, "button_background_hover_color", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "design_button_background_hover_color"
	    }
	  }, [_vm._v("Button Hover Color")]), _vm._v(" "), _c('i', {
	    staticClass: "wide clickable"
	  }, [_c('el-color-picker', {
	    attrs: {
	      "show-alpha": ""
	    },
	    model: {
	      value: (_vm.contestLayout.design.button_background_hover_color),
	      callback: function($$v) {
	        _vm.$set(_vm.contestLayout.design, "button_background_hover_color", $$v)
	      },
	      expression: "contestLayout.design.button_background_hover_color"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Font Family")]), _vm._v(" "), _c('font-picker', {
	    attrs: {
	      "passedFont": _vm.contestLayout.design.font_family
	    },
	    on: {
	      "updateFont": _vm.setFontFamily
	    }
	  })], 1), _vm._v(" "), (_vm.contestLayout.design.font_family.family) ? _c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Font Weight")]), _vm._v(" "), _c('dropdown', {
	    staticClass: "full-width"
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default full-width",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.contestLayout.design.font_weight || 'Select a Font Weight') + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down pull-right"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu full-width",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_vm._l((_vm.fontWeights), function(weight) {
	    return [(_vm.contestLayout.design.font_family.variants.indexOf(weight.name) !== -1) ? _c('li', [_c('a', {
	      style: ({
	        fontWeight: weight.weight
	      }),
	      on: {
	        "click": function($event) {
	          _vm.setFontWeight(weight)
	        }
	      }
	    }, [_vm._v(_vm._s(weight.weight))])]) : _vm._e()]
	  })], 2)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "edit-contest-design-continue-two",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_3', 'step_2')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('contest-preview', {
	    attrs: {
	      "design": _vm.contestLayout.design,
	      "form": _vm.contestLayout.form,
	      "agreement": _vm.contestLayout.agreement
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
	    key: "step_3"
	  }, [_c('div', {
	    staticClass: "col-sm-7 scroll-column"
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.urls[0].url),
	      expression: "contestLayout.agreement.urls[0].url",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.urls[0].url.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_url_1",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.urls[0].url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement.urls[0], "url", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_url_1"
	    }
	  }, [_vm._v("Agreement URL")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.urls[0].name),
	      expression: "contestLayout.agreement.urls[0].name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.urls[0].name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_name_1",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.urls[0].name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement.urls[0], "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_name_1"
	    }
	  }, [_vm._v("Agreement Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.urls[1].url),
	      expression: "contestLayout.agreement.urls[1].url",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.urls[1].url.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_url_2",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.urls[1].url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement.urls[1], "url", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_url_2"
	    }
	  }, [_vm._v("Agreement URL")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.urls[1].name),
	      expression: "contestLayout.agreement.urls[1].name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.urls[1].name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_name_2",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.urls[1].name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement.urls[1], "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_name_2"
	    }
	  }, [_vm._v("Agreement Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.terms_error),
	      expression: "contestLayout.agreement.terms_error",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.terms_error.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_terms_error",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.terms_error)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement, "terms_error", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_terms_error"
	    }
	  }, [_vm._v("Terms and Conditions Error")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The message that will be displayed to the user if they fail to accept the terms and conditions.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-md-checkboxes margin-top-40"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contestLayout.agreement.require_access_code),
	      expression: "contestLayout.agreement.require_access_code"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-require-access-code"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.contestLayout.agreement.require_access_code) ? _vm._i(_vm.contestLayout.agreement.require_access_code, null) > -1 : (_vm.contestLayout.agreement.require_access_code)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.contestLayout.agreement.require_access_code,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.contestLayout.agreement.require_access_code = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.contestLayout.agreement.require_access_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.contestLayout.agreement, "require_access_code", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-require-access-code"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n                    \t\t\t\t\t\t\tRequire Access Code\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'Access Code is used to verify that a prize has been redeemed.'
	    }
	  })], 1)])]), _vm._v(" "), (_vm.contestLayout.agreement.require_access_code) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.contestLayout.agreement.access_code),
	      expression: "contestLayout.agreement.access_code",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.contestLayout.agreement.access_code.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_agreement_access_code",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.contestLayout.agreement.access_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contestLayout.agreement, "access_code", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_agreement_access_code"
	    }
	  }, [_vm._v("Access Code")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The access code that is required to claim the prize.")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('contest-preview', {
	    attrs: {
	      "design": _vm.contestLayout.design,
	      "form": _vm.contestLayout.form,
	      "agreement": _vm.contestLayout.agreement
	    }
	  })], 1)]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.editContestLayoutNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tEdit Contest Layout\n\t\t\t\t")])])
	}]}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "popover-block"
	  }, [_c('i', {
	    staticClass: "fa fa-question-circle font-blue clickable",
	    attrs: {
	      "id": ("popover-id-" + _vm.id)
	    },
	    on: {
	      "click": function($event) {
	        _vm.openPopover()
	      }
	    }
	  }), _vm._v(" "), (_vm.open) ? _c('div', {
	    staticClass: "popover-styles",
	    class: {
	      'shift-left': _vm.rightSide
	    }
	  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login",
	    attrs: {
	      "id": "set_password"
	    }
	  }, [_c('div', {
	    staticClass: "user-login-5"
	  }, [_c('div', {
	    staticClass: "row bs-reset"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 login-container bs-reset mt-login-5-bsfix"
	  }, [(_vm.currentView === 'expired_token') ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h1', [_vm._v("This token is expired.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn green",
	    on: {
	      "click": function($event) {
	        _vm.routeToLogin()
	      }
	    }
	  }, [_vm._v("Return to Login")])]) : _vm._e(), _vm._v(" "), (_vm.currentView === 'set_password_form') ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h1', [_vm._v("Set UNOapp Password")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-10"
	  }, [_vm._v("Enter your desired password in the fields below.")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-10"
	  }, [_vm._v("Please note that you may only use a secure strengthened password.")]), _vm._v(" "), _c('p', {
	    staticClass: "margin-10"
	  }, [_vm._v("It is best to use at least 10 characters, and to avoid using dictionary words.")]), _vm._v(" "), _c('form', {
	    staticClass: "login-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.setPassword($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
	    attrs: {
	      "type": "password",
	      "autocomplete": "off",
	      "placeholder": "Password",
	      "name": "password"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.strength.length) ? _c('div', {
	    staticClass: "password-approval-blocks",
	    class: {
	      'very-weak': _vm.strength === 'Very Weak' || _vm.strength == 'Password must be 8 characters minimum', 'weak': _vm.strength === 'Weak', 'ok': _vm.strength === 'OK', 'strong': _vm.strength === 'Strong'
	    }
	  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.strength.length) ? _c('div', {
	    staticClass: "password-approval-text",
	    class: {
	      'very-weak': _vm.strength === 'Very Weak' || _vm.strength == 'Password must be 8 characters minimum', 'weak': _vm.strength === 'Weak', 'ok': _vm.strength === 'OK', 'strong': _vm.strength === 'Strong'
	    }
	  }, [_vm._v(_vm._s(_vm.strength))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.confirmPassword),
	      expression: "confirmPassword"
	    }],
	    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
	    attrs: {
	      "type": "password",
	      "autocomplete": "off",
	      "placeholder": "Confirm Password",
	      "name": "confirm_password"
	    },
	    domProps: {
	      "value": (_vm.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.confirmPassword = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.confirmPassword.length && !_vm.passwordsMatch) ? _c('div', {
	    staticClass: "password-approval-text very-weak"
	  }, [_vm._v("Passwords do not match")]) : _vm._e(), _vm._v(" "), (_vm.confirmPassword.length && _vm.passwordsMatch) ? _c('div', {
	    staticClass: "password-approval-text strong"
	  }, [_vm._v("Passwords match")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.currentView === 'password_success') ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h1', [_vm._v("Your password was set successfully!")]), _vm._v(" "), _c('button', {
	    staticClass: "btn green",
	    on: {
	      "click": function($event) {
	        _vm.routeToLogin()
	      }
	    }
	  }, [_vm._v("Login to UNOapp")])]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 bs-reset mt-login-5-bsfix"
	  }, [_c('div', {
	    staticClass: "login-bg"
	  }, [_c('img', {
	    staticClass: "login-logo",
	    attrs: {
	      "src": __webpack_require__(84)
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 text-right"
	  }, [_c('button', {
	    staticClass: "btn green",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")])])])
	}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('users', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Invite and manage your business users.',
	      "businessId": _vm.activeBusinessId,
	      "baseRoute": '/app/my_business/users',
	      "baseRouteName": 'My Business Users'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('roles', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Create and manage your business roles.',
	      "businessId": _vm.activeBusinessId,
	      "baseRoute": '/app/my_business/roles',
	      "baseRouteName": 'My Business Roles'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h4', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
	    staticClass: "preview-container",
	    style: ({
	      backgroundColor: _vm.design.background_color,
	      backgroundImage: 'url(\'' + _vm.design.background_image + '\')',
	      color: _vm.design.text_color
	    })
	  }, [_c('div', {
	    staticClass: "preview-content",
	    style: ({
	      'font-family': _vm.design.font_family.family,
	      'font-weight': _vm.design.font_weight
	    })
	  }, [_c('div', {
	    staticClass: "preview-header",
	    style: ({
	      backgroundImage: 'url(\'' + _vm.design.header_image + '\')'
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "preview-form-instructions",
	    style: ({
	      color: _vm.design.text_color
	    })
	  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.form.form_instructions) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "preview-form"
	  }, [(_vm.form.fields.full_name.request) ? _c('input', {
	    staticClass: "form-control margin-top-10 preview-input",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("FULL NAME" + (_vm.form.fields.full_name.require ? '*' : ''))
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.email.request) ? _c('input', {
	    staticClass: "form-control margin-top-10 preview-input",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("EMAIL" + (_vm.form.fields.email.require ? '*' : ''))
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.phone.request) ? _c('input', {
	    staticClass: "form-control margin-top-10 preview-input",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("PHONE" + (_vm.form.fields.phone.require ? '*' : ''))
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.dob.request) ? _c('div', {
	    staticClass: "preview-dob"
	  }, [_c('p', {
	    staticClass: "margin-top-20"
	  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control margin-right-10 preview-input dob-input-style",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("MM" + (_vm.form.fields.dob.require ? '*' : ''))
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "form-control margin-right-10 preview-input dob-input-style",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("DD" + (_vm.form.fields.dob.require ? '*' : ''))
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "form-control preview-input dob-input-style",
	    style: ({
	      backgroundColor: _vm.design.input_background_color,
	      color: _vm.design.input_text_color
	    }),
	    attrs: {
	      "type": "text",
	      "placeholder": ("YYYY" + (_vm.form.fields.dob.require ? '*' : ''))
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "preview-button btn default margin-top-20 full-width",
	    style: ({
	      backgroundColor: _vm.design.button_background_color,
	      color: _vm.design.button_text_color,
	      'font-weight': _vm.design.font_weight
	    }),
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("SUBMIT")]), _vm._v(" "), _c('div', {
	    staticClass: "preview-agreement"
	  }, [(_vm.agreement.urls[0].url.length || _vm.agreement.urls[0].name.length || _vm.agreement.urls[1].url.length || _vm.agreement.urls[1].name.length) ? _c('p', [_vm._v("\n    \t\t\t\t\t\tI have read and agree to the "), _c('a', {
	    attrs: {
	      "href": _vm.agreement.urls[0].url
	    }
	  }, [_vm._v(_vm._s(_vm.agreement.urls[0].name || _vm.agreement.urls[0].url))]), (_vm.agreement.urls[1].url.length || _vm.agreement.urls[1].name.length) ? _c('span', [_vm._v(" and "), _c('a', {
	    attrs: {
	      "href": _vm.agreement.urls[1].url
	    }
	  }, [_vm._v(_vm._s(_vm.agreement.urls[1].name || _vm.agreement.urls[1].url))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "preview-footer",
	    style: ({
	      backgroundColor: _vm.design.footer_background_color,
	      borderTop: (_vm.design.footer_border_color ? ("5px solid " + (_vm.design.footer_border_color)) : 'none')
	    })
	  }, [(_vm.design.footer_image.length) ? _c('img', {
	    attrs: {
	      "src": _vm.design.footer_image
	    }
	  }) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('dropdown', {
	    staticClass: "full-width",
	    attrs: {
	      "maxHeight": 250
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default full-width",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.passedFont.family) + "\n\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down pull-right"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu full-width",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_vm._l((_vm.allGoogleFonts), function(font) {
	    return [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.emitFontFamily(font)
	        }
	      }
	    }, [_vm._v(_vm._s(font.family))])])]
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.$router.message) ? _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.$router.message))]) : _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("You've reached this page because of an error.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success centered-button uppercase",
	    on: {
	      "click": function($event) {
	        _vm.routeToLogin()
	      }
	    }
	  }, [_vm._v("Return to Login")])])
	},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sideways-page-one"
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), (_vm.showModal) ? _c('div', {
	    staticClass: "show-modal",
	    staticStyle: {
	      "z-index": "9999",
	      "position": "fixed",
	      "top": "0",
	      "left": "0",
	      "height": "100vh",
	      "width": "100vw",
	      "display": "flex",
	      "justify-content": "center",
	      "align-items": "center",
	      "background-color": "rgba(0,0,0,0.5)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "background-color": "white",
	      "border-radius": "4px",
	      "width": "700px",
	      "height": "500px",
	      "padding": "20px",
	      "align-items": "center",
	      "display": "flex",
	      "flex-direction": "column"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('h2', [_vm._v(" Select Day, Start time and Date range")]), _vm._v(" "), _c('div', [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.multipleDays),
	      callback: function($$v) {
	        _vm.multipleDays = $$v
	      },
	      expression: "multipleDays"
	    }
	  }, _vm._l((_vm.days), function(item, i) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": i
	      }
	    })
	  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
	    attrs: {
	      "placeholder": "Select Start Time"
	    },
	    model: {
	      value: (_vm.startTime),
	      callback: function($$v) {
	        _vm.startTime = $$v
	      },
	      expression: "startTime"
	    }
	  }), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "datetimerange",
	      "range-separator": " - ",
	      "placeholder": "Select range",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date"
	    },
	    model: {
	      value: (_vm.dateRange),
	      callback: function($$v) {
	        _vm.dateRange = $$v
	      },
	      expression: "dateRange"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    class: {
	      'clickable-blue': _vm.multipleDays !== null && _vm.startTime !== null && _vm.dateRange !== null
	    },
	    staticStyle: {
	      "background-color": "grey",
	      "pointer-events": "none"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addLimitedTimePlaylist({
	          start_time: _vm.timeFormat(_vm.startTime),
	          presentation_id: _vm.selectedPresentation.presentation_id,
	          day_of_week: _vm.multipleDays,
	          playlist_type: 'one-time',
	          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
	          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
	        })
	      }
	    }
	  }, [_vm._v(" Add ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createPres(), _vm.getLayouts()
	      }
	    }
	  }, [_vm._v(" Create a new Presentation")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(3), _vm.getPresentations()
	      }
	    }
	  }, [_vm._v(" Open existing Presentation")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.layoutList), function(layout, index) {
	    return [_c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setActiveLayout(index)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(layout.name) + " w: " + _vm._s(layout.width) + " h: " + _vm._s(layout.height) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._l((_vm.presentationList), function(pres, index) {
	    return [_c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPres(index)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(pres.name) + " ")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.deletePres(pres.presentation_id, index)
	        }
	      }
	    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_c('div', [_c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.showAll()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-th fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\tShow all Displays\n\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.showOne()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-stop fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\tShow One Display\n\t\t")]), _vm._v(" "), _c('div', [_c('h1', [_vm._v(" Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])])]), _vm._v(" "), (_vm.displayNumber !== false) ? [_c('div', [_c('div', [_c('h1', [_vm._v(" Layout: " + _vm._s(_vm.name) + " (Display " + _vm._s(_vm.displayNumber + 1) + "/" + _vm._s(_vm.displayCount) + ")")])]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    attrs: {
	      "disabled": !_vm.displayNumber > 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.prevDisplay()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-left fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tPrevious Display\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.toggle()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-alt fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tFullscreen\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    attrs: {
	      "disabled": !(this.displayNumber < this.displayCount - 1)
	    },
	    on: {
	      "click": function($event) {
	        _vm.nextDisplay()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-right fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tNext Display\n\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "auto!important",
	      "padding": "5px"
	    },
	    style: ({
	      'margin-bottom': _vm.padding + 'px'
	    })
	  }, [_c('fs', {
	    ref: "fs",
	    attrs: {
	      "fullscreen": _vm.fullscreen
	    },
	    on: {
	      "update:fullscreen": function($event) {
	        _vm.fullscreen = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "layout-editor",
	    staticStyle: {
	      "position": "relative",
	      "transform-origin": "top",
	      "outline": "5px solid black"
	    },
	    style: ({
	      width: _vm.layoutWidth + 'px',
	      height: _vm.layoutHeight + 'px',
	      transform: 'scale(' + _vm.demoScale + ',' + _vm.demoScale + ')',
	      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
	    })
	  }, [_vm._l((_vm.zones), function(region, i) {
	    return (region.background !== 'transparent' && region.screen === _vm.displayNumber && !region.limited) ? [_c('vue-draggable-resizable', {
	      staticClass: "demo-region",
	      class: {
	        'selected-playlist-text': _vm.selectedPlaylist === i, 'seethru': _vm.selectedPlaylist !== null && _vm.fullscreen === false
	      },
	      style: ({
	        'background-color': region.background
	      }),
	      attrs: {
	        "draggable": false,
	        "resizable": false,
	        "grid": [_vm.grid, _vm.grid],
	        "id": ("region-" + i),
	        "index": i,
	        "x": region.x,
	        "y": region.y,
	        "w": region.width,
	        "h": region.height,
	        "z": region.z,
	        "parent": true
	      },
	      on: {
	        "activated": function($event) {
	          _vm.selectPlaylist(i)
	        }
	      }
	    }, [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])]) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'mp4') ? _c('video', {
	      key: ("video-" + (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)),
	      staticClass: "autoPlayMe",
	      attrs: {
	        "width": region.width,
	        "height": region.height,
	        "loop": "",
	        "autoplay": ""
	      }
	    }, [_c('source', {
	      attrs: {
	        "src": _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url,
	        "type": "video/mp4"
	      }
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'png' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpeg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'gif') ? _c('div', {
	      staticClass: "imageContainer",
	      style: ({
	        width: region.width + 'px',
	        height: region.height + 'px',
	        'background': 'url(' + _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url + ')'
	      })
	    }) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'html') ? _c('div', {
	      staticStyle: {
	        "background-color": "white!important"
	      },
	      style: ({
	        width: region.width + 'px',
	        height: region.height + 'px',
	      }),
	      domProps: {
	        "innerHTML": _vm._s(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)
	      }
	    }) : _vm._e()] : _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "4px",
	        "padding": "1%",
	        "font-size": "25px"
	      }
	    }, [_c('h1', {
	      staticStyle: {
	        "margin-top": "5%"
	      }
	    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t\t")])] : _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "4px",
	        "padding": "1%",
	        "font-size": "25px"
	      }
	    }, [_c('h1', {
	      staticStyle: {
	        "margin-top": "5%"
	      }
	    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t")])], 2)] : _vm._e()
	  })], 2)])], 1), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "button btn",
	    class: {
	      'clickable-white': !_vm.play
	    },
	    staticStyle: {
	      "background-color": "grey",
	      "pointer-events": "none"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addNewRegion()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tAdd\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    class: {
	      'clickable-white': !_vm.play
	    },
	    staticStyle: {
	      "background-color": "grey",
	      "pointer-events": "none"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteRegion()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tDelete\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.save(_vm.selectedPresentation.presentation_id)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tSave\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.setStep(0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-undo fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tCancel\n\t\t\t")]), _vm._v(" "), _c('resource-modal', {
	    staticStyle: {
	      "position": "absolute",
	      "bottom": "-10vh"
	    },
	    attrs: {
	      "id": "invisible-button",
	      "buttonText": 'Select content'
	    },
	    on: {
	      "selected": _vm.selectedResource
	    }
	  })], 1), _vm._v(" "), _c('div', [(!_vm.play) ? _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.reset()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-play fa-2x"
	  })]) : _vm._e(), _vm._v(" "), (_vm.play) ? _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.stop()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-stop fa-2x"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("\n\t\t\tMax Time (s) of playlist\n\t\t\t"), _c('el-slider', {
	    attrs: {
	      "step": 5,
	      "show-input": "",
	      "min": 10,
	      "max": 10000
	    },
	    model: {
	      value: (_vm.maxTime),
	      callback: function($$v) {
	        _vm.maxTime = $$v
	      },
	      expression: "maxTime"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-bottom": "50px"
	    }
	  }, [_c('div', {
	    staticClass: "region-block",
	    staticStyle: {
	      "margin": "0 !important",
	      "display": "inline-block",
	      "float": "left",
	      "width": "100px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "height": "50px",
	      "width": "100px"
	    }
	  }, [(_vm.groupModeOn) ? _c('button', {
	    style: ({
	      'background-color': _vm.colorHash('', _vm.selectedGroup)
	    }),
	    on: {
	      "click": function($event) {
	        _vm.groupMode()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-object-group"
	  })]) : _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.groupMode()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-object-group"
	  })])]), _vm._v(" "), _vm._l((_vm.zones), function(region, j) {
	    return (_vm.zones[j].screen === _vm.displayNumber) ? _c('div', {
	      class: {
	        'groupHover': _vm.groupModeOn
	      },
	      staticStyle: {
	        "width": "100%",
	        "display": "inline-block",
	        "margin": "0",
	        "padding": "0"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPlaylist(j), _vm.groupToggle(j)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "display": "flex",
	        "justify-content": "center",
	        "align-items": "center",
	        "flex-direction": "row"
	      }
	    }, [(region.group !== false) ? _c('span', {
	      staticStyle: {
	        "width": "10%",
	        "top": "0",
	        "left": "0",
	        "height": "50px",
	        "border": "1px solid black"
	      },
	      style: ({
	        'background-color': _vm.colorHash('', region.group)
	      })
	    }) : _c('span', {
	      staticStyle: {
	        "width": "10%",
	        "top": "0",
	        "left": "0",
	        "height": "50px",
	        "background-color": "transparent"
	      }
	    }), _vm._v(" "), _c('p', {
	      class: {
	        'selected-playlist-text': _vm.selectedPlaylist === j
	      },
	      staticStyle: {
	        "margin-left": "0",
	        "margin-top": "0",
	        "margin-bottom": "0",
	        "margin-right": "15px",
	        "width": "90%",
	        "flex-direction": "column",
	        "display": "flex",
	        "justify-content": "center",
	        "align-items": "center",
	        "background-color": "white",
	        "padding": "0",
	        "line-height": "20px",
	        "height": "50px",
	        "opacity": "0.5"
	      },
	      style: ({
	        'background-color': _vm.zones[j].background
	      })
	    }, [(!region.limited) ? _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "2px",
	        "padding": "2px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('el-tooltip', {
	      staticClass: "item",
	      attrs: {
	        "effect": "dark",
	        "content": _vm.days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range,
	        "placement": "top-start"
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "2px",
	        "padding": "2px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + ": " + _vm._s(_vm.daysShort[region.limited.day_of_week]) + " \n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('button', {
	      staticStyle: {
	        "color": "black"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removePlaylist(j)
	        }
	      }
	    }, [_vm._v(" - ")]) : _vm._e()], 1)])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "playlist-block",
	    staticStyle: {
	      "white-space": "nowrap",
	      "overflow-x": "auto",
	      "overflow-y": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "playlist",
	    staticStyle: {
	      "height": "50px",
	      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px)",
	      "position": "relative",
	      "transform-origin": "top",
	      "outline": "1px solid transparent"
	    },
	    style: ({
	      width: _vm.maxTime * _vm.scale + 'px',
	      'background-size': _vm.scale + 'px ' + _vm.height + 'px'
	    })
	  }, _vm._l((_vm.maxTime + 1), function(n, i) {
	    return ((n - 1) % 10 === 0 || (n - 1) % 5 === 0) ? _c('span', {
	      class: {
	        'floatLeft': i !== _vm.maxTime
	      },
	      staticStyle: {
	        "text-align": "left",
	        "z-index": "9",
	        "left": "0",
	        "position": "relative"
	      },
	      style: ({
	        width: _vm.scale * 5 + 'px'
	      })
	    }, [_c('span', {
	      staticStyle: {
	        "margin-left": "2px"
	      }
	    }, [_vm._v(" " + _vm._s(n - 1) + "s ")]), _vm._v(" "), ((n - 1) % 10 === 0) ? _c('span', {
	      staticStyle: {
	        "position": "absolute",
	        "left": "0",
	        "height": "30px",
	        "border-left": "1px solid black"
	      }
	    }) : ((n - 1) % 5 === 0) ? _c('span', {
	      staticStyle: {
	        "position": "absolute",
	        "left": "0",
	        "height": "20px",
	        "border-left": "1px solid black"
	      }
	    }) : _vm._e()]) : _vm._e()
	  })), _vm._v(" "), _vm._l((_vm.regionList), function(regions, j) {
	    return (_vm.zones[j].screen === _vm.displayNumber) ? _c('div', {
	      staticClass: "playlist",
	      staticStyle: {
	        "height": "50px",
	        "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px)",
	        "position": "relative",
	        "transform-origin": "top",
	        "outline": "1px solid transparent"
	      },
	      style: ({
	        width: _vm.maxTime * _vm.scale + 'px',
	        'background-size': _vm.scale + 'px ' + _vm.height + 'px'
	      })
	    }, [(_vm.zones[j].group === false) ? _c('el-slider', {
	      attrs: {
	        "min": 0,
	        "max": _vm.maxTime,
	        "show-tooltip": false
	      },
	      model: {
	        value: (_vm.players[j]),
	        callback: function($$v) {
	          _vm.$set(_vm.players, j, $$v)
	        },
	        expression: "players[j]"
	      }
	    }) : _c('el-slider', {
	      attrs: {
	        "min": 0,
	        "max": _vm.maxTime,
	        "show-tooltip": false
	      },
	      model: {
	        value: (_vm.players[_vm.getIndexOfStartGroup(_vm.zones[j].group)]),
	        callback: function($$v) {
	          _vm.$set(_vm.players, _vm.getIndexOfStartGroup(_vm.zones[j].group), $$v)
	        },
	        expression: "players[getIndexOfStartGroup(zones[j].group)]"
	      }
	    }), _vm._v(" "), _vm._l((regions), function(region, i) {
	      return [(region.del !== true) ? _c('vue-draggable-resizable', {
	        staticClass: "region",
	        class: {
	          'selected-playlist': _vm.selectedPlaylist === j,
	            'selected-region': _vm.selectedRegion === i && _vm.selectedPlaylist === j
	        },
	        staticStyle: {
	          "border": "1px solid grey",
	          "display": "flex",
	          "justify-content": "center",
	          "align-items": "center",
	          "height": "50px",
	          "background-color": "white"
	        },
	        attrs: {
	          "draggable": false,
	          "grid": [_vm.scale, _vm.height],
	          "minw": _vm.scale,
	          "id": ("region-" + j + "-" + i),
	          "playlist": j,
	          "index": i,
	          "z": region.z,
	          "x": region.x,
	          "y": region.y,
	          "w": region.width,
	          "parent": true
	        },
	        on: {
	          "mouseOver": _vm.hoverButton,
	          "mouseLeave": _vm.leaveButton,
	          "resizing": _vm.onResize,
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	          },
	          "update:z": function($event) {
	            _vm.$set(region, "z", $event)
	          },
	          "update:x": function($event) {
	            _vm.$set(region, "x", $event)
	          },
	          "update:w": function($event) {
	            _vm.$set(region, "width", $event)
	          }
	        }
	      }, [(region.resource) ? [(region.resource.extension === 'mp4') ? _c('video', {
	        key: ("thumb-" + (region.resource.url)),
	        attrs: {
	          "width": region.width,
	          "height": 50,
	          "loop": ""
	        }
	      }, [_c('source', {
	        attrs: {
	          "src": region.resource.url,
	          "type": "video/mp4"
	        }
	      }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif') ? _c('div', {
	        staticClass: "imageContainer",
	        style: ({
	          width: region.width + 'px',
	          height: 50 + 'px',
	          'background': 'url(' + region.resource.url + ')'
	        })
	      }) : (region.resource.extension === 'html') ? _c('div', {
	        staticStyle: {
	          "background-color": "white!important"
	        },
	        style: ({
	          width: region.width + 'px',
	          height: region.height + 'px',
	        }),
	        domProps: {
	          "innerHTML": _vm._s(region.resource.url)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
	          expression: "showButtons[0] === i && showButtons[1] === j"
	        }],
	        staticStyle: {
	          "border-radius": "2px",
	          "padding": "2px",
	          "position": "absolute",
	          "bottom": "25px",
	          "color": "white",
	          "background-color": "rgba(0, 0, 0, 0.5)"
	        }
	      }, [_vm._v("  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + " ")]), _vm._v(" "), _c('button', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
	          expression: "showButtons[0] === i && showButtons[1] === j"
	        }],
	        staticClass: "btn button",
	        staticStyle: {
	          "position": "absolute",
	          "bottom": "0",
	          "width": "30px",
	          "font-size": "10px",
	          "padding": "0",
	          "height": "25px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickInvisibleButton(j, i)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-2x fa-upload",
	        staticStyle: {
	          "color": "black"
	        }
	      })])] : (region.width > 30) ? _c('div', {
	        staticStyle: {
	          "display": "flex",
	          "flex-direction": "column"
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + "\n\t\t\t\t\t\t\t\t"), _c('button', {
	        staticClass: "btn button",
	        staticStyle: {
	          "width": "30px",
	          "font-size": "10px",
	          "padding": "0",
	          "height": "25px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickInvisibleButton(j, i)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-2x fa-upload",
	        staticStyle: {
	          "color": "black"
	        }
	      })])]) : _vm._e()], 2) : _vm._e()]
	    })], 2) : _vm._e()
	  })], 2)])] : [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "center",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('div', [_c('h1', [_vm._v(" Layout: " + _vm._s(_vm.name) + " " + _vm._s(_vm.actualWidth) + " x " + _vm._s(_vm.layoutHeight))])]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.toggle()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-alt fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tFullscreen\n\t\t\t")])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "width": "auto!important",
	      "padding": "5px"
	    },
	    style: ({
	      'margin-bottom': _vm.padding + 'px'
	    })
	  }, [_c('fs', {
	    ref: "fs",
	    attrs: {
	      "fullscreen": _vm.fullscreen
	    },
	    on: {
	      "update:fullscreen": function($event) {
	        _vm.fullscreen = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "layout-editor",
	    staticStyle: {
	      "position": "relative",
	      "transform-origin": "top",
	      "outline": "5px solid black"
	    },
	    style: ({
	      width: _vm.actualWidth + 'px',
	      height: _vm.layoutHeight + 'px',
	      transform: 'scale(' + _vm.demoScale + ',' + _vm.demoScale + ')',
	      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
	    })
	  }, [_vm._l((_vm.zones), function(region, i) {
	    return (region.background !== 'transparent' && !region.limited) ? [_c('vue-draggable-resizable', {
	      staticClass: "demo-region",
	      class: {
	        'selected-playlist-text': _vm.selectedPlaylist === i, 'seethru': _vm.selectedPlaylist !== null && _vm.fullscreen === false
	      },
	      style: ({
	        'background-color': region.background
	      }),
	      attrs: {
	        "draggable": false,
	        "resizable": false,
	        "grid": [_vm.grid, _vm.grid],
	        "id": ("region-" + i),
	        "index": i,
	        "x": region.actual_x,
	        "y": region.y,
	        "w": region.width,
	        "h": region.height,
	        "z": region.z,
	        "parent": true
	      },
	      on: {
	        "activated": function($event) {
	          _vm.selectPlaylist(i)
	        },
	        "mouseOver": _vm.hoverButton
	      }
	    }, [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])]) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'mp4') ? _c('video', {
	      key: ("video-" + (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)),
	      staticClass: "autoPlayMe",
	      attrs: {
	        "width": region.width,
	        "height": region.height,
	        "loop": "",
	        "autoplay": ""
	      }
	    }, [_c('source', {
	      attrs: {
	        "src": _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url,
	        "type": "video/mp4"
	      }
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'png' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpeg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'gif') ? _c('div', {
	      staticClass: "imageContainer",
	      style: ({
	        width: region.width + 'px',
	        height: region.height + 'px',
	        'background': 'url(' + _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url + ')'
	      })
	    }) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'html') ? _c('div', {
	      staticStyle: {
	        "background-color": "white!important"
	      },
	      style: ({
	        width: region.width + 'px',
	        height: region.height + 'px',
	      }),
	      domProps: {
	        "innerHTML": _vm._s(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)
	      }
	    }) : _vm._e()] : _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "4px",
	        "padding": "1%",
	        "font-size": "25px"
	      }
	    }, [_c('h1', {
	      staticStyle: {
	        "margin-top": "5%"
	      }
	    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t\t")])] : _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "4px",
	        "padding": "1%",
	        "font-size": "25px"
	      }
	    }, [_c('h1', {
	      staticStyle: {
	        "margin-top": "5%"
	      }
	    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t")])], 2)] : _vm._e()
	  })], 2)])], 1), _vm._v(" "), _c('div', [_c('button', {
	    staticClass: "button btn",
	    class: {
	      'clickable-white': !_vm.play
	    },
	    staticStyle: {
	      "background-color": "grey",
	      "pointer-events": "none"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addNewRegion()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tAdd\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    class: {
	      'clickable-white': !_vm.play
	    },
	    staticStyle: {
	      "background-color": "grey",
	      "pointer-events": "none"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteRegion()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tDelete\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.save(_vm.selectedPresentation.presentation_id)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tSave\n\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.setStep(0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-undo fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tCancel\n\t\t\t")]), _vm._v(" "), _c('resource-modal', {
	    staticStyle: {
	      "position": "absolute",
	      "bottom": "-10vh"
	    },
	    attrs: {
	      "id": "invisible-button",
	      "buttonText": 'Select content'
	    },
	    on: {
	      "selected": _vm.selectedResource
	    }
	  })], 1), _vm._v(" "), _c('div', [(!_vm.play) ? _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.reset()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-play fa-2x"
	  })]) : _vm._e(), _vm._v(" "), (_vm.play) ? _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.stop()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-stop fa-2x"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("\n\t\t\tMax Time (s) of playlist\n\t\t\t"), _c('el-slider', {
	    attrs: {
	      "step": 5,
	      "show-input": "",
	      "min": 10,
	      "max": 10000
	    },
	    model: {
	      value: (_vm.maxTime),
	      callback: function($$v) {
	        _vm.maxTime = $$v
	      },
	      expression: "maxTime"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "margin-bottom": "50px"
	    }
	  }, [_c('div', {
	    staticClass: "region-block",
	    staticStyle: {
	      "margin": "0 !important",
	      "display": "inline-block",
	      "float": "left",
	      "width": "100px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "height": "50px",
	      "width": "100px"
	    }
	  }, [(_vm.groupModeOn) ? _c('button', {
	    style: ({
	      'background-color': _vm.colorHash('', _vm.selectedGroup)
	    }),
	    on: {
	      "click": function($event) {
	        _vm.groupMode()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-object-group"
	  })]) : _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.groupMode()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-object-group"
	  })])]), _vm._v(" "), _vm._l((_vm.zones), function(region, j) {
	    return _c('div', {
	      class: {
	        'groupHover': _vm.groupModeOn
	      },
	      staticStyle: {
	        "width": "100%",
	        "display": "inline-block",
	        "margin": "0",
	        "padding": "0"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPlaylist(j), _vm.groupToggle(j)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "display": "flex",
	        "justify-content": "center",
	        "align-items": "center",
	        "flex-direction": "row"
	      }
	    }, [(region.group !== false) ? _c('span', {
	      staticStyle: {
	        "width": "10%",
	        "top": "0",
	        "left": "0",
	        "height": "50px",
	        "border": "1px solid black"
	      },
	      style: ({
	        'background-color': _vm.colorHash('', region.group)
	      })
	    }) : _c('span', {
	      staticStyle: {
	        "width": "10%",
	        "top": "0",
	        "left": "0",
	        "height": "50px",
	        "background-color": "transparent"
	      }
	    }), _vm._v(" "), _c('p', {
	      class: {
	        'selected-playlist-text': _vm.selectedPlaylist === j
	      },
	      staticStyle: {
	        "margin-left": "0",
	        "margin-top": "0",
	        "margin-bottom": "0",
	        "margin-right": "15px",
	        "width": "90%",
	        "flex-direction": "column",
	        "display": "flex",
	        "justify-content": "center",
	        "align-items": "center",
	        "background-color": "white",
	        "padding": "0",
	        "line-height": "20px",
	        "height": "50px",
	        "opacity": "0.5"
	      },
	      style: ({
	        'background-color': _vm.zones[j].background
	      })
	    }, [(!region.limited) ? _c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "2px",
	        "padding": "2px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('el-tooltip', {
	      staticClass: "item",
	      attrs: {
	        "effect": "dark",
	        "content": _vm.days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range,
	        "placement": "top-start"
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "flex-align": "center",
	        "align-items": "center",
	        "display": "flex",
	        "flex-direction": "column",
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "2px",
	        "padding": "2px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + ": " + _vm._s(_vm.daysShort[region.limited.day_of_week]) + " \n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('button', {
	      staticStyle: {
	        "color": "black"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removePlaylist(j)
	        }
	      }
	    }, [_vm._v(" - ")]) : _vm._e()], 1)])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "playlist-block",
	    staticStyle: {
	      "white-space": "nowrap",
	      "overflow-x": "auto",
	      "overflow-y": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "playlist",
	    staticStyle: {
	      "height": "50px",
	      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px)",
	      "position": "relative",
	      "transform-origin": "top",
	      "outline": "1px solid transparent"
	    },
	    style: ({
	      width: _vm.maxTime * _vm.scale + 'px',
	      'background-size': _vm.scale + 'px ' + _vm.height + 'px'
	    })
	  }, _vm._l((_vm.maxTime + 1), function(n, i) {
	    return ((n - 1) % 10 === 0 || (n - 1) % 5 === 0) ? _c('span', {
	      class: {
	        'floatLeft': i !== _vm.maxTime
	      },
	      staticStyle: {
	        "text-align": "left",
	        "z-index": "9",
	        "left": "0",
	        "position": "relative"
	      },
	      style: ({
	        width: _vm.scale * 5 + 'px'
	      })
	    }, [_c('span', {
	      staticStyle: {
	        "margin-left": "2px"
	      }
	    }, [_vm._v(" " + _vm._s(n - 1) + "s ")]), _vm._v(" "), ((n - 1) % 10 === 0) ? _c('span', {
	      staticStyle: {
	        "position": "absolute",
	        "left": "0",
	        "height": "30px",
	        "border-left": "1px solid black"
	      }
	    }) : ((n - 1) % 5 === 0) ? _c('span', {
	      staticStyle: {
	        "position": "absolute",
	        "left": "0",
	        "height": "20px",
	        "border-left": "1px solid black"
	      }
	    }) : _vm._e()]) : _vm._e()
	  })), _vm._v(" "), _vm._l((_vm.regionList), function(regions, j) {
	    return _c('div', {
	      staticClass: "playlist",
	      staticStyle: {
	        "height": "50px",
	        "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px)",
	        "position": "relative",
	        "transform-origin": "top",
	        "outline": "1px solid transparent"
	      },
	      style: ({
	        width: _vm.maxTime * _vm.scale + 'px',
	        'background-size': _vm.scale + 'px ' + _vm.height + 'px'
	      })
	    }, [(_vm.zones[j].group === false) ? _c('el-slider', {
	      attrs: {
	        "min": 0,
	        "max": _vm.maxTime,
	        "show-tooltip": false
	      },
	      model: {
	        value: (_vm.players[j]),
	        callback: function($$v) {
	          _vm.$set(_vm.players, j, $$v)
	        },
	        expression: "players[j]"
	      }
	    }) : _c('el-slider', {
	      attrs: {
	        "min": 0,
	        "max": _vm.maxTime,
	        "show-tooltip": false
	      },
	      model: {
	        value: (_vm.players[_vm.getIndexOfStartGroup(_vm.zones[j].group)]),
	        callback: function($$v) {
	          _vm.$set(_vm.players, _vm.getIndexOfStartGroup(_vm.zones[j].group), $$v)
	        },
	        expression: "players[getIndexOfStartGroup(zones[j].group)]"
	      }
	    }), _vm._v(" "), _vm._l((regions), function(region, i) {
	      return [(region.del !== true) ? _c('vue-draggable-resizable', {
	        staticClass: "region",
	        class: {
	          'selected-playlist': _vm.selectedPlaylist === j,
	            'selected-region': _vm.selectedRegion === i && _vm.selectedPlaylist === j
	        },
	        staticStyle: {
	          "border": "1px solid grey",
	          "display": "flex",
	          "justify-content": "center",
	          "align-items": "center",
	          "height": "50px",
	          "background-color": "white"
	        },
	        attrs: {
	          "draggable": false,
	          "grid": [_vm.scale, _vm.height],
	          "minw": _vm.scale,
	          "id": ("region-" + j + "-" + i),
	          "playlist": j,
	          "index": i,
	          "z": region.z,
	          "x": region.x,
	          "y": region.y,
	          "w": region.width,
	          "parent": true
	        },
	        on: {
	          "mouseOver": _vm.hoverButton,
	          "mouseLeave": _vm.leaveButton,
	          "resizing": _vm.onResize,
	          "click": function($event) {
	            $event.stopPropagation();
	            $event.preventDefault();
	          },
	          "update:z": function($event) {
	            _vm.$set(region, "z", $event)
	          },
	          "update:x": function($event) {
	            _vm.$set(region, "x", $event)
	          },
	          "update:w": function($event) {
	            _vm.$set(region, "width", $event)
	          }
	        }
	      }, [(region.resource) ? [(region.resource.extension === 'mp4') ? _c('video', {
	        key: ("thumb-" + (region.resource.url)),
	        attrs: {
	          "width": region.width,
	          "height": 50,
	          "loop": ""
	        }
	      }, [_c('source', {
	        attrs: {
	          "src": region.resource.url,
	          "type": "video/mp4"
	        }
	      }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif') ? _c('div', {
	        staticClass: "imageContainer",
	        style: ({
	          width: region.width + 'px',
	          height: 50 + 'px',
	          'background': 'url(' + region.resource.url + ')'
	        })
	      }) : (region.resource.extension === 'html') ? _c('div', {
	        staticStyle: {
	          "background-color": "white!important"
	        },
	        style: ({
	          width: region.width + 'px',
	          height: region.height + 'px',
	        }),
	        domProps: {
	          "innerHTML": _vm._s(region.resource.url)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('div', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
	          expression: "showButtons[0] === i && showButtons[1] === j"
	        }],
	        staticStyle: {
	          "border-radius": "2px",
	          "padding": "2px",
	          "position": "absolute",
	          "bottom": "25px",
	          "color": "white",
	          "background-color": "rgba(0, 0, 0, 0.5)"
	        }
	      }, [_vm._v("  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + " ")]), _vm._v(" "), _c('button', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
	          expression: "showButtons[0] === i && showButtons[1] === j"
	        }],
	        staticClass: "btn button",
	        staticStyle: {
	          "position": "absolute",
	          "bottom": "0",
	          "width": "30px",
	          "font-size": "10px",
	          "padding": "0",
	          "height": "25px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickInvisibleButton(j, i)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-2x fa-upload",
	        staticStyle: {
	          "color": "black"
	        }
	      })])] : (region.width > 30) ? _c('div', {
	        staticStyle: {
	          "display": "flex",
	          "flex-direction": "column"
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + "\n\t\t\t\t\t\t\t\t"), _c('button', {
	        staticClass: "btn button",
	        staticStyle: {
	          "width": "30px",
	          "font-size": "10px",
	          "padding": "0",
	          "height": "25px"
	        },
	        on: {
	          "click": function($event) {
	            _vm.clickInvisibleButton(j, i)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-2x fa-upload",
	        staticStyle: {
	          "color": "black"
	        }
	      })])]) : _vm._e()], 2) : _vm._e()]
	    })], 2)
	  })], 2)])]], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Presentation Editor ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Select a layout ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Select a Presentation ")])])
	}]}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.modifyLocation($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.location_access),
	        expression: "app.location_access"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("app_access_location_" + (app.app_id))
	      },
	      domProps: {
	        "checked": Array.isArray(app.location_access) ? _vm._i(app.location_access, null) > -1 : (app.location_access)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = app.location_access,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (app.location_access = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (app.location_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(app, "location_access", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_access_location_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tAssign App Access\n\t\t\t\t")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Include App")])])])])
	}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\tManage Locations for "), _c('b', [_vm._v(_vm._s(_vm.editingRegion.name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.editingRegion.locations), function(location) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(location.name))])]), _vm._v(" "), _c('td')])
	  }))])])])])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Location Name")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Actions")])])])])
	}]}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "custom-step-counter text-center"
	  }, [_c('p', {
	    staticClass: "font-blue"
	  }, [_c('b', [_vm._v(_vm._s(_vm.computedStepText))])]), _vm._v(" "), _vm._l((_vm.steps), function(step, $index) {
	    return _c('span', {
	      class: {
	        'bg-blue': _vm.process === step.key, 'bg-grey-cascade': _vm.process !== step.key
	      }
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("What to do next . . .")]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "timeline col-sm-6"
	  }, _vm._l((_vm.toDos), function(toDo) {
	    return (_vm.activeAccount.account_type === toDo.type) ? _c('div', {
	      staticClass: "timeline-item"
	    }, [_c('div', {
	      staticClass: "timeline-badge"
	    }, [_c('div', {
	      staticClass: "timeline-icon"
	    }, [_c('i', {
	      class: [toDo.color, toDo.icon_class]
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "timeline-body"
	    }, [_c('div', {
	      staticClass: "timeline-body-arrow"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "timeline-body-head"
	    }, [_c('div', {
	      staticClass: "timeline-body-head-caption"
	    }, [_c('span', {
	      staticClass: "timeline-body-alerttitle clickable",
	      class: toDo.color,
	      on: {
	        "click": function($event) {
	          _vm.startOnboarding(toDo.app, toDo.subApp)
	        }
	      }
	    }, [_vm._v(_vm._s(toDo.title))])])]), _vm._v(" "), _c('div', {
	      staticClass: "timeline-body-content"
	    }, [_c('span', {
	      staticClass: "font-grey-cascade"
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(toDo.text) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	      staticClass: "btn blue margin-top-20",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.startOnboarding(toDo.app, toDo.subApp)
	        }
	      }
	    }, [_vm._v("Get Started")])])])]) : _vm._e()
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('button', {
	    staticClass: "btn blue",
	    on: {
	      "click": function($event) {
	        _vm.openResourceModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.showResourceModal,
	      "effect": "custom",
	      "width": '96%'
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.showResourceModal = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header center",
	    attrs: {
	      "slot": "modal-header"
	    },
	    slot: "modal-header"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Select a Resource")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    style: ({
	      'height': 'calc(100vh - 180px)',
	      'max-height': 'none'
	    }),
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [_c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', {
	    staticClass: "margin-bottom-25 col-sm-4"
	  }, [_c('div', {
	    staticClass: "jstree-default"
	  }, [_c('ul', {
	    staticClass: "jstree-container-ul jstree-children"
	  }, [_c('li', {
	    staticClass: "jstree-node jstree-last",
	    class: {
	      'jstree-open': _vm.folders.expanded, 'jstree-closed': !_vm.folders.expanded
	    }
	  }, [_c('i', {
	    staticClass: "jstree-icon jstree-ocl",
	    on: {
	      "click": function($event) {
	        _vm.expandNode(_vm.folders)
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jstree-anchor",
	    class: {
	      'jstree-clicked': _vm.folders.id === _vm.activeFolder.id
	    },
	    on: {
	      "click": function($event) {
	        _vm.activePageUpdate(1, _vm.folders, true)
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.activeLocationId ? _vm.activeLocationName : _vm.activeBusinessName) + " Resources\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.folders.expanded) ? _c('ul', {
	    staticClass: "jstree-children"
	  }, [_vm._l((_vm.folders.children), function(folder, index) {
	    return [_c('resource-folder', {
	      attrs: {
	        "folder": folder,
	        "activeFolder": _vm.activeFolder.id,
	        "last": index === _vm.folders.children.length - 1,
	        "selectOnly": true
	      },
	      on: {
	        "expandNode": _vm.expandNode,
	        "createFolder": _vm.createFolder,
	        "manageFolder": _vm.manageFolder,
	        "getResources": _vm.activePageUpdate
	      }
	    })]
	  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [(!_vm.activeFolder.id && !_vm.allFoldersView) ? _c('div', {
	    staticClass: "center margin-top-20"
	  }, [_vm._v("Select a folder to view resources.")]) : _vm._e(), _vm._v(" "), (_vm.activeFolder.id || _vm.allFoldersView) ? _c('div', [_c('div', {
	    staticClass: "resource-header clearfix"
	  }, [(!_vm.allFoldersView) ? _c('file-upload', {
	    attrs: {
	      "folderId": _vm.activeFolder.id
	    },
	    on: {
	      "savingUpdate": _vm.checkSaving,
	      "success": _vm.imageUploaded
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('button', {
	    staticClass: "btn btn-sm btn-outline btn-default margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleFilterPanel()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.filterCollapse ? 'Show' : 'Hide') + " Filter and Search Options")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "portlet box blue-hoki portlet-blue-override"
	  }, [_c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.filterCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedResourceSearch()
	      }
	    }
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), (_vm.tags.length) ? _c('div', {
	    staticClass: "filter-tags"
	  }, [_c('label', [_vm._v("Resource Tags "), _c('small', [_vm._v("(Toggle the tags you want to filter by.)")])]), _vm._v(" "), _c('div', [_vm._l((_vm.tags), function(tag) {
	    return [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      class: {
	        'blue': tag.active
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleTag(tag)
	        }
	      }
	    }, [_vm._v(_vm._s(tag.name))])]
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "filter-tags",
	    class: {
	      'margin-top-20': _vm.tags.length
	    }
	  }, [_c('label', [_vm._v("File Types "), _c('small', [_vm._v("(Toggle the types you want to filter by.)")])]), _vm._v(" "), _c('div', [_vm._l((_vm.fileTypes), function(type) {
	    return [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      class: {
	        'blue': type.active
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleFileType(type)
	        }
	      }
	    }, [_c('i', {
	      class: type.icon
	    }), _vm._v(" " + _vm._s(type.name))])]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search"
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v(" Select search range below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-radio-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.advancedSearch.range),
	        expression: "advancedSearch.range"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("advanced_search_radio_" + (option.value)),
	        "name": ("advanced_search_radio_" + (option.value))
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.advancedSearch.range, option.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(_vm.advancedSearch, "range", option.value)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_radio_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetResourceSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "cbp cbp-caption-active cbp-caption-overlayBottomReveal cbp-ready"
	  }, [_c('div', {
	    staticClass: "cbp-wrapper-outer"
	  }, [_c('div', {
	    staticClass: "cbp-wrapper"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingResourceData || _vm.isSaving,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (!_vm.loadingResourceData && !_vm.isSaving) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('name')
	      }
	    }
	  }, [_vm._v("Name")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'size'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('size')
	      }
	    }
	  }, [_vm._v("Size")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'created_at'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('created_at')
	      }
	    }
	  }, [_vm._v("Date Added")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage,
	      "allowPageChange": false,
	      "resultsPerPageOverride": 27
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (!_vm.currentResources.length) ? _c('div', {
	    staticClass: "cbp-no-files"
	  }, [_vm._v("There are currently no resources in this folder.")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_vm._l((_vm.currentResources), function(resource) {
	    return [_c('div', {
	      ref: "resource",
	      refInFor: true,
	      staticClass: "cbp-item col-sm-4",
	      class: {
	        'selected': _vm.selectedResource.id === resource.id
	      }
	    }, [_c('div', {
	      staticClass: "cbp-item-wrapper"
	    }, [_c('div', {
	      staticClass: "cbp-caption"
	    }, [_c('div', {
	      staticClass: "cbp-caption-defaultWrap"
	    }, [_c('img', {
	      attrs: {
	        "src": resource.url
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "cbp-caption-activeWrap"
	    }, [_c('div', {
	      staticClass: "cbp-l-caption-alignCenter"
	    }, [_c('div', {
	      staticClass: "cbp-l-caption-body"
	    }, [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      on: {
	        "click": function($event) {
	          _vm.setResource(resource)
	        }
	      }
	    }, [_vm._v("Select Resource")])])])])])])])]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1)]) : _vm._e()], 1)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closeResourceModal()
	      }
	    }
	  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.selectedResource.id
	    },
	    on: {
	      "click": function($event) {
	        _vm.resourceSelectionComplete()
	      }
	    }
	  }, [_vm._v("Done")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [(_vm.process === 'step_1') ? [_vm._v("\n\t\t\t\t\t\tEdit Skill Testing Questions\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? [_vm._v("\n\t\t\t\t\t\tCreate New Skill Testing Question\n\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Skill Testing Question")]), _vm._v(" "), (_vm.questions.length) ? _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Q")]), _vm._v(" "), _c('th', [_vm._v("A")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.questions), function(question) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(question.question))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(question.answer))]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.deleteQuestionConfirmation(question)
	        }
	      }
	    }, [_vm._v("Delete Question")])])])])], 1)])
	  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.questions.length) ? _c('div', {
	    staticClass: "center margin-top-20 font-grey-cascade"
	  }, [_c('i', [_vm._v("No questions created yet.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createQuestion($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newQuestion.question),
	      expression: "newQuestion.question",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newQuestion.question.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_question_question"
	    },
	    domProps: {
	      "value": (_vm.newQuestion.question)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newQuestion, "question", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_question_question"
	    }
	  }, [_vm._v("Question")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newQuestion.answer),
	      expression: "newQuestion.answer",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newQuestion.answer.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_question_answer"
	    },
	    domProps: {
	      "value": (_vm.newQuestion.answer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newQuestion, "answer", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_question_answer"
	    }
	  }, [_vm._v("Answer")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "edit-skill-testing-question-submit",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])])]) : _vm._e()])], 1)])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'extra-padding': !_vm.allowPageChange
	    }
	  }, [(_vm.totalResults && _vm.activePage) ? _c('small', [_c('b', [_vm._v(_vm._s(_vm.pageStart))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(_vm.pageEnd))]), _vm._v(" of "), _c('b', [_vm._v(_vm._s(_vm.totalResults))]), _vm._v(" results")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('b', {
	    staticClass: "margin-left-5 margin-right-5"
	  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('small', [_vm._v("Show")]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.resultsPerPage) + "\n\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, _vm._l((_vm.resultOptions), function(result) {
	    return _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.updateResultsPerPage(result)
	        }
	      }
	    }, [_vm._v(_vm._s(result))])])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.allowPageChange) ? _c('small', [_vm._v("Results Per Page")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vdr",
	    class: {
	      draggable: _vm.draggable, resizable: _vm.resizable, active: _vm.enabled, dragging: _vm.dragging, resizing: _vm.resizing
	    },
	    style: (_vm.style),
	    on: {
	      "mouseover": _vm.mouseOver,
	      "mouseleave": _vm.mouseLeave,
	      "mousedown": function($event) {
	        $event.stopPropagation();
	        _vm.elmDown($event)
	      },
	      "dblclick": _vm.fillParent
	    }
	  }, [_vm._l((_vm.handles), function(handle) {
	    return (_vm.resizable) ? _c('div', {
	      staticClass: "handle",
	      class: 'handle-' + handle,
	      style: ({
	        display: _vm.enabled ? 'block' : 'none'
	      }),
	      on: {
	        "mousedown": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          _vm.handleDown(handle, $event)
	        }
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createRegion($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newRegion.region_name),
	      expression: "newRegion.region_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newRegion.region_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_region_name"
	    },
	    domProps: {
	      "value": (_vm.newRegion.region_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newRegion, "region_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_region_name"
	    }
	  }, [_vm._v("Region Name")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return To Regions Dashboard")]), _vm._v(" "), _c('button', {
	    key: "create-location-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit ")])])]) : _vm._e()])], 1)])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.createRegionNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\tCreate A Region\n\t\t\t")])])
	}]}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vdr",
	    class: {
	      draggable: _vm.draggable, resizable: _vm.resizable, active: _vm.enabled, dragging: _vm.dragging, resizing: _vm.resizing
	    },
	    style: (_vm.style),
	    on: {
	      "mousedown": function($event) {
	        $event.stopPropagation();
	        _vm.elmDown($event)
	      },
	      "dblclick": _vm.fillParent
	    }
	  }, [_vm._l((_vm.handles), function(handle) {
	    return (_vm.resizable) ? _c('div', {
	      staticClass: "handle",
	      class: 'handle-' + handle,
	      style: ({
	        display: _vm.enabled ? 'block' : 'none'
	      }),
	      on: {
	        "mousedown": function($event) {
	          $event.stopPropagation();
	          $event.preventDefault();
	          _vm.handleDown(handle, $event)
	        }
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "unoapp-typeahead",
	    class: {
	      'open': _vm.showDropdown
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.predictiveValue),
	      expression: "predictiveValue"
	    }],
	    staticClass: "form-control prediction-input",
	    attrs: {
	      "type": "text",
	      "readonly": "",
	      "autocomplete": "off",
	      "spellcheck": "false",
	      "tabindex": "-1"
	    },
	    domProps: {
	      "value": (_vm.predictiveValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.predictiveValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "form-control input-sm prediction-output-input",
	    class: {
	      'edited': _vm.value.length
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder,
	      "autocomplete": "off",
	      "tabindex": _vm.tabindex
	    },
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }, _vm.update],
	      "keydown": [function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
	        _vm.up($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
	        _vm.down($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.hit($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
	        _vm.reset($event)
	      }, function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
	        _vm.selectPredictiveOption($event)
	      }],
	      "blur": function($event) {
	        _vm.showDropdown = false;
	        _vm.hidePredictiveValue()
	      },
	      "focus": function($event) {
	        _vm.onFocus()
	      }
	    }
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._l((_vm.items), function(item, index) {
	    return _c('li', {
	      class: {
	        'active': _vm.isActive(index)
	      }
	    }, [_c('a', {
	      on: {
	        "mousedown": function($event) {
	          $event.preventDefault();
	          _vm.hit($event)
	        },
	        "mousemove": function($event) {
	          _vm.setActive(index)
	        }
	      }
	    }, [(_vm.multiSearch) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.highlight(_vm.buildText(item)))
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.objectKey && !_vm.multiSearch) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.highlight(item))
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.objectKey && !_vm.multiSearch) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.highlight(item[_vm.objectKey]))
	      }
	    }) : _vm._e()])])
	  }), _vm._v(" "), (!_vm.items.length) ? _c('li', [_c('a', [_c('span', [_vm._v("There are no " + _vm._s(((_vm.label.toLowerCase()) + "s")) + " that match your search.")])])]) : _vm._e()], 2), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.helpBlock) ? _c('span', {
	    staticClass: "help-block persist",
	    domProps: {
	      "innerHTML": _vm._s(_vm.helpBlock)
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-wrapper"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.displayLoadingScreen,
	      "appBackground": true,
	      "autoStop": true
	    },
	    on: {
	      "stopLoadingScreen": function($event) {
	        _vm.displayLoadingScreen = false
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header navbar navbar-fixed-top"
	  }, [_c('div', {
	    staticClass: "page-header-inner"
	  }, [_c('div', {
	    staticClass: "page-logo"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "menu-toggler sidebar-toggler",
	    on: {
	      "click": function($event) {
	        _vm.toggleSidebarCollapse()
	      }
	    }
	  }, [_c('span')])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.waitingForData) ? _c('div', {
	    staticClass: "top-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav pull-right"
	  }, [_c('dropdown', {
	    attrs: {
	      "isLi": true,
	      "passedClass": 'dropdown-user'
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "slot": "button",
	      "href": "javascript:;",
	      "data-toggle": "dropdown",
	      "data-hover": "dropdown",
	      "data-close-others": "true"
	    },
	    slot: "button"
	  }, [_c('span', {
	    staticClass: "username username-hide-on-mobile"
	  }, [_vm._v(_vm._s(_vm.activeUser.name.first_name && _vm.activeUser.name.last_name ? ((_vm.activeUser.name.first_name) + " " + (_vm.activeUser.name.last_name)) : 'User'))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [(_vm.userAccountsLength > 1) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.changeAccount()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-users"
	  }), _vm._v(" Change Account\n\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.logOut()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-logout"
	  }), _vm._v(" Log Out\n\t\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown dropdown-quick-sidebar-toggler width-auto",
	    on: {
	      "click": function($event) {
	        _vm.toggleQuickSidebar($event)
	      }
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-toggle location-panel width-auto"
	  }, [_vm._m(2), _vm._v(" "), (_vm.activeLocationId) ? _c('div', {
	    staticClass: "location-name-container"
	  }, [_c('span', {
	    staticClass: "business-name"
	  }, [_vm._v(_vm._s(_vm.activeBusinessName))]), _vm._v(" "), _c('span', {
	    staticClass: "business-location-name"
	  }, [_vm._v(_vm._s(_vm.activeLocationName))])]) : _c('div', {
	    staticClass: "location-name-container"
	  }, [_c('span', {
	    staticClass: "business-name big"
	  }, [_vm._v(_vm._s(_vm.activeBusinessName))])])])])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (!_vm.waitingForData) ? _c('div', {
	    staticClass: "page-container"
	  }, [_c('div', {
	    staticClass: "page-sidebar-wrapper"
	  }, [_c('div', {
	    staticClass: "page-sidebar navbar-collapse collapse"
	  }, [_c('ul', {
	    staticClass: "page-sidebar-menu page-header-fixed",
	    attrs: {
	      "data-keep-expand": "false"
	    }
	  }, [_c('li', {
	    staticClass: "nav-item start",
	    class: {
	      'active': _vm.currentRoute === 'dashboard'
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link nav-toggle",
	    attrs: {
	      "to": "/app/dashboard"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
	    staticClass: "selected"
	  })])], 1), _vm._v(" "), (_vm.activeBusinessId && _vm.activeBusinessId !== 1 && !_vm.activeLocationId) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_business'
	    },
	    attrs: {
	      "id": "my_business_link"
	    }
	  }, [_c('a', {
	    staticClass: "nav-link nav-toggle unselectable",
	    on: {
	      "click": function($event) {
	        _vm.toggleNavigation($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-briefcase"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("My Business")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'users'
	    },
	    attrs: {
	      "id": "my_business_users_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_business/users"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'roles'
	    },
	    attrs: {
	      "id": "my_business_roles_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_business/roles"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Roles")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'regions'
	    },
	    attrs: {
	      "id": "my_business_regions_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_business/regions"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Regions")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_business' && _vm.currentSubRoute === 'locations'
	    },
	    attrs: {
	      "id": "my_business_locations_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_business/locations"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Locations")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeBusinessId && _vm.activeLocationId) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_location'
	    },
	    attrs: {
	      "id": "my_location_link"
	    }
	  }, [_c('a', {
	    staticClass: "nav-link nav-toggle unselectable",
	    on: {
	      "click": function($event) {
	        _vm.toggleNavigation($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("My Location")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_location' && _vm.currentSubRoute === 'users'
	    },
	    attrs: {
	      "id": "my_location_users_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_location/users"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'my_location' && _vm.currentSubRoute === 'roles'
	    },
	    attrs: {
	      "id": "my_location_roles_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/my_location/roles"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Roles")])])], 1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.accessibleApps), function(app) {
	    return _c('li', {
	      staticClass: "nav-item",
	      class: {
	        'active': _vm.currentRoute === app.route
	      },
	      attrs: {
	        "id": app.app_id
	      }
	    }, [(app.id !== 12) ? _c('router-link', {
	      staticClass: "nav-link",
	      attrs: {
	        "to": ("/app/" + (app.route))
	      }
	    }, [_c('i', {
	      staticClass: "fa",
	      class: app.fa
	    }), _vm._v(" "), _c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(app.title))])]) : _vm._e(), _vm._v(" "), (app.id === 12) ? _c('a', {
	      attrs: {
	        "href": ("https://ecomm.staging.unoapp.io/#/login/" + _vm.activeBusinessId + "/" + _vm.v3Token),
	        "target": "_blank"
	      }
	    }, [_c('i', {
	      staticClass: "fa",
	      class: app.fa
	    }), _vm._v(" "), _c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(app.title))])]) : _vm._e()], 1)
	  }), _vm._v(" "), (_vm.unoappAccount && _vm.activeBusinessId && _vm.activeLocationId) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_signage'
	    },
	    attrs: {
	      "id": "unoapp_signage_link"
	    }
	  }, [_c('a', {
	    staticClass: "nav-link nav-toggle unselectable",
	    on: {
	      "click": function($event) {
	        _vm.toggleNavigation($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Signage")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'layout'
	    },
	    attrs: {
	      "id": "unoapp_signage_layout_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/unoapp_signage/layout"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Layouts")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'playlist'
	    },
	    attrs: {
	      "id": "unoapp_signage_playlist_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/unoapp_signage/playlist"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Presentations/Playlists")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_signage' && _vm.currentSubRoute === 'content'
	    },
	    attrs: {
	      "id": "unoapp_signage_content_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/unoapp_signage/content"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Schedules")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
	    staticClass: "heading"
	  }, [_c('h3', {
	    staticClass: "uppercase"
	  }, [_vm._v("UNOapp Admin Tools")])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_business'
	    },
	    attrs: {
	      "id": "unoapp_business_link"
	    }
	  }, [_c('a', {
	    staticClass: "nav-link nav-toggle unselectable",
	    on: {
	      "click": function($event) {
	        _vm.toggleNavigation($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("UNOapp Business")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_business' && _vm.currentSubRoute === 'users'
	    },
	    attrs: {
	      "id": "unoapp_business_users_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/unoapp_business/users"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Users")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'unoapp_business' && _vm.currentSubRoute === 'roles'
	    },
	    attrs: {
	      "id": "unoapp_business_roles_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/unoapp_business/roles"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Roles")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active': _vm.currentRoute === 'business_manager'
	    },
	    attrs: {
	      "id": "business_manager_link"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/app/business_manager"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-briefcase"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Business Manager")])])], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "page-content-wrapper"
	  }, [_c('div', {
	    staticClass: "page-content"
	  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "page-quick-sidebar-wrapper",
	    attrs: {
	      "data-close-on-body-click": "false"
	    }
	  }, [_c('a', {
	    staticClass: "page-quick-sidebar-toggler",
	    on: {
	      "click": function($event) {
	        _vm.toggleQuickSidebar($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-close"
	  })]), _vm._v(" "), _c('app-side-panel', {
	    on: {
	      "updateActiveBusiness": _vm.setActiveBusiness
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.displayImStillHere,
	      "effect": "fade"
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.displayImStillHere = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header",
	    attrs: {
	      "slot": "modal-header"
	    },
	    slot: "modal-header"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Are you still there?")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [_vm._v("\n\t\t\t\tYou've been away from the computer for a while. Let us know if you are still here or you will be logged out.\n\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.imStillHere()
	      }
	    }
	  }, [_vm._v("I'm still here")])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', [_c('img', {
	    staticClass: "logo-default logo-unoapp",
	    attrs: {
	      "src": __webpack_require__(84),
	      "alt": "logo"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "menu-toggler responsive-toggler"
	  }, [_c('span')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "logo-container"
	  }, [_c('img', {
	    staticClass: "business-logo",
	    attrs: {
	      "src": __webpack_require__(59),
	      "width": "38",
	      "height": "38"
	    }
	  })])
	}]}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login",
	    attrs: {
	      "id": "login"
	    }
	  }, [_c('div', {
	    staticClass: "user-login-5"
	  }, [_c('div', {
	    staticClass: "row bs-reset"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 login-container bs-reset mt-login-5-bsfix"
	  }, [(!_vm.forgotPassword) ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h1', [_vm._v("UNOapp Login")]), _vm._v(" "), _c('form', {
	    staticClass: "login-form",
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
	    attrs: {
	      "type": "email",
	      "autocomplete": "off",
	      "placeholder": "Email",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
	    attrs: {
	      "type": "password",
	      "autocomplete": "off",
	      "placeholder": "Password",
	      "name": "password"
	    },
	    domProps: {
	      "value": (_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "password", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 text-right"
	  }, [_c('div', {
	    staticClass: "forgot-password"
	  }, [_c('a', {
	    staticClass: "forget-password",
	    attrs: {
	      "id": "forget-password"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showForgotPassword()
	      }
	    }
	  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn green",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Login")])])])])]) : _vm._e(), _vm._v(" "), (_vm.forgotPassword) ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h3', {
	    staticClass: "font-green"
	  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('p', [_vm._v(" Enter your e-mail address below to reset your password. ")]), _vm._v(" "), (!_vm.emailSent) ? _c('form', {
	    staticClass: "forget-form",
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submitForgotPassword($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger alert-email-error"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control placeholder-no-fix form-group",
	    attrs: {
	      "type": "email",
	      "autocomplete": "off",
	      "placeholder": "Email",
	      "name": "email"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions"
	  }, [_c('button', {
	    staticClass: "btn green btn-outline",
	    attrs: {
	      "type": "button",
	      "id": "back-btn"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success uppercase pull-right",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSent) ? _c('div', {
	    staticClass: "login-content"
	  }, [_c('h1', [_vm._v("An email has been sent to you with a link to reset your password! Please make sure you check your spam folder.")]), _vm._v(" "), _c('button', {
	    staticClass: "btn green",
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_vm._v("Login")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
	    attrs: {
	      "show": _vm.showMobileAppPopup,
	      "effect": "fade"
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.showMobileAppPopup = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header text-center",
	    attrs: {
	      "slot": "modal-header"
	    },
	    slot: "modal-header"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Hi!")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [_vm._v("\n\t\t\t\tWe recommend using our mobile app for " + _vm._s(_vm.deviceType) + ". The app can be downloaded from "), _c('a', {
	    attrs: {
	      "href": _vm.appStoreDetails.url
	    }
	  }, [_vm._v(_vm._s(_vm.appStoreDetails.type))]), _vm._v(".\n\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showMobileAppPopup = false
	      }
	    }
	  }, [_vm._v("Okay")])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 bs-reset mt-login-5-bsfix"
	  }, [_c('div', {
	    staticClass: "login-bg"
	  }, [_c('img', {
	    staticClass: "login-logo",
	    attrs: {
	      "src": __webpack_require__(84)
	    }
	  })])])
	}]}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.modifyLocation($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingLocation.location_name),
	      expression: "editingLocation.location_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingLocation.location_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_location_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.editingLocation.location_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingLocation, "location_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_location_name"
	    }
	  }, [_vm._v("Location Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingLocation.store_number),
	      expression: "editingLocation.store_number",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingLocation.store_number
	    },
	    attrs: {
	      "type": "number",
	      "id": "edit_location_store_number"
	    },
	    domProps: {
	      "value": (_vm.editingLocation.store_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingLocation, "store_number", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingLocation.salesforce_id),
	      expression: "editingLocation.salesforce_id",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingLocation.salesforce_id
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_location_salesforce"
	    },
	    domProps: {
	      "value": (_vm.editingLocation.salesforce_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingLocation, "salesforce_id", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Location Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tEdit Location Details\n\t\t\t\t")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "edit_location_store_number"
	    }
	  }, [_vm._v("Store Number "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(optional)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "edit_location_salesforce"
	    }
	  }, [_vm._v("Salesforce ID "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(optional)")])])
	}]}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "jstree-node",
	    class: {
	      'jstree-last': _vm.last, 'jstree-open': _vm.folder.expanded, 'jstree-closed': !_vm.folder.expanded
	    }
	  }, [_c('i', {
	    staticClass: "jstree-icon jstree-ocl",
	    on: {
	      "click": function($event) {
	        _vm.expandNode()
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jstree-anchor",
	    class: {
	      'jstree-clicked': _vm.folder.id === _vm.activeFolder
	    },
	    on: {
	      "click": function($event) {
	        _vm.getResources(1, _vm.folder)
	      }
	    }
	  }, [_vm._v("\n\t\t" + _vm._s(_vm.folder.name) + " \n\t\t"), (!_vm.activeLocationId && !_vm.selectOnly) ? _c('i', {
	    staticClass: "fa",
	    class: {
	      'fa-eye': _vm.folder.is_shared, 'fa-eye-slash': !_vm.folder.is_shared
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.selectOnly) ? _c('i', {
	    staticClass: "fa fa-pencil",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.manageFolder()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.folder.expanded) ? _c('ul', {
	    staticClass: "jstree-children"
	  }, [(!_vm.selectOnly) ? _c('li', {
	    staticClass: "jstree-node jstree-leaf",
	    class: {
	      'jstree-last': !_vm.folder.children || !_vm.folder.children.length
	    }
	  }, [_c('i', {
	    staticClass: "jstree-icon jstree-ocl"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jstree-anchor",
	    on: {
	      "click": function($event) {
	        _vm.createFolder()
	      }
	    }
	  }, [_c('button', {
	    staticClass: "btn blue btn-xs"
	  }, [_vm._v("Create Folder")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.folder.children), function(subfolder, subindex) {
	    return [_c('resource-folder', {
	      attrs: {
	        "folder": subfolder,
	        "activeFolder": _vm.activeFolder,
	        "last": subindex === _vm.folder.children.length - 1,
	        "selectOnly": _vm.selectOnly
	      },
	      on: {
	        "expandNode": _vm.expandNode,
	        "createFolder": _vm.createFolder,
	        "manageFolder": _vm.manageFolder,
	        "getResources": _vm.getResources
	      }
	    })]
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading-spinner",
	    class: {
	      'no-z-index': this.display === 'inline', 'float-left': this.position === 'left', 'scale-down': this.size === 'small'
	    },
	    style: ({
	      'color': this.color
	    })
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process !== 'next_actions') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createBusiness($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newBusiness.business_name),
	      expression: "newBusiness.business_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newBusiness.business_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_business_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newBusiness.business_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newBusiness, "business_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_business_name"
	    }
	  }, [_vm._v("Business Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newBusiness.salesforce_id),
	      expression: "newBusiness.salesforce_id",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newBusiness.salesforce_id
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_business_salesforce"
	    },
	    domProps: {
	      "value": (_vm.newBusiness.salesforce_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newBusiness, "salesforce_id", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_business_salesforce"
	    }
	  }, [_vm._v("Salesforce ID "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(optional)")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-md-checkboxes"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newBusiness.blacklisted),
	      expression: "newBusiness.blacklisted"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-blacklisted"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newBusiness.blacklisted) ? _vm._i(_vm.newBusiness.blacklisted, null) > -1 : (_vm.newBusiness.blacklisted)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newBusiness.blacklisted,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newBusiness.blacklisted = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newBusiness.blacklisted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newBusiness, "blacklisted", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-blacklisted"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t                        \t\t\t\tAdd " + _vm._s(_vm.newBusiness.business_name || 'this business') + " to the "), _c('b', [_vm._v("Blacklist")]), _vm._v(".\n\t\t                        \t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'Blacklisted businesses are not accessible by all UNOapp staff, they need to be individually assigned to each user.'
	    }
	  })], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    key: "create-business-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-top-20 portlet-title-alternate"
	  }, [_vm._v("Choose a Service Package")]), _vm._v(" "), _c('div', {
	    staticClass: "mt-element-list"
	  }, [_c('div', {
	    staticClass: "mt-list-container list-default no-border"
	  }, [_c('ul', [_c('li', {
	    staticClass: "mt-list-item selected-case",
	    on: {
	      "click": function($event) {
	        _vm.selectServicePackage('easy')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "list-icon-container",
	    class: {
	      'done': _vm.newBusiness.service_package === 'easy'
	    }
	  }, [_c('a', [_c('span', [_vm._v("1")])])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item-content",
	    class: {
	      'done': _vm.newBusiness.service_package === 'easy'
	    }
	  }, [_c('h3', {
	    staticClass: "uppercase bold"
	  }, [_c('a', [_vm._v("Easy")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("This is a description")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "mt-list-item selected-case",
	    on: {
	      "click": function($event) {
	        _vm.selectServicePackage('assisted')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "list-icon-container",
	    class: {
	      'done': _vm.newBusiness.service_package === 'assisted'
	    }
	  }, [_c('a', [_c('span', [_vm._v("2")])])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item-content",
	    class: {
	      'done': _vm.newBusiness.service_package === 'assisted'
	    }
	  }, [_c('h3', {
	    staticClass: "uppercase bold"
	  }, [_c('a', [_vm._v("Assisted")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("This is a description")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "mt-list-item selected-case",
	    on: {
	      "click": function($event) {
	        _vm.selectServicePackage('3rd_one')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "list-icon-container",
	    class: {
	      'done': _vm.newBusiness.service_package === '3rd_one'
	    }
	  }, [_c('a', [_c('span', [_vm._v("3")])])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item-content",
	    class: {
	      'done': _vm.newBusiness.service_package === '3rd_one'
	    }
	  }, [_c('h3', {
	    staticClass: "uppercase bold"
	  }, [_c('a', [_vm._v("3rd One")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("This is a description")])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-business-continue-two",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_3', 'step_2')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
	    key: "step_3"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-top-20 portlet-title-alternate"
	  }, [_vm._v("Build a Product Package")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped ta ble-condensed"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Include App")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.business_access),
	        expression: "app.business_access"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("app_access_business_" + (app.app_id))
	      },
	      domProps: {
	        "checked": Array.isArray(app.business_access) ? _vm._i(app.business_access, null) > -1 : (app.business_access)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = app.business_access,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (app.business_access = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (app.business_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(app, "business_access", $$c)
	          }
	        }, function($event) {
	          _vm.forceAppSelection('business_access', app)
	        }]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_access_business_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "create-business-submit",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.createBusinessNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tCreate A Business\n\t\t\t\t")])])
	}]}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('users', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Invite and manage the UNOapp Business users.',
	      "businessId": 1,
	      "baseRoute": '/app/unoapp_business/users',
	      "baseRouteName": 'UNOapp Business Users'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('roles', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Create and manage the UNOapp Business roles.',
	      "businessId": 1,
	      "baseRoute": '/app/unoapp_business/roles',
	      "baseRouteName": 'UNOapp Business Roles'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process === 'form' || _vm.process === 'form_advanced') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    class: {
	      'disabled': _vm.process === 'form_advanced'
	    },
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRole.name),
	      expression: "newRole.name"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newRole.name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_role_name",
	      "disabled": _vm.process === 'form_advanced'
	    },
	    domProps: {
	      "value": (_vm.newRole.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newRole, "name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_role_name"
	    }
	  }, [_vm._v("Role Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRole.approval_permission),
	      expression: "newRole.approval_permission"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-assign-approval",
	      "disabled": _vm.process === 'form_advanced'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newRole.approval_permission) ? _vm._i(_vm.newRole.approval_permission, null) > -1 : (_vm.newRole.approval_permission)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newRole.approval_permission,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newRole.approval_permission = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newRole.approval_permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newRole, "approval_permission", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), (_vm.process === 'form') ? _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.newRole.name.length
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm()
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })]) : _vm._e()])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.process === 'form_advanced') ? _c('form', {
	    staticClass: "border-top",
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createRole($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "margin-top-20 portlet-title-alternate"
	  }, [_vm._v("Assign App Privileges")]), _vm._v(" "), (_vm.apps.length) ? _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("No Access")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("View")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("View & Modify")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_no_access_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "none"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "none")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "none")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_no_access_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_view_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "view"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "view")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "view")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_view_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_modify_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "modify"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "modify")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "modify")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_modify_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])]) : _c('div', [_c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('span', [_vm._v("No apps found for your business.")])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])]) : _vm._e()])], 1)]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.createRoleNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tCreate A Role\n\t\t\t\t")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "checkbox-assign-approval"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n                        \t\t\t\tAssign this role "), _c('b', [_vm._v("Approval Permissions.")])])
	}]}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('users', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Invite and manage your location users.',
	      "businessId": _vm.activeBusinessId,
	      "locationId": _vm.activeLocationId,
	      "baseRoute": '/app/my_location/users',
	      "baseRouteName": 'My Location Users'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('roles', {
	    attrs: {
	      "breadcrumbs": _vm.breadcrumbArray,
	      "note": 'Create and manage your location roles.',
	      "businessId": _vm.activeBusinessId,
	      "locationId": _vm.activeLocationId,
	      "baseRoute": '/app/my_location/roles',
	      "baseRouteName": 'My Location Roles'
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('modal', {
	    staticClass: "account-selection-modal",
	    attrs: {
	      "show": _vm.showAccountModal,
	      "effect": "custom"
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.showAccountModal = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header center",
	    attrs: {
	      "slot": "modal-header"
	    },
	    slot: "modal-header"
	  }, [_c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Please Select Your Account")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body center",
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [_c('div', {
	    staticClass: "mt-element-card mt-card-round mt-element-overlay"
	  }, _vm._l((_vm.userAccounts), function(account) {
	    return _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('div', {
	      staticClass: "mt-card-item",
	      class: {
	        'selected': _vm.selectedAccountId === account.account_id
	      }
	    }, [_c('div', {
	      staticClass: "mt-card-avatar mt-overlay-1"
	    }, [_c('img', {
	      attrs: {
	        "src": __webpack_require__(354)
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "mt-card-content"
	    }, [_c('h3', {
	      staticClass: "mt-card-name"
	    }, [_vm._v(_vm._s(account.business_name))]), _vm._v(" "), (account.role === 'system_admin') ? _c('p', {
	      staticClass: "mt-card-desc font-grey-mint"
	    }, [_vm._v("System Admin")]) : (account.role === 'super_admin') ? _c('p', {
	      staticClass: "mt-card-desc font-grey-mint"
	    }, [_vm._v("Super Admin")]) : (account.role === 'staff') ? _c('p', {
	      staticClass: "mt-card-desc font-grey-mint"
	    }, [_vm._v("Staff")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "mt-card-social"
	    }, [_c('ul', [_c('li', [_c('button', {
	      staticClass: "btn btn-success",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectAccount(account.account_id)
	        }
	      }
	    }, [_vm._v("Select")])])])])])])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.selectedAccountId
	    },
	    on: {
	      "click": function($event) {
	        _vm.loginToSelectedAccount($event)
	      }
	    }
	  }, [_vm._v("Let's Begin")])])])
	},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.display) ? _c('div', {
	    staticClass: "text-center margin-top-30"
	  }, [_c('h4', [_vm._v("No Results Found")]), _vm._v(" "), _c('p', {
	    staticClass: "no-margin-top"
	  }, [_vm._v("There are no " + _vm._s(_vm.type) + " that match your current search criteria.")])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('modal', {
	    staticClass: "account-selection-modal",
	    attrs: {
	      "show": _vm.showZoomModal,
	      "effect": "custom",
	      "title": _vm.activeResource.name,
	      "backdrop": true
	    },
	    on: {
	      "update:show": function($event) {
	        _vm.showZoomModal = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-body center",
	    attrs: {
	      "slot": "modal-body"
	    },
	    slot: "modal-body"
	  }, [_c('img', {
	    staticClass: "zoomed-image",
	    attrs: {
	      "src": _vm.activeResource.url
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer",
	    attrs: {
	      "slot": "modal-footer"
	    },
	    slot: "modal-footer"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Resources")]), _vm._v(" "), _c('div', {
	    staticClass: "note note-info"
	  }, [_vm._v("\n\t\t\tManage your business resources for use across your locations.\n\t\t")]), _vm._v(" "), (_vm.folders.id) ? _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', {
	    staticClass: "margin-bottom-25",
	    class: {
	      'col-sm-4': _vm.activePanel, 'col-sm-12': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "jstree-default"
	  }, [_c('ul', {
	    staticClass: "jstree-container-ul jstree-children"
	  }, [_c('li', {
	    staticClass: "jstree-node jstree-last",
	    class: {
	      'jstree-open': _vm.folders.expanded, 'jstree-closed': !_vm.folders.expanded
	    }
	  }, [_c('i', {
	    staticClass: "jstree-icon jstree-ocl",
	    on: {
	      "click": function($event) {
	        _vm.expandNode(_vm.folders)
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jstree-anchor",
	    class: {
	      'jstree-clicked': _vm.folders.id === _vm.activeFolder.id
	    },
	    on: {
	      "click": function($event) {
	        _vm.activePageUpdate(1, _vm.folders, true)
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.activeLocationId ? _vm.activeLocationName : _vm.activeBusinessName) + " Resources\n\t\t\t\t\t\t\t\t"), (!_vm.activeLocationId) ? _c('i', {
	    staticClass: "fa",
	    class: {
	      'fa-eye': _vm.folders.is_shared, 'fa-eye-slash': !_vm.folders.is_shared
	    }
	  }) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-pencil",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.manageFolder(_vm.folders)
	      }
	    }
	  })]), _vm._v(" "), (_vm.folders.expanded) ? _c('ul', {
	    staticClass: "jstree-children"
	  }, [_c('li', {
	    staticClass: "jstree-node jstree-leaf",
	    class: {
	      'jstree-last': !_vm.folders.children || !_vm.folders.children.length
	    }
	  }, [_c('i', {
	    staticClass: "jstree-icon jstree-ocl"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jstree-anchor",
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate(_vm.folders)
	      }
	    }
	  }, [_c('button', {
	    staticClass: "btn blue btn-xs"
	  }, [_vm._v("Create Folder")])])]), _vm._v(" "), _vm._l((_vm.folders.children), function(folder, index) {
	    return [_c('resource-folder', {
	      attrs: {
	        "folder": folder,
	        "activeFolder": _vm.activeFolder.id,
	        "last": index === _vm.folders.children.length - 1
	      },
	      on: {
	        "expandNode": _vm.expandNode,
	        "createFolder": _vm.createFolder,
	        "manageFolder": _vm.manageFolder,
	        "getResources": _vm.activePageUpdate
	      }
	    })]
	  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    class: {
	      'col-sm-8': _vm.activePanel, 'col-sm-12': !_vm.activePanel
	    }
	  }, [(!_vm.activeFolder.id && !_vm.allFoldersView) ? _c('div', {
	    staticClass: "center margin-top-20"
	  }, [_vm._v("Select a folder to view resources.")]) : _vm._e(), _vm._v(" "), (_vm.activeFolder.id || _vm.allFoldersView) ? _c('div', [_c('div', {
	    staticClass: "resource-header clearfix"
	  }, [(!_vm.allFoldersView) ? _c('file-upload', {
	    attrs: {
	      "folderId": _vm.activeFolder.id
	    },
	    on: {
	      "savingUpdate": _vm.checkSaving,
	      "success": _vm.imageUploaded
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('button', {
	    staticClass: "btn btn-sm btn-outline btn-default margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleFilterPanel()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.filterCollapse ? 'Show' : 'Hide') + " Filter and Search Options")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "portlet box blue-hoki portlet-blue-override"
	  }, [_c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.filterCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedResourceSearch()
	      }
	    }
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), (_vm.tags.length) ? _c('div', {
	    staticClass: "filter-tags"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._l((_vm.tags), function(tag) {
	    return [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      class: {
	        'blue': tag.active
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleTag(tag)
	        }
	      }
	    }, [_vm._v(_vm._s(tag.name))])]
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "filter-tags",
	    class: {
	      'margin-top-20': _vm.tags.length
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.fileTypes), function(type) {
	    return [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      class: {
	        'blue': type.active
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleFileType(type)
	        }
	      }
	    }, [_c('i', {
	      class: type.icon
	    }), _vm._v(" " + _vm._s(type.name))])]
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Select search range below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-radio-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.advancedSearch.range),
	        expression: "advancedSearch.range"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("advanced_search_radio_" + (option.value)),
	        "name": ("advanced_search_radio_" + (option.value))
	      },
	      domProps: {
	        "value": option.value,
	        "checked": _vm._q(_vm.advancedSearch.range, option.value)
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(_vm.advancedSearch, "range", option.value)
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_radio_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t")])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetResourceSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "tabindex": _vm.activePanel ? 0 : -1
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "cbp cbp-caption-active cbp-caption-overlayBottomReveal cbp-ready"
	  }, [_c('div', {
	    staticClass: "cbp-wrapper-outer"
	  }, [_c('div', {
	    staticClass: "cbp-wrapper"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingResourceData || _vm.isSaving,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (!_vm.loadingResourceData && !_vm.isSaving) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('name')
	      }
	    }
	  }, [_vm._v("Name")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'size'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('size')
	      }
	    }
	  }, [_vm._v("Size")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'created_at'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('created_at')
	      }
	    }
	  }, [_vm._v("Date Added")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage,
	      "allowPageChange": false,
	      "resultsPerPageOverride": 27
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (!_vm.currentResources.length) ? _c('div', {
	    staticClass: "cbp-no-files"
	  }, [_vm._v("There are currently no resources in this folder.")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }, [_vm._l((_vm.currentResources), function(resource) {
	    return [_c('div', {
	      ref: "resource",
	      refInFor: true,
	      staticClass: "cbp-item col-sm-4"
	    }, [_c('div', {
	      staticClass: "cbp-item-wrapper"
	    }, [_c('div', {
	      staticClass: "cbp-caption"
	    }, [_c('div', {
	      staticClass: "cbp-caption-defaultWrap",
	      on: {
	        "click": function($event) {
	          _vm.zoom(resource)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": resource.url
	      }
	    }), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('div', {
	      staticClass: "cbp-caption-activeWrap"
	    }, [_c('div', {
	      staticClass: "cbp-l-caption-alignCenter"
	    }, [_c('div', {
	      staticClass: "cbp-l-caption-body"
	    }, [_c('button', {
	      staticClass: "btn btn-default btn-xs",
	      on: {
	        "click": function($event) {
	          _vm.manageResource(resource)
	        }
	      }
	    }, [_vm._v("Manage Resource")])])])])])])])]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1)]) : _vm._e()], 1)])])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-folder'), _vm._v(" "), _c('manage-folder'), _vm._v(" "), _c('manage-resource')], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_vm._v("Resource Tags "), _c('small', [_vm._v("(Toggle the tags you want to filter by.)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_vm._v("File Types "), _c('small', [_vm._v("(Toggle the types you want to filter by.)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image-zoom"
	  }, [_c('i', {
	    staticClass: "fa fa-search-plus"
	  })])
	}]}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.modifyRole($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editingRole.role_name),
	      expression: "editingRole.role_name"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingRole.role_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_role_name"
	    },
	    domProps: {
	      "value": (_vm.editingRole.role_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingRole, "role_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_role_name"
	    }
	  }, [_vm._v("Role Name")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.editingRole.role_name.length
	    }
	  }, [_vm._v("Submit")])])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tEdit Role Name\n\t\t\t\t")])])
	}]}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-quick-sidebar"
	  }, [(_vm.businessAccount) ? _c('div', [_c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users active-business",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, [_c('li', {
	    staticClass: "media selected-location"
	  }, [_c('img', {
	    staticClass: "media-object",
	    attrs: {
	      "src": __webpack_require__(59),
	      "alt": "..."
	    }
	  }), _vm._v(" "), (!_vm.activeLocationId) ? _c('div', {
	    staticClass: "media-status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle font-green-jungle"
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [(!_vm.activeLocationId) ? _c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.activeBusinessName))]) : _c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.activeLocationName))]), _vm._v(" "), (_vm.activeLocationId) ? _c('div', {
	    staticClass: "media-heading-sub",
	    on: {
	      "click": function($event) {
	        _vm.selectMasterAccount()
	      }
	    }
	  }, [_c('a', {
	    staticClass: "panel-link"
	  }, [_vm._v("Select Master Account")])]) : _c('div', {
	    staticClass: "media-heading-sub"
	  }, [_vm._v("Master Account Selected")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.locationSearch.search),
	      expression: "locationSearch.search"
	    }],
	    staticClass: "form-control input-sm padding-right-20",
	    class: {
	      'edited': _vm.locationSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "location_search"
	    },
	    domProps: {
	      "value": (_vm.locationSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.locationSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.locationSearch.search.length) ? _c('i', {
	    staticClass: "fa fa-times clear-icon",
	    on: {
	      "click": function($event) {
	        _vm.clearSearch('location')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "location_search"
	    }
	  }, [_vm._v("Search All Locations")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by Location Name")])])]), _vm._v(" "), _c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingLocationData && !_vm.locationSearchResults.length,
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.locationSearchResults.length) ? _c('div', [_c('h3', {
	    staticClass: "list-heading location-panel-heading blue"
	  }, [_vm._v("Search Results")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat scrollable"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, _vm._l((_vm.locationSearchResults), function(location) {
	    return _c('li', {
	      staticClass: "media",
	      on: {
	        "click": function($event) {
	          _vm.setActiveLocation(location)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [_c('h4', {
	      staticClass: "media-heading"
	    }, [_vm._v(_vm._s(location.location_name))]), _vm._v(" "), _c('div', {
	      staticClass: "media-heading-sub"
	    }, [_vm._v(_vm._s(location.location_address))])])])
	  }))])])])]) : _c('div', [(_vm.locationSearchError.length) ? _c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError('location')
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locationSearchError))])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.unoappAccount) ? _c('div', [(!_vm.activeBusinessId || _vm.activeBusinessId === 1) ? _c('div', [_c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users active-business",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, [_c('li', {
	    staticClass: "media selected-location"
	  }, [(!_vm.activeBusinessId || _vm.activeBusinessId === 1) ? _c('img', {
	    staticClass: "media-object",
	    attrs: {
	      "src": __webpack_require__(355),
	      "alt": "..."
	    }
	  }) : _c('img', {
	    staticClass: "media-object",
	    attrs: {
	      "src": __webpack_require__(59),
	      "alt": "..."
	    }
	  }), _vm._v(" "), (!_vm.activeLocationName) ? _c('div', {
	    staticClass: "media-status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle font-green-jungle"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.activeBusinessId || _vm.activeBusinessId === 1) ? _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("No Business Selected")]), _vm._v(" "), _c('div', {
	    staticClass: "media-heading-sub"
	  }, [_vm._v("Select one by searching below")])]) : _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.activeBusinessName))]), _vm._v(" "), (_vm.activeLocationName) ? _c('div', {
	    staticClass: "media-heading-sub",
	    on: {
	      "click": function($event) {
	        _vm.selectMasterAccount()
	      }
	    }
	  }, [_c('a', {
	    staticClass: "panel-link"
	  }, [_vm._v("Select Master Account")])]) : _c('div', {
	    staticClass: "media-heading-sub"
	  }, [_vm._v("Master Account Selected")])])])])])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.businessSearch.search),
	      expression: "businessSearch.search"
	    }],
	    staticClass: "form-control input-sm padding-right-20",
	    class: {
	      'edited': _vm.businessSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "location_search"
	    },
	    domProps: {
	      "value": (_vm.businessSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.businessSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.businessSearch.search.length) ? _c('i', {
	    staticClass: "fa fa-times clear-icon",
	    on: {
	      "click": function($event) {
	        _vm.clearSearch('business')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "location_search"
	    }
	  }, [_vm._v("Search All Businesses")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by Business Name")])])]), _vm._v(" "), _c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingBusinessData && !_vm.businessSearchResults.length,
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.businessSearchResults.length) ? _c('div', [_c('h3', {
	    staticClass: "list-heading location-panel-heading blue"
	  }, [_vm._v("Search Results")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat scrollable"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, _vm._l((_vm.businessSearchResults), function(business) {
	    return _c('li', {
	      staticClass: "media",
	      on: {
	        "click": function($event) {
	          _vm.setActiveBusiness(business)
	        }
	      }
	    }, [_c('img', {
	      staticClass: "media-object",
	      attrs: {
	        "src": __webpack_require__(353),
	        "alt": "..."
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "media-body"
	    }, [_c('h4', {
	      staticClass: "media-heading"
	    }, [_vm._v(_vm._s(business.business_name))])])])
	  }))])])])]) : _c('div', [(_vm.businessSearchError.length) ? _c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError('business')
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.businessSearchError))])])]) : _vm._e()])], 1)]) : _c('div', [_c('div', {
	    staticClass: "floating-tab-button",
	    on: {
	      "click": function($event) {
	        _vm.selectMasterUNOappAccount()
	      }
	    }
	  }, [_vm._v("Select UNOapp Master Account")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users active-business",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, [_c('li', {
	    staticClass: "media selected-location"
	  }, [_c('img', {
	    staticClass: "media-object",
	    attrs: {
	      "src": __webpack_require__(59),
	      "alt": "..."
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [(!_vm.activeLocationId) ? _c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.activeBusinessName))]) : _c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v(_vm._s(_vm.activeLocationName))]), _vm._v(" "), (_vm.activeLocationId) ? _c('div', {
	    staticClass: "media-heading-sub",
	    on: {
	      "click": function($event) {
	        _vm.selectMasterAccount()
	      }
	    }
	  }, [_c('a', {
	    staticClass: "panel-link"
	  }, [_vm._v("Select Master Account")])]) : _c('div', {
	    staticClass: "media-heading-sub"
	  }, [_vm._v("Master Account Selected")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.locationSearch.search),
	      expression: "locationSearch.search"
	    }],
	    staticClass: "form-control input-sm padding-right-20",
	    class: {
	      'edited': _vm.locationSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "location_search"
	    },
	    domProps: {
	      "value": (_vm.locationSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.locationSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.locationSearch.search.length) ? _c('i', {
	    staticClass: "fa fa-times clear-icon",
	    on: {
	      "click": function($event) {
	        _vm.clearSearch('location')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "location_search"
	    }
	  }, [_vm._v("Search All Locations")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by Location Name")])])]), _vm._v(" "), _c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingLocationData && !_vm.locationSearchResults.length,
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.locationSearchResults.length) ? _c('div', [_c('h3', {
	    staticClass: "list-heading location-panel-heading blue"
	  }, [_vm._v("Search Results")]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active page-quick-sidebar-chat scrollable"
	  }, [_c('div', {
	    staticClass: "page-quick-sidebar-chat-users",
	    attrs: {
	      "data-rail-color": "#ddd",
	      "data-wrapper-class": "page-quick-sidebar-list"
	    }
	  }, [_c('ul', {
	    staticClass: "media-list list-items"
	  }, _vm._l((_vm.locationSearchResults), function(location) {
	    return _c('li', {
	      staticClass: "media",
	      on: {
	        "click": function($event) {
	          _vm.setActiveLocation(location)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [_c('h4', {
	      staticClass: "media-heading"
	    }, [_vm._v(_vm._s(location.location_name))]), _vm._v(" "), _c('div', {
	      staticClass: "media-heading-sub"
	    }, [_vm._v(_vm._s(location.location_address))])])])
	  }))])])])]) : _c('div', [(_vm.locationSearchError.length) ? _c('div', {
	    staticClass: "padding-box"
	  }, [_c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError('location')
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locationSearchError))])])]) : _vm._e()])], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.searchTerm),
	      expression: "searchTerm",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.searchTerm
	    },
	    attrs: {
	      "type": "text",
	      "id": "google_places_search",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.searchTerm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.selectedLocation.name && _vm.confirmationMessage.length) ? _c('div', {
	    staticClass: "margin-bottom-5 margin-left-15"
	  }, [_c('small', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.confirmationMessage)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.name) ? _c('div', {
	    staticClass: "col-xs-12 blog-page blog-content-1"
	  }, [_c('div', {
	    staticClass: "blog-post-xs bordered blog-container"
	  }, [_c('div', {
	    staticClass: "blog-img-thumb"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.selectedLocation.main_photo
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blog-post-content"
	  }, [_c('h2', {
	    staticClass: "blog-title blog-post-title"
	  }, [_c('a', [_vm._v(_vm._s(_vm.selectedLocation.name))])]), _vm._v(" "), _c('p', {
	    staticClass: "font-grey-mint",
	    domProps: {
	      "innerHTML": _vm._s(_vm.selectedLocation.adr_address)
	    }
	  }), _vm._v(" "), (_vm.selectedLocation.formatted_phone_number) ? _c('p', {
	    staticClass: "font-grey-mint"
	  }, [_c('i', {
	    staticClass: "fa fa-phone"
	  }), _vm._v(" " + _vm._s(_vm.selectedLocation.formatted_phone_number))]) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.website) ? _c('p', {
	    staticClass: "font-grey-mint"
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.selectedLocation.website,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.selectedLocation.website))])]) : _vm._e()])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "google_places_search"
	    }
	  }, [_vm._v("Search for your location "), _c('small', {
	    staticClass: "font-grey-cascade"
	  }, [_vm._v("(Make sure your location is set up on Google.)")])])
	}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'page-fixed-height': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "sideways-page-one",
	    class: {
	      'disabled': !_vm.activePanel
	    }
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbs
	    }
	  })], 1), _vm._v(" "), _c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v("Roles")]), _vm._v(" "), _c('div', {
	    staticClass: "note note-info"
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.note) + "\n\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Role")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('div', [_c('div', {
	    staticClass: "portlet box blue-hoki"
	  }, [_c('div', {
	    staticClass: "portlet-title",
	    on: {
	      "click": function($event) {
	        _vm.toggleSearchPanel()
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('a', {
	    class: {
	      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body",
	    class: {
	      'display-hide': _vm.searchCollapse
	    }
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.advancedRoleSearch()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [(_vm.searchError.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearSearchError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.search),
	      expression: "advancedSearch.search"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.advancedSearch.search.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "search_options_search",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    domProps: {
	      "value": (_vm.advancedSearch.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.advancedSearch, "search", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.computedSearchOptions.length) ? _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Search by "), _vm._l((_vm.computedSearchOptions), function(option, index) {
	    return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(option.name))])
	  }), _vm._v(".")], 2) : _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Select search terms below.")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-checkbox-inline margin-top-25"
	  }, _vm._l((_vm.advancedSearch.searchOptions), function(option) {
	    return _c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (option.checked),
	        expression: "option.checked"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("advanced_search_checkbox_" + (option.value))
	      },
	      domProps: {
	        "checked": Array.isArray(option.checked) ? _vm._i(option.checked, null) > -1 : (option.checked)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = option.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (option.checked = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (option.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(option, "checked", $$c)
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("advanced_search_checkbox_" + (option.value))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.approval_permission),
	      expression: "advancedSearch.approval_permission"
	    }],
	    staticClass: "form-control edited",
	    attrs: {
	      "id": "search_options_approval_permission",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.advancedSearch, "approval_permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Approval Permission")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("No Approval Permission")])]), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "search_options_status"
	    }
	  }, [_vm._v("Approval Permission")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('typeahead', {
	    attrs: {
	      "data": _vm.apps,
	      "label": 'App',
	      "emitter": 'app',
	      "passedValue": _vm.advancedSearch.app,
	      "objectKey": 'app_name',
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "app": _vm.updateApp,
	      "onFocus": _vm.appFocus
	    }
	  }), _vm._v(" "), (_vm.advancedSearch.app.app_id) ? _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("Choose a level of app access below:")]) : _vm._e()], 1), _vm._v(" "), (_vm.advancedSearch.app.app_id) ? _c('div', {
	    staticClass: "md-radio-inline margin-top-25"
	  }, [_c('div', {
	    staticClass: "md-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.access_level),
	      expression: "advancedSearch.access_level"
	    }],
	    staticClass: "md-radio",
	    attrs: {
	      "type": "radio",
	      "id": "advanced_search_radio_none",
	      "name": "advanced_search_access_level",
	      "value": "none"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.advancedSearch.access_level, "none")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.advancedSearch, "access_level", "none")
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "md-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.access_level),
	      expression: "advancedSearch.access_level"
	    }],
	    staticClass: "md-radio",
	    attrs: {
	      "type": "radio",
	      "id": "advanced_search_radio_view",
	      "name": "advanced_search_access_level",
	      "value": "view"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.advancedSearch.access_level, "view")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.advancedSearch, "access_level", "view")
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
	    staticClass: "md-radio"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.advancedSearch.access_level),
	      expression: "advancedSearch.access_level"
	    }],
	    staticClass: "md-radio",
	    attrs: {
	      "type": "radio",
	      "id": "advanced_search_radio_view_modify",
	      "name": "advanced_search_access_level",
	      "value": "modify"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.advancedSearch.access_level, "modify")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.advancedSearch, "access_level", "modify")
	      }
	    }
	  }), _vm._v(" "), _vm._m(3)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "tabindex": _vm.activePanel ? 0 : -1
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetRoleSearch()
	      }
	    }
	  }, [_vm._v(" Reset Search ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "tabindex": _vm.activePanel ? 0 : -1
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search ")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "relative-block"
	  }, [_c('loading-screen', {
	    attrs: {
	      "show": _vm.loadingRoleData,
	      "color": '#3598dc',
	      "display": 'inline'
	    }
	  }), _vm._v(" "), (_vm.loadingRoleData === false) ? _c('div', [_c('div', {
	    staticClass: "clearfix"
	  }, [_c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort By"), (_vm.sortBy.field) ? _c('span', [_c('b', [_vm._v(": " + _vm._s(_vm.sortOptions[_vm.sortBy.field]) + " "), (_vm.sortBy.order === 'asc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }) : _vm._e(), (_vm.sortBy.order === 'desc') ? _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "rounded-button-group-block"
	  }, [_c('div', {
	    staticClass: "btn-group",
	    attrs: {
	      "data-toggle": "buttons"
	    }
	  }, [_c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'asc'
	    },
	    attrs: {
	      "for": "sort_asc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_asc",
	      "value": "asc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "asc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "asc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "btn blue btn-outline",
	    class: {
	      'active': _vm.sortBy.order === 'desc'
	    },
	    attrs: {
	      "for": "sort_desc"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sortBy.order),
	      expression: "sortBy.order"
	    }],
	    staticClass: "toggle",
	    attrs: {
	      "type": "radio",
	      "id": "sort_desc",
	      "value": "desc"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sortBy.order, "desc")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.sortBy, "order", "desc")
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  })])])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'role_name'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('role_name')
	      }
	    }
	  }, [_vm._v("Role Name")])]), _vm._v(" "), _c('li', {
	    class: {
	      'active': _vm.sortBy.field === 'num_accounts'
	    }
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setSortField('num_accounts')
	      }
	    }
	  }, [_vm._v("# of Accounts")])])])]), _vm._v(" "), _c('page-results', {
	    staticClass: "pull-right",
	    attrs: {
	      "totalResults": _vm.totalResults,
	      "activePage": _vm.activePage
	    },
	    on: {
	      "pageResults": _vm.pageResultsUpdate
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
	    staticClass: "margin-top-30 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-bordered table-striped table-condensed"
	  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.roles), function(role) {
	    return _c('tr', [_c('td', [_c('h3', [_vm._v(_vm._s(role.role_name) + " "), (role.locked_role) ? _c('small', [_c('i', {
	      staticClass: "fa fa-lock font-grey-cascade"
	    })]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(role.num_accounts || 0))]), _vm._v(" " + _vm._s(role.num_accounts === 1 ? 'account' : 'accounts'))])]), _vm._v(" "), _c('td', [(role.approval_permission) ? _c('i', {
	      staticClass: "fa fa-check font-green-haze"
	    }) : _c('i', {
	      staticClass: "fa fa-close font-red-thunderbird"
	    })]), _vm._v(" "), _c('td', [_c('dropdown', [_c('button', {
	      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	      attrs: {
	        "slot": "button",
	        "type": "button",
	        "data-toggle": "dropdown"
	      },
	      slot: "button"
	    }, [_c('i', {
	      staticClass: "fa fa-cogs"
	    })]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu",
	      attrs: {
	        "slot": "dropdown-menu"
	      },
	      slot: "dropdown-menu"
	    }, [(!role.locked_role) ? _c('li', [(role.approval_permission) ? _c('a', {
	      on: {
	        "click": function($event) {
	          _vm.modifyApprovalPermissions(role, 'remove')
	        }
	      }
	    }, [_vm._v("Remove Approval Permission")]) : _c('a', {
	      on: {
	        "click": function($event) {
	          _vm.modifyApprovalPermissions(role, 'add')
	        }
	      }
	    }, [_vm._v("Assign Approval Permission")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editRolePermissions(role.role_id)
	        }
	      }
	    }, [_vm._v("View App Access")])]), _vm._v(" "), (!role.locked_role) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.editRoleName(role.role_id)
	        }
	      }
	    }, [_vm._v("Edit Role Name")])]) : _vm._e(), _vm._v(" "), (!role.locked_role) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.deleteRoleConfirmation('delete', role)
	        }
	      }
	    }, [_vm._v("Delete Role")])]) : _vm._e()])])], 1)])
	  }))])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
	    attrs: {
	      "show": _vm.numPages === 0,
	      "type": 'roles'
	    }
	  }), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "passedPage": _vm.activePage,
	      "numPages": _vm.numPages
	    },
	    on: {
	      "activePageChange": _vm.activePageUpdate
	    }
	  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "sideways-page-two",
	    class: {
	      'active': !_vm.activePanel, 'inactive': _vm.activePanel
	    },
	    style: ({
	      height: _vm.computedHeight
	    })
	  }, [_c('div', {
	    staticClass: "sideways-blank-fold"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg margin-bottom-10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-role', {
	    attrs: {
	      "baseRoute": _vm.baseRoute,
	      "baseRouteName": _vm.baseRouteName,
	      "businessId": _vm.businessId
	    }
	  }), _vm._v(" "), _c('edit-role-name', {
	    attrs: {
	      "baseRoute": _vm.baseRoute,
	      "baseRouteName": _vm.baseRouteName
	    }
	  }), _vm._v(" "), _c('edit-role-permissions', {
	    attrs: {
	      "baseRoute": _vm.baseRoute,
	      "baseRouteName": _vm.baseRouteName,
	      "businessId": _vm.businessId
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "caption"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v("\n\t\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "advanced_search_radio_none"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNo Access\n\t\t\t\t\t\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "advanced_search_radio_view"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tView Access\n\t\t\t\t\t\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "advanced_search_radio_view_modify"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tView & Modify Access\n\t\t\t\t\t\t\t\t\t\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', {
	    staticClass: "bg-blue"
	  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Approval Permission")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click"
	  }, [_vm._v("Actions")])])])])
	}]}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isLi) ? _c('li', {
	    class: _vm.classes,
	    attrs: {
	      "id": ("dropdown-id-" + _vm.id)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
	        _vm.open = false
	      }
	    }
	  }, [_vm._t("button", [_c('a', {
	    staticClass: "dropdown-toggle",
	    class: {
	      disabled: _vm.disabled
	    },
	    attrs: {
	      "role": "button"
	    }
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t"), _c('span', {
	    staticClass: "caret"
	  })])]), _vm._v(" "), _vm._t("dropdown-menu", [_c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._t("default")], 2)])], 2) : _c('div', {
	    class: _vm.classes,
	    attrs: {
	      "id": ("dropdown-id-" + _vm.id)
	    }
	  }, [_vm._t("before"), _vm._v(" "), _vm._t("button", [_c('button', {
	    staticClass: "btn dropdown-toggle",
	    class: _vm.type,
	    attrs: {
	      "type": "button",
	      "disabled": _vm.disabled
	    }
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t"), _c('span', {
	    staticClass: "caret"
	  })])]), _vm._v(" "), _vm._t("dropdown-menu", [_c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._t("default")], 2)])], 2)
	},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.editBusiness($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingBusiness.business_name),
	      expression: "editingBusiness.business_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingBusiness.business_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "edit_business_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.editingBusiness.business_name)
	    },
	    on: {
	      "change": function($event) {
	        _vm.businessNameUpdated()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingBusiness, "business_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "edit_business_name"
	    }
	  }, [_vm._v("Business Name")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    key: "edit-business-continue-one",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.advanceForm($event, 'step_2', 'step_1')
	      }
	    }
	  }, [_vm._v("Continue "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "margin-top-20 portlet-title-alternate"
	  }, [_vm._v("Edit Product Package")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped ta ble-condensed"
	  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("Include App")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-checkbox"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.business_access),
	        expression: "app.business_access"
	      }],
	      staticClass: "md-check",
	      attrs: {
	        "type": "checkbox",
	        "id": ("app_access_business_" + (app.app_id))
	      },
	      domProps: {
	        "checked": Array.isArray(app.business_access) ? _vm._i(app.business_access, null) > -1 : (app.business_access)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = app.business_access,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (app.business_access = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (app.business_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(app, "business_access", $$c)
	          }
	        }, function($event) {
	          _vm.forceAppSelection('business_access', app)
	        }]
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_access_business_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Business Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "edit-business-submit",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
	    attrs: {
	      "steps": _vm.steps,
	      "process": _vm.process
	    }
	  })], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tEdit Business\n\t\t\t\t")])])
	}]}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sideways-page-one"
	  }, [_c('div', {
	    staticClass: "page-bar"
	  }, [_c('breadcrumb', {
	    attrs: {
	      "crumbs": _vm.breadcrumbArray
	    }
	  })], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(1)
	      }
	    }
	  }, [_vm._v(" Create a new Layout")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(2), _vm.getLayouts()
	      }
	    }
	  }, [_vm._v(" Open existing layout")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_c('div', [(_vm.type === 0) ? _c('h1', [_vm._v(" Create new layout ")]) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('h1', [_vm._v(" Edit layout Region: " + _vm._s(_vm.name) + " (" + _vm._s(this.displayCount) + " screens)")]) : _vm._e()]), _vm._v(" "), (_vm.type === 1) ? _c('div', [_c('h2', [_vm._v(" Click on a screen below to edit its regions")])]) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-input', {
	    staticStyle: {
	      "width": "30%"
	    },
	    attrs: {
	      "placeholder": "Layout name"
	    },
	    model: {
	      value: (_vm.name),
	      callback: function($$v) {
	        _vm.name = $$v
	      },
	      expression: "name"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "15%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setLayoutSize(1920, 1080)
	      }
	    }
	  }, [_vm._v(" Horizontal (1920 x 1080)")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "15%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setLayoutSize(1080, 1920)
	      }
	    }
	  }, [_vm._v(" Vertical (1080 x 1920)")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_vm._v("\n\t\t\t\t Number of screens "), _c('el-input-number', {
	    attrs: {
	      "min": 1
	    },
	    model: {
	      value: (_vm.displayCount),
	      callback: function($$v) {
	        _vm.displayCount = $$v
	      },
	      expression: "displayCount"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createLayout()
	      }
	    }
	  }, [_vm._v(" Save ")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "width": "8%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setStep(0)
	      }
	    }
	  }, [_vm._v(" Cancel ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayCount), function(n, i) {
	    return (_vm.type === 1) ? _c('div', {
	      staticClass: "hoverDisplay",
	      staticStyle: {
	        "position": "relative",
	        "display": "flex",
	        "width": "auto!important",
	        "margin": "0"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setStep(3, 0, i), _vm.displayNumber = i
	        }
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "outline": "1px solid black"
	      },
	      style: ({
	        width: _vm.layoutWidth / 60 + 'vw',
	        height: _vm.layoutHeight / 60 + 'vw'
	      }),
	      attrs: {
	        "id": "text-area",
	        "disabled": ""
	      }
	    }, _vm._l((_vm.regionList), function(zone) {
	      return (zone.screen === i) ? _c('div', {
	        staticStyle: {
	          "position": "absolute"
	        },
	        style: ({
	          top: zone.y / 60 + 'vw',
	          left: zone.x / 60 + 'vw',
	          width: zone.width / 60 + 'vw',
	          height: zone.height / 60 + 'vw',
	          backgroundColor: zone.background
	        }),
	        attrs: {
	          "disabled": ""
	        }
	      }) : _vm._e()
	    }))]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.displayCount), function(n, i) {
	    return (_vm.type === 0) ? _c('div', {
	      staticClass: "hoverDisplay",
	      staticStyle: {
	        "position": "relative",
	        "display": "flex",
	        "width": "auto!important",
	        "margin": "0"
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "outline": "1px solid black"
	      },
	      style: ({
	        width: _vm.layoutWidth / 60 + 'vw',
	        height: _vm.layoutHeight / 60 + 'vw'
	      }),
	      attrs: {
	        "id": "text-area",
	        "disabled": ""
	      }
	    }, _vm._l((_vm.regionList), function(zone) {
	      return (zone.screen === i) ? _c('div', {
	        staticStyle: {
	          "position": "absolute"
	        },
	        style: ({
	          top: zone.y / 60 + 'vw',
	          left: zone.x / 60 + 'vw',
	          width: zone.width / 60 + 'vw',
	          height: zone.height / 60 + 'vw',
	          backgroundColor: zone.background
	        }),
	        attrs: {
	          "disabled": ""
	        }
	      }) : _vm._e()
	    }))]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.layoutList), function(layout, index) {
	    return [_c('el-button', {
	      staticStyle: {
	        "width": "25%"
	      },
	      attrs: {
	        "type": "primary"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setStep(1, 1), _vm.setActiveLayout(index)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(layout.name) + " w: " + _vm._s(layout.width) + " h: " + _vm._s(layout.height) + " ")]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger"
	      },
	      on: {
	        "click": function($event) {
	          _vm.deleteLayout(layout.layout_id, index)
	        }
	      }
	    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
	    staticClass: "flex-center"
	  }, [_c('div', [_c('div', [_c('h1', [_vm._v(" " + _vm._s(_vm.name) + " (Display " + _vm._s(_vm.displayNumber + 1) + "/" + _vm._s(_vm.displayCount) + ")")])]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    attrs: {
	      "disabled": !_vm.displayNumber > 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.prevDisplay()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-left fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tPrevious Display\n\t\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.toggle()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-alt fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tFullscreen\n\t\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    attrs: {
	      "disabled": !(this.displayNumber < this.displayCount - 1)
	    },
	    on: {
	      "click": function($event) {
	        _vm.nextDisplay()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-right fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tNext Display\n\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "center",
	      "align-items": "center"
	    }
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Zoom: ")]), _vm._v(" "), _c('el-slider', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "step": 0.1,
	      "show-input": "",
	      "min": 0.1,
	      "max": 1
	    },
	    on: {
	      "change": _vm.updatePadding
	    },
	    model: {
	      value: (_vm.scale),
	      callback: function($$v) {
	        _vm.scale = $$v
	      },
	      expression: "scale"
	    }
	  })], 1)]), _vm._v(" "), _c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Grid Size:  ")]), _vm._v(" "), _c('el-slider', {
	    staticStyle: {
	      "width": "25%"
	    },
	    attrs: {
	      "step": 5,
	      "show-input": "",
	      "min": 5,
	      "max": 20,
	      "show-stops": ""
	    },
	    model: {
	      value: (_vm.grid),
	      callback: function($$v) {
	        _vm.grid = $$v
	      },
	      expression: "grid"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-bottom": "2px"
	    }
	  }, [_c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.updateZones()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-save fa-2x "
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t  Save\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn",
	    on: {
	      "click": function($event) {
	        _vm.setStep(1, 1), _vm.getZones()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-th fa-2x"
	  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t  MultiView\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "25%"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "display": "flex",
	      "justify-content": "center",
	      "align-items": "center",
	      "flex-wrap": "wrap"
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('button', {
	    staticClass: "button btn primary",
	    on: {
	      "click": function($event) {
	        _vm.addNewRegion()
	      }
	    }
	  }, [_vm._v(" Add region ")]), _vm._v(" "), _c('button', {
	    staticClass: "button btn primary",
	    on: {
	      "click": function($event) {
	        _vm.deleteRegion()
	      }
	    }
	  }, [_vm._v(" Delete region ")])]), _vm._v(" "), _c('draggable', {
	    on: {
	      "end": _vm.onEnd
	    }
	  }, _vm._l((_vm.regionList), function(region, i) {
	    return (region.background !== 'transparent' && region.screen === _vm.displayNumber) ? _c('div', {
	      class: {
	        'selectedBlock': i === _vm.selectedRegion
	      },
	      staticStyle: {
	        "display": "inline-block:float:left",
	        "color": "white",
	        "padding": "5px"
	      },
	      style: ({
	        'background-color': region.background
	      }),
	      attrs: {
	        "id": 'minimap-' + i
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectRegion(i)
	        }
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t" + _vm._s(region.width) + "x" + _vm._s(region.height) + "\n")]) : _vm._e()
	  }))], 1)]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "auto!important",
	      "padding": "5px"
	    },
	    style: ({
	      'margin-bottom': _vm.padding + 'px'
	    })
	  }, [_c('fs', {
	    ref: "fs",
	    attrs: {
	      "fullscreen": _vm.fullscreen
	    },
	    on: {
	      "update:fullscreen": function($event) {
	        _vm.fullscreen = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "layout-editor",
	    staticStyle: {
	      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, lightgrey 1px, transparent 1px)",
	      "position": "relative",
	      "transform-origin": "top",
	      "outline": "5px solid black"
	    },
	    style: ({
	      width: _vm.layoutWidth + 'px',
	      height: _vm.layoutHeight + 'px',
	      transform: 'scale(' + _vm.scale + ',' + _vm.scale + ')',
	      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
	    })
	  }, [_vm._l((_vm.regionList), function(region, i) {
	    return (region.background !== 'transparent' && region.screen === _vm.displayNumber) ? [_c('vue-draggable-resizable', {
	      staticClass: "region",
	      style: ({
	        'background-color': region.background
	      }),
	      attrs: {
	        "grid": [_vm.grid, _vm.grid],
	        "id": ("region-" + i),
	        "index": i,
	        "x": region.x,
	        "y": region.y,
	        "w": region.width,
	        "h": region.height,
	        "z": region.z,
	        "parent": true
	      },
	      on: {
	        "activated": function($event) {
	          _vm.selectRegion(i)
	        },
	        "dragging": _vm.onDrag,
	        "resizing": _vm.onResize
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "background-color": "rgba(0,0,0,0.5)",
	        "color": "white",
	        "border-radius": "4px",
	        "padding": "2px"
	      }
	    }, [_vm._v("\n\t\t\t\t\t\t\t\ttop:" + _vm._s(region.y) + " left:" + _vm._s(region.x) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.width) + "w " + _vm._s(region.height) + "h "), _c('br')])])] : _vm._e()
	  })], 2)])], 1)], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Layouts ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(" Select a layout ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('h1', [_vm._v(" Toolbox ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('h1', [_vm._v(" Layers ")])])
	}]}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_vm._v("Confirm the placement of the map pin."), _c('br'), _c('small', {
	    staticClass: "font-grey-mint"
	  }, [_vm._v("Drag the map marker to your location if the coordinates are not correct")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-bottom": "25px",
	      "margin-top": "25px",
	      "height": "300px"
	    },
	    attrs: {
	      "id": "map"
	    }
	  }, [_vm._v("There was an issue loading the map. Please try again.")])])
	}]}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [(_vm.process === 'form') ? _c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.inviteUser($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.invitedUser.email),
	      expression: "invitedUser.email"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.invitedUser.email.length
	    },
	    attrs: {
	      "type": "email",
	      "id": "invite_user_email"
	    },
	    domProps: {
	      "value": (_vm.invitedUser.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.invitedUser, "email", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "invite_user_email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("Please make sure you enter a valid email address.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.invitedUser.name.first_name),
	      expression: "invitedUser.name.first_name"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.invitedUser.name.first_name && _vm.invitedUser.name.first_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "invite_user_first_name"
	    },
	    domProps: {
	      "value": (_vm.invitedUser.name.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.invitedUser.name, "first_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "invite_user_first_name"
	    }
	  }, [_vm._v("First Name")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("The user will get the opportunity to confirm this.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.invitedUser.name.last_name),
	      expression: "invitedUser.name.last_name"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.invitedUser.name.last_name && _vm.invitedUser.name.last_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "invite_user_last_name"
	    },
	    domProps: {
	      "value": (_vm.invitedUser.name.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.invitedUser.name, "last_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "invite_user_last_name"
	    }
	  }, [_vm._v("Last Name")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("The user will get the opportunity to confirm this.")])]), _vm._v(" "), (!_vm.locationId) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('typeahead', {
	    attrs: {
	      "data": _vm.roles,
	      "label": 'Role',
	      "emitter": 'role',
	      "objectKey": 'role_name'
	    },
	    on: {
	      "role": _vm.updateRole,
	      "onFocus": _vm.roleFocus
	    }
	  })], 1) : _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('typeahead', {
	    attrs: {
	      "data": _vm.locationRoles,
	      "label": 'Location Role',
	      "emitter": 'locationRole',
	      "objectKey": 'role_name'
	    },
	    on: {
	      "locationRole": _vm.updateLocationRole,
	      "onFocus": _vm.locationRoleFocus
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Users Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])]) : _c('next-actions', {
	    attrs: {
	      "actionsList": _vm.inviteUserNextActions
	    },
	    on: {
	      "runFunction": _vm.runFunction
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tInvite A User\n\t\t\t\t")])])
	}]}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createFolder($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newFolder.name),
	      expression: "newFolder.name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newFolder.name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "create_folder_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newFolder.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newFolder, "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "create_folder_name"
	    }
	  }, [_vm._v("Folder Name")])]), _vm._v(" "), (!_vm.activeLocationId) ? _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newFolder.is_shared),
	      expression: "newFolder.is_shared"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-privatize"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newFolder.is_shared) ? _vm._i(_vm.newFolder.is_shared, null) > -1 : (_vm.newFolder.is_shared)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newFolder.is_shared,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newFolder.is_shared = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newFolder.is_shared = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newFolder, "is_shared", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-privatize"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t\t                        \t\t\t\tMake this folder "), _c('b', [_vm._v("public")]), _vm._v(" to all locations.\n\t\t                        \t\t\t")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Resources Dashboard")]), _vm._v(" "), _c('button', {
	    key: "create-folder-confirm",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\tCreate A Folder\n\t\t\t\t")])])
	}]}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [(_vm.process === 'step_1') ? [_vm._v("\n\t\t\t\t\t\tEdit Contest Prizes\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.activePrize.id ? 'Edit' : 'Create New') + " Contest Prize\n\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? [_vm._v("\n\t\t\t\t\t\tCreate New Contest Rule\n\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.process === 'step_1') ? _c('div', {
	    key: "step_1"
	  }, [_c('button', {
	    staticClass: "btn blue btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.throttledCreate()
	      }
	    }
	  }, [_vm._v("Create a New Prize")]), _vm._v(" "), _c('div', {
	    staticClass: "prize-progress"
	  }, [_vm._l((_vm.prizes), function(prize) {
	    return [_c('div', {
	      staticClass: "clickable",
	      style: ({
	        backgroundColor: prize.color,
	        width: ((prize.weight) + "%"),
	        padding: ("2px " + ((prize.weight >= 2) ? '5px' : '0'))
	      }),
	      on: {
	        "mouseover": function($event) {
	          _vm.selectPrize(prize)
	        }
	      }
	    }, [_vm._v(_vm._s((prize.weight >= 4) ? ((prize.weight) + "%") : ''))])]
	  })], 2), _vm._v(" "), (_vm.prizes.length && _vm.currentCoverage < 100) ? _c('i', {
	    staticClass: "font-red-thunderbird"
	  }, [_c('small', [_vm._v("* Note that 100% prize coverage is required to run your campaign.")])]) : _vm._e(), _vm._v(" "), (_vm.activePrize.id) ? _c('div', {
	    staticClass: "portlet box blue-hoki margin-top-20",
	    style: ({
	      border: ("1px solid " + (_vm.activePrize.color))
	    })
	  }, [_c('div', {
	    staticClass: "portlet-title",
	    style: ({
	      backgroundColor: _vm.activePrize.color
	    })
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.activePrize.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('div', [_c('img', {
	    staticClass: "active-prize-image",
	    attrs: {
	      "src": _vm.activePrize.image
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "margin-top-20"
	  }, [_c('ul', {
	    staticStyle: {
	      "listStyleType": "none",
	      "paddingLeft": "0"
	    }
	  }, [_c('li', [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s((_vm.activePrize.quantity === 0) ? 'Unlimited' : _vm.activePrize.quantity) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Odds of Winning: ")]), _vm._v(_vm._s(_vm.activePrize.weight) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Claim Type: ")]), _vm._v(_vm._s(_vm.activePrize.claim_type) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-sm margin-top-20",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.editPrize(_vm.activePrize)
	      }
	    }
	  }, [_vm._v("Edit Prize")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-sm margin-top-20",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addRule()
	      }
	    }
	  }, [_vm._v("Add Prize Rule")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue btn-sm margin-top-20",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewRules(_vm.activePrize)
	      }
	    }
	  }, [_vm._v("View Prize Rules")])])])]) : _vm._e(), _vm._v(" "), (!_vm.prizes.length) ? _c('div', {
	    staticClass: "center margin-top-20 font-grey-cascade"
	  }, [_c('i', [_vm._v("No prizes created yet.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
	    key: "step_2"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createContestPrize($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.name),
	      expression: "newPrize.name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_prize_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newPrize.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_name"
	    }
	  }, [_vm._v("Name")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("This is the name of the prize that will be displayed to the user.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.image),
	      expression: "newPrize.image",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.image.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_prize_image",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.newPrize.image)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "image", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_image"
	    }
	  }, [_vm._v("Image")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("This is the image of the prize that will be displayed to the user.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.quantity),
	      expression: "newPrize.quantity",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.quantity || _vm.newPrize.quantity === 0
	    },
	    attrs: {
	      "type": "number",
	      "id": "new_prize_quantity",
	      "maxlength": "255",
	      "disabled": _vm.newPrize.unlimited_quantity
	    },
	    domProps: {
	      "value": (_vm.newPrize.quantity)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "quantity", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_quantity"
	    }
	  }, [_vm._v("Quantity")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The total quantity of this prize that will be available.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPrize.unlimited_quantity),
	      expression: "newPrize.unlimited_quantity"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-no-age-limit"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newPrize.unlimited_quantity) ? _vm._i(_vm.newPrize.unlimited_quantity, null) > -1 : (_vm.newPrize.unlimited_quantity)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newPrize.unlimited_quantity,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newPrize.unlimited_quantity = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newPrize.unlimited_quantity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newPrize, "unlimited_quantity", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-no-age-limit"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n\t            \t\t\t\t\t\t\tUnlimited Quantity\n\t            \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'Enabling this will set the limit of this prize to unlimited.'
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.weight),
	      expression: "newPrize.weight",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.weight > 0
	    },
	    attrs: {
	      "type": "number",
	      "id": "new_prize_weight",
	      "min": "0",
	      "max": "100"
	    },
	    domProps: {
	      "value": (_vm.newPrize.weight)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "weight", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_weight"
	    }
	  }, [_vm._v("Odds of Winning (%)")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("This value represents the odds (out of 100) that a user has of winning this prize.")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-bottom-20"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tClaim Type\n\t\t\t\t\t\t\t\t\t"), _c('info-popover', {
	    attrs: {
	      "content": 'Select `none` if this is a prize that cannot be claimed.'
	    }
	  })], 1), _vm._v(" "), _c('dropdown', [_c('button', {
	    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
	    attrs: {
	      "slot": "button",
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    slot: "button"
	  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.newPrize.claim_type || 'Select a Claim Type') + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-angle-down"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "slot": "dropdown-menu"
	    },
	    slot: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setClaimType('none')
	      }
	    }
	  }, [_vm._v("none")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setClaimType('text')
	      }
	    }
	  }, [_vm._v("text")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setClaimType('href')
	      }
	    }
	  }, [_vm._v("href")])]), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.setClaimType('post_request')
	      }
	    }
	  }, [_vm._v("post_request")])])])])], 1), _vm._v(" "), (_vm.newPrize.claim_type.length && _vm.newPrize.claim_type !== 'none') ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.claim),
	      expression: "newPrize.claim",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.claim.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_prize_claim"
	    },
	    domProps: {
	      "value": (_vm.newPrize.claim)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "claim", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_claim"
	    }
	  }, [(_vm.newPrize.claim_type === 'text') ? [_vm._v("\n\t                            \t\tClaim Text\n\t                            \t")] : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type === 'href') ? [_vm._v("\n\t                            \t\tClaim Link\n\t                            \t")] : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type === 'post_request') ? [_vm._v("\n\t                            \t\tClaim Post Request\n\t                            \t")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.newPrize.claim_type.length && _vm.newPrize.claim_type === 'post_request') ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.newPrize.claim_post_request_params),
	      expression: "newPrize.claim_post_request_params",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newPrize.claim_post_request_params.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "new_prize_claim"
	    },
	    domProps: {
	      "value": (_vm.newPrize.claim_post_request_params)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPrize, "claim_post_request_params", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "new_prize_claim"
	    }
	  }, [_vm._v("\n\t                            \tPost Request Claim Type\n\t                            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "add-contest-rules-submit",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
	    key: "step_3"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.createPrizeRule($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Starts At")]), _vm._v(" "), _c('el-time-picker', {
	    attrs: {
	      "format": "h:mm A",
	      "editable": false,
	      "placeholder": "Select Start Time"
	    },
	    model: {
	      value: (_vm.newRule.starts_at),
	      callback: function($$v) {
	        _vm.$set(_vm.newRule, "starts_at", $$v)
	      },
	      expression: "newRule.starts_at"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Ends At")]), _vm._v(" "), _c('el-time-picker', {
	    attrs: {
	      "format": "h:mm A",
	      "editable": false,
	      "placeholder": "Select End Time"
	    },
	    model: {
	      value: (_vm.newRule.ends_at),
	      callback: function($$v) {
	        _vm.$set(_vm.newRule, "ends_at", $$v)
	      },
	      expression: "newRule.ends_at"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-md-checkboxes margin-bottom-20"
	  }, [_c('div', {
	    staticClass: "md-checkbox-inline"
	  }, [_c('div', {
	    staticClass: "md-checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRule.specific_day),
	      expression: "newRule.specific_day"
	    }],
	    staticClass: "md-check",
	    attrs: {
	      "type": "checkbox",
	      "id": "checkbox-specific-day",
	      "disabled": _vm.process !== 'step_3'
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newRule.specific_day) ? _vm._i(_vm.newRule.specific_day, null) > -1 : (_vm.newRule.specific_day)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newRule.specific_day,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newRule.specific_day = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newRule.specific_day = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newRule, "specific_day", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "checkbox-specific-day"
	    }
	  }, [_c('span'), _vm._v(" "), _c('span', {
	    staticClass: "check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "box"
	  }), _vm._v("\n                \t\t\t\t\t\t\tOnly on specific day\n                \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
	    attrs: {
	      "content": 'By enabling this, the promotional odds will only run on one specific day.'
	    }
	  })], 1)])]), _vm._v(" "), (_vm.newRule.specific_day) ? _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
	  }, [_c('label', {
	    staticClass: "dropdown-label-override"
	  }, [_vm._v("Date")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": 'MMM dd, yyyy',
	      "type": "date",
	      "editable": false,
	      "placeholder": "Select Date"
	    },
	    model: {
	      value: (_vm.newRule.date),
	      callback: function($$v) {
	        _vm.$set(_vm.newRule, "date", $$v)
	      },
	      expression: "newRule.date"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRule.max_redemptions),
	      expression: "newRule.max_redemptions"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newRule.max_redemptions >= 0
	    },
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.newRule.max_redemptions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newRule, "max_redemptions", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Max Redemptions")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("The maximum redemptions that will be available for this prize. Use ‘0’ if unlimited.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newRule.weight),
	      expression: "newRule.weight"
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.newRule.weight > 0
	    },
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "100"
	    },
	    domProps: {
	      "value": (_vm.newRule.weight)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newRule, "weight", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Odds of Winning (%)")]), _vm._v(" "), _c('span', {
	    staticClass: "help-block persist"
	  }, [_vm._v("This value represents the odds (out of 100) that a user has of winning this prize.")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions margin-top-20"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseForm()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
	    key: "edit-contest-prize-submit",
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])])]) : _vm._e()])], 1)])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body portlet-overflow"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.updateResource($event)
	      }
	    }
	  }, [(_vm.errorMessage.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-close": "alert"
	    },
	    on: {
	      "click": function($event) {
	        _vm.clearError()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "form-body invite-user-form"
	  }, [_c('div', {
	    staticClass: "form-group form-md-line-input form-md-floating-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.editingResource.user_defined_name),
	      expression: "editingResource.user_defined_name",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control input-sm",
	    class: {
	      'edited': _vm.editingResource.user_defined_name.length
	    },
	    attrs: {
	      "type": "text",
	      "id": "manage_resource_name",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.editingResource.user_defined_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.editingResource, "user_defined_name", $event.target.value.trim())
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "manage_resource_name"
	    }
	  }, [_vm._v("Resource Name")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-actions noborder invite-user-actions"
	  }, [_c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Resources Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\tManage\n\t\t\t")])])
	}]}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.activePanel) ? _c('div', {
	    staticClass: "sideways-content-fold"
	  }, [_c('div', {
	    staticClass: "portlet light bordered"
	  }, [_c('div', {
	    staticClass: "portlet-title"
	  }, [_c('div', {
	    staticClass: "caption"
	  }, [_vm._v("\n\t\t\t\tAssign App Permissions For "), _c('b', [_vm._v(_vm._s(_vm.editingRole.role_name))])])]), _vm._v(" "), _c('div', {
	    staticClass: "portlet-body"
	  }, [_c('form', {
	    attrs: {
	      "role": "form",
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.modifyRole($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "margin-top-20 row search-content-4"
	  }, [_c('div', {
	    staticClass: "search-table table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
	    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_no_access_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "none"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "none")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "none")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_no_access_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_view_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "view"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "view")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "view")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_view_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "md-radio"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (app.access_level),
	        expression: "app.access_level"
	      }],
	      staticClass: "md-radiobtn",
	      attrs: {
	        "type": "radio",
	        "id": ("app_privileges_modify_" + (app.app_id)),
	        "name": ("app_privileges_" + (app.app_id)),
	        "value": "modify"
	      },
	      domProps: {
	        "checked": _vm._q(app.access_level, "modify")
	      },
	      on: {
	        "change": function($event) {
	          _vm.$set(app, "access_level", "modify")
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": ("app_privileges_modify_" + (app.app_id))
	      }
	    }, [_c('span'), _vm._v(" "), _c('span', {
	      staticClass: "check"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "box"
	    })])])])])
	  }))])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default exit-invitation-setup",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closePanel()
	      }
	    }
	  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), _c('button', {
	    staticClass: "btn blue",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.editingRole.locked_role
	    }
	  }, [_vm._v("Submit")])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("No Access")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("View")])]), _vm._v(" "), _c('th', [_c('a', {
	    staticClass: "no-click font-grey-mint"
	  }, [_vm._v("View & Modify")])])])])
	}]}

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.f3dcea149dc37e3bebff.js